/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 2.26.723 on 2026-11-04 04:28:11.

export interface Page<T> extends Slice<T> {
    totalPages?: number;
    totalElements?: number;
}

export interface Slice<T> extends Streamable<T> {
    size?: number;
    content?: T[];
    number?: number;
    numberOfElements?: number;
    first?: boolean;
    pageable?: Pageable;
    sort?: any;
    last?: boolean;
}

export interface BuildProperties extends InfoProperties {
    name?: string;
    time?: Date;
    version?: string;
    group?: string;
    artifact?: string;
}

export interface Audit extends AbstractAuditingEntity, SignableForm {
    id?: number;
    auditNo?: string;
    auditRef?: string;
    productType?: AuditProductType;
    brand?: Brand;
    issuer?: Officer;
    auditFor?: string;
    issuerName?: string;
    issuerPosition?: string;
    expireDate?: any;
    entrepreneurs?: AuditEntrepreneur[];
    auditAuthorizedDirectors?: AuditAuthorizedDirector[];
    animalFeedType?: AnimalFeedType;
    ownerGroup?: OwnerGroup;
    directorNote?: AuditForm1DirectorNote;
    files?: { [P in AuditFileType]?: AuditFile };
    actGroup?: AnimalFeedActGroup;
    resultConsideration?: AuditForm1ResultConsideration;
    productBook?: AuditForm1ProductBook;
    objectiveType?: AuditFormObjectiveType;
    considerOrderingDate?: any;
    manualFlag?: boolean;
    considerUser?: Officer;
    userId?: number;
}

export interface AuditAcademicConsideration extends AbstractAuditingEntity {
    id?: number;
    approveStatus?: ApproveStatus;
    considerer?: Officer;
    considererName?: string;
    considererPosition?: string;
    considererComment?: string;
    comment?: string;
    attachFile?: FileUpload;
    statementComment?: string;
    statementFile?: FileUpload;
    acceptCorrection?: boolean;
    acceptCorrectionDate?: any;
    correctionItems?: AuditAcademicCorrectionItem[];
}

export interface AuditAcademicCorrectionItem extends CorrectionItem {
}

export interface AuditAuthorizedDirector extends AbstractAuthorizedDirector {
    id?: number;
}

export interface AuditBasicConsideration extends AbstractAuditingEntity {
    id?: number;
    considerer?: Officer;
    considererName?: string;
    considererPosition?: string;
    correctionComment?: string;
    acceptCorrection?: boolean;
    acceptCorrectionDate?: any;
    correctionFile?: FileUpload;
    statementComment?: string;
    statementFile?: FileUpload;
    correctionItems?: AuditBasicCorrectionItem[];
}

export interface AuditBasicCorrectionItem extends CorrectionItem {
}

export interface AuditConsiderOrdering extends AbstractAuditingEntity {
    id?: number;
    considerer?: Officer;
    considererName?: string;
    considererPosition?: string;
    considererComment?: string;
    attachFile?: FileUpload;
    statementComment?: string;
    statementFile?: FileUpload;
    notApproveBecause?: string;
    approveWithConditionBecause?: string;
    acceptCorrection?: boolean;
    acceptCorrectionDate?: any;
    releaseDate?: any;
    correctionItems?: AuditConsiderOrderingCorrectionItem[];
}

export interface AuditConsiderOrderingCorrectionItem extends CorrectionItem {
}

export interface AuditEntrepreneur extends AbstractEntrepreneur {
    id?: number;
}

export interface AuditFile extends FileUpload {
    other?: string;
    fileType?: AuditFileType;
}

export interface AuditForm extends AbstractAuditingEntity, FormDraft, SignableForm {
    id?: number;
    dtype?: FormType;
    filingOffice?: FilingOffice;
    productType?: AuditProductType;
    dofOrg?: DofOrg;
    considerUser?: Officer;
    requestNo?: string;
    petitionNo?: string;
    auditNo?: string;
    auditRef?: string;
    filingDate?: any;
    receivedDate?: any;
    resolvedDate?: any;
    basicConsiderationDate?: any;
    academicConsiderationDate?: any;
    notificationBookDate?: any;
    offerSignDate?: any;
    considerOrderingDate?: any;
    expireDate?: any;
    formStatus?: AuditFormStatus;
    remarkFromStaff?: string;
    auditFormConsideration?: AuditFormConsideration;
    files?: { [P in AuditFileType]?: AuditFile };
    auditFormEntrepreneurs?: AuditEntrepreneur[];
    auditFormAuthorizedDirectors?: AuditAuthorizedDirector[];
    basicConsideration?: AuditBasicConsideration;
    academicConsideration?: AuditAcademicConsideration;
    notificationBook?: AuditNotificationBook;
    offerSign?: AuditOfferSign;
    considerOrdering?: AuditConsiderOrdering;
    commentOfficer?: string;
    auditId?: number;
    filingLocation?: FilingLocation;
    brand?: Brand;
    user?: Applicant;
    lastedCorrectionStatus?: AuditCorrectionFormStatus;
}

export interface AuditForm1 extends AuditForm {
    f1ObjectiveType?: AuditFormObjectiveType;
    f1DirectorNote?: AuditForm1DirectorNote;
    f1ProductBook?: AuditForm1ProductBook;
    f1Process?: string;
    f1ProcessFile?: FileUpload;
    f1CopyLabel?: AuditForm1CopyLabel;
    auditForm1SupportDocProduct?: AuditForm1SupportDocProduct;
    auditForm1CertificateManufacture?: AuditForm1CertificateManufacture;
    auditForm1CertificateAnalysis?: AuditForm1CertificateAnalysis;
    auditForm1Certificate?: AuditForm1Certificate;
    f1ResultConsideration?: AuditForm1ResultConsideration;
}

export interface AuditForm1Certificate {
    id?: number;
    fileCertificateOfHealth?: FileUpload;
    fileCertificateOfPhytosanitary?: FileUpload;
}

export interface AuditForm1CertificateAnalysis {
    id?: number;
    fileAnalysisChemical?: FileUpload;
    fileAnalysisAflatoxin?: FileUpload;
    fileAnalysisResidue?: FileUpload;
    fileAnalysisTotalBacteria?: FileUpload;
    fileAnalysisTotalMold?: FileUpload;
    fileAnalysisSalmonellaApp?: FileUpload;
    fileAnalysisEcoli?: FileUpload;
    fileAnalysisHeavyMetal?: FileUpload;
    fileAnalysisOther?: FileUpload;
}

export interface AuditForm1CertificateManufacture {
    id?: number;
    fileCertificateFreeSale?: FileUpload;
    certificateFreeSaleOther?: string;
    fileCertificateFreeSaleOther?: FileUpload;
}

export interface AuditForm1CopyLabel extends AbstractAuditingEntity {
    id?: number;
    copyLabelPurposes?: AuditForm1CopyLabelPurpose[];
    fileCopyLabelEnglish?: FileUpload;
    fileCopyLabelThai?: FileUpload;
}

export interface AuditForm1CopyLabelPurpose {
    id?: AuditForm1CopyLabelPurposeId;
    auditFormPurpose?: AuditFormPurpose;
    purposeRemark?: string;
    checked?: boolean;
}

export interface AuditForm1CopyLabelPurposeId {
    auditForm1CopyLabelId?: number;
    auditFormPurposeId?: number;
}

export interface AuditForm1DirectorNote extends AbstractAuditingEntity {
    id?: number;
    productAppearance?: string;
    manufacturer?: Location;
    importer?: Location;
    importerForeignName?: string;
    importerForeignAddress?: string;
    manufacturerForeignName?: string;
    manufacturerForeignAddress?: string;
    objective?: string;
}

export interface AuditForm1ProductBook extends AbstractAuditingEntity {
    id?: number;
    purpose?: string;
    other?: string;
    f1ProductBookCompoundAnimalFeeds?: AuditForm1ProductBookCompoundAnimalFeed[];
    f1ProductBookCompounds?: AuditForm1ProductBookCompound[];
    summaryOfIngredientsAnimalFeed?: string;
    summaryOfIngredientsPremix?: string;
    f1ProductBookPackages?: AuditForm1ProductBookPackage[];
    howTo?: string;
    amount?: string;
    durationMonth?: string;
    guidance?: string;
    productInformationFile?: FileUpload;
    certificateFormula?: FileUpload;
    packages?: { [index: string]: string };
}

export interface AuditForm1ProductBookCompound extends AbstractAuditingEntity {
    id?: number;
    mixIngredientType?: MixIngredientType;
    mixIngredientTypeOther?: string;
    mixIngredientSubType?: MixIngredientSubType;
    mixIngredientSubTypeOther?: string;
    mixIngredientSubTypeName?: MixIngredientSubTypeName;
    mixIngredientSubTypeNameOthers?: string;
    materialQty?: number;
    packageUnit?: Unit;
    analysisResults?: number;
    fileProductBookCompound?: FileUpload;
}

export interface AuditForm1ProductBookCompoundAnimalFeed {
    id?: number;
    mixIngredient?: MixIngredient;
    productBookQualities?: AuditForm1ProductBookQuality[];
    materialQty?: number;
    unit?: Unit;
    mixIngredientOther?: string;
}

export interface AuditForm1ProductBookPackage extends AbstractAuditingEntity {
    id?: number;
    packageUnit?: Unit;
    packageType?: PackageType;
    packageVolume?: number;
    packageTypeOther?: string;
    durationMonth?: string;
}

export interface AuditForm1ProductBookQuality {
    id?: number;
    qualityType?: QualityType;
    ratio?: number;
    result?: number;
    fileProductBookQuality?: FileUpload;
}

export interface AuditForm1ResultConsideration extends AbstractAuditingEntity {
    id?: number;
    resultConsiderationType?: AuditFormResultConsiderationType;
    resultConsideration?: string;
    actGroup?: AnimalFeedActGroup;
    animalFeedType?: AnimalFeedType;
    concreteFeedType?: ConcreteFeedType;
    factorOtherType?: FactorOtherType;
    factorOther?: string;
    otherRemark?: string;
    concreteFeedTypeOther?: string;
    remark?: string;
    attachFile?: FileUpload;
}

export interface AuditForm1SupportDocProduct {
    id?: number;
    rule?: string;
    fileRule?: FileUpload;
    documentSupport?: string;
    fileDocument?: FileUpload;
    supportDocumentOther?: string;
    fileSupportDocumentOther?: FileUpload;
}

export interface AuditFormConsideration extends AbstractAuditingEntity {
    id?: number;
    considerer?: Officer;
    considererName?: string;
    considererPosition?: string;
    considererComment?: string;
    approveStatus?: ApproveStatus;
    approveRemark?: string;
}

export interface AuditFormPurpose {
    id?: number;
    name?: string;
}

export interface AuditNo extends AbstractAuditingEntity {
    currentNo?: number;
    id?: number;
}

export interface AuditNotificationBook extends AbstractAuditingEntity {
    id?: number;
    considerer?: Officer;
    considererName?: string;
    considererPosition?: string;
    considererComment?: string;
    attachFile?: FileUpload;
}

export interface AuditOfferSign extends AbstractAuditingEntity {
    id?: number;
    considerer?: Officer;
    considererName?: string;
    considererPosition?: string;
    considererComment?: string;
    attachFile?: FileUpload;
    statementComment?: string;
    statementFile?: FileUpload;
    acceptCorrection?: boolean;
    acceptCorrectionDate?: any;
    correctionItems?: AuditOfferSignCorrectionItem[];
}

export interface AuditOfferSignCorrectionItem extends CorrectionItem {
}

export interface AuditOtherFactor {
    id?: number;
    name?: string;
}

export interface AuditRef extends AbstractAuditingEntity {
    considerType?: AnimalFeedConsiderType;
    systemType?: SystemType;
    currentNo?: number;
    years?: number;
}

export interface AuditFeedImportDto {
    auditNo?: string;
    auditRef?: string;
    date?: string;
    companyName?: string;
    objectiveType?: string;
    manufacturerName?: string;
    manufacturerAddress?: string;
    manufacturerCountry?: string;
    importCountry?: string;
    importName?: string;
    importAddress?: string;
    objective?: string;
    brandTh?: string;
    brandEn?: string;
    productType?: string;
    productAppearance?: string;
    usedFor?: string;
    animalFeedGroup?: string;
    animalFeedType?: string;
    protein?: string;
    fat?: string;
    fiber?: string;
    moisture?: string;
    chemicalQuality?: string;
    packageType?: string;
    unit?: string;
    packageVolume?: string;
    packageUnit?: string;
    durationMonth?: string;
    howTo?: string;
    amount?: string;
    f1Process?: string;
    copyLabelPurposes?: string;
    animalFeed?: string;
    animalFeedOther?: string;
    notSpecificAnimalFeed?: string;
    notAnimalFeed?: string;
    factorOther?: string;
    resultConsideration?: string;
    fitWithAquaFeed?: string;
    fitWithDrug?: string;
    fitWithDangerousProduct?: string;
    note?: string;
    cardNumber?: string;
    auditFor?: string;
    personType?: string;
    entrepreneurName?: string;
    entrepreneurAddress?: string;
    entrepreneurTel?: string;
    ingredients?: string;
    companyBranch?: string;
}

export interface AuditFormSearchAcademicConsideration {
    requestNo?: string;
    petitionNo?: string;
    receivedDateFrom?: any;
    receivedDateTo?: any;
    resolvedDateFrom?: any;
    resolvedDateTo?: any;
    formStatus?: AuditFormStatus;
    formType?: FormType;
    requestEntrepreneur?: string;
    brandName?: string;
}

export interface AuditFormSearchConsiderOrdering {
    requestNo?: string;
    petitionNo?: string;
    offerSignDateForm?: any;
    offerSignDateTo?: any;
    considerOrderingDateFrom?: any;
    considerOrderingDateTo?: any;
    applicant?: Applicant;
    entrepreneur?: Entrepreneur;
    formStatus?: AuditFormStatus;
    formType?: FormType;
    requestEntrepreneur?: string;
    brandName?: string;
}

export interface AuditFormSearchNotificationBook {
    requestNo?: string;
    petitionNo?: string;
    academicDateFrom?: any;
    academicDateTo?: any;
    notificationBookDateFrom?: any;
    notificationBookDateTo?: any;
    applicant?: Applicant;
    entrepreneur?: Entrepreneur;
    formStatus?: AuditFormStatus;
    formType?: FormType;
    requestEntrepreneur?: string;
    brandName?: string;
}

export interface AuditFormSearchOfferSign {
    requestNo?: string;
    petitionNo?: string;
    academicDateFrom?: any;
    academicDateTo?: any;
    notificationBookDateFrom?: any;
    notificationBookDateTo?: any;
    applicant?: Applicant;
    entrepreneur?: Entrepreneur;
    formStatus?: AuditFormStatus;
    formType?: FormType;
    requestEntrepreneur?: string;
    brandName?: string;
}

export interface AuditFormSearchPreliminaryConsider {
    requestNo?: string;
    petitionNo?: string;
    filingDateFrom?: any;
    filingDateTo?: any;
    receivedDateFrom?: any;
    receivedDateTo?: any;
    resolvedDateFrom?: any;
    resolvedDateTo?: any;
    applicant?: Applicant;
    entrepreneur?: Entrepreneur;
    formStatus?: AuditFormStatus;
    formType?: FormType;
    requestEntrepreneur?: string;
    brandName?: string;
}

export interface AuditFormSearchRequest {
    keyword?: string;
    filingDateFrom?: any;
    filingDateTo?: any;
    formStatus?: AuditFormStatus;
}

export interface AuditImportDto {
    id?: number;
    auditNo?: string;
    issuerDate?: any;
    issuerName?: string;
    brandTh?: string;
    brandEn?: string;
    objectiveType?: string;
    country?: string;
    auditName?: string;
    auditLocation?: string;
    produceName?: string;
    produceLocation?: string;
    companyName?: string;
    animalFeedGroup?: string;
    animalFeedType?: string;
    usedFor?: string;
    chemicalQuality?: string;
    result?: string;
    ingredient?: string;
    feedAppearance?: string;
    color?: string;
    netWeight?: string;
    weightUnit?: string;
    packageType?: string;
    usedAmount?: string;
    durationMonth?: string;
    feedWarning?: string;
    ownerGroupId?: string;
}

export interface AuditConsiderOrderingProjection {
    releaseDate?: any;
}

export interface AuditFormProjection {
    id?: number;
    user?: ApplicantProjection;
    brand?: Brand;
    auditRef?: string;
    considerOrderingDate?: any;
    considerOrdering?: AuditConsiderOrderingProjection;
    requestNo?: string;
    petitionNo?: string;
    filingDate?: any;
    formStatus?: AuditFormStatus;
    resolvedDate?: any;
    basicConsiderationDate?: any;
    academicConsiderationDate?: any;
    notificationBookDate?: any;
    offerSignDate?: any;
    dtype?: FormType;
}

export interface CertOfHealthFile extends FileUpload {
    fileType?: CertOfHealthFileType;
}

export interface CertOfHealthFileTypeRequire {
    certOfHealthFileTypeRequireId?: CertOfHealthFileTypeRequireId;
    certOfHealthFileType?: CertOfHealthFileType;
}

export interface Certificate extends AbstractAuditingEntity {
    id?: number;
    certificateType?: CertificateType;
    issuer?: Officer;
    issuerName?: string;
    issuerPosition?: string;
    certificateNo?: string;
    ownerGroup?: OwnerGroup;
    user?: Applicant;
    bookNo?: string;
    requestInspection?: RequestInspection;
    filingLocation?: FilingLocation;
    licenseForEn?: string;
    licenseForTh?: string;
    addressEn?: string;
    addressTh?: string;
    exporter?: CertificateExporter;
    domesticSales?: CertificateDomesticSales;
    healthCert?: CertificateHealthCert;
    filingOffice?: FilingOffice;
    dofOrg?: DofOrg;
    requestType?: RequestType;
    superGroup?: AnimalFeedActGroup;
    department?: Department;
    applicantType?: ApplicantType;
    filingDate?: any;
    receivedDate?: any;
    requestLicensing?: CertificateRequestLicensing;
    requestGmp?: CertificateRequestGmpHaccp;
    requestHaccp?: CertificateRequestGmpHaccp;
    files?: { [P in CertificateFileType]?: CertificateFile };
    issueDate?: any;
    expireDate?: any;
    bookApproveDate?: any;
    correctionCertificateNo?: string;
    correctionIssueDate?: string;
    receivedNo?: string;
    manualFlag?: boolean;
    certification?: string;
    certification2?: string;
    dtype?: FormType;
    branchNO?: string;
    year?: string;
    correctionRequest?: CertificateFormCorrectionRequest;
    correctionRequestTypes?: CertificateCorrectionRequestType[];
    canceled?: boolean;
}

export interface CertificateAcademicConsider extends AbstractAuditingEntity {
    id?: number;
    basicConsiderer?: Officer;
    basicConsiderDate?: any;
    considerer?: Officer;
    considererName?: string;
    considererPosition?: string;
    considerDate?: any;
    correctionComment?: string;
    acceptCorrection?: boolean;
    acceptedDate?: any;
    correctionFile?: FileUpload;
    statementComment?: string;
    statementFile?: FileUpload;
    correctionItems?: CertificateAcademicConsiderCorrectionItem[];
}

export interface CertificateAcademicConsiderCorrectionItem extends CorrectionItem {
}

export interface CertificateAnimalFeedTypeDesc {
    id?: CertificateAnimalFeedTypeDescId;
    nameTh?: string;
    nameEng?: string;
}

export interface CertificateAuditProductBookQuality {
    id?: number;
    qualityType?: QualityType;
    ratio?: number;
    result?: number;
    fileProductBookQuality?: FileUpload;
}

export interface CertificateConsiderOrdering extends AbstractAuditingEntity {
    id?: number;
    basicConsiderer?: Officer;
    basicConsiderDate?: any;
    considerer?: Officer;
    considererName?: string;
    considererPosition?: string;
    considerDate?: any;
    correctionComment?: string;
    acceptCorrection?: boolean;
    acceptedDate?: any;
    correctionFile?: FileUpload;
    statementComment?: string;
    statementFile?: FileUpload;
    approveStatus?: CertificateFormStatus;
    approveDate?: any;
    rejectComment?: string;
    approveWithConditionComment?: string;
    correctionItems?: CertificateConsiderOrderingCorrectionItem[];
}

export interface CertificateConsiderOrderingCorrectionItem extends CorrectionItem {
}

export interface CertificateCorrectionRequestType {
    id?: number;
    name?: string;
}

export interface CertificateCreateCertificate extends AbstractAuditingEntity {
    id?: number;
    officer?: Officer;
    officerName?: string;
    officerPosition?: string;
}

export interface CertificateDomesticSaleAuditAnalysisCompound extends AbstractAuditingEntity {
    id?: number;
    domesticSaleAnalysis?: DomesticSaleAnalysis;
}

export interface CertificateDomesticSaleAuditAnalysisQuality {
    id?: number;
    domesticSaleAnalysis?: DomesticSaleAnalysis;
}

export interface CertificateDomesticSales extends AbstractAuditingEntity {
    id?: number;
    domesticSalesType?: CertificateDomesticSalesType;
    animalFeedGroup?: AnimalFeedGroup;
    domesticSalesVouchers?: CertificateDomesticSalesVoucher[];
    domesticSalesAudits?: CertificateDomesticSalesAudit[];
    domesticSalesBuyer?: CertificateFormDomesticSalesBuyer;
    domesticSalesTransport?: CertificateFormDomesticSalesTransport;
    domesticSalesCopyRequest?: CertificateDomesticSalesCopyRequest;
    domesticSalesVouchersDistinctBrandTh?: CertificateDomesticSalesVoucher[];
    domesticSalesAuditDistinctBrandTh?: CertificateDomesticSalesAudit[];
    voucherSumByPackageUnit?: string;
    auditSumByPackageUnit?: string;
}

export interface CertificateDomesticSalesAudit extends AbstractAuditingEntity {
    id?: number;
    other?: string;
    hsCode?: string;
    auditRef?: string;
    brand?: Brand;
    productType?: AuditProductType;
    animalFeedType?: AnimalFeedType;
    purpose?: string;
    productBookCompoundAnimalFeeds?: CertificateProductBookCompoundAnimalFeed[];
    productBookCompounds?: CertificateProductBookCompound[];
    domesticSaleAuditPackages?: CertificateProductBookPackage[];
    auditFile?: FileUpload;
    audit?: Audit;
    domesticSalesAddition?: DomesticSalesAddition;
    certificateDomesticSaleAnalysisCompounds?: CertificateDomesticSaleAuditAnalysisCompound[];
    certificateDomesticSaleAnalysisQualities?: CertificateDomesticSaleAuditAnalysisQuality[];
    domesticSaleAnalysisQualities?: DomesticSaleAuditAnalysisQuality[];
}

export interface CertificateDomesticSalesVoucher extends AbstractAuditingEntity {
    id?: number;
    other?: string;
    hsCode?: string;
    voucherNo?: string;
    brand?: Brand;
    animalFeedType?: AnimalFeedType;
    feedPurpose?: CertificateVoucherFeedPurpose;
    domesticSalesAddition?: DomesticSalesAddition;
    domesticSaleAnalysisQualities?: DomesticSaleVoucherAnalysisQuality[];
    domesticSaleVoucherAnalysisIngredients?: DomesticSaleVoucherAnalysisIngredient[];
    domesticSaleVoucherPackages?: DomesticSaleVoucherPackage[];
    files?: { [P in CertificateDomesticSalesVoucherFileType]?: CertificateDomesticSalesVoucherFile };
    certificateAnimalFeedTypeDesc?: string;
}

export interface CertificateDomesticSalesVoucherFile extends FileUpload {
    fileType?: CertificateDomesticSalesVoucherFileType;
}

export interface CertificateExporter extends AbstractAuditingEntity {
    id?: number;
    exporterType?: CertificateExporterType;
    department?: Department;
    exporterName?: string;
    exporterAddress?: string;
    exporterNameEn?: string;
    exporterAddressEn?: string;
    taxNo?: string;
    branch?: string;
    requestLicensing?: CertificateRequestLicensing;
    contractFile?: FileUpload;
}

export interface CertificateFcNo extends AbstractAuditingEntity {
    documentType?: CertificateDocumentType;
    years?: number;
    systemType?: CertificateSystemType;
    currentNo?: number;
}

export interface CertificateFile extends FileUpload {
    other?: string;
    fileType?: CertificateFileType;
}

export interface CertificateForm extends AbstractAuditingEntity, FormDraft, SignableForm {
    id?: number;
    user?: Applicant;
    considerUser?: Officer;
    filingLocation?: FilingLocation;
    certificateNo?: string;
    certificateNoOld?: string;
    certificateDateOld?: any;
    licenseForEn?: string;
    licenseForTh?: string;
    addressEn?: string;
    addressTh?: string;
    exporter?: CertificateExporter;
    domesticSales?: CertificateDomesticSales;
    healthCert?: CertificateHealthCert;
    dtype?: FormType;
    filingOffice?: FilingOffice;
    dofOrg?: DofOrg;
    requestType?: RequestType;
    consideration?: CertificateFormConsideration;
    superGroup?: AnimalFeedActGroup;
    correctionRequestTypes?: CertificateCorrectionRequestType[];
    payment?: Payment;
    department?: Department;
    applicantType?: ApplicantType;
    petitionNo?: string;
    requestNo?: string;
    purposeNo?: string;
    filingDate?: any;
    receivedDate?: any;
    resolvedDate?: any;
    preliminaryDate?: any;
    academicConsiderationDate?: any;
    academicOfficerComment?: string;
    createBookDate?: any;
    createCertOfficerComment?: string;
    offerSignDate?: any;
    considerOrderingDate?: any;
    formStatus?: CertificateFormStatus;
    remarkFromStaff?: string;
    acceptCorrection?: boolean;
    acceptCorrectionDate?: any;
    licenseNo?: string;
    requestLicensing?: CertificateRequestLicensing;
    bookNo?: string;
    basicConsideration?: CertificatePreliminaryConsider;
    academicConsider?: CertificateAcademicConsider;
    createdCertificate?: CertificateCreateCertificate;
    offerSign?: CertificateOfferSign;
    considerOrdering?: CertificateConsiderOrdering;
    certification?: string;
    certification2?: string;
    requestInspection?: RequestInspection;
    acceptAgreement?: boolean;
    correctionRemark?: string;
    lastedCorrectionStatus?: CertificateCorrectionFormStatus;
    applicantId?: number;
    ownerGroupId?: string;
    issueDate?: any;
    issuerPosition?: string;
    issuer?: Officer;
    bookApproveDate?: any;
    requestGmp?: CertificateRequestGmpHaccp;
    requestHaccp?: CertificateRequestGmpHaccp;
    fsw?: boolean;
}

export interface CertificateForm1 extends CertificateForm {
    files?: { [P in CertificateForm1FileType]?: CertificateForm1File };
}

export interface CertificateForm1File extends FileUpload {
    other?: string;
    fileType?: CertificateForm1FileType;
}

export interface CertificateForm2 extends CertificateForm {
    correctionRequest?: CertificateFormCorrectionRequest;
    files?: { [P in CertificateForm2FileType]?: CertificateForm2File };
}

export interface CertificateForm2File extends FileUpload {
    fileType?: CertificateForm2FileType;
    other?: string;
}

export interface CertificateForm3 extends CertificateForm {
    attachFileRequest?: CertificateDomesticSaleAttachFileRequest;
    files?: { [P in CertificateForm3FileType]?: CertificateForm3File };
}

export interface CertificateForm3File extends FileUpload {
    fileType?: CertificateForm3FileType;
    other?: string;
}

export interface CertificateForm4 extends CertificateForm {
    attachFileRequest?: CertificateDomesticSaleAttachFileRequest;
    correctionRequest?: CertificateFormCorrectionRequest;
    files?: { [P in CertificateForm4FileType]?: CertificateForm4File };
}

export interface CertificateForm4File extends FileUpload {
    fileType?: CertificateForm4FileType;
    other?: string;
}

export interface CertificateFormCert {
    id?: number;
    name?: string;
    supperGroup?: AnimalFeedActGroup;
    requireFileTypes?: CertOfHealthFileTypeRequire[];
}

export interface CertificateFormConsideration extends AbstractAuditingEntity {
    id?: number;
    considerer?: Officer;
    considererName?: string;
    considererPosition?: string;
    considererComment?: string;
    approveStatus?: ApproveStatus;
    approveRemark?: string;
}

export interface CertificateFormCorrectionRequest extends AbstractAuditingEntity {
    id?: number;
    requestCorrectionItems?: { [index: string]: CertificateFormRequestCorrectionItem };
    exporterCorrection?: boolean;
    productIssuanceCorrection?: boolean;
    requestCopyCorrection?: boolean;
    documentCorrection?: boolean;
    manufacturerCorrection?: boolean;
    certificateCorrection?: boolean;
    declarationCorrection?: boolean;
}

export interface CertificateFormDomesticSalesBuyer {
    buyerNameEn?: string;
    buyerAddressEn?: string;
    buyerCountryOfOrigin?: Country;
    buyerDestinationCountry?: Country;
    buyerInvoiceNo?: string;
    buyerInvoiceDate?: any;
    buyerIssueDate?: any;
    buyerIsInvoice?: boolean;
    buyerInvoiceFile?: FileUpload;
    buyerPackingListInvoiceFile?: FileUpload;
}

export interface CertificateFormDomesticSalesTransport {
    type?: TransportType;
    other?: string;
    vesselName?: string;
    shipmentDate?: any;
    confDoc?: FileUpload;
    checkpoint?: DofPort;
    provincePortExport?: Province;
    portLoading?: Port;
    portDischarge?: Port;
    customsOrg?: CustomsOrg;
    station?: string;
    port?: Port;
    transportLetterCreditNumber?: string;
    transportLetterCreditNumberFile?: FileUpload;
    transportContainerNo?: string;
    transportContainerNoFile?: FileUpload;
    transportSealNo?: string;
    transportBatchNo?: string;
}

export interface CertificateFormRequestCorrectionItem extends RequestCorrectionItem {
}

export interface CertificateFormSalesLicensing {
    licenseType?: LicenseType;
    licenseNo?: string;
    licensingIssue?: string;
    licensingIssueDate?: any;
    licensingBook?: string;
    licensingExpireDate?: any;
    licensingFile?: FileUpload;
}

export interface CertificateHcNo extends AbstractAuditingEntity {
    documentType?: CertificateDocumentType;
    years?: number;
    systemType?: CertificateSystemType;
    currentNo?: number;
}

export interface CertificateHealthCert extends AbstractAuditingEntity {
    id?: number;
    healthCertLists?: CertificateHealthCertList[];
    requestForAttachments?: CertificateHealthCertList[];
    certificationRemark?: string;
    certificationFile?: FileUpload;
    salesType?: CertificateDomesticSalesType;
    healthCertVouchers?: CertificateHealthCertVoucher[];
    healthCertAudits?: CertificateHealthCertAudit[];
    buyer?: CertificateFormDomesticSalesBuyer;
    transport?: CertificateFormDomesticSalesTransport;
    copyRequest?: CertificateDomesticSalesCopyRequest;
    certificateDomesticSaleAttachFileRequest?: CertificateDomesticSaleAttachFileRequest;
    files?: { [P in CertOfHealthFileType]?: CertOfHealthFile };
    requestForAttachmentFiles?: { [P in CertOfHealthFileType]?: CertOfHealthFile };
    requestForAttachmentRemark?: string;
    requestForAttachmentFile?: FileUpload;
}

export interface CertificateHealthCertAudit extends AbstractAuditingEntity {
    id?: number;
    productType?: ProductType;
    hS_Code?: string;
    auditFile?: FileUpload;
    healthCert?: CertificateHealthCert;
    netWeight?: number;
    fobBath?: number;
}

export interface CertificateHealthCertList extends AbstractAuditingEntity {
    id?: number;
    certificateFormCert?: CertificateFormCert;
}

export interface CertificateHealthCertVoucher extends AbstractAuditingEntity {
    id?: number;
    hS_Code?: string;
    voucherFile?: FileUpload;
    healthCert?: CertificateHealthCert;
    netWeight?: number;
    fobBath?: number;
}

export interface CertificateLicensing extends AbstractAuditingEntity {
    id?: number;
    requestNo?: string;
    petitionNo?: string;
    filingDate?: any;
    receivedDate?: any;
    licenseType?: LicenseType;
    licensingIssue?: string;
    licensingBook?: string;
    licensingIssueDate?: any;
    licensingExpireDate?: any;
    licenseFor?: string;
    address?: string;
    licenseForEn?: string;
    addressEn?: string;
    file?: FileUpload;
}

export interface CertificateNo extends AbstractAuditingEntity {
    id?: CertificateNoId;
    currentNo?: number;
    years?: number;
}

export interface CertificateOfferSign extends AbstractAuditingEntity {
    id?: number;
    considerer?: Officer;
    correctionComment?: string;
    acceptCorrection?: boolean;
    acceptedDate?: any;
    correctionFile?: FileUpload;
    statementComment?: string;
    statementFile?: FileUpload;
    correctionItems?: CertificateOfferSignCorrectionItem[];
}

export interface CertificateOfferSignCorrectionItem extends CorrectionItem {
}

export interface CertificatePreliminaryConsider extends AbstractAuditingEntity {
    id?: number;
    considerer?: Officer;
    correctionComment?: string;
    acceptCorrection?: boolean;
    acceptedDate?: any;
    correctionFile?: FileUpload;
    statementComment?: string;
    statementFile?: FileUpload;
    correctionItems?: CertificatePreliminaryConsiderCorrectionItem[];
}

export interface CertificatePreliminaryConsiderCorrectionItem extends CorrectionItem {
}

export interface CertificateProductBookCompound extends AbstractAuditingEntity {
    id?: number;
    mixIngredientType?: MixIngredientType;
    mixIngredientTypeOther?: string;
    mixIngredientSubType?: MixIngredientSubType;
    mixIngredientSubTypeOther?: string;
    mixIngredientSubTypeName?: MixIngredientSubTypeName;
    mixIngredientSubTypeNameOthers?: string;
    materialQty?: number;
    packageUnit?: Unit;
    analysisResults?: number;
    fileProductBookCompound?: FileUpload;
}

export interface CertificateProductBookCompoundAnimalFeed {
    id?: number;
    mixIngredient?: MixIngredient;
    materialQty?: number;
    unit?: Unit;
    mixIngredientOther?: string;
    productBookQualities?: CertificateAuditProductBookQuality[];
}

export interface CertificateProductBookPackage extends AbstractAuditingEntity {
    id?: number;
    packageUnit?: Unit;
    packageType?: PackageType;
    packageVolume?: number;
    packageTypeOther?: string;
    netWeight?: number;
    durationMonth?: string;
}

export interface CertificateRequestGmpHaccp extends RequestGmpHaccp {
}

export interface CertificateRequestLicensing extends RequestLicensing<CertificateRequestLicensingItem> {
    licensingItems?: CertificateRequestLicensingItem[];
    files?: { [P in LicensingFileType]?: LicensingFile };
    entrepreneurs?: LicensingEntrepreneur[];
    location?: Location;
    warehouses?: Location[];
}

export interface CertificateRequestLicensingItem extends RequestLicensingItem {
}

export interface CertificateVoucherFeedPurpose extends AbstractAuditingEntity {
    id?: number;
    animalTypes?: AnimalType[];
    animalSubTypes?: AnimalSubType[];
    animalAge?: AnimalAge;
    usedFor?: string;
}

export interface DomesticSaleAnalysis {
    mixIngredientType?: MixIngredientType;
    mixIngredientTypeOther?: string;
    mixIngredientSubType?: MixIngredientSubType;
    mixIngredientSubTypeOther?: string;
    mixIngredientSubTypeName?: MixIngredientSubTypeName;
    mixIngredientSubTypeNameOthers?: string;
    materialQty?: number;
    unit?: Unit;
    analysisResults?: string;
    fileCompound?: FileUpload;
}

export interface DomesticSaleAuditAnalysisIngredient {
    id?: number;
    mixIngredientType?: MixIngredientType;
    mixIngredientSubType?: MixIngredientSubType;
    mixIngredientSubtypeOthers?: string;
    mixIngredientSubTypeName?: MixIngredientSubTypeName;
    mixIngredientSubTypeNameOthers?: string;
    amount?: number;
    unit?: Unit;
    result?: number;
    file?: FileUpload;
}

export interface DomesticSaleAuditAnalysisQuality {
    id?: number;
    qualityType?: QualityType;
    ratio?: number;
    result?: number;
    fileQuality?: FileUpload;
}

export interface DomesticSaleAuditPackage {
    id?: number;
    packageType?: PackageType;
    packageTypeOthers?: string;
    packageUnit?: Unit;
    netWeight?: number;
    durationMonth?: number;
}

export interface DomesticSaleVoucherAnalysisIngredient {
    id?: number;
    mixIngredientType?: MixIngredientType;
    mixIngredientSubType?: MixIngredientSubType;
    mixIngredientSubtypeOthers?: string;
    mixIngredientSubTypeName?: MixIngredientSubTypeName;
    mixIngredientSubTypeNameOthers?: string;
    amount?: number;
    amountText?: string;
    unit?: Unit;
    result?: number;
    resultText?: string;
    file?: FileUpload;
}

export interface DomesticSaleVoucherAnalysisQuality {
    id?: number;
    qualityType?: QualityType;
    ratio?: number;
    result?: number;
    fileQuality?: FileUpload;
}

export interface DomesticSaleVoucherPackage {
    id?: number;
    packageType?: PackageType;
    packageTypeOthers?: string;
    packageUnit?: Unit;
    netWeight?: number;
    durationMonth?: number;
}

export interface DomesticSalesAddition {
    descGood?: string;
    packageType?: PackageType;
    packageTypeOther?: string;
    packingSize?: number;
    packingUnit?: Unit;
    amountPackingContainer?: number;
    unitPackingContainer?: PackageUnit;
    netWeight?: number;
    netWeightUnit?: Unit;
    grossWeight?: number;
    grossWeightUnit?: Unit;
    price?: number;
    currency?: Currency;
    exchangeRate?: number;
    priceBaht?: number;
    fobBath?: number;
    analysisECoilMethod?: string;
    analysisECoilResult?: string;
    analysisECoilUnit?: string;
    fileAnalysisECoilResult?: FileUpload;
    analysisSalmonellaAppMethod?: string;
    analysisSalmonellaAppResult?: string;
    analysisSalmonellaAppUnit?: string;
    fileAnalysisSalmonellaAppResult?: FileUpload;
    analysisTotalMoldMethod?: string;
    analysisTotalMoldResult?: string;
    analysisTotalMoldUnit?: string;
    fileAnalysisTotalMoldResult?: FileUpload;
    analysisChemicalMethod?: string;
    analysisChemicalResult?: string;
    analysisChemicalUnit?: string;
    fileAnalysisChemicalResult?: FileUpload;
    fileAnalysisAllResult?: FileUpload;
}

export interface CertOfHealthFileTypeRequireId {
    certOfHealthFileType?: CertOfHealthFileType;
    certificateFormCertId?: number;
}

export interface CertificateAnimalFeedTypeDescId {
    animalFeedType?: AnimalFeedType;
    animalType?: AnimalType;
}

export interface CertificateNoId {
    documentType?: CertificateDocumentType;
    module?: Modules;
    systemType?: CertificateSystemType;
}

export interface CertificateFormSearch {
    id?: number;
    dtype?: FormType;
    requestNo?: string;
    certificateNo?: string;
    petitionNo?: string;
    filingDate?: any;
    receivedDate?: any;
    resolvedDate?: any;
    shipmentDate?: any;
    applicantName?: string;
    formStatus?: CertificateFormStatus;
    academicConsiderationDate?: any;
    createBookDate?: any;
    offerSignDate?: any;
    user?: Applicant;
    amount?: number;
    fsw?: boolean;
}

export interface CertificateFormSearchRequest {
    keyword?: string;
    requestNo?: string;
    petitionNo?: string;
    filingDateFrom?: any;
    filingDateTo?: any;
    receivedDateFrom?: any;
    receivedDateTo?: any;
    meetingDateFrom?: any;
    meetingDateTo?: any;
    registrationDateFrom?: any;
    registrationDateTo?: any;
    correctionDateFrom?: any;
    correctionDateTo?: any;
    shipmentDateFrom?: any;
    shipmentDateTo?: any;
    academicConsiderationDateFrom?: any;
    academicConsiderationDateTo?: any;
    createBookDateFrom?: any;
    createBookDateTo?: any;
    offerSignDateFrom?: any;
    offerSignDateTo?: any;
    filingUserName?: string;
    formType?: FormType;
    formStatus?: CertificateFormStatus;
    statusIn?: CertificateFormStatus[];
}

export interface CertificateImportDto {
    id?: string;
    companyName?: string;
    branchManuFacturer?: string;
    countryName?: string;
    certificateType?: CertificateType;
    invoice?: string;
    receivedNo?: string;
    receivedDate?: any;
    certificateNo?: string;
    issueDate?: any;
    brandName?: string;
    voucherNo?: string;
    animalFeedGroup?: string;
    animalFeedType?: string;
    animalSubType?: string;
    usedFor?: string;
    volume?: number;
    value?: number;
    unit?: string;
    rate?: number;
    amount?: number;
    year?: string;
}

export interface CertificatePaymentRequest {
    certificateFormId?: number;
    receiptFile?: FileUpload;
}

export interface CertificateSearchRequest {
    certificateNo?: string;
    issueDateFrom?: any;
    issueDateTo?: any;
    createdDateTo?: any;
    createdDateFrom?: any;
    canceled?: boolean;
}

export interface GroupSumVoucherAudit {
    id?: number;
    netWeight?: number;
    fobBath?: number;
    buyerInvoiceNo?: string;
    hsCode?: string;
    certificateAnimalFeedTypeDesc?: string;
}

export interface SumPackageUnit {
    weight?: number;
    packageUnit?: PackageUnit;
}

export interface SumUnit {
    weight?: number;
    packageUnit?: PackageUnit;
    unit?: Unit;
}

export interface CertificateFormProjection {
    id?: number;
    user?: ApplicantProjection;
    document?: FileUpload;
    requestNo?: string;
    petitionNo?: string;
    filingDate?: any;
    receivedDate?: any;
    formStatus?: CertificateFormStatus;
    dtype?: FormType;
    certificateNo?: string;
}

export interface CertificatePayment {
    certificate?: Certificate;
    certificateForm?: CertificateForm;
}

export interface CertificateProjection {
    id?: number;
    user?: ApplicantProjection;
    expireDate?: any;
    createdDate?: any;
    lastUpdatedDate?: any;
    certificateNo?: string;
    certificateType?: CertificateType;
    licenseForEn?: string;
    licenseForTh?: string;
    department?: Department;
    canceled?: boolean;
    issueDate?: any;
    correctionCertificateNo?: string;
    correctionIssueDate?: string;
}

export interface AbstractAttorney extends AbstractAuditingEntity {
    title?: Title;
    firstNameTh?: string;
    lastNameTh?: string;
    birthDate?: any;
    nation?: Nation;
    identityCard?: IdentityCard;
    contactAddress?: ContactAddress;
    ownerGroup?: OwnerGroup;
}

export interface AbstractAuditingEntity {
    createdId?: string;
    createdDate?: any;
    lastUpdatedId?: string;
    lastUpdatedDate?: any;
}

export interface AbstractAuthorizedDirector extends AbstractAuditingEntity {
    title?: Title;
    firstNameTh?: string;
    lastNameTh?: string;
    birthDate?: any;
    nation?: Nation;
    identityCard?: IdentityCard;
    contactAddress?: ContactAddress;
    ownerGroup?: OwnerGroup;
    age?: number;
    fullNameTh?: string;
}

export interface AbstractEntrepreneur extends AbstractAuditingEntity {
    title?: Title;
    firstNameTh?: string;
    lastNameTh?: string;
    firstNameEn?: string;
    lastNameEn?: string;
    birthDate?: any;
    nation?: Nation;
    identityCard?: IdentityCard;
    contactAddress?: ContactAddress;
    ownerGroup?: OwnerGroup;
    age?: number;
    fullNameTh?: string;
}

export interface AbstractLicensing<T> extends AbstractAuditingEntity, LicensingWithItems<T> {
    licenseType?: LicenseType;
    licenseSubType?: LicenseSubType;
    licensor?: Officer;
    licensorName?: string;
    licensorPosition?: string;
    licensingIssue?: string;
    licensingBook?: string;
    licensingIssueDate?: any;
    licensingExpireDate?: any;
    licensingEffectiveDate?: any;
    licenseFor?: string;
    filingOffice?: FilingOffice;
    dofOrg?: DofOrg;
    filingLocation?: FilingLocation;
    filingProvince?: Province;
    certificateOfFreeSaleType?: CertificateOfFreeSaleType;
    licensingIssueType?: LicensingIssueType;
    renewFlag?: boolean;
    substitutionDate?: any;
    substitutionOfficerName?: string;
    substitutionOfficerPosition?: string;
    department?: Department;
    type?: string;
    remark?: string;
    ownerGroup?: OwnerGroup;
    actingDirectorFlag?: boolean;
}

export interface AbstractLicensingItem extends AbstractAuditingEntity {
    animalFeedType?: AnimalFeedType;
    productionEfficiency?: number;
    feedPackage?: string;
    usedTogether?: boolean;
    remark?: string;
    animalFeedGroup?: AnimalFeedGroup;
}

export interface Address {
    address?: string;
    soi?: string;
    street?: string;
    moo?: string;
    tambon?: Tambon;
    postalCode?: string;
}

export interface AddressEn {
    address?: string;
    moo?: string;
    soi?: string;
    street?: string;
    tambon?: Tambon;
    postalCode?: string;
    tel?: string;
    placeName?: string;
    fullAddressEn?: string;
}

export interface AddressEnLite {
    address?: string;
    fullAddress?: string;
    placeName?: string;
}

export interface Amphur {
    id?: string;
    name?: string;
    nameEn?: string;
    province?: Province;
}

export interface AnimalAge {
    id?: number;
    age?: string;
    animalType?: AnimalType;
    animalSubType?: AnimalSubType;
    proteinRatio?: number;
    fatRatio?: number;
    fiberRatio?: number;
    moistureRatio?: number;
}

export interface AnimalFeedGroup {
    id?: AnimalFeedGroupId;
    actGroup?: AnimalFeedActGroup;
    name?: string;
}

export interface AnimalFeedType {
    id?: AnimalFeedTypeId;
    name?: string;
    nameEn?: string;
    animalFeedGroup?: AnimalFeedGroup;
    certificateOfFreeSale?: string;
    certificateOfHealth?: string;
    nameHC?: string;
}

export interface AnimalGroup {
    id?: string;
    groupName?: string;
    groupNameEn?: string;
}

export interface AnimalHowTo {
    id?: number;
    name?: string;
    nameEn?: string;
}

export interface AnimalSubType {
    id?: string;
    subtypeName?: string;
    aquaticAnimalType?: AnimalType;
}

export interface AnimalType {
    id?: string;
    typeName?: string;
    animalGroup?: AnimalGroup;
}

export interface Applicant extends AbstractAuditingEntity, OwnerIdentity {
    id?: number;
    personType?: PersonType;
    username?: string;
    title?: Title;
    firstNameTh?: string;
    lastNameTh?: string;
    fullNameTh?: string;
    email?: string;
    identityCard?: IdentityCardLite;
    addressEn?: AddressEnLite;
    contactAddress?: ContactAddressLite;
    company?: CompanyLite;
    authorities?: Authority[];
    ownerGroup?: OwnerGroup;
    performType?: PerformType;
    enable?: boolean;
    applicantName?: string;
    dofPort?: DofPort;
    dofOrg?: DofOrg;
    age?: number;
}

export interface AssignAuthorities extends AbstractAuditingEntity {
    id?: number;
    assigner?: OfficerAssign;
    assignTo?: OfficerAssign;
    assignDate?: any;
    effectiveDateFrom?: any;
    effectiveDateTo?: any;
    authoritiesItem?: Authority[];
    deleted?: boolean;
    deletedDateTime?: any;
}

export interface AssignWork {
    id?: number;
    assignDate?: any;
    assignDateForm?: any;
    assignDateTo?: any;
    assigner?: Officer;
    assigned?: Officer;
    authority?: Authority;
}

export interface Attorney extends AbstractAttorney {
    id?: number;
    enable?: boolean;
    fullNameTh?: string;
}

export interface Authority extends GrantedAuthority {
    name?: AuthorityType;
}

export interface AuthorizedDirector extends AbstractAuthorizedDirector {
    id?: number;
}

export interface CompCode {
    compCode?: string;
    provinceName?: string;
    province?: Province;
}

export interface Company extends OwnerIdentity {
    id?: number;
    companyType?: CompanyType;
    companyTypeId?: number;
    otherCompanyType?: string;
    nameTh?: string;
    nameEn?: string;
    taxId?: string;
    branch?: string;
    companyBranch?: CompanyBranch;
    branchDescription?: string;
    corporateNumber?: string;
    foundationNumber?: string;
    dateOfRegistration?: any;
    registeredCapital?: number;
    address?: string;
    moo?: string;
    soi?: string;
    street?: string;
    tambon?: Tambon;
    tambonId?: string;
    postalCode?: string;
    addressEn?: AddressEn;
    email?: string;
    tel?: string;
    fullAddressTh?: string;
    fullAddressEn?: string;
    registerSeq?: number;
    ownerGroup?: OwnerGroup;
    migrateFlag?: boolean;
    fullAddressEn2?: string;
}

export interface CompanyBranch {
    id?: number;
    branch?: string;
    branchName?: string;
}

export interface CompanyLite extends OwnerIdentity {
    id?: number;
    companyType?: CompanyType;
    companyTypeId?: number;
    otherCompanyType?: string;
    nameTh?: string;
    nameEn?: string;
    taxId?: string;
    branch?: string;
    branchDescription?: string;
    corporateNumber?: string;
    dateOfRegistration?: any;
    registeredCapital?: number;
    address?: string;
    addressEn?: AddressEnLite;
    fullAddressTh?: string;
    fullAddressEn?: string;
    email?: string;
    tel?: string;
    registerSeq?: number;
    ownerGroup?: OwnerGroup;
}

export interface CompanyType {
    id?: number;
    name?: string;
}

export interface ConcreteFeedType {
    id?: number;
    name?: string;
    nameEn?: string;
}

export interface ContactAddress {
    contactAddress?: string;
    contactMoo?: string;
    contactSoi?: string;
    contactStreet?: string;
    contactPostalCode?: string;
    contactTel?: string;
    contactTambon?: Tambon;
    contactTambonId?: string;
    fullAddress?: string;
}

export interface ContactAddressLite {
    contactAddress?: string;
    contactMoo?: string;
    contactSoi?: string;
    contactStreet?: string;
    contactPostalCode?: string;
    contactTel?: string;
    contactTambon?: Tambon;
    contactTambonId?: string;
    fullAddress?: string;
}

export interface CorrectionItem extends AbstractAuditingEntity {
    id?: number;
    headerText?: string;
    comment?: string;
}

export interface CorrectionItemRepo extends JpaRepository<CorrectionItem, number> {
}

export interface CorrectionRequestType {
    id?: number;
    name?: string;
    correctionRequestGroup?: CorrectionRequestGroup;
}

export interface Country {
    id?: number;
    nameTh?: string;
    nameEn?: string;
    shortNameEn?: string;
    commonName?: string;
    countryCode?: string;
    joinCountryGroup?: string;
    remark?: string;
    officialNameTh?: string;
    officialNameEn?: string;
}

export interface Currency {
    currencyCode?: string;
    countryName?: string;
    currencyName?: string;
    currencyFullName?: string;
}

export interface CustomsOrg {
    id?: number;
    code?: string;
    name?: string;
    portId?: string;
    transMode?: TransMode;
    transModeCode?: string;
    provinceId?: string;
    province?: Province;
    dischargePort?: boolean;
    loadPort?: boolean;
    show?: boolean;
}

export interface Delegate {
    id?: DelegatePk;
    ownerGroupId?: string;
    no?: string;
    modules?: Modules;
    delegateUserId?: number;
    delegateUser?: User;
}

export interface Division {
    id?: number;
    name?: string;
}

export interface DofOrg {
    id?: string;
    name?: string;
    provinceId?: string;
    province?: Province;
    dofOrgType?: DofOrgType;
}

export interface DofPort {
    id?: string;
    name?: string;
    orgId?: string;
    dofOrg?: DofOrg;
    fullAddress?: string;
    tambon?: Tambon;
    postalCode?: string;
    email?: string;
    tel?: string;
    fax?: string;
    customsOrgList?: CustomsOrg[];
}

export interface DraftCollection extends AbstractAuditingEntity, FormDraft {
    profile?: string;
    collectionName?: string;
    systemName?: string;
    formData?: ObjectNode;
    draftFormId?: string;
    draftFormName?: string;
    draftState?: string;
    draftUser?: string;
    draftMarkAsDelete?: boolean;
}

export interface DummyEnver {
    id?: number;
    name?: string;
}

export interface Employee extends AbstractAuditingEntity {
    id?: number;
    title?: Title;
    firstNameTh?: string;
    lastNameTh?: string;
    birthDate?: any;
    nation?: Nation;
    identityCard?: IdentityCard;
    contactAddress?: ContactAddress;
    files?: { [P in EmployeeFileType]?: EmployeeFile };
    ownerGroup?: OwnerGroup;
    enable?: boolean;
    usersPermission?: UsersPermission;
    fullNameTh?: string;
}

export interface EmployeeFile extends FileUpload {
    fileType?: EmployeeFileType;
}

export interface Entrepreneur extends AbstractEntrepreneur {
    id?: number;
    files?: { [P in EntrepreneurFileType]?: EntrepreneurFile };
    enable?: boolean;
    usersPermission?: UsersPermission;
}

export interface EntrepreneurFile extends FileUpload {
    fileType?: EntrepreneurFileType;
}

export interface EquipmentList extends IEquipmentList {
}

export interface FeeRate {
    id?: string;
    name?: string;
    fee?: number;
    unit?: string;
    volume?: string;
    module?: Modules;
}

export interface FeeRateCompCode {
    id?: FeeRateCompCodeId;
    module?: Modules;
    feeRateId?: string;
    feeRate?: FeeRate;
    code?: string;
    compCode?: CompCode;
    incomeCode?: string;
}

export interface FeedHowTo {
    id?: string;
    useCase?: string;
    desc?: string;
}

export interface FeedProperties {
    id?: string;
    desc?: string;
}

export interface FeedPurpose {
    id?: string;
    name?: string;
}

export interface FeedWarning {
    id?: string;
    desc?: string;
}

export interface FileUpload extends AbstractAuditingEntity, IFileUpload<any> {
    dtype?: FileUploadType;
    fileType?: Enum<any>;
}

export interface FilingLocation {
    writeAt?: string;
}

export interface FormDraft {
    draftId?: string;
}

export interface IEquipmentList {
    model?: string;
    remark?: string;
    seq?: string;
    rec?: string;
    createBy?: string;
    housePower?: string;
    efficient?: string;
    quantity?: string;
    work?: string;
}

export interface IFileUpload<T> {
    id?: number;
    state?: State;
    size?: number;
    ref?: string;
    fileName?: string;
    event?: Event;
    expireDate?: any;
    createdDate?: any;
    lastUpdatedDate?: any;
    effectiveDate?: any;
    fileType?: Enum<T>;
    filePath?: string;
    originalFileName?: string;
    upload?: boolean;
    updateDate?: any;
    contentType?: string;
}

export interface IUserOwner {
    user?: ApplicantProjection;
    userId?: number;
}

export interface IUserWithAuthority {
    authorities?: Authority[];
    actionDirectorFlag?: boolean;
    provinceOfficer?: boolean;
}

export interface IdentityCard {
    cardType?: CardType;
    cardNumber?: string;
    issueAmphur?: Amphur;
    issueAmphurId?: string;
    issueDate?: any;
    expireDate?: any;
    cardAddress?: string;
    cardMoo?: string;
    cardSoi?: string;
    cardStreet?: string;
    cardPostalCode?: string;
    cardTel?: string;
    cardTambon?: Tambon;
    fullAddressTh?: string;
    noneExpire?: boolean;
}

export interface IdentityCardLite {
    cardType?: CardType;
    cardNumber?: string;
    cardTel?: string;
    fullAddress?: string;
}

export interface InformationProperty {
    id?: number;
    ownerGroupId?: string;
    no?: string;
    modules?: Modules;
    description?: string;
}

export interface Ingredient {
    id?: number;
    name?: string;
}

export interface Inspector extends AbstractAuditingEntity {
    id?: number;
    fname?: string;
    lname?: string;
    position?: string;
    address?: string;
}

export interface InviteUserAuthority {
    id?: InviteUserAuthorityId;
    uuid?: string;
    authority?: string;
}

export interface InviteUserAuthorityId {
    uuid?: string;
    authority?: string;
}

export interface License {
    id?: LicensePk;
    licenseId?: number;
    module?: Modules;
    issue?: string;
    book?: string;
    no?: string;
    licenseFor?: string;
    branch?: string;
    branchName?: string;
    licenseForEn?: string;
    scope?: string;
    scopeEn?: string;
    issueDate?: any;
    expireDate?: any;
    effectiveDate?: any;
    department?: Department;
    subType?: LicenseSubType;
    location?: Location;
    warehouses?: Location[];
    status?: LicenseStatus;
    requestInspectionRequest?: RequestInspectionRequest;
    type?: string;
    audit?: Audit;
    ns4?: Ns4;
    certificate?: Certificate;
    voucher?: Voucher;
    moduleName?: string;
}

export interface LicensingBook extends AbstractAuditingEntity {
    id?: LicenseType;
    bookNo?: number;
}

export interface LicensingIssue extends AbstractAuditingEntity {
    id?: LicenseType;
    years?: number;
    currentNo?: number;
}

export interface LicensingIssueProvince extends AbstractAuditingEntity {
    id?: LicensingIssueProvinceId;
    currentNo?: number;
    licenseType?: LicenseType;
    provinceId?: string;
    years?: number;
}

export interface LicensingIssueProvinceId {
    licenseType?: LicenseType;
    provinceId?: string;
    years?: number;
}

export interface LicensingWithItems<T> {
    licensingItems?: T[];
}

export interface Location extends AbstractAuditingEntity, Address {
    id?: number;
    placeName?: string;
    country?: Country;
    tel?: string;
    email?: string;
    addressEn?: AddressEn;
    fullAddressEn?: string;
    fullAddressTh?: string;
    fullGmpHaccpAddressEn?: string;
}

export interface MaterialGroup {
    id?: string;
    name?: string;
    materialTypes?: MaterialType[];
    otherType?: boolean;
}

export interface MaterialType {
    id?: string;
    name?: string;
    nameEn?: string;
    unit?: string;
    shrimpMinimumQuantity?: number;
    shrimpMaximumQuantity?: number;
    fishMinimumQuantity?: number;
    fishMaximumQuantity?: number;
}

export interface MeetingParticipant extends AbstractAuditingEntity {
    id?: number;
    participantTitle?: Title;
    participantFname?: string;
    participantLname?: string;
    participantContact?: string;
    participantPosition?: string;
}

export interface MixIngredient {
    id?: string;
    name?: string;
}

export interface MixIngredientSubType {
    id?: string;
    name?: string;
    mixIngredientSubTypeNames?: MixIngredientSubTypeName[];
}

export interface MixIngredientSubTypeName {
    id?: string;
    name?: string;
}

export interface MixIngredientType {
    id?: string;
    name?: string;
    mixIngredientSubTypeList?: MixIngredientSubType[];
}

export interface Nation {
    id?: number;
    name?: string;
    natCode?: string;
}

export interface Officer extends AbstractAuditingEntity, OwnerIdentity, IUserWithAuthority {
    id?: number;
    personType?: PersonType;
    username?: string;
    fullNameTh?: string;
    fullNameEn?: string;
    email?: string;
    identityCard?: IdentityCardLite;
    addressEn?: AddressEnLite;
    contactAddress?: ContactAddressLite;
    ownerGroup?: OwnerGroup;
    performType?: PerformType;
    enable?: boolean;
    applicantName?: string;
    dofPort?: DofPort;
    dofOrg?: DofOrg;
    position?: Position;
    division?: Division;
    age?: number;
}

export interface OfficerAssign extends AbstractAuditingEntity, OwnerIdentity {
    id?: number;
    personType?: PersonType;
    username?: string;
    firstNameTh?: string;
    lastNameTh?: string;
    firstNameEn?: string;
    lastNameEn?: string;
    authorities?: UserAuthority[];
}

export interface OfficerComment {
    id?: OfficerCommentPk;
    comment?: string;
}

export interface OwnerGroup extends AbstractAuditingEntity {
    id?: string;
}

export interface OwnerIdentity {
    ownerIdentity?: string;
}

export interface PackageType {
    id?: string;
    name?: string;
}

export interface PackageUnit {
    id?: string;
    name?: string;
    nameTH?: string;
    nameEN?: string;
    isoCode?: string;
    symbol?: string;
    remake?: string;
}

export interface PetitionNo extends AbstractAuditingEntity {
    id?: number;
    currentNo?: number;
    version?: number;
}

export interface Port {
    id?: number;
    name?: string;
    iso31161?: string;
    countryName?: string;
    locode?: string;
    nameWoDiacritics?: string;
    subDiv?: string;
    function?: string;
    status?: string;
    date?: string;
    coordinates?: string;
    remark?: string;
}

export interface Position {
    id?: number;
    name?: string;
    nameEn?: string;
}

export interface ProductType {
    id?: number;
    name?: string;
}

export interface Province {
    id?: string;
    name?: string;
    nameAbbr?: string;
    nameEn?: string;
    zone?: Zone;
    ports?: Port[];
}

export interface PurposeNo extends AbstractAuditingEntity {
    id?: number;
    currentNo?: number;
    version?: number;
}

export interface RequestAgent extends AbstractAuditingEntity {
    uuid?: string;
    email?: string;
    authorities?: Authority[];
    expiredDate?: any;
    status?: RequestAgentStatus;
    requestAgentType?: RequestAgentType;
    refId?: string;
}

export interface RequestAttorney extends AbstractAuditingEntity {
    id?: number;
    title?: Title;
    firstNameTh?: string;
    lastNameTh?: string;
    birthDate?: any;
    nation?: Nation;
    identityCard?: IdentityCard;
    contactAddress?: ContactAddress;
    requestAgent?: RequestAgent;
    attorneyRequestUserId?: number;
    refId?: number;
    fullNameTh?: string;
}

export interface RequestCompany {
    id?: number;
    companyType?: CompanyType;
    companyTypeId?: number;
    otherCompanyType?: string;
    nameTh?: string;
    nameEn?: string;
    taxId?: string;
    branch?: string;
    companyBranch?: CompanyBranch;
    branchDescription?: string;
    corporateNumber?: string;
    foundationNumber?: string;
    dateOfRegistration?: any;
    registeredCapital?: number;
    address?: string;
    moo?: string;
    soi?: string;
    street?: string;
    tambon?: Tambon;
    tambonId?: string;
    postalCode?: string;
    addressEn?: AddressEn;
    email?: string;
    tel?: string;
    fullAddressTh?: string;
    fullAddressEn?: string;
    registerSeq?: number;
    refId?: number;
}

export interface RequestCorrectUserValidateGroupSelector extends ValidateGroupSelector<RequestUser> {
}

export interface RequestCorrectionItem extends AbstractAuditingEntity {
    id?: number;
    headerText?: string;
    title?: string;
    comment?: string;
}

export interface RequestEmployee extends AbstractAuditingEntity {
    id?: number;
    title?: Title;
    firstNameTh?: string;
    lastNameTh?: string;
    birthDate?: any;
    nation?: Nation;
    identityCard?: IdentityCard;
    contactAddress?: ContactAddress;
    requestAgent?: RequestAgent;
    files?: { [P in RequestEmployeeFileType]?: RequestEmployeeFile };
    employeeRequestUserId?: number;
    refAttorneyId?: number;
    refId?: number;
    fullNameTh?: string;
}

export interface RequestEmployeeFile extends FileUpload {
    fileType?: RequestEmployeeFileType;
}

export interface RequestEntrepreneur extends AbstractAuditingEntity {
    id?: number;
    title?: Title;
    firstNameTh?: string;
    lastNameTh?: string;
    firstNameEn?: string;
    lastNameEn?: string;
    birthDate?: any;
    nation?: Nation;
    identityCard?: IdentityCard;
    contactAddress?: ContactAddress;
    requestAgent?: RequestAgent;
    files?: { [P in RequestEntrepreneurFileType]?: RequestEntrepreneurFile };
    entrepreneurRequestUserId?: number;
    refId?: number;
    fullNameTh?: string;
}

export interface RequestEntrepreneurFile extends FileUpload {
    fileType?: RequestEntrepreneurFileType;
}

export interface RequestGmpHaccp extends AbstractAuditingEntity {
    id?: number;
    gmpHaccpType?: GmpHaccpType;
    issuer?: Officer;
    issuerName?: string;
    issuerPosition?: string;
    issuerNameEn?: string;
    issuerPositionEn?: string;
    issueDate?: any;
    expireDate?: any;
    effectiveDate?: any;
    scopeTypeTh?: string;
    scopeTypeEn?: string;
    gmpHaccpNo?: string;
    user?: Applicant;
    staff?: RequestGmpHaccpStaff;
    countries?: Country[];
    factoryLicense?: string;
    factoryLicenseFile?: FileUpload;
    correctionRequests?: RequestGmpHaccpCorrectionRequest[];
    scopeOfCertifications?: RequestGmpHaccpScopeOfCertification[];
    requestVouchers?: RequestGmpHaccpFormRequestVoucher[];
    ownerGroup?: OwnerGroup;
    department?: Department;
    gmpDepartmentForHaccp?: Department;
    gmpNoForHaccp?: string;
    vnc?: string;
    licensing?: GmpHaccpRequestLicensing;
    entrepreneurs?: RequestGmpHaccpEntrepreneur[];
    location?: Location;
    files?: { [P in GmpHaccpFileType]?: GmpHaccpFile };
}

export interface RequestGmpHaccpCorrectionRequest extends AbstractAuditingEntity {
    id?: number;
    gmpHaccpCorrectionRequestType?: GmpHaccpCorrectionRequestType;
    otherRemark?: string;
    gmpHaccp?: RequestGmpHaccp;
}

export interface RequestGmpHaccpEntrepreneur extends AbstractEntrepreneur {
    id?: number;
}

export interface RequestGmpHaccpFormRequestVoucher {
    id?: RequestGmpHaccpFormRequestVoucherId;
    requestVoucher?: RequestVoucher;
    licensingItem?: GmpHaccpRequestLicensingItem;
}

export interface RequestGmpHaccpFormRequestVoucherId {
    requestGmpHaccpId?: number;
    voucherId?: number;
}

export interface RequestGmpHaccpScopeAnimal {
    id?: number;
    requestGmpHaccpScopeOfCertification?: RequestGmpHaccpScopeOfCertification;
    animalHowToScope?: AnimalHowTo;
    typeHowToScopes?: ConcreteFeedType[];
}

export interface RequestGmpHaccpScopeOfCertification {
    id?: number;
    gmpHaccp?: RequestGmpHaccp;
    animalFeedType?: AnimalFeedType;
    scopeAnimalHowTos?: RequestGmpHaccpScopeAnimal[];
    licensingItem?: LicensingItem;
}

export interface RequestGmpHaccpStaff extends AbstractAuditingEntity {
    id?: number;
    staffAll?: number;
    staffAdmin?: number;
    staffGmp?: number;
    title?: Title;
    fName?: string;
    lName?: string;
    position?: string;
    tel?: string;
    fax?: string;
}

export interface RequestLicensing<T> extends AbstractLicensing<T> {
    id?: number;
    licensingCompany?: RequestLicensingCompany;
}

export interface RequestLicensingCompany {
    id?: number;
    corporateNumber?: string;
    foundationNumber?: string;
    companyType?: CompanyType;
    companyTypeId?: number;
    otherCompanyType?: string;
    nameTh?: string;
    taxId?: string;
    branch?: string;
    branchDescription?: string;
    dateOfRegistration?: any;
    registeredCapital?: number;
    address?: string;
    moo?: string;
    soi?: string;
    street?: string;
    addressEn?: AddressEn;
    tambon?: Tambon;
    tambonId?: string;
    postalCode?: string;
    email?: string;
    tel?: string;
    fullAddressTh?: string;
    fullAddressEn?: string;
    registerSeq?: number;
}

export interface RequestLicensingItem extends AbstractLicensingItem {
    id?: number;
}

export interface RequestNo extends AbstractAuditingEntity {
    id?: DocumentType;
    years?: number;
    currentNo?: number;
}

export interface RequestRegisterForm extends AbstractAuditingEntity {
    id?: number;
    user?: User;
    requestUser?: RequestUser;
    registerType?: RequestRegisterType;
    status?: RequestRegisterStatus;
    approvedDate?: any;
    requestNo?: string;
    filingDate?: any;
    approvedOfficer?: User;
    approvedOfficerName?: string;
    approvedOfficerPosition?: string;
    approvedOfficerComment?: string;
    requestCorrection?: string;
}

export interface RequestRegisterNo extends AbstractAuditingEntity {
    id?: number;
    currentNo?: number;
}

export interface RequestShipping extends AbstractAuditingEntity {
    id?: number;
    personType?: PersonType;
    title?: Title;
    firstNameTh?: string;
    lastNameTh?: string;
    firstNameEn?: string;
    lastNameEn?: string;
    birthDate?: any;
    identityCard?: IdentityCard;
    contactAddress?: ContactAddress;
    nation?: Nation;
    requestShippingCompany?: RequestShippingCompany;
    refId?: number;
    fullNameTh?: string;
}

export interface RequestShippingCompany extends AbstractAuditingEntity {
    id?: number;
    companyType?: CompanyType;
    nameTh?: string;
    nameEn?: string;
    taxId?: string;
    branch?: string;
    companyBranch?: CompanyBranch;
    branchDescription?: string;
    corporateNumber?: string;
    foundationNumber?: string;
    dateOfRegistration?: any;
    registeredCapital?: number;
    address?: string;
    moo?: string;
    soi?: string;
    street?: string;
    tambon?: Tambon;
    postalCode?: string;
    email?: string;
    tel?: string;
    refId?: number;
}

export interface RequestUser extends AbstractAuditingEntity, OwnerIdentity {
    id?: number;
    personType?: PersonType;
    username?: string;
    password?: string;
    email?: string;
    title?: Title;
    titleId?: number;
    firstNameTh?: string;
    lastNameTh?: string;
    firstNameEn?: string;
    lastNameEn?: string;
    birthDate?: any;
    resetPasswordToken?: string;
    resetPasswordTokenExpired?: any;
    changeEmailToken?: string;
    changeEmailTemp?: string;
    nation?: Nation;
    nationId?: number;
    identityCard?: IdentityCard;
    addressEn?: AddressEn;
    contactAddress?: ContactAddress;
    company?: RequestCompany;
    authorities?: Authority[];
    files?: { [P in RequestUserFileType]?: RequestUserFile };
    performType?: PerformType;
    entrepreneurs?: RequestEntrepreneur[];
    attorneys?: RequestAttorney[];
    shippings?: RequestShipping[];
    employees?: RequestEmployee[];
    agents?: RequestAgent[];
    refId?: number;
    fullNameTh?: string;
    attorneyFileEffectiveDate?: any;
    attorneyFileExpireDate?: any;
}

export interface RequestUserFile extends FileUpload {
    fileType?: RequestUserFileType;
}

export interface ScopeOfCertification {
    id?: number;
    scopeTh?: string;
    scopeEn?: string;
}

export interface Shipping extends AbstractAuditingEntity {
    id?: number;
    personType?: PersonType;
    title?: Title;
    firstNameTh?: string;
    lastNameTh?: string;
    firstNameEn?: string;
    lastNameEn?: string;
    birthDate?: any;
    identityCard?: IdentityCard;
    contactAddress?: ContactAddress;
    nation?: Nation;
    shippingCompany?: ShippingCompany;
    shippingEffectiveDate?: any;
    shippingExpireDate?: any;
    sendNotifyExpireDate?: boolean;
    ownerGroup?: OwnerGroup;
    canRenew?: boolean;
    fullNameTh?: string;
}

export interface ShippingCompany extends AbstractAuditingEntity {
    id?: number;
    companyType?: CompanyType;
    nameTh?: string;
    nameEn?: string;
    taxId?: string;
    branch?: string;
    companyBranch?: CompanyBranch;
    branchDescription?: string;
    corporateNumber?: string;
    foundationNumber?: string;
    dateOfRegistration?: any;
    registeredCapital?: number;
    address?: string;
    moo?: string;
    soi?: string;
    street?: string;
    tambon?: Tambon;
    postalCode?: string;
    email?: string;
    tel?: string;
}

export interface SignableForm {
    p12password?: string;
    document?: FileUpload;
}

export interface SiteInspectionInspector extends AbstractAuditingEntity {
    id?: number;
    fname?: string;
    lname?: string;
    position?: string;
    address?: string;
}

export interface Statistic {
    id?: StatisticId;
    module?: Modules;
    number?: number;
    month?: number;
    year?: number;
}

export interface Tambon {
    id?: string;
    name?: string;
    nameEn?: string;
    postalCode?: string;
    amphur?: Amphur;
    fullAddress?: string;
    fullAddressTh?: string;
}

export interface Title {
    id?: number;
    nameTh?: string;
    nameEn?: string;
}

export interface TransMode {
    transModeCode?: string;
    transModeCodeTxt?: string;
}

export interface TransportType {
    id?: string;
    name?: string;
    group?: number;
}

export interface Unit {
    id?: string;
    nameTh?: string;
    nameEn?: string;
    unitCode?: string;
    livestockUnitCode?: string;
    remark?: string;
    citesunitCode?: string;
}

export interface User extends AbstractAuditingEntity, OwnerIdentity, IUserWithAuthority, UserDetails {
    id?: number;
    personType?: PersonType;
    email?: string;
    title?: Title;
    titleId?: number;
    firstNameTh?: string;
    lastNameTh?: string;
    firstNameEn?: string;
    lastNameEn?: string;
    fullNameTh?: string;
    fullNameEn?: string;
    birthDate?: any;
    resetPasswordToken?: string;
    resetPasswordTokenExpired?: any;
    changeEmailToken?: string;
    changeEmailTokenExpired?: any;
    changeEmailTemp?: string;
    nation?: Nation;
    nationId?: number;
    identityCard?: IdentityCard;
    addressEn?: AddressEn;
    contactAddress?: ContactAddress;
    company?: Company;
    authorities?: Authority[];
    files?: { [P in UserFileType]?: UserFile };
    ownerGroup?: OwnerGroup;
    performType?: PerformType;
    enable?: boolean;
    applicantName?: string;
    dofPort?: DofPort;
    dofOrg?: DofOrg;
    position?: Position;
    division?: Division;
    registerEffectiveDate?: any;
    registerExpireDate?: any;
    age?: number;
}

export interface UserAuthority extends AbstractAuditingEntity {
    id?: UserAuthorityPk;
}

export interface UserFile extends FileUpload {
    fileType?: UserFileType;
}

export interface VAttorney {
    id?: number;
    fullNameTh?: string;
    companyNameTh?: string;
    cardNumber?: string;
    contactFullAddress?: string;
    contactTel?: string;
    entrepreneurName?: string;
    email?: string;
    effectiveDate?: any;
    expireDate?: any;
}

export interface VShipping {
    id?: number;
    fullNameTh?: string;
    companyNameTh?: string;
    shippingCompanyNameTh?: string;
    cardNumber?: string;
    personType?: PersonType;
    effectiveDate?: any;
    expireDate?: any;
    expireInDays?: number;
}

export interface VUser {
    id?: number;
    personType?: PersonType;
    userType?: UserType;
    username?: string;
    applicantName?: string;
    fullNameTh?: string;
    companyNameTh?: string;
    companyFullAddressTh?: string;
    corporateNumber?: string;
    foundationNumber?: string;
    taxId?: string;
    branch?: string;
    branchName?: string;
    fullAddressTh?: string;
    tel?: string;
    position?: Position;
    positionId?: number;
    positionName?: string;
    approvedDate?: any;
    contactTel?: string;
    email?: string;
}

export interface Zone {
    code?: string;
    name?: string;
}

export interface AuditAnimalFeedTypeConfig {
    id?: AnimalFeedTypeId;
    animalFeedType?: AnimalFeedType;
}

export interface CertificateAnimalFeedTypeConfig {
    id?: AnimalFeedTypeId;
    animalFeedType?: AnimalFeedType;
}

export interface GmpHaccpAnimalFeedGroupConfig {
    id?: AnimalFeedGroupId;
    animalFeedGroup?: AnimalFeedGroup;
}

export interface GmpHaccpAnimalFeedTypeConfig {
    id?: AnimalFeedTypeId;
    animalFeedType?: AnimalFeedType;
}

export interface IngredientUnitConfig {
    id?: string;
    ingredientUnit?: Unit;
}

export interface LicensingAnimalFeedGroupConfig {
    id?: AnimalFeedGroupId;
    animalFeedGroup?: AnimalFeedGroup;
}

export interface LicensingAnimalFeedTypeConfig {
    id?: AnimalFeedTypeId;
    animalFeedType?: AnimalFeedType;
}

export interface LicensingAnimalTypeConfig {
    id?: string;
    animalType?: AnimalType;
    seq?: number;
}

export interface LicensingReportBackwardAnimalTypeConfig {
    id?: string;
    animalType?: AnimalType;
    seq?: number;
}

export interface PackageUnitCertiNs4Config {
    id?: string;
    packageUnit?: PackageUnit;
}

export interface PackageUnitConfig {
    id?: string;
    packageUnit?: Unit;
}

export interface PackageUnitProductConfig {
    id?: string;
    packageUnit?: Unit;
}

export interface RequestInspectionFeedTypeConfig {
    id?: AnimalFeedTypeId;
    animalFeedType?: AnimalFeedType;
}

export interface UnitCertiNs4Config {
    id?: string;
    unit?: Unit;
}

export interface VoucherAnimalFeedTypeConfig {
    id?: AnimalFeedTypeId;
    animalFeedType?: AnimalFeedType;
}

export interface VoucherAnimalTypeConfig {
    id?: string;
    animalType?: AnimalType;
    seq?: number;
}

export interface StatisticId {
    module?: Modules;
    month?: number;
    year?: number;
}

export interface AssignAuthoritiesPk {
    assigner?: OfficerAssign;
    assignTo?: OfficerAssign;
}

export interface DelegatePk {
    ownerGroupId?: string;
    no?: string;
    modules?: Modules;
    delegateUserId?: number;
}

export interface FeeRateCompCodeId {
    module?: Modules;
    feeRateId?: string;
    compCode?: string;
}

export interface LicensePk {
    licenseId?: number;
    module?: Modules;
}

export interface OfficerCommentPk {
    formType?: FormType;
    noAppointment?: boolean;
    filingOffice?: FilingOffice;
}

export interface UserAuthorityPk {
    authority?: AuthorityType;
}

export interface ConfirmAppointmentDto {
    id?: number;
    status?: AppointmentStatus;
}

export interface ConfirmChangeEmail {
    token?: string;
}

export interface DocumentParam {
    data?: SignableForm;
    beanCollectionClass?: string;
    reportPath?: string;
    documentName?: string;
}

export interface FileUploadDto extends IFileUpload<any> {
    fileType?: Enum<any>;
}

export interface FileUploadPatcher {
    id?: number;
    ref?: string;
    newFile?: FileUploadDto;
}

export interface FileUploadRequestDto {
    file?: MultipartFile;
}

export interface FileUploadWithEquipmentList {
    file?: FileUploadDto;
    equipments?: EquipmentList[];
}

export interface GetInviteUser {
    uuid?: string;
}

export interface ImportCertificateDto {
    dtoList?: LicensingImportDto[];
}

export interface ImportLicensingRequest {
    file?: MultipartFile;
    licenseType?: LicenseType;
    department?: Department;
    filingOffice?: FilingOffice;
}

export interface LicenseSearchRequest {
    module?: Modules;
    book?: string;
    issue?: string;
    licenseFor?: string;
    no?: string;
    province?: string;
    brandTh?: string;
    brandEn?: string;
    country?: Country;
    issueDate?: any;
    objective?: string;
    userFor?: string;
}

export interface LicensingSearch {
    id?: number;
    licenseType?: LicenseType;
    licensingIssue?: string;
    department?: Department;
    ownerGroup?: string;
}

export interface LoginRequest {
    username?: string;
    password?: string;
}

export interface PaymentFileUploadRequestDto {
    file?: MultipartFile;
}

export interface ReportCondition {
    reportPath?: string;
    reportName?: string;
    reportTitle?: string;
    reportType?: string;
    fileType?: string;
    attachment?: boolean;
    budgetYearStart?: number;
    budgetYearEnd?: number;
    year?: number;
    page?: number;
    pdfa3?: boolean;
    className?: string;
    formData?: any;
    mergePdf?: FileUpload;
    mergePdfName?: string;
    mergePdfName2?: string;
    mergePdfName3?: string;
    mergePdfName4?: string;
    mergePdfName5?: string;
    mergePdfName6?: string;
    mergePdfName7?: string;
    mergePdfVoucher1?: FileUpload;
    mergePdfNameVoucher1?: string;
    mergePdfVoucher2?: FileUpload;
    mergePdfVoucherCorrection?: FileUpload;
    mergePdfVoucherLabel?: FileUpload;
    mergePdfNameVoucher2?: string;
    mergePdfNameVoucherFormP4?: string;
    mergePdfNameVoucherSubstitute?: string;
    yearThai?: number;
    startIssueDate?: string;
    endIssueDate?: string;
    brandEn?: string;
    voucherFor?: string;
    licenseFor?: string;
    usedFor?: string;
    label?: string;
    labelVoucher?: string;
    howto?: string;
    resultAmount?: string;
    instructionAmount?: string;
    packageTypeId?: string;
    packageUnitId?: string;
    countryId?: number;
    animalAgeId?: number;
    concreteFeedId?: number;
    createdDateFrom?: any;
    createdDateTo?: any;
    durationMonth?: number;
    qualityProtein?: number;
    qualityFat?: number;
    qualityFiber?: number;
    qualityMoisture?: number;
    packageNetWeight?: number;
    licenseStatus?: LicenseStatus;
    licenseType?: LicenseType;
    gmphaccpNo?: string;
    placeName?: string;
    corporateNumber?: string;
    provinceId?: string;
    maxSumProductionEfficiency?: number;
    minSumProductionEfficiency?: number;
    animalFeedTypeName?: string;
    fileId?: number;
    voucherNo?: string;
    animalFeedTypeId?: string;
    mixIngredientSubTypeNameId?: string;
    brandTh?: string;
    animalTypes?: string[];
    animalSubTypes?: string[];
    summaryIngredientList?: string[];
    summaryLabelIngredientList?: string[];
    summaryLabelIngredientListCondition?: string;
    summaryIngredientListCondition?: string;
    userType?: UserType;
    userTypes?: string[];
    companyNameTh?: string;
    applicantName?: string;
    position?: Position;
    approvedDateFrom?: any;
    approvedDateTo?: any;
    authorityType?: AuthorityType;
    entrepreneurFullNameTh?: string;
    cardNumber?: string;
    attorneyFullNameTh?: string;
    employeeFullNameTh?: string;
    personType?: PersonType;
    filingOffice?: FilingOffice;
    province?: Province;
    taxId?: string;
    yearCalendar?: number;
    budgetYear?: number;
    certificateType?: CertificateType;
    invoiceNo?: string;
    yearFrom?: number;
    yearTo?: number;
    dateFrom?: any;
    dateTo?: any;
    buyerDestinationCountryId?: string;
    buyerDestinationCountry?: Country;
    startRequestInspectionIssueDate?: any;
    endRequestInspectionIssueDate?: any;
    issueDateFrom?: any;
    issueDateTo?: any;
    licensingBook?: string;
    licensingIssue?: string;
    licenseDepartment?: Department;
    locationProvinceId?: string;
    warehouseProvinceId?: string;
    animalFeedGroupId?: string;
    licenseSubType?: LicenseSubType;
    productionEfficiencyGreaterThanOrEqualTo?: number;
    productionEfficiencyLessThanOrEqualTo?: number;
    requestInspectIssueDateFrom?: any;
    requestInspectIssueDateTo?: any;
    productLocationProvinceId?: string;
    animalFeedActGroup?: AnimalFeedActGroup;
    voucherRequestNo?: string;
    receiptDateFrom?: string;
    receiptDateTo?: string;
    feedType?: string;
    animalFeedGroup?: AnimalFeedGroup;
    animalFeedType?: AnimalFeedType;
    ns4FeedType?: Ns4FeedType;
    showDocx?: boolean;
    officerProvinceId?: string;
    approveDateStart?: string;
    approveDateEnd?: string;
    companyName?: string;
    objectiveType?: string;
    meetingBookingId?: number;
    positionId?: number;
    currentDateTime?: string;
    animalTypesCondition?: string;
    animalSubTypesCondition?: string;
    userTypesAsStringArray?: string;
}

export interface RequestAgentDto {
    email?: string;
    password?: string;
    requestUser?: RequestUser;
    requestAgentType?: RequestAgentType;
    authorityTypes?: AuthorityType[];
}

export interface RequestChangeAgentType {
    userId?: number;
    agentType?: AuthorityType;
}

export interface RequestChangeEmail {
    currentPassword?: string;
    email?: string;
}

export interface RequestChangePassword {
    token?: string;
    currentPassword?: string;
    newPassword?: string;
    confirmNewPassword?: string;
}

export interface RequestForgotPassword {
    username?: string;
}

export interface RequestRegister {
    verifyCode?: string;
    password?: string;
    user?: RequestUser;
}

export interface RequestRegisterFormConsideration {
    approvedDate?: any;
    comment?: string;
    formId?: number;
}

export interface RequestRegisterFormSearchParam {
    filingDateFrom?: any;
    filingDateTo?: any;
    filingName?: string;
    companyName?: string;
    requestNo?: string;
    registerType?: RequestRegisterType;
    status?: RequestRegisterStatus;
}

export interface RequestRegisterInvite {
    uuid?: string;
    user?: RequestUser;
    username?: string;
    password?: string;
    confirmPassword?: string;
    requestAgentType?: RequestAgentType;
}

export interface RequestSendOriginalDocumentDto {
    userId?: number;
    petitionNo?: string;
    formType?: FormType;
    module?: Modules;
}

export interface RequestVerifyCode {
    email?: string;
    confirmEmail?: string;
    name?: string;
    username?: string;
    password?: string;
    confirmPassword?: string;
}

export interface ScopeOfCertificationSearchRequest {
    scopeName?: string;
}

export interface UserReportSearchParam extends ReportCondition {
}

export interface UserSearchRequest {
    firstNameOrLastName?: string;
    division?: Division;
    position?: Position;
    username?: string;
    personType?: PersonType;
    enableFlags?: boolean;
    email?: string;
    authority?: AuthorityType;
    authorities?: AuthorityType[];
    operatorName?: string;
    taxId?: string;
    requestNo?: string;
}

export interface UserStatistic {
    applicantUsers?: number;
    officerUsers?: number;
    totalUsers?: number;
}

export interface MessageSentDto {
    messageType?: string;
    conversationId?: string;
    refMessageId?: string;
    payload?: string;
}

export interface MessageSentBuilder {
}

export interface GmpHaccp extends AbstractAuditingEntity {
    id?: number;
    gmpHaccpType?: GmpHaccpType;
    issuer?: Officer;
    issuerName?: string;
    issuerPosition?: string;
    issuerNameEn?: string;
    issuerPositionEn?: string;
    issueDate?: any;
    expireDate?: any;
    effectiveDate?: any;
    entrepreneurs?: GmpHaccpEntrepreneur[];
    authorizedDirectors?: GmpHaccpAuthorizedDirector[];
    gmpHaccpItems?: GmpHaccpItem[];
    location?: Location;
    countries?: Country[];
    factoryLicense?: string;
    factoryLicenseFile?: FileUpload;
    ownerGroup?: OwnerGroup;
    licensing?: Licensing;
    gmp?: GmpHaccp;
    department?: Department;
    vnc?: string;
    gmpHaccpNo?: string;
    gmpHaccpNoPrefix?: string;
    gmpHaccpCurrentNo?: number;
    gmpHaccpForEn?: string;
    gmpHaccpForTh?: string;
    scopeTypeTh?: string;
    scopeTypeEn?: string;
    level?: GmpHaccpCertificateLevel;
    qMarkTh?: string;
    qMarkEn?: string;
    codexRemark?: string;
    qMarkFile?: FileUpload;
    remarkTh?: string;
    remarkEn?: string;
    gmpHaccpIssueType?: GmpHaccpIssueType;
    gmpHaccpTypeRenewal?: boolean;
    files?: { [P in GmpHaccpFileType]?: GmpHaccpFile };
    sendNotifyExpireDate?: boolean;
    notifyEmail?: string;
    notifyName?: string;
    manualFlag?: boolean;
    requestSubstituteReason?: RequestSubstituteReason;
    user?: User;
    gmpDepartmentForHaccp?: Department;
    gmpNoForHaccp?: string;
}

export interface GmpHaccpAuthorizedDirector extends AbstractAuthorizedDirector {
    id?: number;
}

export interface GmpHaccpConsideration extends AbstractAuditingEntity {
    id?: number;
    considerer?: Officer;
    considererName?: string;
    considererPosition?: string;
    considererComment?: string;
    approveStatus?: ApproveStatus;
    correctionItems?: GmpHaccpConsiderationCorrectionItem[];
}

export interface GmpHaccpConsiderationCorrectionItem extends CorrectionItem {
}

export interface GmpHaccpEntrepreneur extends AbstractEntrepreneur {
    id?: number;
}

export interface GmpHaccpEntrepreneurFile extends FileUpload {
}

export interface GmpHaccpFile extends FileUpload {
    fileType?: GmpHaccpFileType;
    other?: string;
}

export interface GmpHaccpForm extends AbstractAuditingEntity, FormDraft, SignableForm {
    id?: number;
    dtype?: FormType;
    filingOffice?: FilingOffice;
    dofOrg?: DofOrg;
    requestNo?: string;
    petitionNo?: string;
    filingDate?: any;
    receivedDate?: any;
    formStatus?: GmpHaccpFormStatus;
    noAppointment?: boolean;
    gmpHaccpConsideration?: GmpHaccpConsideration;
    payment?: Payment;
    gmp?: GmpHaccp;
    gmpHaccp?: GmpHaccp;
    filingLocation?: FilingLocation;
    user?: Applicant;
    gmpHaccpFormStaff?: GmpHaccpStaff;
    countries?: Country[];
    requestLicensing?: GmpHaccpRequestLicensing;
    gmpHaccpFormAuthorizedDirectors?: GmpHaccpAuthorizedDirector[];
    gmpHaccpFormEntrepreneurs?: GmpHaccpEntrepreneur[];
    gmpHaccpFormItems?: GmpHaccpFormItem[];
    inspection?: GmpHaccpFormCheckSiteInspection;
    followInspection?: GmpHaccpFormFollowInspection;
    requestType?: RequestType;
    gmpHaccpType?: GmpHaccpType;
    offerSignBy?: Officer;
    offerSignConsiderComment?: string;
    gmpHaccpOrder?: GmpHaccpOrder;
    scopeTypeTh?: string;
    scopeTypeEn?: string;
    level?: GmpHaccpCertificateLevel;
    qMarkTh?: string;
    qMarkEn?: string;
    qMarkFile?: FileUpload;
    codexRemark?: string;
    remarkTh?: string;
    remarkEn?: string;
    location?: Location;
    documents?: { [index: string]: GmpHaccpFormDocument };
    gmpHaccpTypeRenewal?: boolean;
    formName?: string;
}

export interface GmpHaccpForm1 extends GmpHaccpForm {
    files?: { [P in GmpHaccpForm1FileType]?: GmpHaccpForm1File };
    f1FactoryLicense?: string;
    f1FactoryLicenseFile?: FileUpload;
}

export interface GmpHaccpForm1File extends FileUpload {
    fileType?: GmpHaccpForm1FileType;
    other?: string;
}

export interface GmpHaccpForm2 extends GmpHaccpForm {
    f2Files?: { [P in GmpHaccpForm2FileType]?: GmpHaccpForm2File };
}

export interface GmpHaccpForm2File extends FileUpload {
    fileType?: GmpHaccpForm2FileType;
    other?: string;
}

export interface GmpHaccpForm3 extends GmpHaccpForm {
    f3Files?: { [P in GmpHaccpForm3FileType]?: GmpHaccpForm3File };
    correctionRequest?: GmpHaccpFormCorrectionRequest;
}

export interface GmpHaccpForm3File extends FileUpload {
    fileType?: GmpHaccpForm3FileType;
    other?: string;
}

export interface GmpHaccpForm4 extends GmpHaccpForm {
    f4Files?: { [P in GmpHaccpForm4FileType]?: GmpHaccpForm4File };
    requestSubstituteReason?: RequestSubstituteReason;
}

export interface GmpHaccpForm4File extends FileUpload {
    fileType?: GmpHaccpForm4FileType;
    other?: string;
}

export interface GmpHaccpForm5 extends GmpHaccpForm {
    f5Files?: { [P in GmpHaccpForm5FileType]?: GmpHaccpForm5File };
}

export interface GmpHaccpForm5File extends FileUpload {
    fileType?: GmpHaccpForm5FileType;
    other?: string;
}

export interface GmpHaccpForm6 extends GmpHaccpForm {
    f6Files?: { [P in GmpHaccpForm6FileType]?: GmpHaccpForm6File };
}

export interface GmpHaccpForm6File extends FileUpload {
    fileType?: GmpHaccpForm6FileType;
    other?: string;
}

export interface GmpHaccpForm7 extends GmpHaccpForm {
    f7Files?: { [P in GmpHaccpForm7FileType]?: GmpHaccpForm7File };
    correctionRequest?: GmpHaccpFormCorrectionRequest;
}

export interface GmpHaccpForm7File extends FileUpload {
    fileType?: GmpHaccpForm7FileType;
    other?: string;
}

export interface GmpHaccpForm8 extends GmpHaccpForm {
    requestSubstituteReason?: RequestSubstituteReason;
    f8Files?: { [P in GmpHaccpForm8FileType]?: GmpHaccpForm8File };
}

export interface GmpHaccpForm8File extends FileUpload {
    fileType?: GmpHaccpForm8FileType;
    other?: string;
}

export interface GmpHaccpFormAppointment extends AbstractAuditingEntity {
    id?: number;
    status?: AppointmentStatus;
    formStatus?: GmpHaccpFormStatus;
    appointmentDate?: GmpHaccpFormAppointmentDate;
    gmpHaccpForm?: GmpHaccpForm;
    placeName?: string;
    locationAddress?: string;
}

export interface GmpHaccpFormAppointmentDate extends AbstractAuditingEntity {
    id?: number;
    appointStartDate?: any;
    appointEndDate?: any;
}

export interface GmpHaccpFormCheckSiteInspection extends AbstractAuditingEntity {
    id?: number;
    users?: User[];
    inspectionCompositions?: { [index: string]: GmpHaccpFormCheckSiteInspectionComposition };
    checkSiteInspectionResult?: GmpHaccpCheckSiteInspectionResult;
    files?: { [P in GmpHaccpFormCheckSiteInspectionFileType]?: GmpHaccpFormCheckSiteInspectionFile };
    remark?: string;
    monitoringReportRemark?: string;
}

export interface GmpHaccpFormCheckSiteInspectionComposition extends AbstractAuditingEntity {
    id?: number;
    gmpHaccpCheckInspectionType?: GmpHaccpCheckInspectionType;
    observe?: boolean;
    key?: string;
    groupKey?: string;
    detected?: string;
}

export interface GmpHaccpFormCheckSiteInspectionFile extends FileUpload {
    fileType?: GmpHaccpFormCheckSiteInspectionFileType;
}

export interface GmpHaccpFormCorrectionRequest extends AbstractAuditingEntity {
    id?: number;
    correctScopeOfCertification?: boolean;
    correctLocation?: boolean;
    correctOthers?: boolean;
    other?: string;
}

export interface GmpHaccpFormDocument extends AbstractAuditingEntity {
    id?: number;
    checked?: boolean;
    key?: string;
}

export interface GmpHaccpFormFollowInspection extends AbstractAuditingEntity {
    id?: number;
    officer?: Officer;
    officerName?: string;
    officerPosition?: string;
    followStartDate1?: any;
    followEndDate1?: any;
    followStartDate2?: any;
    followEndDate2?: any;
    followInspectionStatus?: FollowInspectionStatus;
    files?: { [P in GmpHaccpFormFollowInspectionFileType]?: GmpHaccpFormFollowInspectionFile };
}

export interface GmpHaccpFormFollowInspectionFile extends FileUpload {
    fileType?: GmpHaccpFormFollowInspectionFileType;
}

export interface GmpHaccpFormItem {
    id?: number;
    animalFeedType?: AnimalFeedType;
    productionEfficiency?: number;
    feedPackage?: string;
    usedTogether?: boolean;
    remark?: string;
    scopeOfCertifications?: GmpHaccpFormScopeOfCertification[];
    vouchers?: GmpHaccpFormVoucher[];
    refId?: number;
}

export interface GmpHaccpFormRequestVoucher extends AbstractAuditingEntity {
    id?: GmpHaccpFormRequestVoucherId;
    requestVoucher?: RequestVoucher;
}

export interface GmpHaccpFormRequestVoucherId {
    requestLicensingItemId?: number;
    voucherId?: number;
}

export interface GmpHaccpFormScopeAnimal {
    id?: number;
    animalHowTo?: AnimalHowTo;
    concreteFeedTypes?: ConcreteFeedType[];
}

export interface GmpHaccpFormScopeOfCertification {
    id?: number;
    animalFeedType?: AnimalFeedType;
    scopeAnimalHowTos?: GmpHaccpFormScopeAnimal[];
    descriptionTh?: string;
    descriptionEn?: string;
}

export interface GmpHaccpFormVoucher extends AbstractAuditingEntity {
    id?: number;
    requestVoucher?: RequestVoucher;
    voucher?: Voucher;
}

export interface GmpHaccpItem extends AbstractLicensingItem {
    id?: number;
    scopeOfCertifications?: GmpHaccpScopeOfCertification[];
    vouchers?: GmpHaccpVoucher[];
    refId?: number;
}

export interface GmpHaccpMeetingBooking extends AbstractAuditingEntity {
    id?: number;
    confDate?: any;
    confTimeStart?: any;
    confTimeEnd?: any;
    confDateTimeStart?: any;
    confDateTimeEnd?: any;
    confSubject?: string;
    meetingStatus?: GmpHaccpMeetingStatus;
    meetingParticipants?: MeetingParticipant[];
    meetingForms?: GmpHaccpMeetingForm[];
    files?: { [P in GmpHaccpMeetingBookingFileType]?: GmpHaccpMeetingBookingFile };
}

export interface GmpHaccpMeetingBookingFile extends FileUpload {
    fileType?: GmpHaccpMeetingBookingFileType;
}

export interface GmpHaccpMeetingForm extends AbstractAuditingEntity, SignableForm {
    id?: number;
    gmpHaccpForm?: GmpHaccpForm;
    meetingFormRequestLicensingItems?: GmpHaccpMeetingFormRequestLicensingItem[];
}

export interface GmpHaccpMeetingFormRequestLicensingItem extends AbstractAuditingEntity {
    id?: number;
    animalFeedType?: AnimalFeedType;
    productionEfficiency?: number;
    usedTogether?: boolean;
    remark?: string;
    scopeOfCertifications?: GmpHaccpMeetingScopeOfCertification[];
    requestVouchers?: GmpHaccpMeetingRequestVoucher[];
    feedPackageTh?: string;
    feedPackageEn?: string;
}

export interface GmpHaccpMeetingRequestVoucher extends AbstractAuditingEntity {
    id?: number;
    requestVoucher?: RequestVoucher;
    voucher?: Voucher;
    animalFeedType?: AnimalFeedType;
    brand?: Brand;
    voucherNo?: string;
    voucherNoEn?: string;
    department?: Department;
}

export interface GmpHaccpMeetingScopeAnimal extends AbstractAuditingEntity {
    id?: number;
    animalHowTo?: AnimalHowTo;
    concreteFeedTypes?: ConcreteFeedType[];
}

export interface GmpHaccpMeetingScopeOfCertification extends AbstractAuditingEntity {
    id?: number;
    animalFeedType?: AnimalFeedType;
    scopeAnimalHowTos?: GmpHaccpMeetingScopeAnimal[];
    descriptionTh?: string;
    descriptionEn?: string;
}

export interface GmpHaccpNo extends AbstractAuditingEntity {
    id?: GmpHaccpType;
    systemNo?: string;
    currentNo?: number;
}

export interface GmpHaccpOrder extends AbstractAuditingEntity {
    id?: number;
    officer?: Officer;
    approve?: boolean;
    issueDate?: any;
    certificateFile?: FileUpload;
}

export interface GmpHaccpRequestLicensing extends RequestLicensing<GmpHaccpRequestLicensingItem> {
    licensingItems?: GmpHaccpRequestLicensingItem[];
    entrepreneurs?: LicensingEntrepreneur[];
    location?: Location;
}

export interface GmpHaccpRequestLicensingItem extends RequestLicensingItem {
    scopeOfCertifications?: GmpHaccpRequestScopeOfCertification[];
    requestVouchers?: GmpHaccpFormRequestVoucher[];
}

export interface GmpHaccpRequestScopeAnimal {
    id?: number;
    animalHowTo?: AnimalHowTo;
    concreteFeedTypes?: ConcreteFeedType[];
}

export interface GmpHaccpRequestScopeOfCertification {
    id?: number;
    animalFeedType?: AnimalFeedType;
    scopeAnimalHowTos?: GmpHaccpRequestScopeAnimal[];
    descriptionTh?: string;
    descriptionEn?: string;
}

export interface GmpHaccpScopeAnimal {
    id?: number;
    animalHowTo?: AnimalHowTo;
    concreteFeedTypes?: ConcreteFeedType[];
}

export interface GmpHaccpScopeOfCertification {
    id?: number;
    animalFeedType?: AnimalFeedType;
    scopeAnimalHowTos?: GmpHaccpScopeAnimal[];
    descriptionTh?: string;
    descriptionEn?: string;
}

export interface GmpHaccpStaff extends AbstractAuditingEntity {
    id?: number;
    staffAll?: number;
    staffAdmin?: number;
    staffGmp?: number;
    title?: Title;
    fName?: string;
    lName?: string;
    position?: string;
    tel?: string;
    fax?: string;
    fullNameTh?: string;
}

export interface GmpHaccpVoucher extends AbstractAuditingEntity {
    id?: number;
    voucher?: Voucher;
}

export interface GmpHaccpFormSearch {
    id?: number;
    dtype?: FormType;
    requestNo?: string;
    petitionNo?: string;
    filingDate?: any;
    receivedDate?: any;
    formStatus?: GmpHaccpFormStatus;
    userFullnameTh?: string;
    userApplicantName?: string;
    userId?: number;
    appointmentId?: number;
    inspectionId?: number;
    gmpHaccpType?: GmpHaccpType;
    followInspectionId?: number;
    followInspectionStatus?: FollowInspectionStatus;
    gmpHaccpNo?: string;
    paymentId?: number;
    formatedAmount?: string;
}

export interface GmpHaccpMeetingBookingSearch {
    id?: number;
    confDate?: any;
    confSubject?: string;
    meetingStatus?: GmpHaccpMeetingStatus;
}

export interface GmapHaccpCertificateFileRequest {
    gmpHaccpNo?: string;
    gmpHaccpType?: GmpHaccpType;
}

export interface GmpCertificateVoucherDto {
    animalFeedType?: AnimalFeedType;
    feedPackageTh?: string;
    feedPackageEn?: string;
    brand?: Brand;
    voucherNo?: string;
    voucherNoEn?: string;
}

export interface GmpHaccpConsiderationRequest<T> {
    formId?: number;
    receivedDate?: any;
    approveStatus?: ApproveStatus;
    comment?: string;
    correctionItems?: GmpHaccpConsiderationCorrectionItem[];
}

export interface GmpHaccpFormAppointmentConfirmRequest {
    id?: number;
    status?: AppointmentStatus;
}

export interface GmpHaccpFormAppointmentRequest {
    formId?: number;
    appointment?: GmpHaccpFormAppointment;
}

export interface GmpHaccpFormCheckSiteInspectionReportRequest {
    inspectionId?: number;
    formStatus?: GmpHaccpFormStatus;
    files?: { [P in GmpHaccpFormCheckSiteInspectionFileType]?: GmpHaccpFormCheckSiteInspectionFile };
}

export interface GmpHaccpFormCheckSiteInspectionRequest {
    formId?: number;
    formStatus?: GmpHaccpFormStatus;
    inspection?: GmpHaccpFormCheckSiteInspection;
    inspectionDate?: any;
}

export interface GmpHaccpFormFollowInspectionRequest {
    formId?: number;
    followInspection?: GmpHaccpFormFollowInspection;
}

export interface GmpHaccpFormSearchRequest {
    formStatus?: GmpHaccpFormStatus;
    requestNo?: string;
    purposeNo?: string;
    petitionNo?: string;
    filingDateFrom?: any;
    filingDateTo?: any;
    receivedDateFrom?: any;
    receivedDateTo?: any;
    appointmentDateStart?: any;
    appointmentDateEnd?: any;
    formType?: FormType;
    name?: string;
    gmpHaccpNo?: string;
}

export interface GmpHaccpImportDto {
    seq?: number;
    placeName?: string;
    branch?: string;
    corporateNumber?: string;
    entrepreneurPrefix?: string;
    entrepreneurFname?: string;
    entrepreneurLname?: string;
    entrepreneurPid?: string;
    entrepreneurCardNumber?: string;
    addressNo?: string;
    soi?: string;
    road?: string;
    moo?: string;
    tambonName?: string;
    amphurName?: string;
    provinceName?: string;
    postalCode?: string;
    scope?: string;
    gmpHaccpNo?: string;
    qMarkTh?: string;
    placeNameEn?: string;
    branchEn?: string;
    addressNoEn?: string;
    soiEn?: string;
    roadEn?: string;
    mooEn?: string;
    tambonNameEn?: string;
    amphurNameEn?: string;
    provinceNameEn?: string;
    postalCodeEn?: string;
    countryEn?: string;
    scopeEn?: string;
    gmpHaccpNoEn?: string;
    qMarkEn?: string;
    level?: GmpHaccpCertificateLevel;
    productionEfficiency?: number;
    effectiveDate?: any;
    expireDate?: any;
    licensingBook?: string;
    licensingIssue?: string;
    animalFeedTypeName?: string;
    licensingIssueDate?: any;
    licensingExpireDate?: any;
    voucherAnimalFeedTypeName?: string;
    brandName?: string;
    voucherNo?: string;
    voucherAnimalFeedTypeNameEn?: string;
    brandNameEn?: string;
    voucherNoEn?: string;
    haccpFor?: string;
    gmpPlaceName?: string;
    issueDate?: any;
    gmpNo?: string;
}

export interface GmpHaccpMeetingBookingFileRequest {
    files?: { [P in GmpHaccpMeetingBookingFileType]?: GmpHaccpMeetingBookingFile };
    gmpHaccpMeetingBookingId?: number;
}

export interface GmpHaccpMeetingBookingSearchRequest {
    confStartDate?: any;
    confEndDate?: any;
    confSubject?: string;
    meetingStatus?: GmpHaccpMeetingStatus;
}

export interface GmpHaccpMeetingFormRequestLicensingItemRequest {
    id?: number;
    feedPackageTh?: string;
    feedPackageEn?: string;
}

export interface GmpHaccpOfferSignRequest {
    formId?: number;
    comment?: string;
}

export interface GmpHaccpOrderRequest extends SignableForm {
    formId?: number;
    approve?: boolean;
    issueDate?: any;
}

export interface GmpHaccpPaymentRequest {
    formId?: number;
    receiptFile?: FileUpload;
}

export interface GmpHaccpProduceCertificateRequest {
    formId?: number;
    meetingFormId?: number;
    qMarkTh?: string;
    qMarkEn?: string;
    gmpHaccpType?: GmpHaccpType;
    qMarkFile?: FileUpload;
    level?: GmpHaccpCertificateLevel;
    itemRequests?: GmpHaccpMeetingFormRequestLicensingItemRequest[];
    scopeTypeTh?: string;
    scopeTypeEn?: string;
    codexRemark?: string;
    remarkTh?: string;
    remarkEn?: string;
    formType?: FormType;
    gmpHaccpTypeRenewal?: boolean;
}

export interface GmpHaccpFormAppointmentProjection {
    id?: number;
    status?: AppointmentStatus;
    gmpHaccpForm?: GmpHaccpFormProjection;
    appointmentDate?: GmpHaccpFormAppointmentDate;
    locationAddress?: string;
}

export interface GmpHaccpFormCheckSiteInspectionProjection {
    id?: number;
    files?: { [P in GmpHaccpFormCheckSiteInspectionFileType]?: GmpHaccpFormCheckSiteInspectionFile };
    monitoringReportRemark?: string;
}

export interface GmpHaccpFormProjection {
    id?: number;
    user?: ApplicantProjection;
    requestNo?: string;
    petitionNo?: string;
    filingDate?: any;
    formStatus?: GmpHaccpFormStatus;
    dtype?: FormType;
    requestLicensing?: GmpHaccpRequestLicensing;
}

export interface Licensing extends AbstractLicensing<LicensingItem>, SignableForm {
    id?: number;
    licensingItems?: LicensingItem[];
    files?: { [P in LicensingFileType]?: LicensingFile };
    entrepreneurs?: LicensingEntrepreneur[];
    authorizedDirectors?: LicensingAuthorizedDirector[];
    location?: Location;
    warehouses?: Location[];
    licensingCompany?: LicensingCompany;
    sendNotifyExpireDate?: boolean;
    notifyEmail?: string;
    manualFlag?: boolean;
    preprocessLicensingIssueDate?: any;
    preprocessLicensingExpireDate?: any;
    migrateFlag?: boolean;
    user?: User;
    licensingFormEquipments?: LicensingFormEquipment[];
    licensingFormEquipmentNews?: LicensingFormEquipment[];
}

export interface LicensingAuthorizedDirector extends AbstractAuthorizedDirector {
    id?: number;
}

export interface LicensingCompany {
    corporateNumber?: string;
    foundationNumber?: string;
    companyType?: CompanyType;
    companyTypeId?: number;
    otherCompanyType?: string;
    nameTh?: string;
    taxId?: string;
    branch?: string;
    branchDescription?: string;
    dateOfRegistration?: any;
    registeredCapital?: number;
    address?: string;
    moo?: string;
    soi?: string;
    street?: string;
    addressEn?: AddressEn;
    tambon?: Tambon;
    tambonId?: string;
    postalCode?: string;
    email?: string;
    tel?: string;
    fullAddressTh?: string;
    fullAddressEn?: string;
    registerSeq?: number;
}

export interface LicensingConsideration extends AbstractAuditingEntity {
    id?: number;
    considerer?: Officer;
    considererName?: string;
    considererPosition?: string;
    considererComment?: string;
    approveStatus?: ApproveStatus;
    noAppointment?: boolean;
    correctionItems?: LicensingConsiderationCorrectionItem[];
}

export interface LicensingConsiderationCorrectionItem extends CorrectionItem {
}

export interface LicensingEntrepreneur extends AbstractEntrepreneur {
    id?: number;
    files?: { [P in LicensingEntrepreneurFileType]?: LicensingEntrepreneurFile };
    livestockEntrepreneur?: boolean;
}

export interface LicensingEntrepreneurFile extends FileUpload {
    fileType?: LicensingEntrepreneurFileType;
}

export interface LicensingFile extends FileUpload {
    other?: string;
    fileType?: LicensingFileType;
}

export interface LicensingForm extends AbstractAuditingEntity, FormDraft, SignableForm {
    id?: number;
    dtype?: FormType;
    filingOffice?: FilingOffice;
    dofOrg?: DofOrg;
    licenseType?: LicenseType;
    licenseSubType?: LicenseSubType;
    requestType?: RequestType;
    petitionNo?: string;
    requestNo?: string;
    purposeNo?: string;
    filingDate?: any;
    formStatus?: LicensingFormStatus;
    receivedDate?: any;
    licensingConsideration?: LicensingConsideration;
    licensingSignProposal?: LicensingSignProposal;
    licensingOrder?: LicensingOrder;
    payment?: Payment;
    user?: Applicant;
    licensingFormLocation?: Location;
    filingLocation?: FilingLocation;
    licensingFormEntrepreneurs?: LicensingEntrepreneur[];
    licensingFormAuthorizedDirectors?: LicensingAuthorizedDirector[];
    licensingFormWarehouses?: Location[];
    licensingFormItems?: LicensingFormItem[];
    licensing?: Licensing;
    department?: Department;
    type?: string;
    remark?: string;
    jobRemark?: string;
    licensingFormEquipments?: LicensingFormEquipment[];
    licensingFormEquipmentNews?: LicensingFormEquipment[];
    draftMarkAsDelete?: boolean;
    licensingIssueDate?: any;
    licensingIssue?: string;
    licensingBook?: string;
    licensingEffectiveDate?: any;
    licensingExpireDate?: any;
    renewFlag?: boolean;
    substitutionDate?: any;
    substitutionOfficerName?: string;
    substitutionOfficerPosition?: string;
    licensorName?: string;
    licensorPosition?: string;
    licensor?: User;
    formName?: string;
    formStatusDesc?: string;
}

export interface LicensingForm1 extends LicensingForm {
    f1Coordinator?: LicensingForm1Coordinator;
    f1Files?: { [P in LicensingForm1FileType]?: LicensingForm1File };
}

export interface LicensingForm10 extends LicensingForm {
    licensingForm1?: LicensingForm1;
    f10Files?: { [P in LicensingForm10FileType]?: LicensingForm10File };
}

export interface LicensingForm10File extends FileUpload {
    fileType?: LicensingForm10FileType;
    other?: string;
}

export interface LicensingForm11 extends LicensingForm {
    f11Files?: { [P in LicensingForm11FileType]?: LicensingForm11File };
}

export interface LicensingForm11File extends FileUpload {
    fileType?: LicensingForm11FileType;
    other?: string;
}

export interface LicensingForm12 extends LicensingForm {
    f12Files?: { [P in LicensingForm12FileType]?: LicensingForm12File };
    correctionRequest?: LicensingFormCorrectionRequest;
}

export interface LicensingForm12File extends FileUpload {
    fileType?: LicensingForm12FileType;
    other?: string;
}

export interface LicensingForm13 extends LicensingForm {
    f13Files?: { [P in LicensingForm13FileType]?: LicensingForm13File };
    requestSubstituteReason?: RequestSubstituteReason;
}

export interface LicensingForm13File extends FileUpload {
    fileType?: LicensingForm13FileType;
    other?: string;
}

export interface LicensingForm14 extends LicensingForm {
    licensingForm1?: LicensingForm1;
    f14Files?: { [P in LicensingForm14FileType]?: LicensingForm14File };
}

export interface LicensingForm14File extends FileUpload {
    fileType?: LicensingForm14FileType;
    other?: string;
}

export interface LicensingForm15 extends LicensingForm {
    f15Files?: { [P in LicensingForm15FileType]?: LicensingForm15File };
}

export interface LicensingForm15File extends FileUpload {
    fileType?: LicensingForm15FileType;
    other?: string;
}

export interface LicensingForm16 extends LicensingForm {
    licensingForm1?: LicensingForm1;
    f16Files?: { [P in LicensingForm16FileType]?: LicensingForm16File };
}

export interface LicensingForm16File extends FileUpload {
    fileType?: LicensingForm16FileType;
    other?: string;
    correct?: boolean;
}

export interface LicensingForm17 extends LicensingForm {
    f17Files?: { [P in LicensingForm17FileType]?: LicensingForm17File };
}

export interface LicensingForm17File extends FileUpload {
    fileType?: LicensingForm17FileType;
    other?: string;
    correct?: boolean;
}

export interface LicensingForm18 extends LicensingForm {
    f18Files?: { [P in LicensingForm18FileType]?: LicensingForm18File };
    correctionRequest?: LicensingFormCorrectionRequest;
    certificateOfFreeSaleType?: CertificateOfFreeSaleType;
    formCertificateOfFreeSales?: LicensingFormCertificateOfFreeSale[];
}

export interface LicensingForm18File extends FileUpload {
    fileType?: LicensingForm18FileType;
    other?: string;
}

export interface LicensingForm19 extends LicensingForm {
    f19Files?: { [P in LicensingForm19FileType]?: LicensingForm19File };
    requestSubstituteReason?: RequestSubstituteReason;
}

export interface LicensingForm19File extends FileUpload {
    fileType?: LicensingForm19FileType;
    other?: string;
}

export interface LicensingForm1Coordinator extends AbstractAuditingEntity {
    id?: number;
    title?: Title;
    fname?: string;
    lname?: string;
    tel?: string;
}

export interface LicensingForm1File extends FileUpload {
    fileType?: LicensingForm1FileType;
}

export interface LicensingForm2 extends LicensingForm {
    licensingForm1?: LicensingForm1;
    f2Files?: { [P in LicensingForm2FileType]?: LicensingForm2File };
    applicantName?: string;
    f2FormFeedGroups?: LicensingFormFeedGroup[];
    f2FormAnimals?: LicensingFormAnimal[];
    countries?: Country[];
    f2FormProductionEstimates?: LicensingFormProductionEstimate[];
    f2FormUseEstimates?: LicensingFormUseEstimate[];
    f2FormQualityControl?: LicensingFormQualityControl;
}

export interface LicensingForm2File extends FileUpload {
    fileType?: LicensingForm2FileType;
    other?: string;
}

export interface LicensingForm3 extends LicensingForm {
    f3Files?: { [P in LicensingForm3FileType]?: LicensingForm3File };
    applicantName?: string;
    f3FormFeedGroups?: LicensingFormFeedGroup[];
    f3FormAnimals?: LicensingFormAnimal[];
    countries?: Country[];
    f3FormProductionEstimates?: LicensingFormProductionEstimate[];
    f3FormUseEstimates?: LicensingFormUseEstimate[];
    f3FormQualityControl?: LicensingFormQualityControl;
}

export interface LicensingForm3File extends FileUpload {
    fileType?: LicensingForm3FileType;
    other?: string;
}

export interface LicensingForm4 extends LicensingForm {
    licensingForm1?: LicensingForm1;
    productionReportBackwards?: LicensingFormProductionReportBackward[];
    qtyReportBackwards?: LicensingFormQtyReportBackward[];
    applicantName?: string;
    f4Files?: { [P in LicensingForm4FileType]?: LicensingForm4File };
    reportType1?: boolean;
    reportType2?: boolean;
}

export interface LicensingForm4File extends FileUpload {
    fileType?: LicensingForm4FileType;
    other?: string;
}

export interface LicensingForm5 extends LicensingForm {
    f5Files?: { [P in LicensingForm5FileType]?: LicensingForm5File };
    productionReportBackwards?: LicensingFormProductionReportBackward[];
    qtyReportBackwards?: LicensingFormQtyReportBackward[];
    applicantName?: string;
    reportType1?: boolean;
    reportType2?: boolean;
}

export interface LicensingForm5File extends FileUpload {
    fileType?: LicensingForm5FileType;
    other?: string;
    correct?: boolean;
}

export interface LicensingForm6 extends LicensingForm {
    f6Files?: { [P in LicensingForm6FileType]?: LicensingForm6File };
    correctionRequest?: LicensingFormCorrectionRequest;
}

export interface LicensingForm6File extends FileUpload {
    fileType?: LicensingForm6FileType;
    other?: string;
}

export interface LicensingForm7 extends LicensingForm {
    f7Files?: { [P in LicensingForm7FileType]?: LicensingForm7File };
    requestSubstituteReason?: RequestSubstituteReason;
}

export interface LicensingForm7File extends FileUpload {
    fileType?: LicensingForm7FileType;
    other?: string;
}

export interface LicensingForm8 extends LicensingForm {
    licensingForm1?: LicensingForm1;
    f8Files?: { [P in LicensingForm8FileType]?: LicensingForm8File };
}

export interface LicensingForm8File extends FileUpload {
    fileType?: LicensingForm8FileType;
    other?: string;
}

export interface LicensingForm9 extends LicensingForm {
    f9Files?: { [P in LicensingForm9FileType]?: LicensingForm9File };
}

export interface LicensingForm9File extends FileUpload {
    fileType?: LicensingForm9FileType;
    other?: string;
}

export interface LicensingFormAnimal extends AbstractAuditingEntity {
    id?: number;
    animal?: Animal;
    animalOther?: string;
    checked?: boolean;
}

export interface LicensingFormAppointment {
    id?: number;
    status?: AppointmentStatus;
    appointmentDateList?: LicensingFormAppointmentDate[];
    licensingForm?: LicensingForm;
}

export interface LicensingFormAppointmentDate {
    id?: number;
    appointDate?: any;
    appointTimeStart?: any;
    appointTimeEnd?: any;
    appointDateTimeStart?: any;
    appointDateTimeEnd?: any;
    appointmentLocation?: Location;
    licensingFormSiteInspection?: LicensingFormSiteInspection;
    appointmentFlag?: boolean;
}

export interface LicensingFormCertificateOfFreeSale extends AbstractAuditingEntity {
    id?: number;
    animalFeedType?: AnimalFeedType;
    licensingForm14?: LicensingForm14;
    licensingForm15?: LicensingForm15;
    licensingForm18?: LicensingForm15;
}

export interface LicensingFormCorrectionRequest extends AbstractAuditingEntity {
    id?: number;
    correctItems?: boolean;
    correctEntrepreneurs?: boolean;
    correctLocation?: boolean;
    correctWarehouses?: boolean;
    correctFileEquipmentList?: boolean;
    correctOthers?: boolean;
    other?: string;
}

export interface LicensingFormEquipment extends IEquipmentList {
    id?: number;
    correctFlag?: boolean;
}

export interface LicensingFormFeedGroup {
    id?: number;
    feedGroup?: AnimalFeedGroup;
    licensingFormFeedTypes?: LicensingFormFeedType[];
}

export interface LicensingFormFeedType extends AbstractAuditingEntity {
    id?: number;
    feedType?: AnimalFeedType;
    quantity?: number;
}

export interface LicensingFormItem extends RequestLicensingItem {
}

export interface LicensingFormProductionEstimate extends AbstractAuditingEntity {
    id?: number;
    feedName?: string;
    productionRate?: number;
    sellingRate?: number;
    exportRate?: number;
    remark?: string;
}

export interface LicensingFormProductionReportBackward extends AbstractAuditingEntity {
    id?: number;
    year?: number;
    seq?: number;
    backwardProductionQtys?: LicensingFormProductionReportBackwardProductionQty[];
    usageQtys?: LicensingFormProductionReportBackwardUsageQty[];
}

export interface LicensingFormProductionReportBackwardProductionQty extends AbstractAuditingEntity {
    id?: number;
    animalType?: AnimalType;
    readyMixedQty?: number;
    forageHeadQty?: number;
    preMixturesQty?: number;
    foodSupplementQty?: number;
}

export interface LicensingFormProductionReportBackwardUsageQty extends AbstractAuditingEntity {
    id?: number;
    ingredient?: Ingredient;
    others?: string;
    quantity?: number;
    cost?: number;
}

export interface LicensingFormQtyReportBackward extends AbstractAuditingEntity {
    id?: number;
    year?: number;
    seq?: number;
    machineQty?: number;
    efficient?: number;
    workHrs?: number;
    workDays?: number;
    ratio1?: number;
    ratio2?: number;
    qtyReportBackwardItems?: LicensingFormQtyReportBackwardItem[];
}

export interface LicensingFormQtyReportBackwardItem extends AbstractAuditingEntity {
    id?: number;
    animalFeedType?: AnimalFeedType;
    animalType?: AnimalType;
    animalTypeOther?: string;
    janQty?: number;
    febQty?: number;
    marQty?: number;
    aprQty?: number;
    mayQty?: number;
    junQty?: number;
    julQty?: number;
    augQty?: number;
    septQty?: number;
    octQty?: number;
    novQty?: number;
    decQty?: number;
    remark?: string;
}

export interface LicensingFormQualityControl extends AbstractAuditingEntity {
    id?: number;
    ingredient?: boolean;
    readymade?: boolean;
    base?: boolean;
    premix?: boolean;
    supplement?: boolean;
    examinatedFactory?: boolean;
    examinatedOther?: boolean;
    examinatedOtherName?: string;
}

export interface LicensingFormSiteInspection extends AbstractAuditingEntity, SignableForm {
    id?: number;
    status?: SiteInspectionStatus;
    files?: { [P in LicensingFormSiteInspectionFileType]?: LicensingFormSiteInspectionFile };
    licensingFormAppointmentDateId?: number;
    officer?: Officer;
    officerName?: string;
    officerPosition?: string;
    siteInspectionInspector?: SiteInspectionInspector;
    checkSiteInspectionExaminatorCrewList?: LicensingFormSiteInspectionExaminatorCrew[];
    checkSiteInspectionLists?: { [index: string]: LicensingFormSiteInspectionList };
    checkSiteInspectionPremixLists?: { [index: string]: LicensingFormSiteInspectionList };
    siteInspectionResult?: SiteInspectionResult;
    inspectionPassResult?: SiteInspectionPassResult;
    checkSiteInspectionResultRemark?: string;
    inspectionTime?: any;
    pouringPlace?: string;
    batch1?: string;
    batch2?: string;
    performPelletMachine?: string;
    materialStorageTemp?: string;
    productStorageTemp?: string;
    machineType?: string;
    bakingTemperature?: string;
    bakingTime?: string;
    coldDryerTemperature?: string;
    pelletMachine?: string;
    fillingMachine?: string;
    inspectionPlace?: string;
    otherPremix?: string;
    materialStorageTempPremix?: string;
    productStorageTempPremix?: string;
    batchPremix?: string;
    batchTimePremix?: string;
    saleTemp?: string;
    importTemp?: string;
}

export interface LicensingFormSiteInspectionExaminatorCrew extends AbstractAuditingEntity {
    id?: number;
    user?: Officer;
}

export interface LicensingFormSiteInspectionFile extends FileUpload {
    fileType?: LicensingFormSiteInspectionFileType;
}

export interface LicensingFormSiteInspectionList extends AbstractAuditingEntity {
    id?: number;
    passCheck?: boolean;
    eventRemark?: string;
    key?: string;
}

export interface LicensingFormUseEstimate extends AbstractAuditingEntity {
    id?: number;
    ingredient?: Ingredient;
    useRate?: number;
    ingredientSource?: string;
    remark?: string;
}

export interface LicensingFormWarehouseLocation {
    id?: LicensingFormWarehouseLocationId;
    location?: Location;
}

export interface LicensingFormWarehouseLocationId {
}

export interface LicensingItem extends AbstractLicensingItem {
    id?: number;
    feedPackageEn?: string;
    scopeOfCertifications?: GmpHaccpRequestScopeOfCertification[];
}

export interface LicensingOrder extends AbstractAuditingEntity {
    id?: number;
    officer?: Officer;
    officerName?: string;
    officerPosition?: string;
    actingDirectorFlag?: boolean;
    approve?: boolean;
    orderDate?: any;
    approveText?: string;
}

export interface LicensingSignProposal extends AbstractAuditingEntity {
    id?: number;
    officer?: Officer;
    officerName?: string;
    officerPosition?: string;
    officerComment?: string;
}

export interface VLicensingReport {
    id?: number;
    licenseType?: LicenseType;
    licenseSubType?: LicenseSubType;
    licenseFor?: string;
    licensingIssue?: string;
    licensingBook?: string;
    licensingIssueDate?: any;
    licensingEffectiveDate?: any;
    licensingExpireDate?: any;
    corporateNumber?: string;
    foundationNumber?: string;
    branch?: string;
    branchName?: string;
    items?: string;
    sumProductionEfficiency?: number;
    animalFeedGroupIds?: string[];
    animalFeedTypeIds?: string[];
    status?: LicenseStatus;
    entrepreneurName?: string;
    entrepreneurCardNumber?: string;
    locationPlaceName?: string;
    locationAddress?: string;
    locationSoi?: string;
    locationStreet?: string;
    locationMoo?: string;
    locationTambonId?: string;
    locationTambonName?: string;
    locationAmphurId?: string;
    locationAmphurName?: string;
    locationProvinceId?: string;
    locationProvinceName?: string;
    locationPostalCode?: string;
    locationTel?: string;
    warehousePlaceName1?: string;
    warehouseAddress1?: string;
    warehouseSoi1?: string;
    warehouseStreet1?: string;
    warehouseMoo1?: string;
    warehouseTambonId1?: string;
    warehouseTambonName1?: string;
    warehouseAmphurId1?: string;
    warehouseAmphurName1?: string;
    warehouseProvinceId1?: string;
    warehouseProvinceName1?: string;
    warehousePostalCode1?: string;
    warehouseTel1?: string;
    warehousePlaceName2?: string;
    warehouseAddress2?: string;
    warehouseSoi2?: string;
    warehouseStreet2?: string;
    warehouseMoo2?: string;
    warehouseTambonId2?: string;
    warehouseTambonName2?: string;
    warehouseAmphurId2?: string;
    warehouseAmphurName2?: string;
    warehouseProvinceId2?: string;
    warehouseProvinceName2?: string;
    warehousePostalCode2?: string;
    warehouseTel2?: string;
    warehousePlaceName3?: string;
    warehouseAddress3?: string;
    warehouseSoi3?: string;
    warehouseStreet3?: string;
    warehouseMoo3?: string;
    warehouseTambonId3?: string;
    warehouseTambonName3?: string;
    warehouseAmphurId3?: string;
    warehouseAmphurName3?: string;
    warehouseProvinceId3?: string;
    warehouseProvinceName3?: string;
    warehousePostalCode3?: string;
    warehouseTel3?: string;
}

export interface LicensingAppointmentReportDto {
    licensingFormAppointmentDateId?: number;
    files?: { [P in LicensingFormSiteInspectionFileType]?: LicensingFormSiteInspectionFile };
}

export interface LicensingConfirmAppointmentDto {
    id?: number;
    status?: AppointmentStatus;
}

export interface LicensingConsiderationRequest<T> {
    licensingForm?: T;
    receivedDate?: any;
    approveStatus?: ApproveStatus;
    correctionItems?: LicensingConsiderationCorrectionItem[];
    comment?: string;
}

export interface LicensingCreateLicenseRequest<T> {
    licensingForm?: T;
    type?: string;
}

export interface LicensingForm1Dto {
    applicant?: Applicant;
    entrepreneurs?: User[];
    representatives?: User[];
}

export interface LicensingForm3SiteInspectionReportRequest {
    id?: number;
    files?: { [P in LicensingFormSiteInspectionFileType]?: LicensingFormSiteInspectionFile };
    p12password?: string;
}

export interface LicensingForm5Dto {
    applicant?: Applicant;
    entrepreneurs?: User[];
    representatives?: User[];
}

export interface LicensingFormAppointmentDateRequest {
    appointDate?: any;
}

export interface LicensingFormSearchRequest {
    formStatus?: LicensingFormStatus;
    requestNo?: string;
    purposeNo?: string;
    petitionNo?: string;
    filingDateFrom?: any;
    filingDateTo?: any;
    receivedDateFrom?: any;
    receivedDateTo?: any;
    appointmentDateStart?: any;
    appointmentDateEnd?: any;
    formType?: FormType;
    name?: string;
}

export interface LicensingFormSiteInspectionOrderEditDto {
    checkSiteInspectionResultRemark?: string;
}

export interface LicensingFormSiteInspectionRequest {
    entrepreneurSign?: boolean;
    licensingFormSiteInspection?: LicensingFormSiteInspection;
}

export interface LicensingImportDto {
    id?: number;
    virtualId?: string;
    department?: Department;
    filingOffice?: FilingOffice;
    seq?: number;
    licensingFor?: string;
    branch?: string;
    corporateNumber?: string;
    foundationNumber?: string;
    entrepreneurPrefix?: string;
    entrepreneurFname?: string;
    entrepreneurLname?: string;
    entrepreneurPid?: string;
    entrepreneurCardNumber?: string;
    locationSell?: string;
    locationImported?: string;
    locationManufacture?: string;
    addressNo?: string;
    soi?: string;
    road?: string;
    moo?: string;
    tambonName?: string;
    amphurName?: string;
    provinceName?: string;
    postalCode?: string;
    tel?: string;
    warehouse1Name?: string;
    warehouse1AddressNo?: string;
    warehouse1Soi?: string;
    warehouse1Road?: string;
    warehouse1Moo?: string;
    warehouse1TambonName?: string;
    warehouse1AmphurName?: string;
    warehouse1ProvinceName?: string;
    warehouse1PostalCode?: string;
    warehouse1Tel?: string;
    warehouse2Name?: string;
    warehouse2AddressNo?: string;
    warehouse2Soi?: string;
    warehouse2Road?: string;
    warehouse2Moo?: string;
    warehouse2TambonName?: string;
    warehouse2AmphurName?: string;
    warehouse2ProvinceName?: string;
    warehouse2PostalCode?: string;
    warehouse2Tel?: string;
    warehouse3Name?: string;
    warehouse3AddressNo?: string;
    warehouse3Soi?: string;
    warehouse3Road?: string;
    warehouse3Moo?: string;
    warehouse3TambonName?: string;
    warehouse3AmphurName?: string;
    warehouse3ProvinceName?: string;
    warehouse3PostalCode?: string;
    warehouse3Tel?: string;
    licenseSubType?: LicenseSubType;
    licensingBook?: string;
    filingProvince?: string;
    licensingIssue?: string;
    licensingIssueDate?: any;
    licensingExpireDate?: any;
    licensingRequestType?: RequestType;
    type?: string;
    productionEfficiency?: number;
    licenseType?: LicenseType;
    animalFeedGroupName?: string;
    animalFeedTypeName?: string;
    feedPackage?: string;
    otherItemList?: LicensingImportDto[];
    locationPlaceName?: string;
}

export interface LicensingOrderRequest<T> {
    licensingForm?: T;
    approve?: boolean;
    orderBy?: string;
    orderDate?: any;
    p12password?: string;
}

export interface LicensingPaymentRequest {
    licensingFormId?: number;
    receiptFile?: FileUpload;
}

export interface LicensingReportRequest extends ReportCondition {
}

export interface LicensingSearchRequest {
    licenseType?: LicenseType;
    licensingIssue?: string;
}

export interface LicensingSignProposalRequest<T> {
    licensingForm?: T;
    officerComment?: string;
}

export interface LicensingSiteInspectionProductReportRequest<T1, T2> {
    id?: number;
    productFiles?: { [index: string]: T2 };
    files?: { [P in LicensingFormSiteInspectionFileType]?: LicensingFormSiteInspectionFile };
    p12password?: string;
}

export interface LicensingSiteInspectionReportRequest {
    id?: number;
    files?: { [P in LicensingFormSiteInspectionFileType]?: LicensingFormSiteInspectionFile };
    p12password?: string;
}

export interface LicensingVoucherDto {
    licenseType?: LicenseType;
    licensingIssue?: string;
    licensingBook?: string;
    licensingIssueDate?: any;
    licensingExpireDate?: any;
    licensingLocation?: Location;
}

export interface LicensingVoucherSellerDto {
    licenseType?: LicenseType;
    licensingIssue?: string;
    licensingBook?: string;
    licensingIssueDate?: any;
    licensingExpireDate?: any;
    entrepreneurs?: LicensingEntrepreneur[];
    licensingLocation?: Location;
}

export interface ReservedLicensingIssue {
    licensingIssue?: string;
    licensingBook?: string;
}

export interface LicensingFormAppointmentDateEventProjection {
    location?: Location;
    status?: AppointmentStatus;
    licensingFormId?: number;
    dateTimeStart?: any;
    dateTimeEnd?: any;
}

export interface LicensingFormAppointmentDateProjection {
    id?: number;
    appointment?: LicensingFormAppointmentProj;
    appointDate?: any;
    appointTimeStart?: any;
    appointTimeEnd?: any;
    appointmentLocation?: Location;
    licensingFormSiteInspection?: LicensingFormSiteInspectionProjection;
}

export interface LicensingFormAppointmentProj {
    status?: AppointmentStatus;
    licensingForm?: LicensingFormProjection;
}

export interface LicensingFormProjection {
    id?: number;
    user?: ApplicantProjection;
    requestNo?: string;
    petitionNo?: string;
    filingDate?: any;
    receivedDate?: any;
    formStatus?: LicensingFormStatus;
    dtype?: FormType;
    purposeNo?: string;
    licensing?: LicensingProjection;
}

export interface LicensingFormSiteInspectionProjection {
    id?: number;
    status?: SiteInspectionStatus;
    siteInspectionResult?: SiteInspectionResult;
    inspectionPassResult?: SiteInspectionPassResult;
}

export interface LicensingPaymentProjection {
    id?: number;
    requestNo?: string;
    petitionNo?: string;
    formStatus?: LicensingFormStatus;
    dtype?: FormType;
    payment?: PaymentProjection;
}

export interface LicensingProjection {
    id?: number;
    licensingIssue?: string;
    licensingBook?: string;
}

export interface LicensingReportProjection {
    location?: Location;
    user?: ApplicantProjection;
    licensingIssue?: string;
    licensingIssueDate?: any;
    licensingBook?: string;
    licensingExpireDate?: any;
    licenseType?: LicenseType;
    licensingIssueType?: LicensingIssueType;
    licensingItems?: LicensingItem[];
    warehouses?: Location[];
}

export interface LicensingReportResult {
    id?: number;
    items?: string;
    status?: LicenseStatus;
    entrepreneurName?: string;
    branch?: string;
    licensingIssue?: string;
    licensingIssueDate?: any;
    licensingBook?: string;
    licensingExpireDate?: any;
    licenseType?: LicenseType;
    licenseFor?: string;
    licenseSubType?: LicenseSubType;
    licensingEffectiveDate?: any;
    corporateNumber?: string;
    branchName?: string;
    foundationNumber?: string;
    locationProvinceId?: string;
    locationAddress?: string;
    entrepreneurCardNumber?: string;
    warehousePlaceName1?: string;
    warehouseAddress1?: string;
    warehouseSoi1?: string;
    warehouseStreet1?: string;
    warehouseMoo1?: string;
    warehouseTambonId1?: string;
    warehouseTambonName1?: string;
    warehouseAmphurId1?: string;
    warehouseAmphurName1?: string;
    warehouseProvinceId1?: string;
    warehouseProvinceName1?: string;
    warehousePostalCode1?: string;
    warehouseTel1?: string;
    warehousePlaceName2?: string;
    warehouseAddress2?: string;
    warehouseSoi2?: string;
    warehouseStreet2?: string;
    warehouseMoo2?: string;
    warehouseTambonId2?: string;
    warehouseTambonName2?: string;
    warehouseAmphurId2?: string;
    warehouseAmphurName2?: string;
    warehouseProvinceId2?: string;
    warehouseProvinceName2?: string;
    warehousePostalCode2?: string;
    warehouseTel2?: string;
    warehousePlaceName3?: string;
    warehouseAddress3?: string;
    warehouseSoi3?: string;
    warehouseStreet3?: string;
    warehouseMoo3?: string;
    warehouseTambonId3?: string;
    warehouseTambonName3?: string;
    warehouseAmphurId3?: string;
    warehouseAmphurName3?: string;
    warehouseProvinceId3?: string;
    warehouseProvinceName3?: string;
    warehousePostalCode3?: string;
    warehouseTel3?: string;
    sumProductionEfficiency?: number;
    locationPlaceName?: string;
    locationSoi?: string;
    locationStreet?: string;
    locationMoo?: string;
    locationTambonId?: string;
    locationTambonName?: string;
    locationAmphurId?: string;
    locationAmphurName?: string;
    locationProvinceName?: string;
    locationPostalCode?: string;
    locationTel?: string;
}

export interface LicensingForm10Report extends LicensingForm10 {
    location?: Location;
    entrepreneurs?: LicensingEntrepreneur[];
    authorizedDirectors?: LicensingAuthorizedDirector[];
    entrepreneurFirst?: LicensingEntrepreneur;
    entrepreneurOthers?: LicensingEntrepreneur[];
    authorizedDirectorFirst?: LicensingAuthorizedDirector;
    authorizedDirectorOthers?: LicensingAuthorizedDirector[];
    warehousesFirst?: Location;
    warehouseOthers?: Location[];
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    fileLicenseOrSubstitute?: boolean;
    fileJuristicRegister?: boolean;
    fileAuthority?: boolean;
    fileAttorneyCopy?: boolean;
}

export interface LicensingForm11Report extends LicensingForm11 {
    location?: Location;
    entrepreneurs?: LicensingEntrepreneur[];
    authorizedDirectors?: LicensingAuthorizedDirector[];
    entrepreneurFirst?: LicensingEntrepreneur;
    entrepreneurOthers?: LicensingEntrepreneur[];
    authorizedDirectorFirst?: LicensingAuthorizedDirector;
    authorizedDirectorOthers?: LicensingAuthorizedDirector[];
    warehousesFirst?: Location;
    warehouseOthers?: Location[];
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    fileLicenseOrSubstitute?: boolean;
    fileJuristicRegister?: boolean;
    fileAuthority?: boolean;
    fileAttorneyCopy?: boolean;
}

export interface LicensingForm12Report extends LicensingForm12 {
    location?: Location;
    entrepreneurs?: LicensingEntrepreneur[];
    authorizedDirectors?: LicensingAuthorizedDirector[];
    entrepreneurFirst?: LicensingEntrepreneur;
    entrepreneurOthers?: LicensingEntrepreneur[];
    authorizedDirectorFirst?: LicensingAuthorizedDirector;
    authorizedDirectorOthers?: LicensingAuthorizedDirector[];
    warehousesFirst?: Location;
    warehouseOthers?: Location[];
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    fileLicenseOrSubstitute?: boolean;
    reportLicensingFormAuthorizedDirectorFirst?: LicensingAuthorizedDirector;
    reportEntrepreneurs?: LicensingEntrepreneur[];
    reportEntrepreneurFirst?: LicensingEntrepreneur;
    correctionRequestList?: string;
    fileCorrectionForm?: boolean;
}

export interface LicensingForm12ReportFactory {
}

export interface LicensingForm13Report extends LicensingForm13 {
    location?: Location;
    entrepreneurs?: LicensingEntrepreneur[];
    authorizedDirectors?: LicensingAuthorizedDirector[];
    entrepreneurFirst?: LicensingEntrepreneur;
    entrepreneurOthers?: LicensingEntrepreneur[];
    authorizedDirectorFirst?: LicensingAuthorizedDirector;
    authorizedDirectorOthers?: LicensingAuthorizedDirector[];
    warehousesFirst?: Location;
    warehouseOthers?: Location[];
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    fileAttorneyCopy?: boolean;
    fileDamagedLicense?: boolean;
    fileLostEvidence?: boolean;
}

export interface LicensingForm14Report extends LicensingForm14 {
    location?: Location;
    entrepreneurs?: LicensingEntrepreneur[];
    licenseFor?: string;
    authorizedDirectors?: LicensingAuthorizedDirector[];
    reportType?: string;
    entrepreneurFirst?: LicensingEntrepreneur;
    entrepreneurOthers?: LicensingEntrepreneur[];
    authorizedDirectorFirst?: LicensingAuthorizedDirector;
    authorizedDirectorOthers?: LicensingAuthorizedDirector[];
    warehousesFirst?: Location;
    warehouseOthers?: Location[];
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    fileJuristicRegister?: boolean;
    fileAuthority?: boolean;
    fileAttorneyCopy?: boolean;
    entrepreneurNames?: string;
    warehouseFirst?: Location;
    fileSellMapAndSellWarehouseMap?: boolean;
    fileOther?: boolean;
    fileOtherComment?: string;
}

export interface LicensingForm15Report extends LicensingForm15 {
    location?: Location;
    entrepreneurs?: LicensingEntrepreneur[];
    licenseFor?: string;
    authorizedDirectors?: LicensingAuthorizedDirector[];
    reportType?: string;
    entrepreneurFirst?: LicensingEntrepreneur;
    entrepreneurOthers?: LicensingEntrepreneur[];
    authorizedDirectorFirst?: LicensingAuthorizedDirector;
    authorizedDirectorOthers?: LicensingAuthorizedDirector[];
    warehousesFirst?: Location;
    warehouseOthers?: Location[];
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    fileJuristicRegister?: boolean;
    fileAuthority?: boolean;
    fileAttorneyCopy?: boolean;
    entrepreneurNames?: string;
    warehouseFirst?: Location;
    fileSellMapAndSellWarehouseMap?: boolean;
    fileOther?: boolean;
    fileOtherComment?: string;
}

export interface LicensingForm16Report extends LicensingForm16 {
    location?: Location;
    entrepreneurs?: LicensingEntrepreneur[];
    authorizedDirectors?: LicensingAuthorizedDirector[];
    entrepreneurFirst?: LicensingEntrepreneur;
    entrepreneurOthers?: LicensingEntrepreneur[];
    authorizedDirectorFirst?: LicensingAuthorizedDirector;
    authorizedDirectorOthers?: LicensingAuthorizedDirector[];
    warehousesFirst?: Location;
    warehouseOthers?: Location[];
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    fileLicenseOrSubstitute?: boolean;
    fileOther?: boolean;
    fileOtherComment?: string;
    fileAuthorityNew?: boolean;
}

export interface LicensingForm17Report extends LicensingForm17 {
    location?: Location;
    entrepreneurs?: LicensingEntrepreneur[];
    authorizedDirectors?: LicensingAuthorizedDirector[];
    entrepreneurFirst?: LicensingEntrepreneur;
    entrepreneurOthers?: LicensingEntrepreneur[];
    authorizedDirectorFirst?: LicensingAuthorizedDirector;
    authorizedDirectorOthers?: LicensingAuthorizedDirector[];
    warehousesFirst?: Location;
    warehouseOthers?: Location[];
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    fileLicenseOrSubstitute?: boolean;
    fileOther?: boolean;
    fileOtherComment?: string;
    fileAuthorityNew?: boolean;
}

export interface LicensingForm18Report extends LicensingForm18 {
    location?: Location;
    entrepreneurs?: LicensingEntrepreneur[];
    authorizedDirectors?: LicensingAuthorizedDirector[];
    entrepreneurFirst?: LicensingEntrepreneur;
    entrepreneurOthers?: LicensingEntrepreneur[];
    authorizedDirectorFirst?: LicensingAuthorizedDirector;
    authorizedDirectorOthers?: LicensingAuthorizedDirector[];
    warehousesFirst?: Location;
    warehouseOthers?: Location[];
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    fileLicenseOrSubstitute?: boolean;
    reportLicensingFormAuthorizedDirectorFirst?: LicensingAuthorizedDirector;
    reportLicensingFormAuthorizedDirectors?: LicensingAuthorizedDirector[];
    reportEntrepreneurFirst?: LicensingEntrepreneur;
    correctionRequestList?: string;
    fileCorrectionForm?: boolean;
}

export interface LicensingForm19Report extends LicensingForm19 {
    location?: Location;
    entrepreneurs?: LicensingEntrepreneur[];
    authorizedDirectors?: LicensingAuthorizedDirector[];
    entrepreneurFirst?: LicensingEntrepreneur;
    entrepreneurOthers?: LicensingEntrepreneur[];
    authorizedDirectorFirst?: LicensingAuthorizedDirector;
    authorizedDirectorOthers?: LicensingAuthorizedDirector[];
    warehousesFirst?: Location;
    warehouseOthers?: Location[];
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    fileOther?: boolean;
    fileOtherComment?: string;
}

export interface LicensingForm1Report extends LicensingForm1 {
    warehouseFirst?: Location;
}

export interface LicensingForm2Report extends LicensingForm2 {
    location?: Location;
    entrepreneurs?: LicensingEntrepreneur[];
    authorizedDirectors?: LicensingAuthorizedDirector[];
    entrepreneurFirst?: LicensingEntrepreneur;
    entrepreneurOthers?: LicensingEntrepreneur[];
    authorizedDirectorFirst?: LicensingAuthorizedDirector;
    authorizedDirectorOthers?: LicensingAuthorizedDirector[];
    warehousesFirst?: Location;
    warehouseOthers?: Location[];
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    fileJuristicRegister?: boolean;
    fileAuthority?: boolean;
    fileAttorneyCopy?: boolean;
    fileOther?: boolean;
    fileOtherComment?: string;
    animals?: LicensingFormAnimal[];
    fileEquipmentList?: boolean;
    fileProcess?: boolean;
    fileProductionMapOrProductionWarehouseMap?: boolean;
    fileHazardLicense?: boolean;
    fileFactoryLicense?: boolean;
    productionEstimates?: LicensingFormProductionEstimate[];
    useEstimates?: LicensingFormUseEstimate[];
    qualityControl?: LicensingFormQualityControl;
    feedGroups?: LicensingFormFeedGroup[];
}

export interface LicensingForm3Report extends LicensingForm3 {
    location?: Location;
    entrepreneurs?: LicensingEntrepreneur[];
    authorizedDirectors?: LicensingAuthorizedDirector[];
    entrepreneurFirst?: LicensingEntrepreneur;
    entrepreneurOthers?: LicensingEntrepreneur[];
    authorizedDirectorFirst?: LicensingAuthorizedDirector;
    authorizedDirectorOthers?: LicensingAuthorizedDirector[];
    warehousesFirst?: Location;
    warehouseOthers?: Location[];
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    fileJuristicRegister?: boolean;
    fileAuthority?: boolean;
    fileAttorneyCopy?: boolean;
    fileOther?: boolean;
    fileOtherComment?: string;
    animals?: LicensingFormAnimal[];
    fileEquipmentList?: boolean;
    fileProcess?: boolean;
    fileProductionMapOrProductionWarehouseMap?: boolean;
    fileHazardLicense?: boolean;
    fileFactoryLicense?: boolean;
    productionEstimates?: LicensingFormProductionEstimate[];
    useEstimates?: LicensingFormUseEstimate[];
    qualityControl?: LicensingFormQualityControl;
    feedGroups?: LicensingFormFeedGroup[];
}

export interface LicensingForm4Report extends LicensingForm4 {
    location?: Location;
    entrepreneurs?: LicensingEntrepreneur[];
    authorizedDirectors?: LicensingAuthorizedDirector[];
    entrepreneurFirst?: LicensingEntrepreneur;
    entrepreneurOthers?: LicensingEntrepreneur[];
    authorizedDirectorFirst?: LicensingAuthorizedDirector;
    authorizedDirectorOthers?: LicensingAuthorizedDirector[];
    warehousesFirst?: Location;
    warehouseOthers?: Location[];
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    fileLicenseOrSubstitute?: boolean;
    fileJuristicRegister?: boolean;
    fileOther?: boolean;
    fileOtherComment?: string;
    fileEquipmentList?: boolean;
    fileProcess?: boolean;
    fileHazardLicense?: boolean;
}

export interface LicensingForm5Report extends LicensingForm5 {
    location?: Location;
    entrepreneurs?: LicensingEntrepreneur[];
    authorizedDirectors?: LicensingAuthorizedDirector[];
    entrepreneurFirst?: LicensingEntrepreneur;
    entrepreneurOthers?: LicensingEntrepreneur[];
    authorizedDirectorFirst?: LicensingAuthorizedDirector;
    authorizedDirectorOthers?: LicensingAuthorizedDirector[];
    warehousesFirst?: Location;
    warehouseOthers?: Location[];
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    fileLicenseOrSubstitute?: boolean;
    fileJuristicRegister?: boolean;
    fileOther?: boolean;
    fileOtherComment?: string;
    fileEquipmentList?: boolean;
    fileProcess?: boolean;
    fileHazardLicense?: boolean;
}

export interface LicensingForm6Report extends LicensingForm6 {
    location?: Location;
    entrepreneurs?: LicensingEntrepreneur[];
    authorizedDirectors?: LicensingAuthorizedDirector[];
    entrepreneurFirst?: LicensingEntrepreneur;
    entrepreneurOthers?: LicensingEntrepreneur[];
    authorizedDirectorFirst?: LicensingAuthorizedDirector;
    authorizedDirectorOthers?: LicensingAuthorizedDirector[];
    warehousesFirst?: Location;
    warehouseOthers?: Location[];
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    fileLicenseOrSubstitute?: boolean;
    correctionRequestList?: string;
}

export interface LicensingForm7Report extends LicensingForm7 {
    location?: Location;
    entrepreneurs?: LicensingEntrepreneur[];
    authorizedDirectors?: LicensingAuthorizedDirector[];
    entrepreneurFirst?: LicensingEntrepreneur;
    entrepreneurOthers?: LicensingEntrepreneur[];
    authorizedDirectorFirst?: LicensingAuthorizedDirector;
    authorizedDirectorOthers?: LicensingAuthorizedDirector[];
    warehousesFirst?: Location;
    warehouseOthers?: Location[];
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    fileDamagedLicense?: boolean;
    fileOther?: boolean;
    fileOtherComment?: string;
}

export interface LicensingForm8Report extends LicensingForm8 {
    location?: Location;
    entrepreneurs?: LicensingEntrepreneur[];
    licenseFor?: string;
    authorizedDirectors?: LicensingAuthorizedDirector[];
    reportType?: string;
    entrepreneurFirst?: LicensingEntrepreneur;
    entrepreneurOthers?: LicensingEntrepreneur[];
    authorizedDirectorFirst?: LicensingAuthorizedDirector;
    authorizedDirectorOthers?: LicensingAuthorizedDirector[];
    warehousesFirst?: Location;
    warehouseOthers?: Location[];
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    fileJuristicRegister?: boolean;
    fileAuthority?: boolean;
    fileAttorneyCopy?: boolean;
    entrepreneurNames?: string;
    warehouseFirst?: Location;
    fileCommercialRegistration?: boolean;
    fileImportMap?: boolean;
}

export interface LicensingForm9Report extends LicensingForm9 {
    location?: Location;
    entrepreneurs?: LicensingEntrepreneur[];
    licenseFor?: string;
    authorizedDirectors?: LicensingAuthorizedDirector[];
    reportType?: string;
    entrepreneurFirst?: LicensingEntrepreneur;
    entrepreneurOthers?: LicensingEntrepreneur[];
    authorizedDirectorFirst?: LicensingAuthorizedDirector;
    authorizedDirectorOthers?: LicensingAuthorizedDirector[];
    warehousesFirst?: Location;
    warehouseOthers?: Location[];
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    fileJuristicRegister?: boolean;
    fileAuthority?: boolean;
    fileAttorneyCopy?: boolean;
    entrepreneurNames?: string;
    warehouseFirst?: Location;
    fileCommercialRegistration?: boolean;
    fileImportMap?: boolean;
}

export interface LicensingFormImportReport extends LicensingForm {
    licenseFor?: string;
    reportType?: string;
    entrepreneurNames?: string;
    warehouseFirst?: Location;
}

export interface LicensingFormReport extends LicensingForm {
    url?: string;
    correctionRequest?: LicensingFormCorrectionRequest;
    fileLicenseOrSubstitute?: boolean;
    fileCorrectionForm?: boolean;
    location?: Location;
    entrepreneurs?: LicensingEntrepreneur[];
    licenseFor?: string;
    licensingIssueType?: LicensingIssueType;
    formId?: number;
    authorizedDirectors?: LicensingAuthorizedDirector[];
    entrepreneurFirst?: LicensingEntrepreneur;
    entrepreneurOthers?: LicensingEntrepreneur[];
    authorizedDirectorFirst?: LicensingAuthorizedDirector;
    authorizedDirectorOthers?: LicensingAuthorizedDirector[];
    warehousesFirst?: Location;
    warehouseOthers?: Location[];
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    reportLicensingFormAuthorizedDirectorFirst?: LicensingAuthorizedDirector;
    reportEntrepreneurs?: LicensingEntrepreneur[];
    entrepreneurNames?: string;
    warehouseFirst?: Location;
    reportLicensingFormAuthorizedDirectors?: LicensingAuthorizedDirector[];
    signatureImagePath?: string;
    reportEntrepreneurFirst?: LicensingEntrepreneur;
    correctionRequestList?: string;
}

export interface LicensingFormSellReport extends LicensingForm {
    entrepreneurs?: LicensingEntrepreneur[];
    licenseFor?: string;
    authorizedDirectors?: LicensingAuthorizedDirector[];
    reportType?: string;
    entrepreneurFirst?: LicensingEntrepreneur;
    authorizedDirectorFirst?: LicensingAuthorizedDirector;
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    entrepreneurNames?: string;
    warehouseFirst?: Location;
}

export interface LicensingFormSiteInspectionCheckListReport extends LicensingFormSiteInspection {
    licenseType?: LicenseType;
    notPremix?: boolean;
    premix?: boolean;
    preview?: boolean;
}

export interface LicensingFormSiteInspectionReport extends LicensingFormSiteInspection {
    animalFeedType?: string;
    animalFeedGroup?: string;
    entrepreneurFirst?: LicensingEntrepreneur;
    licensingFormAppointment?: LicensingFormAppointment;
    inspectorFirst?: SiteInspectionInspector;
    preview?: boolean;
}

export interface LicensingReport extends Licensing {
    url?: string;
    formId?: number;
    entrepreneurFirst?: LicensingEntrepreneur;
    entrepreneurOthers?: LicensingEntrepreneur[];
    authorizedDirectorOthers?: LicensingAuthorizedDirector[];
    warehouseOthers?: Location[];
    entrepreneurNames?: string;
    warehouseFirst?: Location;
    signatureImagePath?: string;
}

export interface LicensingFormQtyReportBackwardReportDto {
    reportType1?: boolean;
    year?: number;
    seq?: number;
    machineQty?: number;
    efficient?: number;
    workHrs?: number;
    workDays?: number;
    ratio1?: number;
    ratio2?: number;
    qtyReportBackwardItems?: LicensingFormQtyReportBackwardItem[];
}

export interface CountryUtils {
}

export interface LicensingFormAnimalUtils {
}

export interface LicensingFormFeedTypeUtils {
}

export interface LicensingFormItemUtils {
}

export interface LicensingFormQtyReportBackwardUtils {
}

export interface LicensingFormSiteInspectionExaminatorCrewUtils {
}

export interface LicensingFormSiteInspectionListUtils {
}

export interface DomesticSalesAuditAddition {
    animalFeedTypeOther?: string;
    invoice?: string;
    lotNo?: string;
    produceDate?: any;
    tariffCode?: string;
    productCode?: string;
    productTypeTariffCodeTh?: string;
    productTypeTariffCodeEn?: string;
    amountPackingContainer?: number;
    unitPackingContainer?: PackageUnit;
    netWeight?: number;
    netWeightUnit?: Unit;
    grossWeight?: number;
    grossWeightUnit?: Unit;
    price?: number;
    currency?: string;
    currencyUnit?: Currency;
    priceBaht?: number;
    fobBath?: number;
    documentOther?: string;
    auditAdditionFile?: FileUpload;
    originCountry?: Country;
    packageType?: PackageType;
    packageTypeOther?: string;
    packingSize?: number;
    packingUnit?: Unit;
}

export interface DomesticSalesAuditDetail {
    resultConsideration?: AuditForm1ResultConsideration;
    auditRef?: string;
    brandNameTH?: string;
    brandNameEn?: string;
    animalFeedType?: AnimalFeedType;
    manufacturerName?: string;
    manufacturerAddress?: string;
    importerName?: string;
    importerAddress?: string;
    rawMaterial?: string;
    netWeightAnimalFeed?: string;
    expiredDate?: string;
    howto?: string;
    warning?: string;
    packagesDurationMonth?: string;
    packagesNetWeight?: string;
    productType?: AuditProductType;
}

export interface DomesticSalesProductReleaseResultDetail {
    codeSample?: string;
    sampleAnalysisDate?: any;
    departmentAnalysis?: string;
    reportResultAnalysisDate?: any;
    ns4CheckingChemical?: Ns4CheckingChemical;
    bl?: ProductReleaseResultChemicalBL;
    mycotoxin?: Mycotoxin;
    medicinesAndResidues?: MedicinesAndResidues;
    salmonellaSppFound?: Ns4Discover;
    salmonellaSppChemical?: Ns4CheckingChemical;
    totalBacterialCountAmount?: number;
    totalBacterialCountChemical?: Ns4CheckingChemical;
    totalMoldAmount?: number;
    totalMoldChemical?: Ns4CheckingChemical;
    productReleaseResultFile?: FileUpload;
}

export interface DomesticSalesVoucherAddition {
    invoice?: string;
    lotNo?: string;
    produceDate?: any;
    tariffCode?: string;
    productCode?: string;
    productTypeTariffCodeTh?: string;
    productTypeTariffCodeEn?: string;
    amountPackingContainer?: number;
    unitPackingContainer?: PackageUnit;
    netWeight?: number;
    netWeightUnit?: Unit;
    grossWeight?: number;
    grossWeightUnit?: Unit;
    price?: number;
    currency?: string;
    currencyUnit?: Currency;
    priceBaht?: number;
    fobBath?: number;
    originCountry?: Country;
    packageType?: PackageType;
    packageTypeOther?: string;
    packingSize?: number;
    packingUnit?: Unit;
}

export interface DomesticSalesVoucherDetail {
    voucherNo?: string;
    licensingIssue?: string;
    brandNameEn?: string;
    brandNameTH?: string;
    manufacturerName?: string;
    manufacturerAddress?: string;
    importerName?: string;
    importerAddress?: string;
    animalFeedType?: AnimalFeedType;
    purpose?: string;
    packagesDurationMonth?: string;
    packagesNetWeight?: string;
    labelFeedWarning?: string;
    manualFlag?: boolean;
    importFlag?: boolean;
}

export interface Ns4 extends AbstractAuditingEntity, SignableForm {
    id?: number;
    department?: Department;
    feedType?: Ns4FeedType;
    petitionNo?: string;
    requestNo?: string;
    filingDate?: any;
    receivedDate?: any;
    resolvedDate?: any;
    basicConsiderationDate?: any;
    academicConsiderationDate?: any;
    makeCertificateDate?: any;
    offerSignDate?: any;
    considerOrderingDate?: any;
    productInspectionDate?: any;
    considerProductReleaseDate?: any;
    productReleaseResultDate?: any;
    considerUser?: Officer;
    considerName?: string;
    issuerPosition?: string;
    ns4No?: string;
    ns4For?: string;
    writeAt?: string;
    requestLicensing?: Ns4RequestLicensing;
    ns4Warehouses?: Location[];
    entrepreneurs?: Ns4Entrepreneur[];
    objective?: Ns4Objective;
    domesticSalesVouchers?: Ns4DomesticSalesVoucher[];
    domesticSalesAudits?: Ns4DomesticSalesAudit[];
    files?: { [P in Ns4FileType]?: Ns4File };
    fileNameDocumentOther?: string;
    foreignManufacturer?: Ns4ForeignManufacturer;
    ownerGroup?: OwnerGroup;
    manualFlag?: boolean;
    importDataFlag?: boolean;
    userId?: number;
    receivedNo?: string;
}

export interface Ns4AcademicConsideration extends AbstractAuditingEntity {
    id?: number;
    considerer?: Officer;
    considererName?: string;
    considererPosition?: string;
    considererComment?: string;
    officerComment?: string;
    attachFile?: FileUpload;
    acceptCorrection?: boolean;
    acceptCorrectionDate?: any;
    statementComment?: string;
    statementFile?: FileUpload;
    correctionItems?: Ns4AcademicCorrectionItem[];
}

export interface Ns4AcademicCorrectionItem extends CorrectionItem {
}

export interface Ns4AuditAddedIngredient extends AbstractAuditingEntity {
    id?: number;
    mixIngredientType?: MixIngredientType;
    mixIngredientSubType?: MixIngredientSubType;
    mixIngredientSubtypeOthers?: string;
    mixIngredientSubTypeName?: MixIngredientSubTypeName;
    mixIngredientSubTypeNameOthers?: string;
    amount?: number;
    unit?: Unit;
    result?: number;
    file?: FileUpload;
    productReleaseResult?: number;
}

export interface Ns4AuditQuality extends AbstractAuditingEntity {
    id?: number;
    qualityType?: QualityType;
    ratio?: number;
    result?: number;
    productReleaseResult?: number;
    file?: FileUpload;
    ns4CheckingChemical?: Ns4CheckingChemical;
}

export interface Ns4BasicConsideration extends AbstractAuditingEntity {
    id?: number;
    considerer?: Officer;
    considererName?: string;
    considererPosition?: string;
    correctionComment?: string;
    correctionFile?: FileUpload;
    statementComment?: string;
    statementFile?: FileUpload;
    acceptCorrection?: boolean;
    acceptCorrectionDate?: any;
    correctionItems?: Ns4BasicCorrectionItem[];
}

export interface Ns4BasicCorrectionItem extends CorrectionItem {
}

export interface Ns4ConsiderNo extends AbstractAuditingEntity {
    id?: Ns4ConsiderNoId;
    currentNo?: number;
    years?: number;
}

export interface Ns4ConsiderOrdering extends AbstractAuditingEntity {
    id?: number;
    considerer?: Officer;
    considererName?: string;
    considererPosition?: string;
    considererComment?: string;
    attachFile?: FileUpload;
    statementComment?: string;
    statementFile?: FileUpload;
    notApproveBecause?: string;
    approveWithConditionBecause?: string;
    acceptCorrection?: boolean;
    acceptCorrectionDate?: any;
    approveStatus?: ApproveStatus;
    releaseDate?: any;
    correctionItems?: Ns4ConsiderOrderingCorrectionItem[];
}

export interface Ns4ConsiderOrderingCorrectionItem extends CorrectionItem {
}

export interface Ns4DomesticSalesAudit {
    id?: number;
    auditFile?: FileUpload;
    domesticSalesAuditAddition?: DomesticSalesAuditAddition;
    domesticSalesAuditDetail?: DomesticSalesAuditDetail;
    releaseResultDetail?: DomesticSalesProductReleaseResultDetail;
    addedIngredients?: Ns4AuditAddedIngredient[];
    qualities?: Ns4AuditQuality[];
    officerComment?: Ns4OfficerComment;
    ns4ProductConsiderationResult?: Ns4ProductConsiderationResult;
    audit?: Audit;
}

export interface Ns4DomesticSalesVoucher {
    id?: number;
    domesticSalesVoucherAddition?: DomesticSalesVoucherAddition;
    domesticSalesVoucherDetail?: DomesticSalesVoucherDetail;
    releaseResultDetail?: DomesticSalesProductReleaseResultDetail;
    ns4VoucherAddedIngredients?: Ns4VoucherAddedIngredient[];
    ns4VoucherQualities?: Ns4VoucherQuality[];
    fileVoucher?: FileUpload;
    officerComment?: Ns4OfficerComment;
    voucher?: Voucher;
    ns4VoucherPackages?: Ns4VoucherPackage[];
    ns4ProductConsiderationResult?: Ns4ProductConsiderationResult;
}

export interface Ns4Entrepreneur extends AbstractEntrepreneur {
    id?: number;
}

export interface Ns4EntrepreneurFile extends FileUpload {
}

export interface Ns4File extends FileUpload {
    fileType?: Ns4FileType;
}

export interface Ns4ForeignManufacturer extends AbstractAuditingEntity {
    id?: number;
    companyName?: string;
    address?: string;
}

export interface Ns4Form extends AbstractAuditingEntity, FormDraft, SignableForm {
    id?: number;
    department?: Department;
    feedType?: Ns4FeedType;
    dtype?: FormType;
    filingOffice?: FilingOffice;
    dofOrg?: DofOrg;
    requestType?: RequestType;
    petitionNo?: string;
    requestNo?: string;
    ns4No?: string;
    ns4ConsiderNo?: string;
    filingDate?: any;
    receivedDate?: any;
    resolvedDate?: any;
    basicConsiderationDate?: any;
    academicConsiderationDate?: any;
    makeCertificateDate?: any;
    offerSignDate?: any;
    considerOrderingDate?: any;
    productInspectionDate?: any;
    considerProductReleaseDate?: any;
    productReleaseResultDate?: any;
    productSampleDate?: any;
    seizeReportDate?: any;
    formStatus?: Ns4FormStatus;
    user?: Applicant;
    considerUser?: Officer;
    entrepreneurs?: Ns4Entrepreneur[];
    formObjective?: Ns4Objective;
    domesticSalesVouchers?: Ns4DomesticSalesVoucher[];
    domesticSalesAudits?: Ns4DomesticSalesAudit[];
    ns4Warehouses?: Location[];
    foreignManufacturer?: Ns4ForeignManufacturer;
    requestLicensing?: Ns4RequestLicensing;
    fileNameDocumentOther?: string;
    basicConsideration?: Ns4BasicConsideration;
    academicConsideration?: Ns4AcademicConsideration;
    makeCertificate?: Ns4MakeCertificate;
    offerSign?: Ns4OfferSign;
    considerOrdering?: Ns4ConsiderOrdering;
    productConsideration?: Ns4ProductConsideration;
    commentOfficer?: string;
    ns4?: Ns4;
    correctionRemark?: string;
    lastedCorrectionStatus?: Ns4CorrectionFormStatus;
    filingLocation?: FilingLocation;
    fsw?: boolean;
}

export interface Ns4Form1 extends Ns4Form {
    f1Files?: { [P in Ns4Form1FileType]?: Ns4Form1File };
}

export interface Ns4Form1File extends FileUpload {
    fileType?: Ns4Form1FileType;
}

export interface Ns4Form1ImportInfo extends AbstractAuditingEntity {
    id?: number;
    containerQty?: number;
    contaienrNo?: string;
    netWeight?: number;
    countryOrigin?: Country;
    portOrigin?: string;
    departDate?: any;
    transportBy?: TransportType;
    vesselNo?: string;
    portProvince?: Province;
    importDate?: any;
    checkpoint?: DofOrg;
    awbblNo?: string;
    awbblDate?: any;
    billOfLanding?: FileUpload;
    invoiceNo?: string;
    invoiceDate?: any;
    invoice?: FileUpload;
    packingList?: FileUpload;
}

export interface Ns4Form1Licensing extends AbstractAuditingEntity {
    id?: number;
    requestNo?: string;
    petitionNo?: string;
    filingDate?: any;
    receivedDate?: any;
    licenseType?: LicenseType;
    licensingIssue?: string;
    licensingBook?: string;
    licensingExpireDate?: any;
    licenseFor?: string;
    file?: FileUpload;
}

export interface Ns4Form1Objective extends AbstractAuditingEntity {
    id?: number;
    ns4Form1ImportInfo?: Ns4Form1ImportInfo;
    ns4Form1Product?: Ns4Form1Product;
}

export interface Ns4Form1Product extends AbstractAuditingEntity {
    id?: number;
    vouchers?: { [index: string]: Voucher };
}

export interface Ns4Form2 extends Ns4Form {
    f2Files?: { [P in Ns4Form2FileType]?: Ns4Form2File };
    correctionRequest?: Ns4FormCorrectionRequest;
}

export interface Ns4Form2File extends FileUpload {
    fileType?: Ns4Form2FileType;
}

export interface Ns4Form2ImportInfo extends AbstractAuditingEntity {
    id?: number;
    containerQty?: number;
    contaienrNo?: string;
    netWeight?: number;
    countryOrigin?: Country;
    portOrigin?: string;
    departDate?: any;
    transportBy?: TransportType;
    vesselNo?: string;
    portProvince?: Province;
    importDate?: any;
    checkpoint?: DofOrg;
    awbblNo?: string;
    awbblDate?: any;
    billOfLanding?: FileUpload;
    invoiceNo?: string;
    invoiceDate?: any;
    invoice?: FileUpload;
    packingList?: FileUpload;
}

export interface Ns4Form2Licensing extends AbstractAuditingEntity {
    id?: number;
    requestNo?: string;
    petitionNo?: string;
    filingDate?: any;
    receivedDate?: any;
    licenseType?: LicenseType;
    licensingIssue?: string;
    licensingBook?: string;
    licensingExpireDate?: any;
    licenseFor?: string;
    file?: FileUpload;
}

export interface Ns4Form2Objective extends AbstractAuditingEntity {
    id?: number;
    ns4Form2ImportInfo?: Ns4Form2ImportInfo;
    ns4Form2Product?: Ns4Form2Product;
}

export interface Ns4Form2Product extends AbstractAuditingEntity {
    id?: number;
    vouchers?: { [index: string]: Voucher };
}

export interface Ns4FormCorrectionRequest {
    id?: number;
    licensingOld?: boolean;
    importInfo?: boolean;
    domesticSale?: boolean;
    wareHouses?: boolean;
    documentFiles?: boolean;
    requestCorrectionItems?: { [index: string]: Ns4FormRequestCorrectionItem };
}

export interface Ns4FormRequestCorrectionItem extends RequestCorrectionItem {
}

export interface Ns4ImportInfo extends AbstractAuditingEntity {
    id?: number;
    containerQty?: number;
    containerNo?: string;
    netWeight?: number;
    netWeightUnit?: Unit;
    countryOrigin?: Country;
    portOrigin?: Port;
    departDate?: any;
    transportBy?: TransportType;
    transportOther?: string;
    vesselNo?: string;
    portProvince?: Province;
    importDate?: any;
    dofPort?: DofPort;
    customsOrg?: CustomsOrg;
    customsStation?: string;
    awbblNo?: string;
    awbblDate?: any;
    billOfLanding?: FileUpload;
    invoiceNo?: string;
    invoiceDate?: any;
    invoice?: FileUpload;
    packingList?: FileUpload;
}

export interface Ns4Licensing extends AbstractAuditingEntity {
    id?: number;
    requestNo?: string;
    petitionNo?: string;
    filingDate?: any;
    receivedDate?: any;
    licenseType?: LicenseType;
    licensingIssue?: string;
    licensingBook?: string;
    licensingExpireDate?: any;
    licenseFor?: string;
    file?: FileUpload;
}

export interface Ns4MakeCertificate extends AbstractAuditingEntity {
    id?: number;
    considerer?: Officer;
    considererName?: string;
    considererPosition?: string;
    correctionComment?: string;
    correctionFile?: FileUpload;
    statementComment?: string;
    statementFile?: FileUpload;
    acceptCorrection?: boolean;
    acceptCorrectionDate?: any;
}

export interface Ns4No extends AbstractAuditingEntity {
    id?: Ns4NoId;
    currentNo?: number;
    years?: number;
}

export interface Ns4Objective extends AbstractAuditingEntity {
    id?: number;
    ns4ImportInfo?: Ns4ImportInfo;
}

export interface Ns4OfferSign extends AbstractAuditingEntity {
    id?: number;
    considerer?: Officer;
    considererName?: string;
    considererPosition?: string;
    considererComment?: string;
    attachFile?: FileUpload;
    statementComment?: string;
    statementFile?: FileUpload;
    acceptCorrection?: boolean;
    acceptCorrectionDate?: any;
    correctionItems?: Ns4OfferSignCorrectionItem[];
}

export interface Ns4OfferSignCorrectionItem extends CorrectionItem {
}

export interface Ns4OfficerComment {
    melamine?: boolean;
    proteinFatResidueMoistureAsh?: boolean;
    dnaRuminant?: boolean;
    salmonella?: boolean;
    aflatoxin?: boolean;
    totalMold?: boolean;
    mycotoxin?: boolean;
    heavyMetal?: boolean;
    dioxin?: boolean;
    other?: boolean;
    otherSampling?: string;
    confiscationProduct?: ConfiscationProduct;
    sampleAnimalFeed?: SampleAnimalFeed;
    sampling?: Sampling;
    animalFeedSampleCollect?: string;
    forEntrepreneur?: string;
    forAquaticAnimalFeed?: string;
    sentForAnalysis?: string;
}

export interface Ns4ProductConsideration {
    id?: number;
    ns4Operator?: Ns4Operator;
    productInspector?: Officer;
    productInspectorName?: string;
    productInspectorPosition?: string;
    productConsiderer?: Officer;
    productConsidererName?: string;
    productConsidererPosition?: string;
    ns4ProductSample?: Ns4ProductSample;
    importDate?: any;
    transportNo?: string;
    transportDate?: any;
    tel?: string;
    fax?: string;
    investigators?: Officer[];
    entrepreneurs?: Entrepreneur[];
    shippings?: Shipping[];
    ns4ProductReleaseResult?: Ns4ProductReleaseResult;
    sampleResult?: Ns4SampleResult;
}

export interface Ns4ProductConsiderationResult {
    id?: number;
    labelResult?: LabelResult;
    labelResultInvalidDesc?: string;
    amountResult?: AmountResult;
    amountResultInvalidDesc?: string;
    checkingResult?: CheckingResult;
    checkingResultInvalidDesc?: string;
    considerer?: Officer;
    considererName?: string;
    considererPosition?: string;
}

export interface Ns4ProductReleaseResult {
    id?: number;
    productReleaseUser?: Officer;
    productReleaseUserName?: string;
    productReleaseUserPosition?: string;
    releaseResults?: Ns4ReleaseResult;
    notPassComment?: string;
    conditionComment?: string;
    releaseSomeComment?: string;
}

export interface Ns4ProductSample {
    id?: number;
    writeAt?: string;
    sampleDate?: any;
    sampleTime?: any;
    auditTrail?: string;
    officerName1?: string;
    officerPosition1?: string;
    officerName2?: string;
    officerPosition2?: string;
}

export interface Ns4RequestLicensing extends RequestLicensing<Ns4RequestLicensingItem> {
    licensingItems?: Ns4RequestLicensingItem[];
    files?: { [P in LicensingFileType]?: LicensingFile };
    entrepreneurs?: LicensingEntrepreneur[];
    location?: Location;
    warehouses?: Location[];
}

export interface Ns4RequestLicensingItem extends RequestLicensingItem {
}

export interface Ns4VoucherAddedIngredient extends AbstractAuditingEntity {
    id?: number;
    mixIngredientType?: MixIngredientType;
    mixIngredientSubType?: MixIngredientSubType;
    mixIngredientSubtypeOthers?: string;
    mixIngredientSubTypeName?: MixIngredientSubTypeName;
    mixIngredientSubTypeNameOthers?: string;
    amount?: number;
    unit?: Unit;
    result?: number;
    analysisResultExponent?: string;
    amountExponent?: string;
    productReleaseResult?: number;
    file?: FileUpload;
}

export interface Ns4VoucherPackage extends AbstractAuditingEntity {
    id?: number;
    packageType?: PackageType;
    packageTypeOthers?: string;
    packageUnit?: Unit;
    netWeight?: number;
    durationMonth?: number;
}

export interface Ns4VoucherQuality extends AbstractAuditingEntity {
    id?: number;
    qualityType?: QualityType;
    ratio?: number;
    result?: number;
    productReleaseResult?: number;
    file?: FileUpload;
    ns4CheckingChemical?: Ns4CheckingChemical;
}

export interface Ns4ConsiderNoId {
    dofPortCode?: string;
    documentType?: Ns4DocumentType;
    module?: Modules;
    systemType?: Ns4SystemType;
}

export interface Ns4NoId {
    documentType?: Ns4DocumentType;
    module?: Modules;
    systemType?: Ns4SystemType;
}

export interface MedicinesAndResidues {
    oxytetracyclineFoundScreeningTest?: Ns4Discover;
    oxytetracyclineChemicalScreeningTest?: Ns4CheckingChemical;
    oxytetracyclineFoundUplc?: Ns4Discover;
    oxytetracyclineChemicalUplc?: Ns4CheckingChemical;
    chlortetracyclineFoundScreeningTest?: Ns4Discover;
    chlortetracyclineChemicalScreeningTest?: Ns4CheckingChemical;
    chlortetracyclineFoundUplc?: Ns4Discover;
    chlortetracyclineChemicalUplc?: Ns4CheckingChemical;
    nitrofutansFoundScreeningTest?: Ns4Discover;
    nitrofutansChemicalScreeningTest?: Ns4CheckingChemical;
    nitrofutansFoundUplc?: Ns4Discover;
    nitrofutansChemicalUplc?: Ns4CheckingChemical;
    chloramphenicolFoundScreeningTest?: Ns4Discover;
    chloramphenicolChemicalScreeningTest?: Ns4CheckingChemical;
    chloramphenicolFoundUplc?: Ns4Discover;
    chloramphenicolChemicalUplc?: Ns4CheckingChemical;
    ethoxyquinFoundScreeningTest?: Ns4Discover;
    ethoxyquinChemicalScreeningTest?: Ns4CheckingChemical;
    ethoxyquinFoundUplc?: Ns4Discover;
    ethoxyquinChemicalUplc?: Ns4CheckingChemical;
}

export interface Mycotoxin {
    totalAflatoxinAmount?: number;
    totalAflatoxinChemical?: Ns4CheckingChemical;
    zearalenoneAmount?: number;
    zearalenoneChemical?: Ns4CheckingChemical;
    fumonisinAmount?: number;
    fumonisinChemical?: Ns4CheckingChemical;
    aflatoxinB1Amount?: number;
    aflatoxinB1Chemical?: Ns4CheckingChemical;
}

export interface ProductReleaseResultChemicalBL {
    ammelideAmount?: number;
    ammelideChemical?: Ns4CheckingChemical;
    ammelineAmount?: number;
    ammelineChemical?: Ns4CheckingChemical;
    cyanuricAcidAmount?: number;
    cyanuricAcidChemical?: Ns4CheckingChemical;
    melamineAmount?: number;
    melamineChemical?: Ns4CheckingChemical;
}

export interface Ns4FeedImportDto {
    id?: string;
    importer?: string;
    ns4For?: string;
    invoiceNo?: string;
    invoiceDate?: string;
    receivedNo?: string;
    receivedDate?: string;
    receiver?: string;
    ns4No?: string;
    ns4Date?: string;
    productCountry?: string;
    portName?: string;
    brandNameTh?: string;
    brandNameEn?: string;
    voucherNo?: string;
    hsCode?: string;
    animalFeedType?: string;
    animalType?: string;
    usedFor?: string;
    concreteFeedType?: string;
    packingSize?: string;
    weightUnit?: string;
    packaging?: string;
    quantity?: string;
    totalWeight?: string;
    value?: string;
    currency?: string;
    price?: string;
    cardNumber?: string;
    department?: string;
    licenseType?: string;
    licensingBook?: string;
    licensingIssue?: string;
    years?: string;
    companyBranch?: string;
}

export interface Ns4FeedOtherImportDto {
    importer?: string;
    ns4For?: string;
    invoiceNo?: string;
    invoiceDate?: string;
    receivedNo?: string;
    receivedDate?: string;
    receiver?: string;
    ns4No?: string;
    ns4Date?: string;
    manufacturerName?: string;
    portName?: string;
    brandNameTh?: string;
    brandNameEn?: string;
    animalFeedType?: string;
    animalType?: string;
    usedFor?: string;
    concreteFeedType?: string;
    packingSize?: string;
    weightUnit?: string;
    packaging?: string;
    value?: string;
    currency?: string;
    price?: string;
    cardNumber?: string;
    department?: string;
    licenseType?: string;
    licensingBook?: string;
    licensingIssue?: string;
    warehouse?: string;
    auditRef?: string;
    netWeightUnit?: string;
    netWeight?: string;
    grossWeight?: string;
    grossWeightUnit?: string;
    unitPackingContainer?: string;
    amountPackingContainer?: string;
    importerAddress?: string;
    years?: string;
    manufacturerAddress?: string;
    companyBranch?: string;
    manufacturerCountry?: string;
}

export interface Ns4FormSearchAcademicConsideration {
    requestNo?: string;
    petitionNo?: string;
    receivedDateFrom?: any;
    receivedDateTo?: any;
    resolvedDateFrom?: any;
    resolvedDateTo?: any;
    formStatus?: Ns4FormStatus;
    formType?: FormType;
    requestEntrepreneur?: string;
}

export interface Ns4FormSearchAssignWork {
    receivedDateFrom?: any;
    receivedDateTo?: any;
    requestNo?: string;
    requestEntrepreneur?: string;
}

export interface Ns4FormSearchBasicConsider {
    requestNo?: string;
    petitionNo?: string;
    filingDateFrom?: any;
    filingDateTo?: any;
    receivedDateFrom?: any;
    receivedDateTo?: any;
    resolvedDateFrom?: any;
    resolvedDateTo?: any;
    applicant?: Applicant;
    entrepreneur?: Entrepreneur;
    formStatus?: Ns4FormStatus;
    formType?: FormType;
    requestEntrepreneur?: string;
    createDatedFrom?: any;
    createDatedTo?: any;
    ns4No?: string;
}

export interface Ns4FormSearchConsiderOrdering {
    requestNo?: string;
    petitionNo?: string;
    offerSignDateForm?: any;
    offerSignDateTo?: any;
    considerOrderingDateFrom?: any;
    considerOrderingDateTo?: any;
    formStatus?: Ns4FormStatus;
    formType?: FormType;
    requestEntrepreneur?: string;
}

export interface Ns4FormSearchConsiderProductRelease {
    ns4No?: string;
    productReleaseResultDateFrom?: any;
    productReleaseResultDateTo?: any;
    considerProductReleaseDateFrom?: any;
    considerProductReleaseDateTo?: any;
    formStatus?: Ns4FormStatus;
    importerName?: string;
}

export interface Ns4FormSearchFiling {
    keyword?: string;
    formType?: FormType;
    formStatus?: Ns4FormStatus;
    filingDateFrom?: any;
    filingDateTo?: any;
}

export interface Ns4FormSearchMakeCertificate {
    requestNo?: string;
    petitionNo?: string;
    academicConsiderationDateFrom?: any;
    academicConsiderationDateTo?: any;
    makeCertificateDateFrom?: any;
    makeCertificateDateTo?: any;
    formStatus?: Ns4FormStatus;
    formType?: FormType;
    requestEntrepreneur?: string;
}

export interface Ns4FormSearchOfferSign {
    requestNo?: string;
    petitionNo?: string;
    makeCertificateDateFrom?: any;
    makeCertificateDateTo?: any;
    offerSignDateForm?: any;
    offerSignDateTo?: any;
    formStatus?: Ns4FormStatus;
    formType?: FormType;
    requestEntrepreneur?: string;
}

export interface Ns4FormSearchProductInspection {
    ns4No?: string;
    makeCertificateDateFrom?: any;
    makeCertificateDateTo?: any;
    productInspectionDateFrom?: any;
    productInspectionDateTo?: any;
    formStatus?: Ns4FormStatus;
    importerName?: string;
    releaseDateFrom?: any;
    releaseDateTo?: any;
}

export interface Ns4FormSearchProductReleaseResult {
    ns4No?: string;
    considerProductReleaseDateFrom?: any;
    considerProductReleaseDateTo?: any;
    productReleaseResultDateFrom?: any;
    productReleaseResultDateTo?: any;
    productSampleDateFrom?: any;
    productInspectionDateFrom?: any;
    productInspectionDateTo?: any;
    productSampleDateTo?: any;
    formStatus?: Ns4FormStatus;
    importerName?: string;
}

export interface Ns4ConsiderOrderingProjection {
    releaseDate?: any;
}

export interface Ns4FormProjection {
    id?: number;
    user?: ApplicantProjection;
    entrepreneurs?: Ns4Entrepreneur[];
    considerOrderingDate?: any;
    considerOrdering?: Ns4ConsiderOrderingProjection;
    requestNo?: string;
    petitionNo?: string;
    filingDate?: any;
    receivedDate?: any;
    formStatus?: Ns4FormStatus;
    resolvedDate?: any;
    basicConsiderationDate?: any;
    academicConsiderationDate?: any;
    offerSignDate?: any;
    dtype?: FormType;
    fsw?: boolean;
    makeCertificateDate?: any;
    productInspectionDate?: any;
    considerProductReleaseDate?: any;
    productReleaseResultDate?: any;
    ns4No?: string;
    productSampleDate?: any;
    ns4ConsiderNo?: string;
}

export interface Ns4Projection {
    id?: number;
    createdDate?: any;
    lastUpdatedDate?: any;
    requestNo?: string;
    department?: Department;
    ns4No?: string;
    ns4For?: string;
}

export interface BankTransferFile extends FileUpload {
    sha1?: string;
    items?: BankTransferItem[];
    itemCnt?: number;
    uploadByOfficer?: Officer;
}

export interface BankTransferItem {
    id?: number;
    payment?: Payment;
    recordType?: string;
    bankReference?: string;
    tranDate?: any;
    tranTime?: any;
    confirmDate?: any;
    tranAmt?: number;
    chequeNumber?: string;
    chequeBankCode?: string;
    transactionType?: string;
    customerReferenceName?: string;
    companyReference2?: string;
    payBillDate?: any;
    companyReference3?: string;
    sequenceNumber?: number;
    companyReference1?: string;
    payTranStatus?: string;
    payTranType?: string;
    filter?: string;
}

export interface LocallityCompCode {
    id?: LocallityCompCodePK;
    feeRate?: FeeRate;
    dofOrg?: DofOrg;
    compCode?: string;
    ref2?: string;
}

export interface Payment extends AbstractAuditingEntity, SignableForm {
    id?: number;
    reference1?: string;
    reference2?: string;
    paymentDateTime?: any;
    dueDateTime?: any;
    confirmDateTime?: any;
    cancelDateTime?: any;
    feeRateCompCode?: FeeRateCompCode;
    amount?: number;
    channel?: string;
    branch?: string;
    terminal?: string;
    name?: string;
    reqNo?: string;
    amountInWord?: string;
    formatedAmount?: string;
    dueDateString?: string;
    customerName?: string;
    customerEmail?: string;
    performUsername?: string;
    performName?: string;
    taxId?: string;
    suffix?: string;
    uuid?: string;
    status?: PaymentStatus;
    txId?: string;
    bankTransferFlag?: boolean;
    receiptFile?: FileUpload;
    compCode?: string;
    receipNo?: string;
    manualReceiptNo?: string;
    receiptDate?: any;
    proofOfPaymentFile?: FileUpload;
    informDateTime?: any;
    note?: string;
    reasonPrintCopyReceipt?: string;
    receiptPrintStatus?: ReceiptPrintStatus;
    createdReceiptUser?: Officer;
    bankTransferItem?: BankTransferItem;
    version?: number;
}

export interface PaymentInfo {
    id?: number;
    formId?: number;
    formType?: FormType;
    requestNo?: string;
    requestType?: string;
    formStatus?: string;
    reference1?: string;
    reference2?: string;
    amount?: number;
    module?: Modules;
    feeName?: string;
    createdName?: string;
    paymentDateTime?: any;
    informDateTime?: any;
    confirmDateTime?: any;
    paymentStatus?: PaymentStatus;
    receiptFile?: FileUpload;
    email?: string;
    cardNumber?: string;
    filingOffice?: FilingOffice;
    dofOrg?: DofOrg;
    petitionNo?: string;
    receiptPrintStatus?: ReceiptPrintStatus;
    proofOfPaymentFile?: FileUpload;
    createdUser?: Applicant;
    createdReceiptUser?: Officer;
    receipNo?: string;
    manualReceiptNo?: string;
    receiptDate?: any;
    uuid?: string;
    compCode?: string;
}

export interface PaymentNo {
    id?: PaymentType;
    years?: number;
    currentNo?: number;
}

export interface BankTransferDataParser {
}

export interface BankTransferData {
    header?: Header;
    details?: Detail[];
}

export interface Detail {
    recordType?: string;
    bankReference?: string;
    tranDatePlainText?: string;
    tranDate?: any;
    tranTimePlainText?: string;
    tranTime?: any;
    tranAmt?: number;
    chequeNumber?: string;
    chequeBankCode?: string;
    transactionType?: string;
    customerReferenceName?: string;
    companyReference2?: string;
    payBillDatePlainText?: string;
    payBillDate?: any;
    companyReference3?: string;
    sequenceNumber?: number;
    companyReference1?: string;
    payTranStatus?: string;
    payTranType?: string;
    filter?: string;
}

export interface Header {
    recordType?: string;
    payCompanyCode?: string;
}

export interface BankTransferSearchParam {
    createdDateFrom?: any;
    createdDateTo?: any;
    fileName?: string;
}

export interface PaymentReceiptFactory {
}

export interface PaymentReceiptReportData {
    paymentInfo?: PaymentInfo;
    payment?: Payment;
    details?: Row[];
    taxId?: string;
    receiptDate?: string;
    receiptNo?: string;
    createdUserName?: string;
    createdAddress?: string;
    amountInText?: string;
    createAt?: string;
    receiptUser?: string;
    receiptUserPosition?: string;
}

export interface Row {
    detail?: string;
    qty?: number;
    amount?: number;
}

export interface PaymentReceiptRequestDto {
    paymentId?: number;
    uuid?: string;
    receiptFile?: FileUpload;
}

export interface PaymentSearchRequest {
    paymentInfo?: PaymentInfo;
    informStartDate?: any;
    informEndDate?: any;
    comfirmStartDate?: any;
    confirmEndDate?: any;
    modules?: Modules[];
    requestNo?: string;
    companyName?: string;
    corporateNumber?: string;
    applicantName?: string;
}

export interface ApplicantProjection {
    id?: number;
    username?: string;
    email?: string;
    firstNameTh?: string;
    lastNameTh?: string;
    identityCard?: IdentityCardLite;
    fullNameTh?: string;
    personType?: PersonType;
    applicantName?: string;
    company?: CompanyLite;
    authorities?: Authority[];
}

export interface CompanyProjection {
    id?: number;
    address?: string;
    email?: string;
    nameTh?: string;
    branch?: string;
    soi?: string;
    street?: string;
    moo?: string;
    tambon?: Tambon;
    postalCode?: string;
    nameEn?: string;
    tel?: string;
    corporateNumber?: string;
    companyType?: CompanyType;
    taxId?: string;
    dateOfRegistration?: any;
    registeredCapital?: number;
    users?: ApplicantProjection[];
}

export interface RequestAgentProjection {
    owner?: UserOwnerProjection;
    email?: string;
    authorities?: Authority[];
    uuid?: string;
    expiredDate?: any;
    ownerId?: number;
}

export interface RequestRegisterFormProjection {
    id?: number;
    status?: RequestRegisterStatus;
    user?: ApplicantProjection;
    requestNo?: string;
    filingDate?: any;
    requestUser?: RequestUserProjection;
    registerType?: RequestRegisterType;
}

export interface RequestUserProjection {
    id?: number;
    title?: Title;
    username?: string;
    files?: { [P in RequestUserFileType]?: RequestUserFile };
    email?: string;
    firstNameTh?: string;
    lastNameTh?: string;
    birthDate?: any;
    nation?: Nation;
    contactAddress?: ContactAddress;
    identityCard?: IdentityCard;
    fullNameTh?: string;
    firstNameEn?: string;
    lastNameEn?: string;
    personType?: PersonType;
    addressEn?: AddressEn;
    company?: RequestCompany;
    authorities?: Authority[];
    performType?: PerformType;
    refId?: number;
}

export interface TambonFullEnAddress extends TambonWithFullName {
    nameEn?: string;
    fullAddress?: string;
    amphur?: Amphur;
}

export interface TambonWithFullName {
    name?: string;
    id?: number;
    fullName?: string;
}

export interface UserOwnerProjection {
    user?: ApplicantProjection;
    userId?: number;
}

export interface UserReport2 {
    count?: number;
    authority?: AuthorityType;
}

export interface UserReport2b {
    count?: number;
    userType?: UserType;
}

export interface UserReport3 {
    entrepreneur?: Entrepreneur;
    companyNameTh?: string;
}

export interface UserReport5 {
    email?: string;
    companyNameTh?: string;
    employee?: Employee;
}

export interface RequestInspection extends AbstractAuditingEntity, SignableForm {
    id?: number;
    issuer?: Officer;
    issuerName?: string;
    issuerPosition?: string;
    requestInspectionNo?: string;
    receivedDate?: any;
    requestNo?: string;
    user?: Applicant;
    authorizedDirectors?: RequestInspectionAuthorizedDirector[];
    entrepreneurs?: RequestInspectionEntrepreneur[];
    files?: { [P in RequestInspectionFileType]?: RequestInspectionFile };
    requestInspectionRequest?: RequestInspectionRequest;
    ownerGroup?: OwnerGroup;
    requestInspectionLicensing?: RequestInspectionLicensing;
    exporter?: string;
    requestInspectIssueDate?: any;
    requestInspectExpiredDate?: any;
    sendNotifyExpireDate?: boolean;
    notifyEmail?: string;
    manualFlag?: boolean;
    requestInspectionFormRequest?: RequestInspectionRequest;
}

export interface RequestInspectionAttorney extends AbstractAuditingEntity {
    id?: number;
    title?: Title;
    firstNameTh?: string;
    lastNameTh?: string;
    firstNameEn?: string;
    lastNameEn?: string;
    identityCard?: IdentityCard;
    requestInspection?: RequestInspection;
    fullNameTh?: string;
}

export interface RequestInspectionAudit {
    id?: number;
    animalFeedType?: AnimalFeedType;
    auditRef?: string;
    productType?: AuditProductType;
    brand?: Brand;
    files?: { [P in RequestInspectionAuditFileType]?: RequestInspectionAuditFile };
}

export interface RequestInspectionAuditFile extends FileUpload {
    other?: string;
    fileType?: RequestInspectionAuditFileType;
}

export interface RequestInspectionAuthorizedDirector extends AbstractAuthorizedDirector {
    id?: number;
}

export interface RequestInspectionCodeRunning extends AbstractAuditingEntity {
    year?: string;
    seq?: number;
}

export interface RequestInspectionConsideration extends AbstractAuditingEntity {
    id?: number;
    considerer?: Officer;
    considererName?: string;
    considererPosition?: string;
    considererComment?: string;
    approveStatus?: ApproveStatus;
    correctionItems?: RequestInspectionConsiderationCorrectionItem[];
}

export interface RequestInspectionConsiderationCorrectionItem extends CorrectionItem {
}

export interface RequestInspectionEntrepreneur extends AbstractEntrepreneur {
    id?: number;
    files?: { [P in RequestInspectionEntrepreneurFileType]?: RequestInspectionEntrepreneurFile };
}

export interface RequestInspectionEntrepreneurFile extends FileUpload {
    fileType?: RequestInspectionEntrepreneurFileType;
}

export interface RequestInspectionFile extends FileUpload {
    fileType?: RequestInspectionFileType;
    certDepartment?: Department;
    certNo?: string;
    other?: string;
}

export interface RequestInspectionForm extends AbstractAuditingEntity, SignableForm, FormDraft {
    id?: number;
    dtype?: FormType;
    filingOffice?: FilingOffice;
    dofOrg?: DofOrg;
    requestNo?: string;
    petitionNo?: string;
    filingDate?: any;
    receivedDate?: any;
    issuer?: Officer;
    issuerName?: string;
    issuerPosition?: string;
    ns4No?: string;
    remarkFromStaff?: string;
    jobRemark?: string;
    requestInspectionConsideration?: RequestInspectionConsideration;
    requestInspectionFormAuthorizedDirectors?: RequestInspectionAuthorizedDirector[];
    requestInspectionFormEntrepreneurs?: RequestInspectionEntrepreneur[];
    payment?: Payment;
    requestLicensing?: RequestInspectionRequestLicensing;
    filingLocation?: FilingLocation;
    exporter?: string;
    formStatus?: RequestInspectionFormStatus;
    user?: Applicant;
    requestInspectionFormRequest?: RequestInspectionFormRequest;
    requestInspectionSignProposal?: RequestInspectionSignProposal;
    requestInspectionOrder?: RequestInspectionOrder;
    requestInspection?: RequestInspection;
    formStatusDesc?: string;
}

export interface RequestInspectionForm1 extends RequestInspectionForm {
    f1Department?: Department;
    f1Files?: { [P in RequestInspectionForm1FileType]?: RequestInspectionForm1File };
}

export interface RequestInspectionForm1CertificateMessage {
    id?: number;
    certificateOfFreeSale?: boolean;
    certificateOfHealth?: boolean;
    restrictedType?: boolean;
    unRestrictedType?: boolean;
    certificateMessage?: string;
}

export interface RequestInspectionForm1File extends FileUpload {
    fileType?: RequestInspectionForm1FileType;
    certDepartment?: Department;
    certNo?: string;
    other?: string;
}

export interface RequestInspectionFormAppointment extends AbstractAuditingEntity {
    id?: number;
    status?: AppointmentStatus;
    appointmentDate?: RequestInspectionFormAppointmentDate;
    requestInspectionForm?: RequestInspectionForm;
}

export interface RequestInspectionFormAppointmentDate extends AbstractAuditingEntity {
    id?: number;
    appointStartDate?: any;
    appointEndDate?: any;
    requestInspectionFormCheckSiteInspection?: RequestInspectionFormCheckSiteInspection;
}

export interface RequestInspectionFormAudit {
    id?: number;
    animalFeedType?: AnimalFeedType;
    auditRef?: string;
    productType?: AuditProductType;
    brand?: Brand;
    files?: { [P in RequestInspectionFormAuditFileType]?: RequestInspectionFormAuditFile };
}

export interface RequestInspectionFormAuditFile extends FileUpload {
    other?: string;
    fileType?: RequestInspectionFormAuditFileType;
}

export interface RequestInspectionFormCheckSiteInspection extends AbstractAuditingEntity, SignableForm {
    id?: number;
    appointmentDateId?: number;
    officer?: Officer;
    officerName?: string;
    officerPosition?: string;
    siteInspectionInspector?: SiteInspectionInspector;
    checkSiteInspectionExaminatorCrews?: RequestInspectionFormCheckSiteInspectionExaminatorCrew[];
    voucherCheckSiteInspectionLists?: { [index: string]: RequestInspectionFormSiteInspectionList };
    voucherCheckSiteInspectionPremixLists?: { [index: string]: RequestInspectionFormSiteInspectionList };
    auditCheckSiteInspectionLists?: { [index: string]: RequestInspectionFormSiteInspectionList };
    siteInspectionResult?: SiteInspectionResult;
    inspectionPassResult?: SiteInspectionPassResult;
    checkSiteInspectionResultRemark?: string;
    files?: { [P in RequestInspectionFormCheckSiteInspectionFileType]?: RequestInspectionFormCheckSiteInspectionFile };
    inspectionTime?: any;
    horsePower?: string;
    pouringPlace?: string;
    batch?: string;
    machineType?: string;
    bakingTemperature?: string;
    bakingTime?: string;
    coldDryerTemperature?: string;
    pelletMachine?: string;
    fillingMachine?: string;
    inspectionPlace?: string;
    materialStorageTemp?: string;
    productStorageTemp?: string;
    materialStorageTempPremix?: string;
    productStorageTempPremix?: string;
    materialStorageTempAudit?: string;
    productStorageTempAudit?: string;
    batchPremix?: string;
    batchTimePremix?: string;
    performancePelletMachine?: string;
    otherPremix?: string;
}

export interface RequestInspectionFormCheckSiteInspectionExaminatorCrew extends AbstractAuditingEntity {
    id?: number;
    user?: Officer;
}

export interface RequestInspectionFormCheckSiteInspectionFile extends FileUpload {
    fileType?: RequestInspectionFormCheckSiteInspectionFileType;
}

export interface RequestInspectionFormRequest {
    id?: number;
    restrictedType?: boolean;
    requestInspectionFormVouchers?: RequestInspectionFormVoucher[];
    unRestrictedType?: boolean;
    requestInspectionFormAudits?: RequestInspectionFormAudit[];
    certificateOfFreeSale?: boolean;
    certificateOfHealth?: boolean;
    certificateOther?: boolean;
    certificateTypeOthers?: string;
    inspectionForm1CertificateMessages?: RequestInspectionForm1CertificateMessage[];
    certificateMessageOthers?: boolean;
    certificateMessageOthersText?: string;
    brandThString?: string;
}

export interface RequestInspectionFormSiteInspectionList extends AbstractAuditingEntity {
    id?: number;
    passCheck?: boolean;
    eventRemark?: string;
    key?: string;
}

export interface RequestInspectionFormVoucher {
    id?: number;
    animalFeedType?: AnimalFeedType;
    voucherNo?: string;
    department?: Department;
    brand?: Brand;
}

export interface RequestInspectionLicensing extends AbstractAuditingEntity {
    id?: number;
    department?: Department;
    licenseType?: LicenseType;
    licenseSubType?: LicenseSubType;
    licensor?: Officer;
    licensorName?: string;
    licensorPosition?: string;
    licensingIssue?: string;
    licensingIssueDate?: any;
    licensingBook?: string;
    licensingExpireDate?: any;
    licenseFor?: string;
    authorizedDirectors?: LicensingAuthorizedDirector[];
    entrepreneurs?: LicensingEntrepreneur[];
    location?: Location;
    warehouses?: Location[];
    ownerGroup?: OwnerGroup;
}

export interface RequestInspectionLocation extends AbstractAuditingEntity, Address {
    id?: number;
    placeName?: string;
    tambonId?: string;
    tel?: string;
}

export interface RequestInspectionOrder extends AbstractAuditingEntity {
    id?: number;
    officer?: Officer;
    officerName?: string;
    officerPosition?: string;
    actingDirectorFlag?: boolean;
    approve?: boolean;
    orderDate?: any;
    approveText?: string;
}

export interface RequestInspectionRequest {
    id?: number;
    restrictedType?: boolean;
    requestInspectionVouchers?: RequestInspectionVoucher[];
    unRestrictedType?: boolean;
    requestInspectionAudits?: RequestInspectionAudit[];
    certificateOfFreeSale?: boolean;
    certificateOfHealth?: boolean;
    certificateOther?: boolean;
    certificateTypeOthers?: string;
    inspectionForm1CertificateMessages?: RequestInspectionForm1CertificateMessage[];
    certificateMessageOthers?: boolean;
    certificateMessageOthersText?: string;
}

export interface RequestInspectionRequestLicensing extends RequestLicensing<RequestInspectionRequestLicensingItem> {
    location?: Location;
    warehouses?: Location[];
    licensingAuthorizedDirectors?: LicensingAuthorizedDirector[];
    licensingEntrepreneurs?: LicensingEntrepreneur[];
    licensingItems?: RequestInspectionRequestLicensingItem[];
    entrepreneursString?: string;
}

export interface RequestInspectionRequestLicensingItem extends RequestLicensingItem {
}

export interface RequestInspectionSignProposal extends AbstractAuditingEntity {
    id?: number;
    officer?: Officer;
    officerName?: string;
    officerPosition?: string;
    officerComment?: string;
}

export interface RequestInspectionVoucher {
    id?: number;
    animalFeedType?: AnimalFeedType;
    voucherNo?: string;
    department?: Department;
    brand?: Brand;
}

export interface RequestInspectionWarehouse extends AbstractAuditingEntity, Address {
    id?: number;
    requestInspection?: RequestInspection;
    placeName?: string;
    tambonId?: string;
    tel?: string;
}

export interface VRequestInspectionReport {
    id?: number;
    applicantName?: string;
    corporateNumber?: string;
    cardNumber?: string;
    exporter?: string;
    requestInspectIssueDate?: any;
    voucherBrandTh?: string;
    voucherBrandEn?: string;
    voucherNo?: string;
    voucherDepartment?: string;
    auditBrandEn?: string;
    auditBrandTh?: string;
    auditRef?: string;
    licensingDepartment?: string;
    licensingBook?: string;
    licensingIssue?: string;
    certificateType?: string;
    voucherAnimalFeedType?: string;
    auditAnimalFeedType?: string;
    voucherAnimalFeedGroupIds?: string[];
    auditAnimalFeedTypeIds?: string[];
    locationPlaceName?: string;
    locationAddress?: string;
    locationSoi?: string;
    locationStreet?: string;
    locationMoo?: string;
    locationTambonId?: string;
    locationTambonName?: string;
    locationAmphurId?: string;
    locationAmphurName?: string;
    locationProvinceId?: string;
    locationProvinceName?: string;
    locationPostalCode?: string;
    locationTel?: string;
    warehousePlaceName1?: string;
    warehouseAddress1?: string;
    warehouseSoi1?: string;
    warehouseStreet1?: string;
    warehouseMoo1?: string;
    warehouseTambonId1?: string;
    warehouseTambonName1?: string;
    warehouseAmphurId1?: string;
    warehouseAmphurName1?: string;
    warehouseProvinceId1?: string;
    warehouseProvinceName1?: string;
    warehousePostalCode1?: string;
    warehouseTel1?: string;
    warehousePlaceName2?: string;
    warehouseAddress2?: string;
    warehouseSoi2?: string;
    warehouseStreet2?: string;
    warehouseMoo2?: string;
    warehouseTambonId2?: string;
    warehouseTambonName2?: string;
    warehouseAmphurId2?: string;
    warehouseAmphurName2?: string;
    warehouseProvinceId2?: string;
    warehouseProvinceName2?: string;
    warehousePostalCode2?: string;
    warehouseTel2?: string;
    warehousePlaceName3?: string;
    warehouseAddress3?: string;
    warehouseSoi3?: string;
    warehouseStreet3?: string;
    warehouseMoo3?: string;
    warehouseTambonId3?: string;
    warehouseTambonName3?: string;
    warehouseAmphurId3?: string;
    warehouseAmphurName3?: string;
    warehouseProvinceId3?: string;
    warehouseProvinceName3?: string;
    warehousePostalCode3?: string;
    warehouseTel3?: string;
}

export interface RequestInspectionAppointmentReportDto {
    requestInspectionAppointmentDateId?: number;
    siteInspectionFiles?: { [P in RequestInspectionFormCheckSiteInspectionFileType]?: RequestInspectionFormCheckSiteInspectionFile };
}

export interface RequestInspectionConsiderationRequest<T> {
    requestInspectionForm?: T;
    receivedDate?: any;
    approveStatus?: ApproveStatus;
    correctionItems?: RequestInspectionConsiderationCorrectionItem[];
    comment?: string;
}

export interface RequestInspectionCreateLicenseOrderEditRequest {
    formId?: number;
    checkSiteInspectionResultRemark?: string;
}

export interface RequestInspectionEntrepreneurSignDto {
    formId?: number;
    p12password?: string;
}

export interface RequestInspectionFormSearchRequest {
    formStatus?: RequestInspectionFormStatus;
    requestNo?: string;
    petitionNo?: string;
    filingDateFrom?: any;
    filingDateTo?: any;
    receivedDateFrom?: any;
    receivedDateTo?: any;
    appointmentDateStart?: any;
    appointmentDateEnd?: any;
    name?: string;
    formType?: FormType;
}

export interface RequestInspectionOrderRequest {
    requestInspectionFormId?: number;
    approve?: boolean;
    orderDate?: any;
    p12password?: string;
}

export interface RequestInspectionReportSearchParam extends ReportCondition {
}

export interface RequestInspectionSignProposalRequest {
    requestInspectionFormId?: number;
    officerComment?: string;
}

export interface RequestInspectionSiteInspectionRequest {
    entrepreneurSign?: boolean;
    requestInspectionFormCheckSiteInspection?: RequestInspectionFormCheckSiteInspection;
}

export interface RequestInspectionFormAppointmentDateProjection {
    id?: number;
    appointStartDate?: any;
    appointEndDate?: any;
    appointment?: RequestInspectionFormAppointmentProj;
    requestInspectionFormCheckSiteInspection?: RRequestInspectionFormCheckSiteInspectionProj;
}

export interface RRequestInspectionFormCheckSiteInspectionProj {
    id?: number;
    siteInspectionResult?: SiteInspectionResult;
    inspectionPassResult?: SiteInspectionPassResult;
}

export interface RequestInspectionFormAppointmentProj {
    id?: number;
    status?: AppointmentStatus;
    requestInspectionForm?: RequestInspectionFormProjection;
}

export interface RequestInspectionFormAppointmentProjection {
    status?: AppointmentStatus;
    appointmentDate?: RequestInspectionFormAppointmentDate;
    requestInspectionForm?: RequestInspectionFormProjection;
}

export interface RequestInspectionFormProjection {
    id?: number;
    user?: ApplicantProjection;
    requestNo?: string;
    petitionNo?: string;
    filingDate?: any;
    formStatus?: RequestInspectionFormStatus;
    dtype?: FormType;
    requestLicensing?: RequestLicensingProj;
    requestInspection?: RequestInspectionProj;
}

export interface LocationProj {
    fullAddressTh?: string;
}

export interface RequestInspectionProj {
    requestInspectionNo?: string;
}

export interface RequestLicensingProj {
    location?: LocationProj;
}

export interface RequestInspectionReportResult {
    id?: number;
    auditRef?: string;
    cardNumber?: string;
    certificateType?: string;
    exporter?: string;
    voucherNo?: string;
    licensingIssue?: string;
    licensingBook?: string;
    applicantName?: string;
    corporateNumber?: string;
    locationProvinceId?: string;
    locationAddress?: string;
    warehousePlaceName1?: string;
    warehouseAddress1?: string;
    warehouseSoi1?: string;
    warehouseStreet1?: string;
    warehouseMoo1?: string;
    warehouseTambonId1?: string;
    warehouseTambonName1?: string;
    warehouseAmphurId1?: string;
    warehouseAmphurName1?: string;
    warehouseProvinceId1?: string;
    warehouseProvinceName1?: string;
    warehousePostalCode1?: string;
    warehouseTel1?: string;
    warehousePlaceName2?: string;
    warehouseAddress2?: string;
    warehouseSoi2?: string;
    warehouseStreet2?: string;
    warehouseMoo2?: string;
    warehouseTambonId2?: string;
    warehouseTambonName2?: string;
    warehouseAmphurId2?: string;
    warehouseAmphurName2?: string;
    warehouseProvinceId2?: string;
    warehouseProvinceName2?: string;
    warehousePostalCode2?: string;
    warehouseTel2?: string;
    warehousePlaceName3?: string;
    warehouseAddress3?: string;
    warehouseSoi3?: string;
    warehouseStreet3?: string;
    warehouseMoo3?: string;
    warehouseTambonId3?: string;
    warehouseTambonName3?: string;
    warehouseAmphurId3?: string;
    warehouseAmphurName3?: string;
    warehouseProvinceId3?: string;
    warehouseProvinceName3?: string;
    warehousePostalCode3?: string;
    warehouseTel3?: string;
    locationPlaceName?: string;
    locationSoi?: string;
    locationStreet?: string;
    locationMoo?: string;
    locationTambonId?: string;
    locationTambonName?: string;
    locationAmphurId?: string;
    locationAmphurName?: string;
    locationProvinceName?: string;
    locationPostalCode?: string;
    locationTel?: string;
    requestInspectIssueDate?: any;
    voucherBrandTh?: string;
    voucherBrandEn?: string;
    voucherDepartment?: string;
    auditBrandEn?: string;
    auditBrandTh?: string;
    licensingDepartment?: string;
    voucherAnimalFeedType?: string;
    voucherAnimalFeedGroupIds?: string[];
    auditAnimalFeedTypeIds?: string[];
    auditAnimalFeedType?: string;
}

export interface RequestInspectionForm1Report extends RequestInspectionForm1 {
    orderDate?: any;
    auditRef?: string;
    voucherNo?: string;
    entrepreneurOthers?: RequestInspectionEntrepreneur[];
    authorizedDirectorFirst?: RequestInspectionAuthorizedDirector;
    authorizedDirectorOthers?: RequestInspectionAuthorizedDirector[];
    warehousesFirst?: Location;
    warehouseOthers?: Location[];
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    voucherBrand?: string;
    voucherType?: string;
    auditBrand?: string;
    checkFileProductInformation?: boolean;
    checkFileFormulaCert?: boolean;
    checkFileProcessChart?: boolean;
    checkFileLabelCopy?: boolean;
    checkFileImportPermit?: boolean;
    checkFileMap?: boolean;
    checkFileOther?: boolean;
    checkFileGmpOrHaccp?: boolean;
    otherFileComment?: string;
    checkAudits?: boolean;
}

export interface RequestInspectionFormReport extends RequestInspectionForm {
    url?: string;
    applicantName?: string;
    requestInspectionRequest?: RequestInspectionRequest;
    formId?: number;
    locationAddress?: string;
    voucherAnimalFeedTypeName?: string;
    orderDate?: any;
    authorizedDirectorOthers?: RequestInspectionAuthorizedDirector[];
    warehouseOthers?: Location[];
    signatureImagePath?: string;
    requestInspectionNo?: string;
    locationName?: string;
    voucherBrandName?: string;
    voucherAllNo?: string;
    auditAnimalFeedTypeName?: string;
    auditBrandName?: string;
    firstPageDataOfRequestInspectionVouchers?: RequestInspectionFormVoucher[];
    secondPageDataOfRequestInspectionVouchers?: RequestInspectionFormVoucher[];
    firstPageDataOfRequestInspectionAudits?: RequestInspectionFormAudit[];
    secondPageDataOfRequestInspectionAudits?: RequestInspectionFormAudit[];
}

export interface RequestInspectionFormSiteInspectionCheckListReport extends RequestInspectionFormCheckSiteInspection {
    audit?: boolean;
    voucher?: boolean;
    premix?: boolean;
    requestInspectionFormAppointmentDate?: RequestInspectionFormAppointmentDate;
}

export interface RequestInspectionReport extends RequestInspection {
    requestInspectionOrder?: RequestInspectionOrder;
    url?: string;
    formId?: number;
    orderDate?: any;
    formStatus?: RequestInspectionFormStatus;
    applicantName?: string;
    locationAddress?: string;
    voucherAnimalFeedTypeName?: string;
    authorizedDirectorOthers?: RequestInspectionAuthorizedDirector[];
    warehouseOthers?: Location[];
    signatureImagePath?: string;
    locationName?: string;
    voucherBrandName?: string;
    voucherAllNo?: string;
    auditAnimalFeedTypeName?: string;
    auditBrandName?: string;
    firstPageDataOfRequestInspectionVouchers?: RequestInspectionVoucher[];
    secondPageDataOfRequestInspectionVouchers?: RequestInspectionVoucher[];
    firstPageDataOfRequestInspectionAudits?: RequestInspectionAudit[];
    secondPageDataOfRequestInspectionAudits?: RequestInspectionAudit[];
}

export interface RequestInspectionSiteInspectionReport extends RequestInspectionFormCheckSiteInspection {
    appointmentDate?: RequestInspectionFormAppointmentDate;
    inspectorFirst?: SiteInspectionInspector;
    preview?: boolean;
    entrepreneursString?: string;
    voucherTypes?: string;
    auditTypes?: string;
    productTypes?: string;
}

export interface RequestInspectionFormCheckSiteInspectionExaminatorCrewUtils {
}

export interface RequestInspectionFormSiteInspectionListUtils {
}

export interface SignatureInfoDto {
    sequence?: number;
    total?: number;
    revision?: number;
    totalRevisions?: number;
    signatureName?: string;
    digestAlgorithm?: string;
    encryptionAlgorithm?: string;
    filterSubtype?: string;
    nameOfTheSigner?: string;
    alternativeNameOfTheSigner?: string;
    signedOn?: any;
    timeStamp?: any;
    timeStampService?: string;
    timestampVerified?: boolean;
    location?: string;
    reason?: string;
    contactInfo?: string;
    signatureType?: string;
    fillingOutFieldsAllowed?: boolean;
    addingAnnotationsAllowed?: boolean;
    locks?: string[];
    signatureCoversWholeDocument?: boolean;
    documentRevision?: string;
    integrityCheckOK?: boolean;
    invisibleSignature?: boolean;
    fieldOnPage?: string;
    issuer?: string;
    subject?: string;
    validFrom?: any;
    validTo?: any;
}

export interface AuditParam {
    bookNo?: string;
    occupier?: string;
}

export interface CertificateParam {
    bookNo?: string;
    occupier?: string;
}

export interface GmpHaccpParam {
    certificateNumber?: string;
    occupier?: string;
}

export interface LicensingParam {
    licensingBook?: string;
    licensingIssue?: string;
    occupier?: string;
    licenseType?: LicenseType;
}

export interface RequestInspectionParam {
    bookNo?: string;
    occupier?: string;
}

export interface SearchingParam {
    modules?: Modules;
    qrCode?: string;
    licensingParam?: LicensingParam;
    voucherParam?: VoucherParam;
    gmpHaccpParam?: GmpHaccpParam;
    certificateParam?: CertificateParam;
    auditParam?: AuditParam;
    requestInspectionParam?: RequestInspectionParam;
}

export interface VoucherParam {
    brandNameTH?: string;
    brandNameEN?: string;
    voucherNo?: string;
    requestNo?: string;
    feedType?: string;
    receivedDateFrom?: any;
    receivedDateTo?: any;
    useFor?: string;
}

export interface VoucherSearching {
    id?: number;
    receivedDate?: any;
    requestNo?: string;
    voucherNo?: string;
    voucherFor?: string;
    licenseType?: string;
    manufacturerAddress?: string;
    manufactureCountry?: string;
    importAddress?: string;
    sellerName?: string;
    sellerAddress?: string;
    feedGroup?: string;
    feedType?: string;
    animalType?: string;
    animalSubType?: string;
    animalAge?: string;
    useFor?: string;
    brandTh?: string;
    brandEn?: string;
    concreteFeedType?: string;
    additionalCharacteristics?: string;
    labelIngredient?: string;
    requestIngredient?: string;
    proteinRatio?: string;
    proteinResult?: string;
    fatRatio?: string;
    fatResult?: string;
    fiberRatio?: string;
    fiberResult?: string;
    moistureRatio?: string;
    moistureResult?: string;
    packages?: string;
    packageWeight?: string;
    duration?: string;
    howTo?: string;
    correctionDate?: any;
    resultAmountText?: string;
    voucherType?: VoucherType;
    ownerGroup?: string;
    status?: string;
}

export interface Brand {
    brandTh?: string;
    brandEn?: string;
}

export interface Instruction {
    howto?: string;
    amount?: string;
}

export interface Manufacturer {
    manufacturerName?: string;
    manufacturerPlace?: string;
    manufacturerCountry?: Country;
}

export interface RequestVoucher extends AbstractAuditingEntity {
    id?: number;
    animalFeedType?: AnimalFeedType;
    brand?: Brand;
    voucherNo?: string;
    voucherNoEn?: string;
    department?: Department;
}

export interface Voucher extends AbstractAuditingEntity {
    id?: number;
    issuer?: Officer;
    issuerName?: string;
    issuerPosition?: string;
    issueDate?: any;
    issuerSubstitute?: Officer;
    issuerSubstituteName?: string;
    issuerSubstitutePosition?: string;
    issueSubstituteDate?: any;
    requestUser?: Applicant;
    voucherNo?: string;
    voucherNoEn?: string;
    voucherFor?: string;
    voucherType?: VoucherType;
    correctionDetails?: VoucherCorrectionDetail[];
    department?: Department;
    files?: { [P in VoucherFileType]?: VoucherFile };
    voucherAuthorizedDirectors?: VoucherAuthorizedDirector[];
    requestLicensing?: VoucherRequestLicensing;
    voucherRequest?: VoucherRequest;
    voucherLabel?: VoucherLabel;
    voucherFeed?: VoucherFeed;
    ownerGroup?: OwnerGroup;
    manualFlag?: boolean;
    substituteFlag?: boolean;
    importFlag?: boolean;
    reason?: string;
    requestSubstituteReason?: RequestSubstituteReason;
    status?: VoucherStatus;
    p12password?: string;
    user?: User;
    correctionRemark?: string;
}

export interface VoucherAcademicConsideration extends AbstractAuditingEntity {
    id?: number;
    basicConsiderer?: Officer;
    basicConsiderDate?: any;
    considerer?: Officer;
    considererName?: string;
    considererPosition?: string;
    considerDate?: any;
    correctionComment?: string;
    acceptCorrection?: boolean;
    acceptedDate?: any;
    correctionFile?: FileUpload;
    statementComment?: string;
    statementFile?: FileUpload;
    correctionItems?: VoucherAcademicCorrectionItem[];
}

export interface VoucherAcademicCorrectionItem extends CorrectionItem {
}

export interface VoucherAddedIngredient extends AbstractAuditingEntity {
    id?: number;
    mixIngredientType?: MixIngredientType;
    mixIngredientSubType?: MixIngredientSubType;
    mixIngredientSubtypeOthers?: string;
    mixIngredientSubTypeName?: MixIngredientSubTypeName;
    mixIngredientSubTypeNameOthers?: string;
    amount?: number;
    amountText?: string;
    unit?: Unit;
    result?: number;
    resultText?: string;
    file?: FileUpload;
}

export interface VoucherAuthorizedDirector extends AbstractAuthorizedDirector {
    id?: number;
    voucher?: Voucher;
}

export interface VoucherBasicConsideration extends AbstractAuditingEntity {
    id?: number;
    considerer?: Officer;
    considererName?: string;
    considererPosition?: string;
    correctionComment?: string;
    acceptCorrection?: boolean;
    acceptedDate?: any;
    animalFeedSample?: boolean;
    correctionFile?: FileUpload;
    statementComment?: string;
    statementFile?: FileUpload;
    correctionItems?: VoucherBasicCorrectionItem[];
}

export interface VoucherBasicCorrectionItem extends CorrectionItem {
}

export interface VoucherCorrectionDetail extends AbstractAuditingEntity {
    id?: number;
    correctionText?: string;
}

export interface VoucherEntrepreneur extends AbstractEntrepreneur {
    id?: number;
    voucher?: Voucher;
}

export interface VoucherEntrepreneurFile extends FileUpload {
}

export interface VoucherFeed extends AbstractAuditingEntity {
    id?: number;
    ratioMin?: number;
    ratioMax?: number;
    defaultUnit?: Unit;
    feedItems?: VoucherFeedItem[];
}

export interface VoucherFeedItem extends AbstractAuditingEntity {
    id?: number;
    feedName?: string;
    mixIngredientType?: MixIngredientType;
    mixIngredientSubTypeName?: MixIngredientSubTypeName;
    mixName?: string;
    mixAmount?: number;
    mixAmountText?: string;
    mixUnit?: string;
    intensity?: number;
    amount?: number;
    amountText?: string;
    unit?: Unit;
    tonMin?: number;
    tonMinText?: string;
    tonMax?: number;
    tonMaxText?: string;
    tonUnit?: Unit;
    file?: FileUpload;
}

export interface VoucherFeedPurpose extends AbstractAuditingEntity {
    id?: number;
    animalTypes?: AnimalType[];
    animalSubTypes?: AnimalSubType[];
    animalAge?: AnimalAge;
    usedFor?: string;
}

export interface VoucherFile extends FileUpload {
    other?: string;
    fileType?: VoucherFileType;
}

export interface VoucherForm extends AbstractAuditingEntity, FormDraft, SignableForm {
    id?: number;
    payment?: Payment;
    user?: Applicant;
    considerUser?: Officer;
    dtype?: FormType;
    filingOffice?: FilingOffice;
    dofOrg?: DofOrg;
    voucherType?: VoucherType;
    requestType?: VoucherRequestType;
    petitionNo?: string;
    requestNo?: string;
    purposeNo?: string;
    filingDate?: any;
    formStatus?: VoucherFormStatus;
    receivedDate?: any;
    department?: Department;
    dailyQuota?: boolean;
    acceptAgreement?: boolean;
    acceptAgreementWithCA?: boolean;
    acceptAgreementWithoutCA?: boolean;
    basicConsideration?: VoucherBasicConsideration;
    academicConsideration?: VoucherAcademicConsideration;
    registration?: VoucherRegistration;
    signProposal?: VoucherSignProposal;
    order?: VoucherOrder;
    officerComment?: string;
    meetingResult?: VoucherMeetingResult;
    meetingResultDate?: any;
    acceptMeetingCorrection?: boolean;
    statementMeetingComment?: string;
    statementMeetingFile?: FileUpload;
    voucher?: Voucher;
    voucherFormAuthorizedDirectors?: VoucherAuthorizedDirector[];
    requestLicensing?: VoucherRequestLicensing;
    voucherFormRequest?: VoucherRequest;
    voucherFormLabel?: VoucherLabel;
    filingLocation?: FilingLocation;
    voucherFormFeed?: VoucherFeed;
    correctionRemark?: string;
    lastedCorrectionStatus?: VoucherCorrectionFormStatus;
    issuer?: Officer;
    issuerSubstitute?: Officer;
    substituteFlag?: boolean;
    issueSubstituteDate?: any;
    academicOfficerComment?: string;
}

export interface VoucherForm1 extends VoucherForm {
    f1Files?: { [P in VoucherForm1FileType]?: VoucherForm1File };
}

export interface VoucherForm1File extends FileUpload {
    fileType?: VoucherForm1FileType;
    other?: string;
}

export interface VoucherForm2 extends VoucherForm {
    f2Files?: { [P in VoucherForm2FileType]?: VoucherForm2File };
    correctionRequest?: VoucherFormCorrectionRequest;
}

export interface VoucherForm2File extends FileUpload {
    fileType?: VoucherForm2FileType;
    other?: string;
}

export interface VoucherForm3 extends VoucherForm {
    f3Files?: { [P in VoucherForm3FileType]?: VoucherForm3File };
}

export interface VoucherForm3File extends FileUpload {
    fileType?: VoucherForm3FileType;
    other?: string;
}

export interface VoucherForm4 extends VoucherForm {
    f4Files?: { [P in VoucherForm4FileType]?: VoucherForm4File };
    correctionRequest?: VoucherFormCorrectionRequest;
}

export interface VoucherForm4File extends FileUpload {
    fileType?: VoucherForm4FileType;
    other?: string;
}

export interface VoucherForm5 extends VoucherForm {
    f5Files?: { [P in VoucherForm5FileType]?: VoucherForm5File };
}

export interface VoucherForm5File extends FileUpload {
    fileType?: VoucherForm5FileType;
    other?: string;
}

export interface VoucherForm6 extends VoucherForm {
    f6Files?: { [P in VoucherForm6FileType]?: VoucherForm6File };
    correctionRequest?: VoucherFormCorrectionRequest;
}

export interface VoucherForm6File extends FileUpload {
    fileType?: VoucherForm6FileType;
    other?: string;
}

export interface VoucherForm7 extends VoucherForm {
    f7Files?: { [P in VoucherForm7FileType]?: VoucherForm7File };
    reason?: string;
    requestSubstituteReason?: RequestSubstituteReason;
}

export interface VoucherForm7File extends FileUpload {
    fileType?: VoucherForm7FileType;
    other?: string;
}

export interface VoucherFormCorrectionRequest extends AbstractAuditingEntity {
    id?: number;
    licensing?: boolean;
    feedDetail?: boolean;
    brand?: boolean;
    manufacturer?: boolean;
    feedPurpose?: boolean;
    mixIngredient?: boolean;
    addedIngredient?: boolean;
    quality?: boolean;
    packages?: boolean;
    instruction?: boolean;
    trademark?: boolean;
    sellerLicensing?: boolean;
    labelIngredient?: boolean;
    descriptionAndWarning?: boolean;
    labelAdding?: boolean;
    voucherFeed?: boolean;
    formFiles?: boolean;
    requestCorrectionItems?: { [index: string]: VoucherFormRequestCorrectionItem };
}

export interface VoucherFormRequestCorrectionItem extends RequestCorrectionItem {
}

export interface VoucherLabel extends AbstractAuditingEntity {
    id?: number;
    trademarkName?: string;
    trademarkOwnerName?: string;
    trademarkRegNumber?: string;
    trademarkExpireDate?: any;
    trademarkFile?: FileUpload;
    trademarkRegistrationFile?: FileUpload;
    searchDate?: any;
    user?: Applicant;
    sellerLicensing?: VoucherRequestLicensing;
    sellerName?: string;
    sellerPlace?: string;
    sellerFile?: FileUpload;
    labelIngredients?: VoucherLabelIngredient[];
    summaryOfIngredients?: string;
    labelRemark?: string;
    feedDescription?: string;
    labelFeedWarning?: string;
    labelAddingList?: VoucherLabelAdding[];
}

export interface VoucherLabelAdding extends AbstractAuditingEntity {
    id?: number;
    materialGroup?: MaterialGroup;
    materialType?: MaterialType;
    materialTypeOther?: string;
    otherUnit?: Unit;
    perBase?: number;
    otherPerBaseText?: string;
    perReadymade?: number;
    otherPerReadymadeText?: string;
    materialFile?: FileUpload;
}

export interface VoucherLabelIngredient extends AbstractAuditingEntity {
    id?: number;
    amount?: number;
    amountText?: string;
    ingredientName?: string;
    mixIngredientTypeLabel?: string;
    mixIngredientSubTypeLabel?: string;
    unitLabel?: string;
}

export interface VoucherMeetingBooking extends AbstractAuditingEntity {
    id?: number;
    confDate?: any;
    confTimeBegin?: any;
    confTimeEnd?: any;
    confDateTimeBegin?: any;
    confDateTimeEnd?: any;
    topic?: string;
    meetingParticipants?: MeetingParticipant[];
    voucherMeetingRefNos?: VoucherMeetingRefNo[];
    confFile?: FileUpload;
    summaryDetails?: string;
    voucherMeetingStatus?: VoucherMeetingStatus;
}

export interface VoucherMeetingRefNo extends AbstractAuditingEntity {
    id?: number;
    voucherForm?: VoucherForm;
    detailsMeeting?: string;
    voucherMeetingResult?: VoucherMeetingResult;
    correctionTimes?: number;
    resultDate?: any;
    resultFile?: FileUpload;
    meetingDate?: any;
}

export interface VoucherMixIngredient extends AbstractAuditingEntity {
    id?: number;
    mixIngredient?: MixIngredient;
    mixIngredientOthers?: string;
    unit?: Unit;
    amount?: number;
    file?: FileUpload;
}

export interface VoucherNo extends AbstractAuditingEntity {
    id?: FeedType;
    years?: number;
    currentNo?: number;
}

export interface VoucherOrder extends AbstractAuditingEntity {
    id?: number;
    officer?: Officer;
    officerName?: string;
    officerPosition?: string;
    approveStatus?: ApproveStatus;
    approveDate?: any;
    rejectComment?: string;
    approveWithConditionComment?: string;
    correctionComment?: string;
    acceptCorrection?: boolean;
    acceptedDate?: any;
    correctionFile?: FileUpload;
    statementComment?: string;
    statementFile?: FileUpload;
    correctionItems?: VoucherOrderCorrectionItem[];
}

export interface VoucherOrderCorrectionItem extends CorrectionItem {
}

export interface VoucherPackage extends AbstractAuditingEntity {
    id?: number;
    packageType?: PackageType;
    packageTypeOthers?: string;
    packageUnit?: Unit;
    netWeight?: number;
    durationMonth?: number;
}

export interface VoucherQuality extends AbstractAuditingEntity {
    id?: number;
    qualityType?: QualityType;
    ratio?: number;
    result?: number;
    file?: FileUpload;
}

export interface VoucherRegistration extends AbstractAuditingEntity {
    id?: number;
    offerSignDate?: any;
    officer?: Officer;
    officerName?: string;
    officerPosition?: string;
}

export interface VoucherRequest extends AbstractAuditingEntity {
    id?: number;
    animalFeedType?: AnimalFeedType;
    concreteFeedType?: ConcreteFeedType;
    additionalText?: string;
    brand?: Brand;
    duplicatedBrandTh?: boolean;
    duplicatedBrandEn?: boolean;
    manufacturer?: Manufacturer;
    feedPurpose?: VoucherFeedPurpose;
    mixIngredients?: VoucherMixIngredient[];
    addedIngredients?: VoucherAddedIngredient[];
    summaryOfIngredients?: string;
    ingredientsRemark?: string;
    qualities?: VoucherQuality[];
    qualityFile?: FileUpload;
    packages?: VoucherPackage[];
    summaryPackageTypeText?: string;
    summaryPackageWeightText?: string;
    instruction?: Instruction;
    packagesDescription?: { [index: string]: string };
}

export interface VoucherRequestLicensing extends RequestLicensing<VoucherRequestLicensingItem> {
    licensingItems?: VoucherRequestLicensingItem[];
    files?: { [P in LicensingFileType]?: LicensingFile };
    entrepreneurs?: LicensingEntrepreneur[];
    location?: Location;
    warehouses?: Location[];
    animalFeedTypes?: string;
    animalFeedGroups?: string;
}

export interface VoucherRequestLicensingItem extends RequestLicensingItem {
}

export interface VoucherSignProposal extends AbstractAuditingEntity {
    id?: number;
    signDate?: any;
    officer?: Officer;
    officerName?: string;
    officerPosition?: string;
    correctionComment?: string;
    acceptCorrection?: boolean;
    acceptedDate?: any;
    correctionFile?: FileUpload;
    statementComment?: string;
    statementFile?: FileUpload;
    correctionItems?: VoucherSignProposalCorrectionItem[];
}

export interface VoucherSignProposalCorrectionItem extends CorrectionItem {
}

export interface VoucherFormSearchRequest {
    requestNo?: string;
    petitionNo?: string;
    filingDateFrom?: any;
    filingDateTo?: any;
    receivedDateFrom?: any;
    receivedDateTo?: any;
    meetingDateFrom?: any;
    meetingDateTo?: any;
    meetingResultDateFrom?: any;
    meetingResultDateTo?: any;
    academicConsiderDateFrom?: any;
    academicConsiderDateTo?: any;
    registrationDateFrom?: any;
    registrationDateTo?: any;
    correctionDateFrom?: any;
    correctionDateTo?: any;
    offerDateFrom?: any;
    offerDateTo?: any;
    signDateFrom?: any;
    signDateTo?: any;
    orderDateFrom?: any;
    orderDateTo?: any;
    filingUserName?: string;
    formType?: FormType;
    formStatus?: VoucherFormStatus;
    selectedForms?: number[];
    condition?: string;
    brandTh?: string;
    approveStatus?: ApproveStatus;
}

export interface VoucherImportDto {
    id?: number;
    voucherNo?: string;
    corporateNumber?: string;
    branch?: string;
    licenseType?: string;
    voucherFor?: string;
    country?: string;
    foreignManufacturer?: string;
    foreignManufacturerPlace?: string;
    animalFeedType?: string;
    brandTh?: string;
    brandEn?: string;
    feedAppearance?: string;
    animalType?: string;
    animalAge?: string;
    usedFor?: string;
    trademarkName?: string;
    sellerName?: string;
    sellerPlace?: string;
    summaryOfIngredient?: string;
    summaryOfIngredientExtra?: string;
    summaryOfIngredientOther?: string;
    proteinRatio?: number;
    fatRatio?: number;
    fiberRatio?: number;
    moistureRatio?: number;
    packageType?: string;
    packageWeight?: string;
    durationMonth?: string;
    howto?: string;
    amount?: string;
    properties?: string;
    warning?: string;
    issueDate?: string;
    licensingIssueDate?: any;
    licensingBook?: string;
    licensingIssue?: string;
    licenseDepartment?: string;
    remark?: string;
    status?: string;
    detailEdit?: string;
}

export interface VoucherMeetingRequest {
    topic?: string;
    confDateFrom?: any;
    confDateTo?: any;
    petitionNo?: string;
    requestNo?: string;
    brandName?: string;
    voucherFor?: string;
    formStatus?: VoucherFormStatus;
    resultDateFrom?: any;
    resultDateTo?: any;
}

export interface VoucherSearchRequest {
    brand?: string;
    voucherNo?: string;
    formType?: FormType;
    voucherLicensingIssue?: string;
    licensingId?: number;
    department?: Department;
    ownerId?: string;
    condition?: string;
    createdDateFrom?: any;
    createdDateTo?: any;
    licenseType?: LicenseType;
}

export interface VoucherUpdateAddressDto {
    voucherNo?: string;
    licensingIssueDate?: any;
    address?: string;
}

export interface VoucherYearSummaryReport {
    org_code?: string;
    org_name?: string;
    service_name?: string;
    data_timestamp?: string;
    amount_service_last_year?: number;
    amount_service_year?: number;
    amount_service_yesterday?: number;
    type_detail?: VoucherYearSummaryReportDetail[];
}

export interface VoucherYearSummaryReportDetail {
    type_name?: string;
    amount_service_year?: number;
    amount_service_yesterday?: number;
}

export interface VoucherAcademicConsiderationProjection {
    considerDate?: any;
}

export interface VoucherBasicConsiderationProjection {
    lastUpdatedDate?: any;
    animalFeedSample?: boolean;
}

export interface VoucherFormProjection {
    id?: number;
    order?: VoucherOrder;
    user?: Applicant;
    document?: FileUpload;
    academicConsideration?: VoucherAcademicConsiderationProjection;
    basicConsideration?: VoucherBasicConsiderationProjection;
    requestNo?: string;
    petitionNo?: string;
    filingDate?: any;
    receivedDate?: any;
    formStatus?: VoucherFormStatus;
    dtype?: FormType;
    payment?: Payment;
    voucher?: VoucherProjection;
    voucherFormRequest?: VoucherRequestProjection;
    meetingResultDate?: any;
    registration?: VoucherRegistration;
    signProposal?: VoucherSignProposal;
}

export interface VoucherLicensingProjection {
    location?: Location;
    licensingIssue?: string;
    licenseFor?: string;
}

export interface VoucherMeetingBookingProjection {
    id?: number;
    confDate?: any;
    topic?: string;
    voucherMeetingRefNos?: VoucherRefNoProjection[];
}

export interface VoucherProjection {
    id?: number;
    files?: { [P in VoucherFileType]?: VoucherFile };
    manualFlag?: boolean;
    requestLicensing?: VoucherLicensingProjection;
    voucherNo?: string;
    voucherFor?: string;
    importFlag?: boolean;
    voucherRequest?: VoucherRequestProjection;
}

export interface VoucherRefNoProjection {
    id?: number;
    detailsMeeting?: string;
    voucherMeetingResult?: VoucherMeetingResult;
    correctionTimes?: number;
    resultDate?: any;
    meetingDate?: any;
    resultFile?: FileUpload;
}

export interface VoucherRefNoWithVoucherProjection {
    id?: number;
    voucherForm?: VoucherFormProjection;
    detailsMeeting?: string;
    voucherMeetingResult?: VoucherMeetingResult;
    correctionTimes?: number;
    resultDate?: any;
    meetingDate?: any;
    resultFile?: FileUpload;
}

export interface VoucherRequestProjection {
    packages?: VoucherPackage[];
    brand?: Brand;
    animalFeedType?: AnimalFeedType;
    manufacturer?: Manufacturer;
    feedPurpose?: VoucherFeedPurpose;
    addedIngredients?: VoucherAddedIngredient[];
    qualities?: VoucherQuality[];
    mixIngredients?: VoucherMixIngredient[];
}

export interface AddedIngredientSubtypeReport {
    subTypeName?: string;
    amount?: number;
    amountText?: string;
    unit?: Unit;
    subTypeName2?: string;
    amount2?: number;
    amountText2?: string;
    unit2?: Unit;
}

export interface FeedItemReport {
    feedAmountIn1Kg?: string;
    ingredientAmountIn1Kg?: string;
    feedAmountIn1TonMin?: string;
    feedAmountIn1TonMax?: string;
    feedAmountIn1TonUnit?: string;
}

export interface VoucherForm7Report extends VoucherForm7 {
    authorizedDirectorFirst?: VoucherAuthorizedDirector;
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    reportEntrepreneurs?: LicensingEntrepreneur[];
    reportEntrepreneurFirst?: LicensingEntrepreneur;
    qrCode?: string;
    personTypePersonal?: boolean;
    packageTypesGroup?: string;
    packageTypesNewlineGroup?: string;
    packageTypesPackageVolume?: string;
    packageTypesPackageVolumeNewline?: string;
    voucherFileUpload?: boolean;
    otherDocFileUpload?: boolean;
    lostEvidenceFileUpload?: boolean;
    damagedEvidenceFileUpload?: boolean;
}

export interface VoucherFormReport extends VoucherForm {
    manufacturerName?: string;
    manufacturerAddress?: string;
    entrepreneurOthers?: LicensingEntrepreneur[];
    authorizedDirectorFirst?: VoucherAuthorizedDirector;
    authorizedDirectorOthers?: VoucherAuthorizedDirector[];
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    reportEntrepreneurs?: LicensingEntrepreneur[];
    signatureImagePath?: string;
    reportEntrepreneurFirst?: LicensingEntrepreneur;
    importerName?: string;
    importerAddress?: string;
    qrCode?: string;
    personTypePersonal?: boolean;
    packageTypesGroup?: string;
    packageTypesNewlineGroup?: string;
    packageTypesPackageVolume?: string;
    substituteSignatureImagePath?: string;
    signLabelSignatureImagePath?: string;
    trademarkImagePath?: string;
    packageTypesGroupInVoucher?: string;
    packageTypesPackageVolumeInVoucher?: string;
    voucherPackageReportList?: VoucherPackageReport[];
    voucherPackageReportListAttachment?: VoucherPackageReport[];
    addedIngredientSubtypeFormReport?: AddedIngredientSubtypeReport[];
    addedIngredientSubtypeReport?: AddedIngredientSubtypeReport[];
    addedIngredientSubtypeReportAttachment?: AddedIngredientSubtypeReport[];
    feedItemReport?: FeedItemReport[];
    durations?: string;
    durationMonthGroup?: string;
    labelAddingPreservativeTypeList?: VoucherLabelAdding[];
    labelAddingOtherTypeList?: VoucherLabelAdding[];
    summaryIngredientExtraLine?: string;
    summaryLabelIngredientExtraLine?: string;
    summaryIngredientExtraLineAttachment?: string;
    summaryIngredientExtraLineAttachment2?: string;
    summaryIngredientExtraLineAttachment3?: string;
    summaryIngredientInVoucher?: string;
    summaryIngredientAttachment?: string;
    packageTypesPackageVolumeNewline?: string;
}

export interface VoucherPackageReport {
    packageName?: string;
    netWeight?: string;
    durationMonth?: string;
}

export interface VoucherReport extends Voucher {
    manufacturerName?: string;
    manufacturerAddress?: string;
    authorizedDirectorFirst?: VoucherAuthorizedDirector;
    personTypeCompany?: boolean;
    userPersonal?: User;
    userCompany?: User;
    reportEntrepreneurs?: LicensingEntrepreneur[];
    reportEntrepreneurFirst?: LicensingEntrepreneur;
    importerName?: string;
    importerAddress?: string;
    personTypePersonal?: boolean;
    packageTypesGroup?: string;
    packageTypesNewlineGroup?: string;
    packageTypesPackageVolume?: string;
    addedIngredientSubtypeReport?: AddedIngredientSubtypeReport[];
    feedItemReport?: FeedItemReport[];
    durations?: string;
    durationMonthGroup?: string;
    labelAddingPreservativeTypeList?: VoucherLabelAdding[];
    labelAddingOtherTypeList?: VoucherLabelAdding[];
    packageTypesPackageVolumeNewline?: string;
}

export interface Pageable {
    offset?: number;
    sort?: any;
    paged?: boolean;
    unpaged?: boolean;
    pageNumber?: number;
    pageSize?: number;
}

export interface InfoProperties {
}

export interface GrantedAuthority {
    authority?: string;
}

export interface ObjectNode extends ContainerNode<ObjectNode> {
}

export interface Enum<E> extends Constable, Comparable<E> {
}

export interface UserDetails {
    enabled?: boolean;
    username?: string;
    authorities?: GrantedAuthority[];
    accountNonExpired?: boolean;
    accountNonLocked?: boolean;
    credentialsNonExpired?: boolean;
    password?: string;
}

export interface MultipartFile extends InputStreamSource {
    name?: string;
    bytes?: any;
    empty?: boolean;
    resource?: Resource;
    size?: number;
    originalFilename?: string;
    contentType?: string;
}

export interface PaymentProjection {
    formatedAmount?: string;
}

export interface LocallityCompCodePK {
    feeRateId?: string;
    dofOrgId?: string;
}

export interface Streamable<T> extends Supplier<Stream<T>> {
    empty?: boolean;
}

export interface JpaRepository<T, ID> extends PagingAndSortingRepository<T, ID>, QueryByExampleExecutor<T> {
}

export interface Constable {
}

export interface ValidateGroupSelector<T> {
}

export interface Resource extends InputStreamSource {
    open?: boolean;
    file?: any;
    readable?: boolean;
    url?: URL;
    uri?: URI;
    filename?: string;
    description?: string;
}

export interface InputStreamSource {
    inputStream?: any;
}

export interface ContainerNode<T> extends BaseJsonNode, JsonNodeCreator {
}

export interface Comparable<T> {
}

export interface URL {
}

export interface URI extends Comparable<URI> {
}

export interface Supplier<T> {
}

export interface Stream<T> extends BaseStream<T, Stream<T>> {
}

export interface PagingAndSortingRepository<T, ID> extends CrudRepository<T, ID> {
}

export interface QueryByExampleExecutor<T> {
}

export interface BaseJsonNode {
}

export interface JsonNodeCreator {
}

export interface BaseStream<T, S> extends AutoCloseable {
    parallel?: boolean;
}

export interface CrudRepository<T, ID> extends Repository<T, ID> {
}

export interface AutoCloseable {
}

export interface Repository<T, ID> {
}

export type AnimalFeedConsiderType = "IS_ANIMAL_FEED" | "IS_ANIMAL_FEED_OTHER" | "IS_OTHER";

export type SystemType = "ONLINE" | "MANUAL";

export type AuditCorrectionFormStatus = "WAIT_PRIM_CORRECT" | "TECH_CORRECT" | "CORRECT_CHIEF" | "CORRECT_DIRECTOR";

export type AuditFormObjectiveType = "PRODUCE" | "IMPORT";

export type AuditFormResultConsiderationType = "IS_ANIMAL_FEED" | "IS_FACTOR_PRODUCTION" | "OTHER";

export type AuditFormStatus = "NEW" | "WAIT_VERIFY_TECH" | "WAIT_PRIM_CORRECT" | "WAIT_VERIFY_CORRECT_PRIM" | "WAIT_PERMIT_TECH" | "TECH_CORRECT" | "WAIT_VERIFY_CORRECT_TECH" | "WAIT_VERIFY_CORRECT_CHIEF" | "WAIT_VERIFY_CORRECT_DIRECTOR" | "WAIT_SIGN" | "WAIT_ORDER" | "CORRECT_CHIEF" | "SPECIFIED" | "FEED_NOT_SPECIFIED" | "NOT_FEED_NOT_SPECIFIED" | "FAILED" | "CORRECT_DIRECTOR" | "WAIT_NOTIFICATION_BOOK" | "APPROVE" | "NOT_APPROVE" | "CONDITION_APPROVE" | "CANCELLATION" | "CANCEL_BY_APPLICANT";

export type AuditProductType = "FORM_FILL_1" | "FORM_FILL_2";

export type ApplicantType = "MANUFACTURER" | "EXPORTER";

export type CertOfHealthFileType = "MANUFACTURE_LICENSE" | "VOUCHER_LICENSE" | "FORMULA_CERT" | "GMP_HACCP_LICENSE" | "ANIMAL_FEED_PRODUCTION_CHART" | "SALMONELLA_SPP" | "FORMULA_CERT_NO_POULTRY" | "FORMULA_CERT_NO_SALMONIDAE" | "CERT_ANALYSIS" | "E_COLI" | "VIBRIO_PARAHAEMOLYTICUS" | "VIBRIO_CHOLERA" | "STAPHYLOCOCCUS_AUREUS" | "AEROBIC_PLATE_COUNT" | "COLIFORM_BACTERIA" | "FECAL_COLIFORM" | "ESHERICHIA_COLI" | "LISTERIA_MONOCYTOGENES" | "CHLORAMPHENICOL" | "NITROFURANS" | "PRODUCT_LABEL_PHOTO" | "FREE_FROM_BIRD_FLU_NOTICE" | "INVOICE_LOADING_CONTAINERS" | "ENTEROBACTER_SPP" | "AFLATOXINS" | "PRODUCT_INFORMATION" | "DOMESTIC_SALES_INVOICE" | "IMPORT_PERMIT_FROM_DESTINATION_COUNTRY" | "COMPANY_RESPONSE_LETTER" | "INSPECTED_BY_THE_LICENSOR" | "PACKAGE_PHOTO" | "CERT_MOISTURE_ANALYSIS" | "PRODUCT_PHOTO";

export type CertificateCorrectionFormStatus = "WAIT_PRIM_CORRECT" | "WAIT_TECH_CORRECT" | "CORRECT_DIRECTOR" | "CORRECT_CHIEF";

export type CertificateDocumentType = "NEW" | "LICESNING_OR_CERTIFICATE" | "REVISE" | "SUBSTITUTE" | "CANCELATION";

export type CertificateDomesticSaleAttachFileRequest = "DO_NOT_REQUEST_ATTACH" | "REQUEST_ATTACH";

export type CertificateDomesticSalesCopyRequest = "DO_NOT_REQUEST_COPY" | "REQUEST_COPY";

export type CertificateDomesticSalesType = "REGISTER" | "FOR_EXPORT";

export type CertificateDomesticSalesVoucherFileType = "VOUCHER";

export type CertificateExporterType = "ADDRESS_THAT_MEETS" | "ADDRESS_DIFFERENT_FROM";

export type CertificateFileType = "CERTIFICATE" | "INVOICE" | "RECIPE_CERTIFICATE" | "OTHER" | "BOOKING_CONFIRM" | "DOCUMENT";

export type CertificateForm1FileType = "CERTIFICATE" | "INVOICE" | "RECIPE_CERTIFICATE" | "OTHER" | "BOOKING_CONFIRM" | "DOCUMENT";

export type CertificateForm2FileType = "CERTIFICATE" | "INVOICE" | "RECIPE_CERTIFICATE" | "OTHER" | "BOOKING_CONFIRM" | "DOCUMENT";

export type CertificateForm3FileType = "CERTIFICATE" | "OTHER" | "DOCUMENT";

export type CertificateForm4FileType = "CERTIFICATE" | "OTHER" | "DOCUMENT";

export type CertificateFormStatus = "NEW" | "CORRECTION" | "SUBSTITUTE" | "CANCELLATION" | "WAIT_PAYMENT" | "UPLOAD_SLIP" | "PAID" | "WAIT_VERIFY_TECH" | "WAIT_PRIM_CORRECT" | "WAIT_VERIFY_CORRECTION_PRIM" | "WAIT_PERMIT_TECH" | "WAIT_TECH_CORRECT" | "WAIT_SCHEDULE" | "WAIT_CERT" | "WAIT_VERIFY_CORRECT_TECH" | "WAIT_VERIFY_CORRECT_CONCLUDE" | "WAIT_VERIFY_CORRECT_CHIEF" | "WAIT_VERIFY_CORRECT_DIRECTOR" | "WAIT_CONFERRED" | "DENIED_CONFERRED" | "CORRECT_CONCLUDE" | "WAIT_SIGN" | "WAIT_ORDER" | "CORRECT_CHIEF" | "APPROVE" | "WAIT_LICENSE" | "DISAPPROVE" | "APPROVE_CONDITION" | "CORRECT_DIRECTOR" | "DENIED" | "CANCEL_REQUEST";

export type CertificateSystemType = "OFFLINE" | "ONLINE" | "MANUAL" | "AUTO_BY_SYSTEM";

export type CertificateTransportInfo = "SHIP" | "PLANE" | "TRUCK" | "OTHER";

export type AuthorityType = "ADMIN" | "OFFICER" | "DIRECTOR" | "ACTING_DIRECTOR_KPO" | "SCG_ADMIN" | "SCG_BASIC_CONSIDERATION" | "SCG_ACADEMIC" | "SCG_CHIEF" | "QCG_ADMIN" | "QCG_ACADEMIC_GOV" | "QCG_OFFICER" | "QCG_ACADEMIC" | "QCG_CHIEF" | "PROVINCE_ACADEMIC_GOV" | "PROVINCE_OFFICER" | "PROVINCE_ACADEMIC" | "PROVINCE_CHIEF" | "PROVINCE_DIRECTOR" | "PROVINCE_FINANCE_ACCOUNTING" | "CHECKPOINT_OFFICER" | "CHECKPOINT_CHIEF" | "FINANCE_ACCOUNTING" | "PERSONAL" | "COMPANY" | "REQUEST_NEW" | "REQUEST_AUTHORIZED" | "MAIN_AGENT" | "AGENT" | "EMPLOYEE" | "ENTREPRENEUR" | "ATTORNEY" | "LICENSING" | "VOUCHER_1" | "VOUCHER_2" | "VOUCHER_3" | "CERTIFICATE" | "NS4" | "GMP_HACCP" | "AUDIT" | "REQUEST_INSPECTION";

export type Event = "NEW" | "COPY";

export type State = "TEMP" | "STORED";

export type DocumentType = "NEW" | "LICESNING_OR_CERTIFICATE" | "REVISE" | "SUBSTITUTE" | "CANCELATION";

export type UsersPermission = "DELETE" | "DISABLE";

export type AmountResult = "VALID" | "INVALID";

export type Animal = "PRAWN" | "FISH" | "FROG" | "SNAPPING_TURTLE" | "OTHER";

export type AnimalFeedActGroup = "ANIMAL_FEED" | "OTHERS";

export type AnimalFeedGroupId = "MIXED" | "SUPPLEMENT" | "OTHERS_MIXED" | "LIVE_FEED" | "FROZEN_LIVE_FEED" | "INGREDIENT" | "FEED_ADDITIVE";

export type AnimalFeedTypeId = "FEED" | "CONCENTRATED_FEED" | "PROTEIN_SUPPLEMENT" | "FAT_SUPPLEMENT" | "MINERAL_SUPPLEMENT" | "VITAMIN_SUPPLEMENT" | "AQUATIC_ANIMAL_PREMIX" | "SUPPLEMENT" | "SHRIMP_FEED" | "FISH_FEED" | "AQUATIC_ANIMAL_FEED" | "ORNAMENTAL_FISH_FEED" | "ORNAMENTAL_TURTLE_FEED" | "ORNAMENTAL_SHRIMP_FEED" | "ORNAMENTAL_FROG_FEED" | "BAIT" | "ENRICHMENT_FOR_ARTEMIA" | "ENRICHMENT_FOR_ROTIFER" | "ENRICHMENT_FOR_ARTEMIA_AND_ROTIFER" | "ARTEMIA_CYSTS" | "FROZEN_WATER_MITES" | "FROZEN_SHRIMP_ROE" | "FROZEN_SEA_MITES" | "FROZEN_SEA_BARNACLES" | "FROZEN_SQUID" | "STIR_SQUID" | "ALPHA_STARCH" | "SEAWEED_MEAL" | "FLAVOR_ADDITIVE" | "COLOR_ENHANCER" | "OREGANO_OIL" | "OTHER" | "CONCENTRATED_FEED_FOR_SHRIMP" | "CONCENTRATED_FEED_FOR_FISH" | "CONCENTRATED_FEED_FOR_AQUATIC_ANIMAL" | "ASTAXANTHIN" | "MARINE_OIL" | "VEGETABLE_OIL" | "TERRESTRIAL_ANIMAL_OIL" | "CHITOSAN" | "SHRIMP_PASTE" | "YEAST" | "ANIMAL_FEED_PRESERVATIVES" | "DIGESTIVE_AID" | "ANTI_CAKING_AGENT" | "PELLET_AID" | "AMINO_ACIDS" | "ENZYME" | "BIO_SUPPLEMENT" | "FROZEN_KRILL" | "FROZEN_RED_WORM" | "EPHIPPIUM_EGG" | "INGREDIENT_OTHER" | "FEED_ADDITIVE_OTHER" | "SUPPLEMENT_OTHER" | "OTHERS_MIXED_OTHER" | "PREMIX_ORNAMENTAL_AQUATIC_ANIMAL" | "SUPPLEMENTS_ORNAMENTAL_AQUATIC_ANIMAL";

export type AppointmentStatus = "ACCEPTED" | "DENIED";

export type ApproveStatus = "APPROVE" | "REJECT" | "CORRECT" | "APPROVE_WITH_CONDITIONS";

export type CardType = "ID_CARD" | "PASSPORT";

export type CertificateMessage = "MSG1" | "MSG2" | "OTHER";

export type CertificateType = "CERTIFICATE_OF_FREE_SALE" | "HEALTH_CERTIFICATE";

export type CheckingResult = "PERMIT" | "REJECT";

export type ConsiderType = "BASIC" | "ACADEMIC";

export type CorrectionRequestGroup = "REGISTRATION" | "LABEL";

export type Department = "DOF" | "DLD" | "NO_LICENSED";

export type DofOrgType = "OFFICE" | "PORT";

export type EmployeeFileType = "ID_CARD_COPY" | "PASSPORT_COPY" | "ATTORNEY_COPY";

export type EntrepreneurFileType = "ID_CARD_COPY" | "PASSPORT_COPY" | "ENTREPRENEUR_ASSIGNMENT";

export type ExporterType = "EXPORTER_TYPE1" | "EXPORTER_TYPE2";

export type FactorOtherType = "DANGEROUS_OBJECTS" | "DRUG" | "OTHER";

export type FileUploadType = "FileUpload" | "UserFile" | "RequestUserFile" | "EntrepreneurFile" | "EmployeeFile" | "RequestEntrepreneurFile" | "RequestEmployeeFile" | "LicensingFile" | "LicensingEntrepreneurFile" | "LicensingForm1File" | "LicensingForm2File" | "LicensingForm3File" | "LicensingForm4File" | "LicensingForm5File" | "LicensingForm6File" | "LicensingForm7File" | "LicensingForm8File" | "LicensingForm9File" | "LicensingForm10File" | "LicensingForm11File" | "LicensingForm12File" | "LicensingForm13File" | "LicensingForm14File" | "LicensingForm15File" | "LicensingForm16File" | "LicensingForm17File" | "LicensingForm18File" | "LicensingForm19File" | "LicensingFormSiteInspectionFile" | "VoucherFile" | "VoucherForm1File" | "VoucherForm2File" | "VoucherForm3File" | "VoucherForm4File" | "VoucherForm5File" | "VoucherForm6File" | "VoucherForm7File" | "CertificateForm1File" | "CertificateForm2File" | "CertificateForm3File" | "CertificateForm4File" | "AuditFile" | "RequestInspectionForm1File" | "Ns4Form1File" | "Ns4Form2File" | "RequestInspectionFormCheckSiteInspectionFile" | "GmpHaccpFormCheckSiteInspectionFile" | "RequestInspectionFile" | "RequestInspectionFormAuditFile" | "RequestInspectionAuditFile" | "RequestInspectionEntrepreneurFile" | "Ns4File" | "GmpHaccpMeetingBookingFile" | "CertOfHealthFile" | "CertificateDomesticSalesVoucherFile" | "GmpHaccpForm1File" | "GmpHaccpForm2File" | "GmpHaccpForm3File" | "GmpHaccpForm4File" | "GmpHaccpForm5File" | "GmpHaccpForm6File" | "GmpHaccpForm7File" | "GmpHaccpForm8File" | "GmpHaccpFile" | "CertificateFile" | "GmpHaccpFormFollowInspectionFile" | "BankTransferFile";

export type FilingOffice = "C" | "P";

export type FormStatus = "NEW" | "CONSIDER" | "REVISE" | "REVISED" | "APPOINTMENT" | "SITE_INSPECTION" | "LICENSING" | "SIGNING" | "ORDER";

export type FormType = "Register" | "Entrepreneur" | "LicensingForm1" | "LicensingForm2" | "LicensingForm3" | "LicensingForm4" | "LicensingForm5" | "LicensingForm6" | "LicensingForm7" | "LicensingForm8" | "LicensingForm9" | "LicensingForm10" | "LicensingForm11" | "LicensingForm12" | "LicensingForm13" | "LicensingForm14" | "LicensingForm15" | "LicensingForm16" | "LicensingForm17" | "LicensingForm18" | "LicensingForm19" | "Licensing" | "VoucherForm1" | "VoucherForm2" | "VoucherForm3" | "VoucherForm4" | "VoucherForm5" | "VoucherForm6" | "VoucherForm7" | "Voucher" | "GmpHaccpForm1" | "GmpHaccpForm2" | "GmpHaccpForm3" | "GmpHaccpForm4" | "GmpHaccpForm5" | "GmpHaccpForm6" | "GmpHaccpForm7" | "GmpHaccpForm8" | "GmpHaccpForm" | "GmpHaccp" | "CertificateForm1" | "CertificateForm2" | "CertificateForm3" | "CertificateForm4" | "Certificate" | "Ns4Form1" | "Ns4Form2" | "AuditForm1" | "Audit" | "RequestInspectionForm1" | "RequestInspection";

export type GmpHaccpIssueType = "N" | "R" | "C" | "S";

export type LabelResult = "VALID" | "INVALID" | "NO_LABEL";

export type LicenseStatus = "AVAILABLE" | "USED" | "CANCELED" | "RENEW" | "EXPIRED";

export type LicenseSubType = "WHOLESALE_AND_RETAIL" | "RETAIL";

export type LicenseType = "P" | "I" | "S";

export type LicensingEntrepreneurFileType = "ID_CARD_COPY" | "PASSPORT_COPY" | "ENTREPRENEUR_ASSIGNMENT";

export type LicensingFormStatus = "NEW" | "PRIM_CORRECTION" | "CANCELATION" | "CANCEL_BY_APPLICANT" | "PRIM_CORRECTED" | "WAIT_VERIFY" | "WAIT_APPOINT_LOCATION" | "WAIT_ACCEPT_LOCATION" | "APPOINT_DENIED" | "WAIT_INSPECT_LOCATION" | "LOCATION_DENIED" | "WAIT_APPLICATION" | "APPLIED" | "WAIT_CERT" | "REPORT_CORRECT" | "WAIT_SIGN_PROPOSAL" | "WAIT_ORDER" | "DENIED" | "WAIT_PAYMENT" | "UPLOAD_SLIP" | "PAID" | "GRANT";

export type LicensingIssueType = "N" | "R" | "C" | "S";

export type Modules = "LICENSING_P" | "LICENSING_I" | "LICENSING_S" | "VOUCHER" | "GMP" | "HACCP" | "CERTIFICATE_FREE_SALE" | "CERTIFICATE_HEALTH" | "NS4" | "AUDIT" | "REQUEST_INSPECTION";

export type PerformType = "ENTREPRENEUR" | "ATTORNEY";

export type PersonType = "PERSONAL" | "COMPANY";

export type QualityType = "PROTEIN" | "FAT" | "FIBER" | "MOISTURE";

export type RequestAgentStatus = "A" | "D";

export type RequestAgentType = "ENTREPRENEUR" | "EMPLOYEE";

export type RequestEmployeeFileType = "ID_CARD_COPY" | "PASSPORT_COPY" | "ATTORNEY_COPY";

export type RequestEntrepreneurFileType = "ID_CARD_COPY" | "PASSPORT_COPY" | "ENTREPRENEUR_ASSIGNMENT";

export type RequestInspectionEntrepreneurFileType = "ID_CARD_COPY" | "PASSPORT_COPY" | "ENTREPRENEUR_ASSIGNMENT";

export type RequestMethod = "OFFLINE" | "ONLINE" | "MANUAL" | "AUTO";

export type RequestRegisterStatus = "NEW" | "PENDING" | "APPROVED" | "CORRECTION" | "WAIT_CORRECTION_CONSIDER" | "DENIED";

export type RequestRegisterType = "N" | "C" | "R";

export type RequestSubstituteReason = "DAMAGED" | "LOST";

export type RequestType = "N" | "R" | "C" | "S";

export type RequestUserFileType = "ID_CARD_COPY" | "PASSPORT_COPY" | "ATTORNEY_PERSON_ACCOUNT" | "ATTORNEY_COPY" | "COMPANY_REGISTRATION_COPY" | "DIGITAL_CERTIFICATE" | "ENTREPRENEUR_ASSIGNMENT" | "SIGNATURE" | "SIGNATURE_EN";

export type Sample = "SAMPLE_3" | "SAMPLE_4" | "SAMPLE_NONE";

export type UserFileType = "ID_CARD_COPY" | "PASSPORT_COPY" | "ATTORNEY_PERSON_ACCOUNT" | "ATTORNEY_COPY" | "COMPANY_REGISTRATION_COPY" | "DIGITAL_CERTIFICATE" | "ENTREPRENEUR_ASSIGNMENT" | "SIGNATURE" | "SIGNATURE_EN";

export type UserStatus = "P" | "R";

export type UserType = "PERSONAL" | "COMPANY" | "OFFICER";

export type FollowInspectionStatus = "MONITORING_1" | "MONITORING_2";

export type GmpHaccpCertificateLevel = "LEVEL1" | "LEVEL2" | "LEVEL3";

export type GmpHaccpCheckInspectionType = "COMPLY" | "NOT_COMPLY" | "PASS" | "DEFECTIVE" | "CR" | "SE" | "M" | "N" | "EMPTY";

export type GmpHaccpCheckSiteInspectionResult = "PASS" | "MONITORING_FACTORY" | "MONITORING_REPORT" | "CANT_FIX_BUGS_180";

export type GmpHaccpCorrectionRequestType = "LOCATION" | "SCOPE_OF_CERTIFICATION" | "OTHER";

export type GmpHaccpFileType = "FACTORY_LICENSE_COPY" | "MANUFACTURE_LICENSE_COPY_FISHERIES" | "MANUFACTURE_LICENSE_COPY_LIVESTOCK" | "FACTORY_MAP_FISHERIES" | "FACTORY_MAP_LIVESTOCK" | "EQUIPMENT_LIST_FISHERIES" | "EQUIPMENT_LIST_LIVESTOCK" | "CORRECTION_FORM" | "ID_CARD_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "OTHER" | "PASSPORT_COPY" | "GMPHACCP_CERTIFICATE_OR_SUBSTITUTE" | "DOCUMENT" | "GMPHACCP_CERTIFICATE" | "DAMAGED_GMPHACCP_CERTIFICATE" | "LOST_EVIDENCE";

export type GmpHaccpForm1FileType = "DOCUMENT" | "FACTORY_LICENSE_COPY" | "MANUFACTURE_LICENSE_COPY_FISHERIES" | "MANUFACTURE_LICENSE_COPY_LIVESTOCK" | "FACTORY_MAP_FISHERIES" | "FACTORY_MAP_LIVESTOCK" | "EQUIPMENT_LIST_FISHERIES" | "EQUIPMENT_LIST_LIVESTOCK" | "ID_CARD_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "OTHER";

export type GmpHaccpForm2FileType = "DOCUMENT" | "GMPHACCP_CERTIFICATE_OR_SUBSTITUTE" | "MANUFACTURE_LICENSE_COPY_FISHERIES" | "MANUFACTURE_LICENSE_COPY_LIVESTOCK" | "FACTORY_MAP_FISHERIES" | "FACTORY_MAP_LIVESTOCK" | "EQUIPMENT_LIST_FISHERIES" | "EQUIPMENT_LIST_LIVESTOCK" | "OTHER" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY";

export type GmpHaccpForm3FileType = "DOCUMENT" | "GMPHACCP_CERTIFICATE_OR_SUBSTITUTE" | "MANUFACTURE_LICENSE_COPY_FISHERIES" | "MANUFACTURE_LICENSE_COPY_LIVESTOCK" | "FACTORY_MAP_FISHERIES" | "FACTORY_MAP_LIVESTOCK" | "EQUIPMENT_LIST_FISHERIES" | "EQUIPMENT_LIST_LIVESTOCK" | "CORRECTION_FORM" | "OTHER" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY";

export type GmpHaccpForm4FileType = "DOCUMENT" | "DAMAGED_GMPHACCP_CERTIFICATE" | "LOST_EVIDENCE" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "OTHER";

export type GmpHaccpForm5FileType = "DOCUMENT" | "GMPHACCP_CERTIFICATE_OR_SUBSTITUTE" | "FACTORY_LICENSE_COPY" | "MANUFACTURE_LICENSE_COPY_FISHERIES" | "MANUFACTURE_LICENSE_COPY_LIVESTOCK" | "FACTORY_MAP_FISHERIES" | "FACTORY_MAP_LIVESTOCK" | "EQUIPMENT_LIST_FISHERIES" | "EQUIPMENT_LIST_LIVESTOCK" | "OTHER" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY";

export type GmpHaccpForm6FileType = "DOCUMENT" | "GMPHACCP_CERTIFICATE_OR_SUBSTITUTE" | "MANUFACTURE_LICENSE_COPY_FISHERIES" | "MANUFACTURE_LICENSE_COPY_LIVESTOCK" | "FACTORY_MAP_FISHERIES" | "FACTORY_MAP_LIVESTOCK" | "EQUIPMENT_LIST_FISHERIES" | "EQUIPMENT_LIST_LIVESTOCK" | "OTHER" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY";

export type GmpHaccpForm7FileType = "DOCUMENT" | "GMPHACCP_CERTIFICATE_OR_SUBSTITUTE" | "MANUFACTURE_LICENSE_COPY_FISHERIES" | "MANUFACTURE_LICENSE_COPY_LIVESTOCK" | "FACTORY_MAP_FISHERIES" | "FACTORY_MAP_LIVESTOCK" | "EQUIPMENT_LIST_FISHERIES" | "EQUIPMENT_LIST_LIVESTOCK" | "CORRECTION_FORM" | "OTHER" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY";

export type GmpHaccpForm8FileType = "DOCUMENT" | "DAMAGED_GMPHACCP_CERTIFICATE" | "LOST_EVIDENCE" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "OTHER";

export type GmpHaccpFormCheckSiteInspectionFileType = "PRODUCTION_EXAM_PIC" | "EXAM_SHED_1" | "EXAM_SHED_2" | "EXAM_SHED_3" | "ERROR_REPORT_1" | "ERROR_REPORT_2" | "ERROR_REPORT_3" | "EXAM_REPORT" | "CORRECTION_REPORT_1" | "CORRECTION_REPORT_2" | "CORRECTION_REPORT_3" | "CORRECTION_REPORT_4" | "REPORT_SITE_INSPECTION";

export type GmpHaccpFormFollowInspectionFileType = "EXAM_SHED_1" | "EXAM_SHED_2" | "ERROR_REPORT_1" | "ERROR_REPORT_2" | "CORRECTION_REPORT_1" | "CORRECTION_REPORT_2" | "OTHER_1" | "OTHER_2";

export type GmpHaccpFormStatus = "NEW" | "VERIFY_CORRECT_PRIM" | "CANCELATION" | "CANCEL_BY_APPLICANT" | "CORRECTED_PRIM" | "WAIT_OG_DOC" | "WAIT_APPOINT_DATE_1" | "WAIT_APPOINT_DATE_2" | "WAIT_APPOINT_DATE_3" | "WAIT_CONFIRM_APPOINT_DATE_1" | "WAIT_CONFIRM_APPOINT_DATE_2" | "WAIT_CONFIRM_APPOINT_DATE_3" | "APPOINT_DENIED_1" | "APPOINT_DENIED_2" | "APPOINT_DENIED_3" | "WAIT_EXAM_PLACE_1" | "WAIT_EXAM_PLACE_2" | "WAIT_EXAM_PLACE_3" | "WAIT_CORRECT_FACTORY_1" | "WAIT_CORRECT_FACTORY_2" | "SEND_CORRECT_REPORT_1" | "SEND_CORRECT_REPORT_2" | "WAIT_EXAM_CORRECTION_1" | "WAIT_EXAM_CORRECTION_2" | "DENIED_CORRECTION_FAILED" | "EXAM_NOTED" | "WAIT_MEETING" | "WAIT_MEETING_REPORT" | "WAIT_CONFIRM_MEETING_REPORT" | "WAIT_LICENSE" | "WAIT_SIGN" | "WAIT_ORDER" | "DISAPPROVE" | "APPROVE" | "WAIT_PAYMENT" | "UPLOAD_SLIP" | "PAID";

export type GmpHaccpMeetingBookingFileType = "MEETING_REPORT" | "SIGN_DOCUMENT" | "INVITATION_LETTER" | "MEETING_PRESENTATION";

export type GmpHaccpMeetingStatus = "WAIT_MEETING_REPORT" | "MEETING_REPORT_DONE" | "MEETING_BYPASS_DONE";

export type GmpHaccpType = "GMP" | "HACCP";

export type AuditFileType = "AUDIT" | "DOCUMENT";

export type CertificateOfFreeSaleType = "WHOLESALE_AND_RETAIL" | "RETAIL";

export type LicensingFileType = "LICENSE" | "LICENSE_OR_SUBSTITUTE" | "DAMAGED_LICENSE" | "LOST_EVIDENCE" | "AUTHORITY" | "AUTHORITY_NEW" | "EQUIPMENT_LIST" | "EQUIPMENT_LIST_NEW" | "PROCESS" | "PROCESS_NEW" | "PRODUCTION_MAP" | "PRODUCTION_WAREHOUSE_MAP" | "IMPORT_MAP" | "IMPORT_WAREHOUSE_MAP" | "SELL_MAP" | "SELL_WAREHOUSE_MAP" | "COMMERCIAL_REGISTRATION" | "JURISTIC_REGISTER" | "HAZARD_LICENSE" | "FACTORY_LICENSE" | "LICENSING_FORM1" | "CORRECTION_FORM" | "OTHER" | "FACTORY_LICENSE_COPY" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "ATTORNEY_PERSON_ACCOUNT" | "ENTREPRENEUR_ASSIGNMENT" | "DIGITAL_CERTIFICATE" | "DOCUMENT";

export type LicensingForm10FileType = "DOCUMENT" | "LICENSE_OR_SUBSTITUTE" | "COMMERCIAL_REGISTRATION" | "JURISTIC_REGISTER" | "AUTHORITY" | "IMPORT_MAP" | "IMPORT_WAREHOUSE_MAP" | "LICENSING_FORM1" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "ATTORNEY_PERSON_ACCOUNT" | "OTHER";

export type LicensingForm11FileType = "DOCUMENT" | "LICENSE_OR_SUBSTITUTE" | "COMMERCIAL_REGISTRATION" | "JURISTIC_REGISTER" | "AUTHORITY" | "IMPORT_MAP" | "IMPORT_WAREHOUSE_MAP" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "ATTORNEY_PERSON_ACCOUNT" | "OTHER";

export type LicensingForm12FileType = "DOCUMENT" | "LICENSE_OR_SUBSTITUTE" | "CORRECTION_FORM" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "ATTORNEY_PERSON_ACCOUNT" | "OTHER";

export type LicensingForm13FileType = "DOCUMENT" | "DAMAGED_LICENSE" | "LOST_EVIDENCE" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "ATTORNEY_PERSON_ACCOUNT" | "OTHER";

export type LicensingForm14FileType = "DOCUMENT" | "COMMERCIAL_REGISTRATION" | "JURISTIC_REGISTER" | "AUTHORITY" | "SELL_MAP" | "SELL_WAREHOUSE_MAP" | "LICENSING_FORM1" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "ATTORNEY_PERSON_ACCOUNT" | "OTHER";

export type LicensingForm15FileType = "DOCUMENT" | "COMMERCIAL_REGISTRATION" | "JURISTIC_REGISTER" | "AUTHORITY" | "SELL_MAP" | "SELL_WAREHOUSE_MAP" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "ATTORNEY_PERSON_ACCOUNT" | "OTHER";

export type LicensingForm16FileType = "DOCUMENT" | "LICENSE_OR_SUBSTITUTE" | "AUTHORITY" | "AUTHORITY_NEW" | "SELL_MAP" | "SELL_WAREHOUSE_MAP" | "LICENSING_FORM1" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "ATTORNEY_PERSON_ACCOUNT" | "OTHER";

export type LicensingForm17FileType = "DOCUMENT" | "LICENSE_OR_SUBSTITUTE" | "AUTHORITY" | "AUTHORITY_NEW" | "SELL_MAP" | "SELL_WAREHOUSE_MAP" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "ATTORNEY_PERSON_ACCOUNT" | "OTHER";

export type LicensingForm18FileType = "DOCUMENT" | "LICENSE_OR_SUBSTITUTE" | "AUTHORITY" | "AUTHORITY_NEW" | "SELL_MAP" | "SELL_WAREHOUSE_MAP" | "CORRECTION_FORM" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "ATTORNEY_PERSON_ACCOUNT" | "OTHER";

export type LicensingForm19FileType = "DOCUMENT" | "DAMAGED_LICENSE" | "LOST_EVIDENCE" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "ATTORNEY_PERSON_ACCOUNT" | "OTHER";

export type LicensingForm1FileType = "DOCUMENT" | "LICENSE_OR_SUBSTITUTE" | "EQUIPMENT_LIST" | "PROCESS" | "PRODUCTION_MAP" | "PRODUCTION_WAREHOUSE_MAP" | "IMPORT_WAREHOUSE_MAP" | "SELL_WAREHOUSE_MAP" | "ID_CARD_COPY" | "PASSPORT_COPY" | "ATTORNEY_COPY" | "ATTORNEY_PERSON_ACCOUNT" | "COMPANY_REGISTRATION_COPY" | "ENTREPRENEUR_ASSIGNMENT" | "DIGITAL_CERTIFICATE";

export type LicensingForm2FileType = "DOCUMENT" | "AUTHORITY" | "JURISTIC_REGISTER" | "EQUIPMENT_LIST" | "PROCESS" | "PRODUCTION_MAP" | "PRODUCTION_WAREHOUSE_MAP" | "HAZARD_LICENSE" | "FACTORY_LICENSE" | "LICENSING_FORM1" | "CORRECTION_FORM" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "ATTORNEY_PERSON_ACCOUNT" | "OTHER";

export type LicensingForm3FileType = "DOCUMENT" | "AUTHORITY" | "JURISTIC_REGISTER" | "EQUIPMENT_LIST" | "PROCESS" | "PRODUCTION_MAP" | "PRODUCTION_WAREHOUSE_MAP" | "HAZARD_LICENSE" | "FACTORY_LICENSE" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "ATTORNEY_PERSON_ACCOUNT" | "OTHER";

export type LicensingForm4FileType = "DOCUMENT" | "JURISTIC_REGISTER" | "LICENSE_OR_SUBSTITUTE" | "EQUIPMENT_LIST" | "PROCESS" | "LICENSING_FORM1" | "HAZARD_LICENSE" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "ATTORNEY_PERSON_ACCOUNT" | "OTHER";

export type LicensingForm5FileType = "DOCUMENT" | "JURISTIC_REGISTER" | "LICENSE_OR_SUBSTITUTE" | "EQUIPMENT_LIST" | "EQUIPMENT_LIST_NEW" | "PROCESS" | "HAZARD_LICENSE" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "ATTORNEY_PERSON_ACCOUNT" | "OTHER";

export type LicensingForm6FileType = "DOCUMENT" | "LICENSE_OR_SUBSTITUTE" | "EQUIPMENT_LIST" | "EQUIPMENT_LIST_NEW" | "PROCESS" | "PROCESS_NEW" | "CORRECTION_FORM" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "ATTORNEY_PERSON_ACCOUNT" | "OTHER";

export type LicensingForm7FileType = "DOCUMENT" | "DAMAGED_LICENSE" | "LOST_EVIDENCE" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "ATTORNEY_PERSON_ACCOUNT" | "OTHER";

export type LicensingForm8FileType = "DOCUMENT" | "COMMERCIAL_REGISTRATION" | "JURISTIC_REGISTER" | "AUTHORITY" | "IMPORT_MAP" | "IMPORT_WAREHOUSE_MAP" | "LICENSING_FORM1" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "ATTORNEY_PERSON_ACCOUNT" | "OTHER";

export type LicensingForm9FileType = "DOCUMENT" | "COMMERCIAL_REGISTRATION" | "JURISTIC_REGISTER" | "AUTHORITY" | "IMPORT_MAP" | "IMPORT_WAREHOUSE_MAP" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "ATTORNEY_PERSON_ACCOUNT" | "OTHER";

export type LicensingFormSiteInspectionFileType = "IMAGE_INSPECTION" | "AUDIT_LOG" | "EQUIPMENT_LIST" | "PROCESS" | "LOCATION_CORRECTION_REPORT" | "SITE_INSPECTION_REPORT" | "CHECKLIST_REPORT";

export type SiteInspectionPassResult = "NOT_INSPECTION_AGAIN" | "SENT_REPORT_LOCATION" | "NOT_OPERATED_PRODUCTION_INSPECTION_AGAIN" | "NOT_KEPT_STOCK_INSPECTION_AGAIN";

export type SiteInspectionResult = "PASS" | "NOT_PASS";

export type SiteInspectionStatus = "WAIT_CORRECTION_SENT" | "WAIT_DIGI_SIGN" | "WAIT_CORRECTION_SENT_AND_DIGI_SIGN" | "CORRECTION_SENT" | "PASS" | "NOT_PASS";

export type ConfiscationProduct = "CONFISCATION" | "NONE_CONFISCATION";

export type SampleAnimalFeed = "COLLECT_SAMPLE" | "NONE_COLLECT_SAMPLE";

export type Sampling = "PROTEIN" | "FAT" | "RESIDUE" | "MOISTURE" | "ASH";

export type Ns4AnalysisResultType = "PROTEIN" | "FAT" | "FIBER" | "MOISTURE" | "ASH" | "CALCIUM" | "PHOSPHORUS" | "NITROFURANS" | "CHLORAMPHENICOL" | "OXYTETRACYCLINE" | "ETHOXY_QUIN" | "FLUOROQUINOLONE" | "MELAMINE" | "OHTER";

export type Ns4CheckingChemical = "PASS" | "NOT_PASS";

export type Ns4ConsiderResult = "PASS" | "NOT_PASS";

export type Ns4CorrectionFormStatus = "WAIT_PRIM_CORRECT" | "WAIT_TECH_CORRECT" | "WAIT_PERMIT_TECH" | "CORRECT_CHIEF" | "CORRECT_DIRECTOR";

export type Ns4CorrectionRequest = "IMPORT" | "PRODUCT" | "WAREHOUSE";

export type Ns4Discover = "FOUND" | "NOT_FOUND";

export type Ns4DocumentType = "NEW" | "LICESNING_OR_CERTIFICATE" | "REVISE" | "SUBSTITUTE" | "CANCELATION";

export type Ns4FeedType = "FEED" | "FEED_OTHERS";

export type Ns4FileType = "CERTIFICATE_OF_ORIGIN_ORIGIN" | "PRODUCT_INFORMATION" | "CERTIFICATE_OF_FORMULA" | "CERTIFICATE_OF_HEALTH_PHYTOSANITANY" | "NS4_ANIMAL_FEED_SAMPLING" | "PURCHASE_PRODUCT_QUANTITY" | "DOCUMENT_OTHER" | "DOCUMENT_ANIMAL_FEED" | "DOCUMENT_ANIMAL_FEED_OTHER" | "NS4_ANIMAL_FEED" | "NS4_ANIMAL_FEED_OTHER" | "CONSIDERATION_FORM" | "ANIMAL_FEED_SAMPLING" | "RECORD_WORD" | "SEIZE";

export type Ns4Form1FileType = "CERTIFICATE_OF_ORIGIN_ORIGIN" | "PRODUCT_INFORMATION" | "CERTIFICATE_OF_FORMULA" | "CERTIFICATE_OF_HEALTH_PHYTOSANITANY" | "NS4_ANIMAL_FEED_SAMPLING" | "PURCHASE_PRODUCT_QUANTITY" | "DOCUMENT_OTHER" | "DOCUMENT_ANIMAL_FEED" | "DOCUMENT_ANIMAL_FEED_OTHER" | "CONSIDERATION_FORM" | "ANIMAL_FEED_SAMPLING" | "RECORD_WORD" | "SEIZE" | "NS4_ANIMAL_FEED" | "NS4_ANIMAL_FEED_OTHER";

export type Ns4Form2FileType = "CERTIFICATE_OF_ORIGIN_ORIGIN" | "PRODUCT_INFORMATION" | "CERTIFICATE_OF_FORMULA" | "CERTIFICATE_OF_HEALTH_PHYTOSANITANY" | "NS4_ANIMAL_FEED_SAMPLING" | "PURCHASE_PRODUCT_QUANTITY" | "DOCUMENT_OTHER" | "DOCUMENT_ANIMAL_FEED" | "DOCUMENT_ANIMAL_FEED_OTHER" | "NS4_ANIMAL_FEED" | "NS4_ANIMAL_FEED_OTHER" | "CONSIDERATION_FORM" | "ANIMAL_FEED_SAMPLING" | "RECORD_WORD" | "SEIZE";

export type Ns4FormStatus = "NEW" | "CORRECTION" | "SUBSTITUTE" | "CANCELLATION" | "WAIT_PAYMENT" | "PAID" | "WAIT_VERIFY_TECH" | "WAIT_PRIM_CORRECT" | "WAIT_VERIFY_CORRECTION_PRIM" | "WAIT_PERMIT_TECH" | "WAIT_TECH_CORRECT" | "WAIT_SCHEDULE" | "WAIT_CERT" | "WAIT_MAKE_CERTIFICATE" | "WAIT_VERIFY_CORRECT_TECH" | "WAIT_VERIFY_CORRECT_CONCLUDE" | "WAIT_VERIFY_CORRECT_CHIEF" | "WAIT_VERIFY_CORRECT_DIRECTOR" | "WAIT_CONFERRED" | "DENIED_CONFERRED" | "CORRECT_CONCLUDE" | "WAIT_SIGN" | "WAIT_ORDER" | "CORRECT_CHIEF" | "APPROVE_CONDITION" | "DISAPPROVE" | "CORRECT_DIRECTOR" | "WAIT_PRODUCT_INSPECTION" | "WAIT_RELEASE_INSPECTION" | "WAIT_RELEASE_RESULT" | "RELEASE_RESULT_IN_PROCESS" | "RELEASE_RESULT_ENDED" | "APPROVE" | "NOT_APPROVE" | "CONDITION_APPROVE" | "CANCEL_BY_APPLICANT";

export type Ns4Operator = "ENTREPRENEUR" | "SHIPPING";

export type Ns4ReleaseResult = "RELEASE" | "NOT_PASS" | "RELEASE_WITH_CONDITION" | "RELEASE_SOME";

export type Ns4SampleResult = "PENDING" | "PROCESS_ENDED";

export type Ns4SystemType = "OFFLINE" | "ONLINE" | "MANUAL" | "AUTO_BY_SYSTEM";

export type PaymentStatus = "WAIT_PAYMENT" | "UPLOAD_SLIP" | "WAIT_RECEIPT" | "PAID" | "CANCEL";

export type ReceiptPrintStatus = "U" | "P";

export type RequestInspectionAuditFileType = "AUDIT";

export type RequestInspectionFileType = "INSPECTION_REPORT" | "PRODUCT_INFORMATION" | "FORMULA_CERT" | "PROCESS_CHART" | "LABEL_COPY" | "IMPORT_PERMIT" | "RESULT_NOTIFY" | "HYGIENIC_LICENSE_GMP" | "CRITICAL_LICENSE_NOTICE" | "PRODUCTION_MAP" | "STORAGE_MAP" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "OTHER" | "DOCUMENT";

export type RequestInspectionForm1FileType = "DOCUMENT" | "PRODUCT_INFORMATION" | "FORMULA_CERT" | "PROCESS_CHART" | "LABEL_COPY" | "IMPORT_PERMIT" | "HYGIENIC_LICENSE_GMP" | "CRITICAL_LICENSE_NOTICE" | "PRODUCTION_MAP" | "STORAGE_MAP" | "ID_CARD_COPY" | "PASSPORT_COPY" | "COMPANY_REGISTRATION_COPY" | "ATTORNEY_COPY" | "OTHER";

export type RequestInspectionFormAuditFileType = "AUDIT";

export type RequestInspectionFormCheckSiteInspectionFileType = "IMAGE_INSPECTION" | "AUDIT_LOG" | "LOCATION_CORRECTION_REPORT" | "EQUIPMENT_LIST" | "PROCESS" | "SITE_INSPECTION_REPORT" | "CHECKLIST_REPORT";

export type RequestInspectionFormStatus = "NEW" | "PRIM_CORRECTION" | "CANCELATION" | "CANCEL_BY_APPLICANT" | "PRIM_CORRECTED" | "WAIT_VERIFY" | "WAIT_APPOINT_LOCATION" | "WAIT_ACCEPT_LOCATION" | "APPOINT_DENIED" | "WAIT_INSPECT_LOCATION" | "LOCATION_DENIED" | "WAIT_DIGI_SIG" | "LOCATION_CORRECTION_REPORT" | "CORRECTION_SENT" | "WAIT_CERT" | "WAIT_SIGN_PROPOSAL" | "WAIT_ORDER" | "DENIED" | "GRANT";

export type FeedType = "FEED" | "CONCENTRATED_FEED" | "AQUATIC_ANIMAL_PREMIX" | "SUPPLEMENT";

export type VoucherCorrectionFormStatus = "WAIT_PRIM_CORRECT" | "WAIT_TECH_CORRECT" | "CORRECT_CONCLUDE" | "CORRECT_DIRECTOR" | "CORRECT_CHIEF";

export type VoucherFileType = "VOUCHER" | "VOUCHER_ORIGINAL" | "VOUCHER_CORRECTION" | "VOUCHER_ATTACHMENT" | "VOUCHER_LABEL" | "ATTORNEY_COPY" | "IMPORT_LABEL" | "IMPORT_CERT_OF_FREE_SALE" | "TRIAL_USE_REPORT" | "CERT_BIOLOGICAL_ANALYSIS" | "CERT_COLOR_ANALYSIS" | "PRODUCT_PROCESS_DOC" | "IMPORT_PRODUCT_INFO" | "IMPORT_CERT_OF_HEALTH" | "COMPANY_REGISTRATION_DOC" | "PACKAGE_AND_LABEL" | "CERT_OF_FORMULA" | "RESULTS_OF_TRAIL_USE" | "CERT_OF_TOTAL_BACTERIA" | "CERT_OF_TOTAL_MOLD" | "CERT_OF_SALMONELLA" | "LOST_EVIDENCE" | "DAMAGED_EVIDENCE" | "OTHER_DOC" | "OTHER_DOC2" | "OTHER_DOC3" | "OTHER_DOC4" | "OTHER_DOC5" | "OTHER_DOC6" | "OTHER_DOC7" | "OTHER_DOC8" | "OTHER_DOC9" | "OTHER_DOC10" | "DOCUMENT";

export type VoucherForm1FileType = "DOCUMENT" | "ATTORNEY_COPY" | "IMPORT_LABEL" | "IMPORT_CERT_OF_FREE_SALE" | "TRIAL_USE_REPORT" | "CERT_BIOLOGICAL_ANALYSIS" | "CERT_COLOR_ANALYSIS" | "PRODUCT_PROCESS_DOC" | "IMPORT_PRODUCT_INFO" | "IMPORT_CERT_OF_HEALTH" | "COMPANY_REGISTRATION_DOC" | "OTHER_DOC" | "OTHER_DOC2" | "OTHER_DOC3" | "OTHER_DOC4" | "OTHER_DOC5" | "OTHER_DOC6" | "OTHER_DOC7" | "OTHER_DOC8" | "OTHER_DOC9" | "OTHER_DOC10";

export type VoucherForm2FileType = "DOCUMENT" | "ATTORNEY_COPY" | "IMPORT_LABEL" | "IMPORT_CERT_OF_FREE_SALE" | "TRIAL_USE_REPORT" | "CERT_BIOLOGICAL_ANALYSIS" | "CERT_COLOR_ANALYSIS" | "PRODUCT_PROCESS_DOC" | "IMPORT_PRODUCT_INFO" | "IMPORT_CERT_OF_HEALTH" | "COMPANY_REGISTRATION_DOC" | "OTHER_DOC" | "OTHER_DOC2" | "OTHER_DOC3" | "OTHER_DOC4" | "OTHER_DOC5" | "OTHER_DOC6" | "OTHER_DOC7" | "OTHER_DOC8" | "OTHER_DOC9" | "OTHER_DOC10";

export type VoucherForm3FileType = "DOCUMENT" | "ATTORNEY_COPY" | "PACKAGE_AND_LABEL" | "CERT_OF_FORMULA" | "IMPORT_CERT_OF_FREE_SALE" | "RESULTS_OF_TRAIL_USE" | "CERT_OF_TOTAL_BACTERIA" | "CERT_OF_TOTAL_MOLD" | "CERT_OF_SALMONELLA" | "PRODUCT_PROCESS_DOC" | "IMPORT_PRODUCT_INFO" | "OTHER_DOC" | "OTHER_DOC2" | "OTHER_DOC3" | "OTHER_DOC4" | "OTHER_DOC5" | "OTHER_DOC6" | "OTHER_DOC7" | "OTHER_DOC8" | "OTHER_DOC9" | "OTHER_DOC10";

export type VoucherForm4FileType = "DOCUMENT" | "ATTORNEY_COPY" | "PACKAGE_AND_LABEL" | "CERT_OF_FORMULA" | "IMPORT_CERT_OF_FREE_SALE" | "RESULTS_OF_TRAIL_USE" | "CERT_OF_TOTAL_BACTERIA" | "CERT_OF_TOTAL_MOLD" | "CERT_OF_SALMONELLA" | "PRODUCT_PROCESS_DOC" | "IMPORT_PRODUCT_INFO" | "OTHER_DOC" | "OTHER_DOC2" | "OTHER_DOC3" | "OTHER_DOC4" | "OTHER_DOC5" | "OTHER_DOC6" | "OTHER_DOC7" | "OTHER_DOC8" | "OTHER_DOC9" | "OTHER_DOC10";

export type VoucherForm5FileType = "DOCUMENT" | "ATTORNEY_COPY" | "PACKAGE_AND_LABEL" | "CERT_OF_FORMULA" | "IMPORT_CERT_OF_FREE_SALE" | "RESULTS_OF_TRAIL_USE" | "CERT_OF_TOTAL_BACTERIA" | "CERT_OF_TOTAL_MOLD" | "CERT_OF_SALMONELLA" | "OTHER_DOC" | "OTHER_DOC2" | "OTHER_DOC3" | "OTHER_DOC4" | "OTHER_DOC5" | "OTHER_DOC6" | "OTHER_DOC7" | "OTHER_DOC8" | "OTHER_DOC9" | "OTHER_DOC10" | "PRODUCT_PROCESS_DOC" | "IMPORT_PRODUCT_INFO";

export type VoucherForm6FileType = "DOCUMENT" | "ATTORNEY_COPY" | "PACKAGE_AND_LABEL" | "CERT_OF_FORMULA" | "IMPORT_CERT_OF_FREE_SALE" | "RESULTS_OF_TRAIL_USE" | "CERT_OF_TOTAL_BACTERIA" | "CERT_OF_TOTAL_MOLD" | "CERT_OF_SALMONELLA" | "OTHER_DOC" | "OTHER_DOC2" | "OTHER_DOC3" | "OTHER_DOC4" | "OTHER_DOC5" | "OTHER_DOC6" | "OTHER_DOC7" | "OTHER_DOC8" | "OTHER_DOC9" | "OTHER_DOC10" | "PRODUCT_PROCESS_DOC" | "IMPORT_PRODUCT_INFO";

export type VoucherForm7FileType = "DOCUMENT" | "VOUCHER" | "ATTORNEY_COPY" | "LOST_EVIDENCE" | "DAMAGED_EVIDENCE" | "OTHER_DOC" | "OTHER_DOC2" | "OTHER_DOC3" | "OTHER_DOC4" | "OTHER_DOC5" | "OTHER_DOC6" | "OTHER_DOC7" | "OTHER_DOC8" | "OTHER_DOC9" | "OTHER_DOC10";

export type VoucherFormStatus = "NEW" | "NEW_IN_QUEUE" | "CORRECTION" | "CORRECTION_IN_QUEUE" | "SUBSTITUTE" | "SUBSTITUTE_IN_QUEUE" | "CANCELLATION" | "WAIT_PAYMENT" | "UPLOAD_SLIP" | "PAID" | "WAIT_VERIFY_TECH" | "WAIT_PRIM_CORRECT" | "WAIT_VERIFY_CORRECTION_PRIM" | "WAIT_PERMIT_TECH" | "WAIT_TECH_CORRECT" | "WAIT_SCHEDULE" | "WAIT_CERT" | "WAIT_VERIFY_CORRECT_TECH" | "WAIT_VERIFY_CORRECT_CONCLUDE" | "WAIT_VERIFY_CORRECT_CHIEF" | "WAIT_VERIFY_CORRECT_DIRECTOR" | "WAIT_CONFERRED" | "DENIED_CONFERRED" | "CORRECT_CONCLUDE" | "WAIT_SIGN" | "WAIT_ORDER" | "CORRECT_CHIEF" | "DENIED" | "CORRECT_DIRECTOR" | "CANCEL_REQUEST" | "GRANT";

export type VoucherMeetingResult = "APPROVED_REQUEST" | "CORRECTION" | "NOT_APPROVED";

export type VoucherMeetingStatus = "MEETING_WAITING" | "MEETING_RECORDED";

export type VoucherRequestType = "N" | "E" | "R";

export type VoucherStatus = "AVAILABLE" | "CANCELED";

export type VoucherType = "M" | "P" | "S";

export type PaymentType = "FEE" | "ADDITIONAL_FEE" | "REFUND" | "CASH_RECEIPT" | "BANK_RECEIPT" | "AUTO_RECEIPT" | "DONATE_RECEIPT" | "CREDIT_NOTE" | "PAYMENT_VOUCHER";


// Added by 'EnumTypeAliasExtension' extension
export type AllEnumClass = "AnimalFeedConsiderType" | "SystemType" | "AuditCorrectionFormStatus" | "AuditFormObjectiveType" | "AuditFormResultConsiderationType" | "AuditFormStatus" | "AuditProductType" | "ApplicantType" | "CertOfHealthFileType" | "CertificateCorrectionFormStatus" | "CertificateDocumentType" | "CertificateDomesticSaleAttachFileRequest" | "CertificateDomesticSalesCopyRequest" | "CertificateDomesticSalesType" | "CertificateDomesticSalesVoucherFileType" | "CertificateExporterType" | "CertificateFileType" | "CertificateForm1FileType" | "CertificateForm2FileType" | "CertificateForm3FileType" | "CertificateForm4FileType" | "CertificateFormStatus" | "CertificateSystemType" | "CertificateTransportInfo" | "AuthorityType" | "Event" | "State" | "DocumentType" | "UsersPermission" | "AmountResult" | "Animal" | "AnimalFeedActGroup" | "AnimalFeedGroupId" | "AnimalFeedTypeId" | "AppointmentStatus" | "ApproveStatus" | "CardType" | "CertificateMessage" | "CertificateType" | "CheckingResult" | "ConsiderType" | "CorrectionRequestGroup" | "Department" | "DofOrgType" | "EmployeeFileType" | "EntrepreneurFileType" | "ExporterType" | "FactorOtherType" | "FileUploadType" | "FilingOffice" | "FormStatus" | "FormType" | "GmpHaccpIssueType" | "LabelResult" | "LicenseStatus" | "LicenseSubType" | "LicenseType" | "LicensingEntrepreneurFileType" | "LicensingFormStatus" | "LicensingIssueType" | "Modules" | "PerformType" | "PersonType" | "QualityType" | "RequestAgentStatus" | "RequestAgentType" | "RequestEmployeeFileType" | "RequestEntrepreneurFileType" | "RequestInspectionEntrepreneurFileType" | "RequestMethod" | "RequestRegisterStatus" | "RequestRegisterType" | "RequestSubstituteReason" | "RequestType" | "RequestUserFileType" | "Sample" | "UserFileType" | "UserStatus" | "UserType" | "FollowInspectionStatus" | "GmpHaccpCertificateLevel" | "GmpHaccpCheckInspectionType" | "GmpHaccpCheckSiteInspectionResult" | "GmpHaccpCorrectionRequestType" | "GmpHaccpFileType" | "GmpHaccpForm1FileType" | "GmpHaccpForm2FileType" | "GmpHaccpForm3FileType" | "GmpHaccpForm4FileType" | "GmpHaccpForm5FileType" | "GmpHaccpForm6FileType" | "GmpHaccpForm7FileType" | "GmpHaccpForm8FileType" | "GmpHaccpFormCheckSiteInspectionFileType" | "GmpHaccpFormFollowInspectionFileType" | "GmpHaccpFormStatus" | "GmpHaccpMeetingBookingFileType" | "GmpHaccpMeetingStatus" | "GmpHaccpType" | "AuditFileType" | "CertificateOfFreeSaleType" | "LicensingFileType" | "LicensingForm10FileType" | "LicensingForm11FileType" | "LicensingForm12FileType" | "LicensingForm13FileType" | "LicensingForm14FileType" | "LicensingForm15FileType" | "LicensingForm16FileType" | "LicensingForm17FileType" | "LicensingForm18FileType" | "LicensingForm19FileType" | "LicensingForm1FileType" | "LicensingForm2FileType" | "LicensingForm3FileType" | "LicensingForm4FileType" | "LicensingForm5FileType" | "LicensingForm6FileType" | "LicensingForm7FileType" | "LicensingForm8FileType" | "LicensingForm9FileType" | "LicensingFormSiteInspectionFileType" | "SiteInspectionPassResult" | "SiteInspectionResult" | "SiteInspectionStatus" | "ConfiscationProduct" | "SampleAnimalFeed" | "Sampling" | "Ns4AnalysisResultType" | "Ns4CheckingChemical" | "Ns4ConsiderResult" | "Ns4CorrectionFormStatus" | "Ns4CorrectionRequest" | "Ns4Discover" | "Ns4DocumentType" | "Ns4FeedType" | "Ns4FileType" | "Ns4Form1FileType" | "Ns4Form2FileType" | "Ns4FormStatus" | "Ns4Operator" | "Ns4ReleaseResult" | "Ns4SampleResult" | "Ns4SystemType" | "PaymentStatus" | "ReceiptPrintStatus" | "RequestInspectionAuditFileType" | "RequestInspectionFileType" | "RequestInspectionForm1FileType" | "RequestInspectionFormAuditFileType" | "RequestInspectionFormCheckSiteInspectionFileType" | "RequestInspectionFormStatus" | "FeedType" | "VoucherCorrectionFormStatus" | "VoucherFileType" | "VoucherForm1FileType" | "VoucherForm2FileType" | "VoucherForm3FileType" | "VoucherForm4FileType" | "VoucherForm5FileType" | "VoucherForm6FileType" | "VoucherForm7FileType" | "VoucherFormStatus" | "VoucherMeetingResult" | "VoucherMeetingStatus" | "VoucherRequestType" | "VoucherStatus" | "VoucherType" | "PaymentType"
// Generate FomrFileType for Aqua Project
export type CertOfHealthFileTypeInstanceType = {[P in CertOfHealthFileType]: {fileType: CertOfHealthFileType} }
export function  createCertOfHealthFileType(): CertOfHealthFileTypeInstanceType { 
return {
  MANUFACTURE_LICENSE: {fileType: 'MANUFACTURE_LICENSE' },
  VOUCHER_LICENSE: {fileType: 'VOUCHER_LICENSE' },
  FORMULA_CERT: {fileType: 'FORMULA_CERT' },
  GMP_HACCP_LICENSE: {fileType: 'GMP_HACCP_LICENSE' },
  ANIMAL_FEED_PRODUCTION_CHART: {fileType: 'ANIMAL_FEED_PRODUCTION_CHART' },
  SALMONELLA_SPP: {fileType: 'SALMONELLA_SPP' },
  FORMULA_CERT_NO_POULTRY: {fileType: 'FORMULA_CERT_NO_POULTRY' },
  FORMULA_CERT_NO_SALMONIDAE: {fileType: 'FORMULA_CERT_NO_SALMONIDAE' },
  CERT_ANALYSIS: {fileType: 'CERT_ANALYSIS' },
  E_COLI: {fileType: 'E_COLI' },
  VIBRIO_PARAHAEMOLYTICUS: {fileType: 'VIBRIO_PARAHAEMOLYTICUS' },
  VIBRIO_CHOLERA: {fileType: 'VIBRIO_CHOLERA' },
  STAPHYLOCOCCUS_AUREUS: {fileType: 'STAPHYLOCOCCUS_AUREUS' },
  AEROBIC_PLATE_COUNT: {fileType: 'AEROBIC_PLATE_COUNT' },
  COLIFORM_BACTERIA: {fileType: 'COLIFORM_BACTERIA' },
  FECAL_COLIFORM: {fileType: 'FECAL_COLIFORM' },
  ESHERICHIA_COLI: {fileType: 'ESHERICHIA_COLI' },
  LISTERIA_MONOCYTOGENES: {fileType: 'LISTERIA_MONOCYTOGENES' },
  CHLORAMPHENICOL: {fileType: 'CHLORAMPHENICOL' },
  NITROFURANS: {fileType: 'NITROFURANS' },
  PRODUCT_LABEL_PHOTO: {fileType: 'PRODUCT_LABEL_PHOTO' },
  FREE_FROM_BIRD_FLU_NOTICE: {fileType: 'FREE_FROM_BIRD_FLU_NOTICE' },
  INVOICE_LOADING_CONTAINERS: {fileType: 'INVOICE_LOADING_CONTAINERS' },
  ENTEROBACTER_SPP: {fileType: 'ENTEROBACTER_SPP' },
  AFLATOXINS: {fileType: 'AFLATOXINS' },
  PRODUCT_INFORMATION: {fileType: 'PRODUCT_INFORMATION' },
  DOMESTIC_SALES_INVOICE: {fileType: 'DOMESTIC_SALES_INVOICE' },
  IMPORT_PERMIT_FROM_DESTINATION_COUNTRY: {fileType: 'IMPORT_PERMIT_FROM_DESTINATION_COUNTRY' },
  COMPANY_RESPONSE_LETTER: {fileType: 'COMPANY_RESPONSE_LETTER' },
  INSPECTED_BY_THE_LICENSOR: {fileType: 'INSPECTED_BY_THE_LICENSOR' },
  PACKAGE_PHOTO: {fileType: 'PACKAGE_PHOTO' },
  CERT_MOISTURE_ANALYSIS: {fileType: 'CERT_MOISTURE_ANALYSIS' },
  PRODUCT_PHOTO: {fileType: 'PRODUCT_PHOTO' }
 }
}
export type CertificateDomesticSalesVoucherFileTypeInstanceType = {[P in CertificateDomesticSalesVoucherFileType]: {fileType: CertificateDomesticSalesVoucherFileType} }
export function  createCertificateDomesticSalesVoucherFileType(): CertificateDomesticSalesVoucherFileTypeInstanceType { 
return {
  VOUCHER: {fileType: 'VOUCHER' }
 }
}
export type CertificateFileTypeInstanceType = {[P in CertificateFileType]: {fileType: CertificateFileType} }
export function  createCertificateFileType(): CertificateFileTypeInstanceType { 
return {
  CERTIFICATE: {fileType: 'CERTIFICATE' },
  INVOICE: {fileType: 'INVOICE' },
  RECIPE_CERTIFICATE: {fileType: 'RECIPE_CERTIFICATE' },
  OTHER: {fileType: 'OTHER' },
  BOOKING_CONFIRM: {fileType: 'BOOKING_CONFIRM' },
  DOCUMENT: {fileType: 'DOCUMENT' }
 }
}
export type CertificateForm1FileTypeInstanceType = {[P in CertificateForm1FileType]: {fileType: CertificateForm1FileType} }
export function  createCertificateForm1FileType(): CertificateForm1FileTypeInstanceType { 
return {
  CERTIFICATE: {fileType: 'CERTIFICATE' },
  INVOICE: {fileType: 'INVOICE' },
  RECIPE_CERTIFICATE: {fileType: 'RECIPE_CERTIFICATE' },
  OTHER: {fileType: 'OTHER' },
  BOOKING_CONFIRM: {fileType: 'BOOKING_CONFIRM' },
  DOCUMENT: {fileType: 'DOCUMENT' }
 }
}
export type CertificateForm2FileTypeInstanceType = {[P in CertificateForm2FileType]: {fileType: CertificateForm2FileType} }
export function  createCertificateForm2FileType(): CertificateForm2FileTypeInstanceType { 
return {
  CERTIFICATE: {fileType: 'CERTIFICATE' },
  INVOICE: {fileType: 'INVOICE' },
  RECIPE_CERTIFICATE: {fileType: 'RECIPE_CERTIFICATE' },
  OTHER: {fileType: 'OTHER' },
  BOOKING_CONFIRM: {fileType: 'BOOKING_CONFIRM' },
  DOCUMENT: {fileType: 'DOCUMENT' }
 }
}
export type CertificateForm3FileTypeInstanceType = {[P in CertificateForm3FileType]: {fileType: CertificateForm3FileType} }
export function  createCertificateForm3FileType(): CertificateForm3FileTypeInstanceType { 
return {
  CERTIFICATE: {fileType: 'CERTIFICATE' },
  OTHER: {fileType: 'OTHER' },
  DOCUMENT: {fileType: 'DOCUMENT' }
 }
}
export type CertificateForm4FileTypeInstanceType = {[P in CertificateForm4FileType]: {fileType: CertificateForm4FileType} }
export function  createCertificateForm4FileType(): CertificateForm4FileTypeInstanceType { 
return {
  CERTIFICATE: {fileType: 'CERTIFICATE' },
  OTHER: {fileType: 'OTHER' },
  DOCUMENT: {fileType: 'DOCUMENT' }
 }
}
export type EmployeeFileTypeInstanceType = {[P in EmployeeFileType]: {fileType: EmployeeFileType} }
export function  createEmployeeFileType(): EmployeeFileTypeInstanceType { 
return {
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' }
 }
}
export type EntrepreneurFileTypeInstanceType = {[P in EntrepreneurFileType]: {fileType: EntrepreneurFileType} }
export function  createEntrepreneurFileType(): EntrepreneurFileTypeInstanceType { 
return {
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  ENTREPRENEUR_ASSIGNMENT: {fileType: 'ENTREPRENEUR_ASSIGNMENT' }
 }
}
export type LicensingEntrepreneurFileTypeInstanceType = {[P in LicensingEntrepreneurFileType]: {fileType: LicensingEntrepreneurFileType} }
export function  createLicensingEntrepreneurFileType(): LicensingEntrepreneurFileTypeInstanceType { 
return {
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  ENTREPRENEUR_ASSIGNMENT: {fileType: 'ENTREPRENEUR_ASSIGNMENT' }
 }
}
export type RequestEmployeeFileTypeInstanceType = {[P in RequestEmployeeFileType]: {fileType: RequestEmployeeFileType} }
export function  createRequestEmployeeFileType(): RequestEmployeeFileTypeInstanceType { 
return {
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' }
 }
}
export type RequestEntrepreneurFileTypeInstanceType = {[P in RequestEntrepreneurFileType]: {fileType: RequestEntrepreneurFileType} }
export function  createRequestEntrepreneurFileType(): RequestEntrepreneurFileTypeInstanceType { 
return {
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  ENTREPRENEUR_ASSIGNMENT: {fileType: 'ENTREPRENEUR_ASSIGNMENT' }
 }
}
export type RequestInspectionEntrepreneurFileTypeInstanceType = {[P in RequestInspectionEntrepreneurFileType]: {fileType: RequestInspectionEntrepreneurFileType} }
export function  createRequestInspectionEntrepreneurFileType(): RequestInspectionEntrepreneurFileTypeInstanceType { 
return {
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  ENTREPRENEUR_ASSIGNMENT: {fileType: 'ENTREPRENEUR_ASSIGNMENT' }
 }
}
export type RequestUserFileTypeInstanceType = {[P in RequestUserFileType]: {fileType: RequestUserFileType} }
export function  createRequestUserFileType(): RequestUserFileTypeInstanceType { 
return {
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  ATTORNEY_PERSON_ACCOUNT: {fileType: 'ATTORNEY_PERSON_ACCOUNT' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  DIGITAL_CERTIFICATE: {fileType: 'DIGITAL_CERTIFICATE' },
  ENTREPRENEUR_ASSIGNMENT: {fileType: 'ENTREPRENEUR_ASSIGNMENT' },
  SIGNATURE: {fileType: 'SIGNATURE' },
  SIGNATURE_EN: {fileType: 'SIGNATURE_EN' }
 }
}
export type UserFileTypeInstanceType = {[P in UserFileType]: {fileType: UserFileType} }
export function  createUserFileType(): UserFileTypeInstanceType { 
return {
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  ATTORNEY_PERSON_ACCOUNT: {fileType: 'ATTORNEY_PERSON_ACCOUNT' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  DIGITAL_CERTIFICATE: {fileType: 'DIGITAL_CERTIFICATE' },
  ENTREPRENEUR_ASSIGNMENT: {fileType: 'ENTREPRENEUR_ASSIGNMENT' },
  SIGNATURE: {fileType: 'SIGNATURE' },
  SIGNATURE_EN: {fileType: 'SIGNATURE_EN' }
 }
}
export type GmpHaccpFileTypeInstanceType = {[P in GmpHaccpFileType]: {fileType: GmpHaccpFileType} }
export function  createGmpHaccpFileType(): GmpHaccpFileTypeInstanceType { 
return {
  FACTORY_LICENSE_COPY: {fileType: 'FACTORY_LICENSE_COPY' },
  MANUFACTURE_LICENSE_COPY_FISHERIES: {fileType: 'MANUFACTURE_LICENSE_COPY_FISHERIES' },
  MANUFACTURE_LICENSE_COPY_LIVESTOCK: {fileType: 'MANUFACTURE_LICENSE_COPY_LIVESTOCK' },
  FACTORY_MAP_FISHERIES: {fileType: 'FACTORY_MAP_FISHERIES' },
  FACTORY_MAP_LIVESTOCK: {fileType: 'FACTORY_MAP_LIVESTOCK' },
  EQUIPMENT_LIST_FISHERIES: {fileType: 'EQUIPMENT_LIST_FISHERIES' },
  EQUIPMENT_LIST_LIVESTOCK: {fileType: 'EQUIPMENT_LIST_LIVESTOCK' },
  CORRECTION_FORM: {fileType: 'CORRECTION_FORM' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  OTHER: {fileType: 'OTHER' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  GMPHACCP_CERTIFICATE_OR_SUBSTITUTE: {fileType: 'GMPHACCP_CERTIFICATE_OR_SUBSTITUTE' },
  DOCUMENT: {fileType: 'DOCUMENT' },
  GMPHACCP_CERTIFICATE: {fileType: 'GMPHACCP_CERTIFICATE' },
  DAMAGED_GMPHACCP_CERTIFICATE: {fileType: 'DAMAGED_GMPHACCP_CERTIFICATE' },
  LOST_EVIDENCE: {fileType: 'LOST_EVIDENCE' }
 }
}
export type GmpHaccpForm1FileTypeInstanceType = {[P in GmpHaccpForm1FileType]: {fileType: GmpHaccpForm1FileType} }
export function  createGmpHaccpForm1FileType(): GmpHaccpForm1FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  FACTORY_LICENSE_COPY: {fileType: 'FACTORY_LICENSE_COPY' },
  MANUFACTURE_LICENSE_COPY_FISHERIES: {fileType: 'MANUFACTURE_LICENSE_COPY_FISHERIES' },
  MANUFACTURE_LICENSE_COPY_LIVESTOCK: {fileType: 'MANUFACTURE_LICENSE_COPY_LIVESTOCK' },
  FACTORY_MAP_FISHERIES: {fileType: 'FACTORY_MAP_FISHERIES' },
  FACTORY_MAP_LIVESTOCK: {fileType: 'FACTORY_MAP_LIVESTOCK' },
  EQUIPMENT_LIST_FISHERIES: {fileType: 'EQUIPMENT_LIST_FISHERIES' },
  EQUIPMENT_LIST_LIVESTOCK: {fileType: 'EQUIPMENT_LIST_LIVESTOCK' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  OTHER: {fileType: 'OTHER' }
 }
}
export type GmpHaccpForm2FileTypeInstanceType = {[P in GmpHaccpForm2FileType]: {fileType: GmpHaccpForm2FileType} }
export function  createGmpHaccpForm2FileType(): GmpHaccpForm2FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  GMPHACCP_CERTIFICATE_OR_SUBSTITUTE: {fileType: 'GMPHACCP_CERTIFICATE_OR_SUBSTITUTE' },
  MANUFACTURE_LICENSE_COPY_FISHERIES: {fileType: 'MANUFACTURE_LICENSE_COPY_FISHERIES' },
  MANUFACTURE_LICENSE_COPY_LIVESTOCK: {fileType: 'MANUFACTURE_LICENSE_COPY_LIVESTOCK' },
  FACTORY_MAP_FISHERIES: {fileType: 'FACTORY_MAP_FISHERIES' },
  FACTORY_MAP_LIVESTOCK: {fileType: 'FACTORY_MAP_LIVESTOCK' },
  EQUIPMENT_LIST_FISHERIES: {fileType: 'EQUIPMENT_LIST_FISHERIES' },
  EQUIPMENT_LIST_LIVESTOCK: {fileType: 'EQUIPMENT_LIST_LIVESTOCK' },
  OTHER: {fileType: 'OTHER' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' }
 }
}
export type GmpHaccpForm3FileTypeInstanceType = {[P in GmpHaccpForm3FileType]: {fileType: GmpHaccpForm3FileType} }
export function  createGmpHaccpForm3FileType(): GmpHaccpForm3FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  GMPHACCP_CERTIFICATE_OR_SUBSTITUTE: {fileType: 'GMPHACCP_CERTIFICATE_OR_SUBSTITUTE' },
  MANUFACTURE_LICENSE_COPY_FISHERIES: {fileType: 'MANUFACTURE_LICENSE_COPY_FISHERIES' },
  MANUFACTURE_LICENSE_COPY_LIVESTOCK: {fileType: 'MANUFACTURE_LICENSE_COPY_LIVESTOCK' },
  FACTORY_MAP_FISHERIES: {fileType: 'FACTORY_MAP_FISHERIES' },
  FACTORY_MAP_LIVESTOCK: {fileType: 'FACTORY_MAP_LIVESTOCK' },
  EQUIPMENT_LIST_FISHERIES: {fileType: 'EQUIPMENT_LIST_FISHERIES' },
  EQUIPMENT_LIST_LIVESTOCK: {fileType: 'EQUIPMENT_LIST_LIVESTOCK' },
  CORRECTION_FORM: {fileType: 'CORRECTION_FORM' },
  OTHER: {fileType: 'OTHER' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' }
 }
}
export type GmpHaccpForm4FileTypeInstanceType = {[P in GmpHaccpForm4FileType]: {fileType: GmpHaccpForm4FileType} }
export function  createGmpHaccpForm4FileType(): GmpHaccpForm4FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  DAMAGED_GMPHACCP_CERTIFICATE: {fileType: 'DAMAGED_GMPHACCP_CERTIFICATE' },
  LOST_EVIDENCE: {fileType: 'LOST_EVIDENCE' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  OTHER: {fileType: 'OTHER' }
 }
}
export type GmpHaccpForm5FileTypeInstanceType = {[P in GmpHaccpForm5FileType]: {fileType: GmpHaccpForm5FileType} }
export function  createGmpHaccpForm5FileType(): GmpHaccpForm5FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  GMPHACCP_CERTIFICATE_OR_SUBSTITUTE: {fileType: 'GMPHACCP_CERTIFICATE_OR_SUBSTITUTE' },
  FACTORY_LICENSE_COPY: {fileType: 'FACTORY_LICENSE_COPY' },
  MANUFACTURE_LICENSE_COPY_FISHERIES: {fileType: 'MANUFACTURE_LICENSE_COPY_FISHERIES' },
  MANUFACTURE_LICENSE_COPY_LIVESTOCK: {fileType: 'MANUFACTURE_LICENSE_COPY_LIVESTOCK' },
  FACTORY_MAP_FISHERIES: {fileType: 'FACTORY_MAP_FISHERIES' },
  FACTORY_MAP_LIVESTOCK: {fileType: 'FACTORY_MAP_LIVESTOCK' },
  EQUIPMENT_LIST_FISHERIES: {fileType: 'EQUIPMENT_LIST_FISHERIES' },
  EQUIPMENT_LIST_LIVESTOCK: {fileType: 'EQUIPMENT_LIST_LIVESTOCK' },
  OTHER: {fileType: 'OTHER' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' }
 }
}
export type GmpHaccpForm6FileTypeInstanceType = {[P in GmpHaccpForm6FileType]: {fileType: GmpHaccpForm6FileType} }
export function  createGmpHaccpForm6FileType(): GmpHaccpForm6FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  GMPHACCP_CERTIFICATE_OR_SUBSTITUTE: {fileType: 'GMPHACCP_CERTIFICATE_OR_SUBSTITUTE' },
  MANUFACTURE_LICENSE_COPY_FISHERIES: {fileType: 'MANUFACTURE_LICENSE_COPY_FISHERIES' },
  MANUFACTURE_LICENSE_COPY_LIVESTOCK: {fileType: 'MANUFACTURE_LICENSE_COPY_LIVESTOCK' },
  FACTORY_MAP_FISHERIES: {fileType: 'FACTORY_MAP_FISHERIES' },
  FACTORY_MAP_LIVESTOCK: {fileType: 'FACTORY_MAP_LIVESTOCK' },
  EQUIPMENT_LIST_FISHERIES: {fileType: 'EQUIPMENT_LIST_FISHERIES' },
  EQUIPMENT_LIST_LIVESTOCK: {fileType: 'EQUIPMENT_LIST_LIVESTOCK' },
  OTHER: {fileType: 'OTHER' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' }
 }
}
export type GmpHaccpForm7FileTypeInstanceType = {[P in GmpHaccpForm7FileType]: {fileType: GmpHaccpForm7FileType} }
export function  createGmpHaccpForm7FileType(): GmpHaccpForm7FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  GMPHACCP_CERTIFICATE_OR_SUBSTITUTE: {fileType: 'GMPHACCP_CERTIFICATE_OR_SUBSTITUTE' },
  MANUFACTURE_LICENSE_COPY_FISHERIES: {fileType: 'MANUFACTURE_LICENSE_COPY_FISHERIES' },
  MANUFACTURE_LICENSE_COPY_LIVESTOCK: {fileType: 'MANUFACTURE_LICENSE_COPY_LIVESTOCK' },
  FACTORY_MAP_FISHERIES: {fileType: 'FACTORY_MAP_FISHERIES' },
  FACTORY_MAP_LIVESTOCK: {fileType: 'FACTORY_MAP_LIVESTOCK' },
  EQUIPMENT_LIST_FISHERIES: {fileType: 'EQUIPMENT_LIST_FISHERIES' },
  EQUIPMENT_LIST_LIVESTOCK: {fileType: 'EQUIPMENT_LIST_LIVESTOCK' },
  CORRECTION_FORM: {fileType: 'CORRECTION_FORM' },
  OTHER: {fileType: 'OTHER' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' }
 }
}
export type GmpHaccpForm8FileTypeInstanceType = {[P in GmpHaccpForm8FileType]: {fileType: GmpHaccpForm8FileType} }
export function  createGmpHaccpForm8FileType(): GmpHaccpForm8FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  DAMAGED_GMPHACCP_CERTIFICATE: {fileType: 'DAMAGED_GMPHACCP_CERTIFICATE' },
  LOST_EVIDENCE: {fileType: 'LOST_EVIDENCE' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  OTHER: {fileType: 'OTHER' }
 }
}
export type GmpHaccpFormCheckSiteInspectionFileTypeInstanceType = {[P in GmpHaccpFormCheckSiteInspectionFileType]: {fileType: GmpHaccpFormCheckSiteInspectionFileType} }
export function  createGmpHaccpFormCheckSiteInspectionFileType(): GmpHaccpFormCheckSiteInspectionFileTypeInstanceType { 
return {
  PRODUCTION_EXAM_PIC: {fileType: 'PRODUCTION_EXAM_PIC' },
  EXAM_SHED_1: {fileType: 'EXAM_SHED_1' },
  EXAM_SHED_2: {fileType: 'EXAM_SHED_2' },
  EXAM_SHED_3: {fileType: 'EXAM_SHED_3' },
  ERROR_REPORT_1: {fileType: 'ERROR_REPORT_1' },
  ERROR_REPORT_2: {fileType: 'ERROR_REPORT_2' },
  ERROR_REPORT_3: {fileType: 'ERROR_REPORT_3' },
  EXAM_REPORT: {fileType: 'EXAM_REPORT' },
  CORRECTION_REPORT_1: {fileType: 'CORRECTION_REPORT_1' },
  CORRECTION_REPORT_2: {fileType: 'CORRECTION_REPORT_2' },
  CORRECTION_REPORT_3: {fileType: 'CORRECTION_REPORT_3' },
  CORRECTION_REPORT_4: {fileType: 'CORRECTION_REPORT_4' },
  REPORT_SITE_INSPECTION: {fileType: 'REPORT_SITE_INSPECTION' }
 }
}
export type GmpHaccpFormFollowInspectionFileTypeInstanceType = {[P in GmpHaccpFormFollowInspectionFileType]: {fileType: GmpHaccpFormFollowInspectionFileType} }
export function  createGmpHaccpFormFollowInspectionFileType(): GmpHaccpFormFollowInspectionFileTypeInstanceType { 
return {
  EXAM_SHED_1: {fileType: 'EXAM_SHED_1' },
  EXAM_SHED_2: {fileType: 'EXAM_SHED_2' },
  ERROR_REPORT_1: {fileType: 'ERROR_REPORT_1' },
  ERROR_REPORT_2: {fileType: 'ERROR_REPORT_2' },
  CORRECTION_REPORT_1: {fileType: 'CORRECTION_REPORT_1' },
  CORRECTION_REPORT_2: {fileType: 'CORRECTION_REPORT_2' },
  OTHER_1: {fileType: 'OTHER_1' },
  OTHER_2: {fileType: 'OTHER_2' }
 }
}
export type GmpHaccpMeetingBookingFileTypeInstanceType = {[P in GmpHaccpMeetingBookingFileType]: {fileType: GmpHaccpMeetingBookingFileType} }
export function  createGmpHaccpMeetingBookingFileType(): GmpHaccpMeetingBookingFileTypeInstanceType { 
return {
  MEETING_REPORT: {fileType: 'MEETING_REPORT' },
  SIGN_DOCUMENT: {fileType: 'SIGN_DOCUMENT' },
  INVITATION_LETTER: {fileType: 'INVITATION_LETTER' },
  MEETING_PRESENTATION: {fileType: 'MEETING_PRESENTATION' }
 }
}
export type AuditFileTypeInstanceType = {[P in AuditFileType]: {fileType: AuditFileType} }
export function  createAuditFileType(): AuditFileTypeInstanceType { 
return {
  AUDIT: {fileType: 'AUDIT' },
  DOCUMENT: {fileType: 'DOCUMENT' }
 }
}
export type LicensingFileTypeInstanceType = {[P in LicensingFileType]: {fileType: LicensingFileType} }
export function  createLicensingFileType(): LicensingFileTypeInstanceType { 
return {
  LICENSE: {fileType: 'LICENSE' },
  LICENSE_OR_SUBSTITUTE: {fileType: 'LICENSE_OR_SUBSTITUTE' },
  DAMAGED_LICENSE: {fileType: 'DAMAGED_LICENSE' },
  LOST_EVIDENCE: {fileType: 'LOST_EVIDENCE' },
  AUTHORITY: {fileType: 'AUTHORITY' },
  AUTHORITY_NEW: {fileType: 'AUTHORITY_NEW' },
  EQUIPMENT_LIST: {fileType: 'EQUIPMENT_LIST' },
  EQUIPMENT_LIST_NEW: {fileType: 'EQUIPMENT_LIST_NEW' },
  PROCESS: {fileType: 'PROCESS' },
  PROCESS_NEW: {fileType: 'PROCESS_NEW' },
  PRODUCTION_MAP: {fileType: 'PRODUCTION_MAP' },
  PRODUCTION_WAREHOUSE_MAP: {fileType: 'PRODUCTION_WAREHOUSE_MAP' },
  IMPORT_MAP: {fileType: 'IMPORT_MAP' },
  IMPORT_WAREHOUSE_MAP: {fileType: 'IMPORT_WAREHOUSE_MAP' },
  SELL_MAP: {fileType: 'SELL_MAP' },
  SELL_WAREHOUSE_MAP: {fileType: 'SELL_WAREHOUSE_MAP' },
  COMMERCIAL_REGISTRATION: {fileType: 'COMMERCIAL_REGISTRATION' },
  JURISTIC_REGISTER: {fileType: 'JURISTIC_REGISTER' },
  HAZARD_LICENSE: {fileType: 'HAZARD_LICENSE' },
  FACTORY_LICENSE: {fileType: 'FACTORY_LICENSE' },
  LICENSING_FORM1: {fileType: 'LICENSING_FORM1' },
  CORRECTION_FORM: {fileType: 'CORRECTION_FORM' },
  OTHER: {fileType: 'OTHER' },
  FACTORY_LICENSE_COPY: {fileType: 'FACTORY_LICENSE_COPY' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  ATTORNEY_PERSON_ACCOUNT: {fileType: 'ATTORNEY_PERSON_ACCOUNT' },
  ENTREPRENEUR_ASSIGNMENT: {fileType: 'ENTREPRENEUR_ASSIGNMENT' },
  DIGITAL_CERTIFICATE: {fileType: 'DIGITAL_CERTIFICATE' },
  DOCUMENT: {fileType: 'DOCUMENT' }
 }
}
export type LicensingForm10FileTypeInstanceType = {[P in LicensingForm10FileType]: {fileType: LicensingForm10FileType} }
export function  createLicensingForm10FileType(): LicensingForm10FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  LICENSE_OR_SUBSTITUTE: {fileType: 'LICENSE_OR_SUBSTITUTE' },
  COMMERCIAL_REGISTRATION: {fileType: 'COMMERCIAL_REGISTRATION' },
  JURISTIC_REGISTER: {fileType: 'JURISTIC_REGISTER' },
  AUTHORITY: {fileType: 'AUTHORITY' },
  IMPORT_MAP: {fileType: 'IMPORT_MAP' },
  IMPORT_WAREHOUSE_MAP: {fileType: 'IMPORT_WAREHOUSE_MAP' },
  LICENSING_FORM1: {fileType: 'LICENSING_FORM1' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  ATTORNEY_PERSON_ACCOUNT: {fileType: 'ATTORNEY_PERSON_ACCOUNT' },
  OTHER: {fileType: 'OTHER' }
 }
}
export type LicensingForm11FileTypeInstanceType = {[P in LicensingForm11FileType]: {fileType: LicensingForm11FileType} }
export function  createLicensingForm11FileType(): LicensingForm11FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  LICENSE_OR_SUBSTITUTE: {fileType: 'LICENSE_OR_SUBSTITUTE' },
  COMMERCIAL_REGISTRATION: {fileType: 'COMMERCIAL_REGISTRATION' },
  JURISTIC_REGISTER: {fileType: 'JURISTIC_REGISTER' },
  AUTHORITY: {fileType: 'AUTHORITY' },
  IMPORT_MAP: {fileType: 'IMPORT_MAP' },
  IMPORT_WAREHOUSE_MAP: {fileType: 'IMPORT_WAREHOUSE_MAP' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  ATTORNEY_PERSON_ACCOUNT: {fileType: 'ATTORNEY_PERSON_ACCOUNT' },
  OTHER: {fileType: 'OTHER' }
 }
}
export type LicensingForm12FileTypeInstanceType = {[P in LicensingForm12FileType]: {fileType: LicensingForm12FileType} }
export function  createLicensingForm12FileType(): LicensingForm12FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  LICENSE_OR_SUBSTITUTE: {fileType: 'LICENSE_OR_SUBSTITUTE' },
  CORRECTION_FORM: {fileType: 'CORRECTION_FORM' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  ATTORNEY_PERSON_ACCOUNT: {fileType: 'ATTORNEY_PERSON_ACCOUNT' },
  OTHER: {fileType: 'OTHER' }
 }
}
export type LicensingForm13FileTypeInstanceType = {[P in LicensingForm13FileType]: {fileType: LicensingForm13FileType} }
export function  createLicensingForm13FileType(): LicensingForm13FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  DAMAGED_LICENSE: {fileType: 'DAMAGED_LICENSE' },
  LOST_EVIDENCE: {fileType: 'LOST_EVIDENCE' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  ATTORNEY_PERSON_ACCOUNT: {fileType: 'ATTORNEY_PERSON_ACCOUNT' },
  OTHER: {fileType: 'OTHER' }
 }
}
export type LicensingForm14FileTypeInstanceType = {[P in LicensingForm14FileType]: {fileType: LicensingForm14FileType} }
export function  createLicensingForm14FileType(): LicensingForm14FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  COMMERCIAL_REGISTRATION: {fileType: 'COMMERCIAL_REGISTRATION' },
  JURISTIC_REGISTER: {fileType: 'JURISTIC_REGISTER' },
  AUTHORITY: {fileType: 'AUTHORITY' },
  SELL_MAP: {fileType: 'SELL_MAP' },
  SELL_WAREHOUSE_MAP: {fileType: 'SELL_WAREHOUSE_MAP' },
  LICENSING_FORM1: {fileType: 'LICENSING_FORM1' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  ATTORNEY_PERSON_ACCOUNT: {fileType: 'ATTORNEY_PERSON_ACCOUNT' },
  OTHER: {fileType: 'OTHER' }
 }
}
export type LicensingForm15FileTypeInstanceType = {[P in LicensingForm15FileType]: {fileType: LicensingForm15FileType} }
export function  createLicensingForm15FileType(): LicensingForm15FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  COMMERCIAL_REGISTRATION: {fileType: 'COMMERCIAL_REGISTRATION' },
  JURISTIC_REGISTER: {fileType: 'JURISTIC_REGISTER' },
  AUTHORITY: {fileType: 'AUTHORITY' },
  SELL_MAP: {fileType: 'SELL_MAP' },
  SELL_WAREHOUSE_MAP: {fileType: 'SELL_WAREHOUSE_MAP' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  ATTORNEY_PERSON_ACCOUNT: {fileType: 'ATTORNEY_PERSON_ACCOUNT' },
  OTHER: {fileType: 'OTHER' }
 }
}
export type LicensingForm16FileTypeInstanceType = {[P in LicensingForm16FileType]: {fileType: LicensingForm16FileType} }
export function  createLicensingForm16FileType(): LicensingForm16FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  LICENSE_OR_SUBSTITUTE: {fileType: 'LICENSE_OR_SUBSTITUTE' },
  AUTHORITY: {fileType: 'AUTHORITY' },
  AUTHORITY_NEW: {fileType: 'AUTHORITY_NEW' },
  SELL_MAP: {fileType: 'SELL_MAP' },
  SELL_WAREHOUSE_MAP: {fileType: 'SELL_WAREHOUSE_MAP' },
  LICENSING_FORM1: {fileType: 'LICENSING_FORM1' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  ATTORNEY_PERSON_ACCOUNT: {fileType: 'ATTORNEY_PERSON_ACCOUNT' },
  OTHER: {fileType: 'OTHER' }
 }
}
export type LicensingForm17FileTypeInstanceType = {[P in LicensingForm17FileType]: {fileType: LicensingForm17FileType} }
export function  createLicensingForm17FileType(): LicensingForm17FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  LICENSE_OR_SUBSTITUTE: {fileType: 'LICENSE_OR_SUBSTITUTE' },
  AUTHORITY: {fileType: 'AUTHORITY' },
  AUTHORITY_NEW: {fileType: 'AUTHORITY_NEW' },
  SELL_MAP: {fileType: 'SELL_MAP' },
  SELL_WAREHOUSE_MAP: {fileType: 'SELL_WAREHOUSE_MAP' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  ATTORNEY_PERSON_ACCOUNT: {fileType: 'ATTORNEY_PERSON_ACCOUNT' },
  OTHER: {fileType: 'OTHER' }
 }
}
export type LicensingForm18FileTypeInstanceType = {[P in LicensingForm18FileType]: {fileType: LicensingForm18FileType} }
export function  createLicensingForm18FileType(): LicensingForm18FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  LICENSE_OR_SUBSTITUTE: {fileType: 'LICENSE_OR_SUBSTITUTE' },
  AUTHORITY: {fileType: 'AUTHORITY' },
  AUTHORITY_NEW: {fileType: 'AUTHORITY_NEW' },
  SELL_MAP: {fileType: 'SELL_MAP' },
  SELL_WAREHOUSE_MAP: {fileType: 'SELL_WAREHOUSE_MAP' },
  CORRECTION_FORM: {fileType: 'CORRECTION_FORM' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  ATTORNEY_PERSON_ACCOUNT: {fileType: 'ATTORNEY_PERSON_ACCOUNT' },
  OTHER: {fileType: 'OTHER' }
 }
}
export type LicensingForm19FileTypeInstanceType = {[P in LicensingForm19FileType]: {fileType: LicensingForm19FileType} }
export function  createLicensingForm19FileType(): LicensingForm19FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  DAMAGED_LICENSE: {fileType: 'DAMAGED_LICENSE' },
  LOST_EVIDENCE: {fileType: 'LOST_EVIDENCE' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  ATTORNEY_PERSON_ACCOUNT: {fileType: 'ATTORNEY_PERSON_ACCOUNT' },
  OTHER: {fileType: 'OTHER' }
 }
}
export type LicensingForm1FileTypeInstanceType = {[P in LicensingForm1FileType]: {fileType: LicensingForm1FileType} }
export function  createLicensingForm1FileType(): LicensingForm1FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  LICENSE_OR_SUBSTITUTE: {fileType: 'LICENSE_OR_SUBSTITUTE' },
  EQUIPMENT_LIST: {fileType: 'EQUIPMENT_LIST' },
  PROCESS: {fileType: 'PROCESS' },
  PRODUCTION_MAP: {fileType: 'PRODUCTION_MAP' },
  PRODUCTION_WAREHOUSE_MAP: {fileType: 'PRODUCTION_WAREHOUSE_MAP' },
  IMPORT_WAREHOUSE_MAP: {fileType: 'IMPORT_WAREHOUSE_MAP' },
  SELL_WAREHOUSE_MAP: {fileType: 'SELL_WAREHOUSE_MAP' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  ATTORNEY_PERSON_ACCOUNT: {fileType: 'ATTORNEY_PERSON_ACCOUNT' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ENTREPRENEUR_ASSIGNMENT: {fileType: 'ENTREPRENEUR_ASSIGNMENT' },
  DIGITAL_CERTIFICATE: {fileType: 'DIGITAL_CERTIFICATE' }
 }
}
export type LicensingForm2FileTypeInstanceType = {[P in LicensingForm2FileType]: {fileType: LicensingForm2FileType} }
export function  createLicensingForm2FileType(): LicensingForm2FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  AUTHORITY: {fileType: 'AUTHORITY' },
  JURISTIC_REGISTER: {fileType: 'JURISTIC_REGISTER' },
  EQUIPMENT_LIST: {fileType: 'EQUIPMENT_LIST' },
  PROCESS: {fileType: 'PROCESS' },
  PRODUCTION_MAP: {fileType: 'PRODUCTION_MAP' },
  PRODUCTION_WAREHOUSE_MAP: {fileType: 'PRODUCTION_WAREHOUSE_MAP' },
  HAZARD_LICENSE: {fileType: 'HAZARD_LICENSE' },
  FACTORY_LICENSE: {fileType: 'FACTORY_LICENSE' },
  LICENSING_FORM1: {fileType: 'LICENSING_FORM1' },
  CORRECTION_FORM: {fileType: 'CORRECTION_FORM' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  ATTORNEY_PERSON_ACCOUNT: {fileType: 'ATTORNEY_PERSON_ACCOUNT' },
  OTHER: {fileType: 'OTHER' }
 }
}
export type LicensingForm3FileTypeInstanceType = {[P in LicensingForm3FileType]: {fileType: LicensingForm3FileType} }
export function  createLicensingForm3FileType(): LicensingForm3FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  AUTHORITY: {fileType: 'AUTHORITY' },
  JURISTIC_REGISTER: {fileType: 'JURISTIC_REGISTER' },
  EQUIPMENT_LIST: {fileType: 'EQUIPMENT_LIST' },
  PROCESS: {fileType: 'PROCESS' },
  PRODUCTION_MAP: {fileType: 'PRODUCTION_MAP' },
  PRODUCTION_WAREHOUSE_MAP: {fileType: 'PRODUCTION_WAREHOUSE_MAP' },
  HAZARD_LICENSE: {fileType: 'HAZARD_LICENSE' },
  FACTORY_LICENSE: {fileType: 'FACTORY_LICENSE' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  ATTORNEY_PERSON_ACCOUNT: {fileType: 'ATTORNEY_PERSON_ACCOUNT' },
  OTHER: {fileType: 'OTHER' }
 }
}
export type LicensingForm4FileTypeInstanceType = {[P in LicensingForm4FileType]: {fileType: LicensingForm4FileType} }
export function  createLicensingForm4FileType(): LicensingForm4FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  JURISTIC_REGISTER: {fileType: 'JURISTIC_REGISTER' },
  LICENSE_OR_SUBSTITUTE: {fileType: 'LICENSE_OR_SUBSTITUTE' },
  EQUIPMENT_LIST: {fileType: 'EQUIPMENT_LIST' },
  PROCESS: {fileType: 'PROCESS' },
  LICENSING_FORM1: {fileType: 'LICENSING_FORM1' },
  HAZARD_LICENSE: {fileType: 'HAZARD_LICENSE' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  ATTORNEY_PERSON_ACCOUNT: {fileType: 'ATTORNEY_PERSON_ACCOUNT' },
  OTHER: {fileType: 'OTHER' }
 }
}
export type LicensingForm5FileTypeInstanceType = {[P in LicensingForm5FileType]: {fileType: LicensingForm5FileType} }
export function  createLicensingForm5FileType(): LicensingForm5FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  JURISTIC_REGISTER: {fileType: 'JURISTIC_REGISTER' },
  LICENSE_OR_SUBSTITUTE: {fileType: 'LICENSE_OR_SUBSTITUTE' },
  EQUIPMENT_LIST: {fileType: 'EQUIPMENT_LIST' },
  EQUIPMENT_LIST_NEW: {fileType: 'EQUIPMENT_LIST_NEW' },
  PROCESS: {fileType: 'PROCESS' },
  HAZARD_LICENSE: {fileType: 'HAZARD_LICENSE' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  ATTORNEY_PERSON_ACCOUNT: {fileType: 'ATTORNEY_PERSON_ACCOUNT' },
  OTHER: {fileType: 'OTHER' }
 }
}
export type LicensingForm6FileTypeInstanceType = {[P in LicensingForm6FileType]: {fileType: LicensingForm6FileType} }
export function  createLicensingForm6FileType(): LicensingForm6FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  LICENSE_OR_SUBSTITUTE: {fileType: 'LICENSE_OR_SUBSTITUTE' },
  EQUIPMENT_LIST: {fileType: 'EQUIPMENT_LIST' },
  EQUIPMENT_LIST_NEW: {fileType: 'EQUIPMENT_LIST_NEW' },
  PROCESS: {fileType: 'PROCESS' },
  PROCESS_NEW: {fileType: 'PROCESS_NEW' },
  CORRECTION_FORM: {fileType: 'CORRECTION_FORM' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  ATTORNEY_PERSON_ACCOUNT: {fileType: 'ATTORNEY_PERSON_ACCOUNT' },
  OTHER: {fileType: 'OTHER' }
 }
}
export type LicensingForm7FileTypeInstanceType = {[P in LicensingForm7FileType]: {fileType: LicensingForm7FileType} }
export function  createLicensingForm7FileType(): LicensingForm7FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  DAMAGED_LICENSE: {fileType: 'DAMAGED_LICENSE' },
  LOST_EVIDENCE: {fileType: 'LOST_EVIDENCE' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  ATTORNEY_PERSON_ACCOUNT: {fileType: 'ATTORNEY_PERSON_ACCOUNT' },
  OTHER: {fileType: 'OTHER' }
 }
}
export type LicensingForm8FileTypeInstanceType = {[P in LicensingForm8FileType]: {fileType: LicensingForm8FileType} }
export function  createLicensingForm8FileType(): LicensingForm8FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  COMMERCIAL_REGISTRATION: {fileType: 'COMMERCIAL_REGISTRATION' },
  JURISTIC_REGISTER: {fileType: 'JURISTIC_REGISTER' },
  AUTHORITY: {fileType: 'AUTHORITY' },
  IMPORT_MAP: {fileType: 'IMPORT_MAP' },
  IMPORT_WAREHOUSE_MAP: {fileType: 'IMPORT_WAREHOUSE_MAP' },
  LICENSING_FORM1: {fileType: 'LICENSING_FORM1' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  ATTORNEY_PERSON_ACCOUNT: {fileType: 'ATTORNEY_PERSON_ACCOUNT' },
  OTHER: {fileType: 'OTHER' }
 }
}
export type LicensingForm9FileTypeInstanceType = {[P in LicensingForm9FileType]: {fileType: LicensingForm9FileType} }
export function  createLicensingForm9FileType(): LicensingForm9FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  COMMERCIAL_REGISTRATION: {fileType: 'COMMERCIAL_REGISTRATION' },
  JURISTIC_REGISTER: {fileType: 'JURISTIC_REGISTER' },
  AUTHORITY: {fileType: 'AUTHORITY' },
  IMPORT_MAP: {fileType: 'IMPORT_MAP' },
  IMPORT_WAREHOUSE_MAP: {fileType: 'IMPORT_WAREHOUSE_MAP' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  ATTORNEY_PERSON_ACCOUNT: {fileType: 'ATTORNEY_PERSON_ACCOUNT' },
  OTHER: {fileType: 'OTHER' }
 }
}
export type LicensingFormSiteInspectionFileTypeInstanceType = {[P in LicensingFormSiteInspectionFileType]: {fileType: LicensingFormSiteInspectionFileType} }
export function  createLicensingFormSiteInspectionFileType(): LicensingFormSiteInspectionFileTypeInstanceType { 
return {
  IMAGE_INSPECTION: {fileType: 'IMAGE_INSPECTION' },
  AUDIT_LOG: {fileType: 'AUDIT_LOG' },
  EQUIPMENT_LIST: {fileType: 'EQUIPMENT_LIST' },
  PROCESS: {fileType: 'PROCESS' },
  LOCATION_CORRECTION_REPORT: {fileType: 'LOCATION_CORRECTION_REPORT' },
  SITE_INSPECTION_REPORT: {fileType: 'SITE_INSPECTION_REPORT' },
  CHECKLIST_REPORT: {fileType: 'CHECKLIST_REPORT' }
 }
}
export type Ns4FileTypeInstanceType = {[P in Ns4FileType]: {fileType: Ns4FileType} }
export function  createNs4FileType(): Ns4FileTypeInstanceType { 
return {
  CERTIFICATE_OF_ORIGIN_ORIGIN: {fileType: 'CERTIFICATE_OF_ORIGIN_ORIGIN' },
  PRODUCT_INFORMATION: {fileType: 'PRODUCT_INFORMATION' },
  CERTIFICATE_OF_FORMULA: {fileType: 'CERTIFICATE_OF_FORMULA' },
  CERTIFICATE_OF_HEALTH_PHYTOSANITANY: {fileType: 'CERTIFICATE_OF_HEALTH_PHYTOSANITANY' },
  NS4_ANIMAL_FEED_SAMPLING: {fileType: 'NS4_ANIMAL_FEED_SAMPLING' },
  PURCHASE_PRODUCT_QUANTITY: {fileType: 'PURCHASE_PRODUCT_QUANTITY' },
  DOCUMENT_OTHER: {fileType: 'DOCUMENT_OTHER' },
  DOCUMENT_ANIMAL_FEED: {fileType: 'DOCUMENT_ANIMAL_FEED' },
  DOCUMENT_ANIMAL_FEED_OTHER: {fileType: 'DOCUMENT_ANIMAL_FEED_OTHER' },
  NS4_ANIMAL_FEED: {fileType: 'NS4_ANIMAL_FEED' },
  NS4_ANIMAL_FEED_OTHER: {fileType: 'NS4_ANIMAL_FEED_OTHER' },
  CONSIDERATION_FORM: {fileType: 'CONSIDERATION_FORM' },
  ANIMAL_FEED_SAMPLING: {fileType: 'ANIMAL_FEED_SAMPLING' },
  RECORD_WORD: {fileType: 'RECORD_WORD' },
  SEIZE: {fileType: 'SEIZE' }
 }
}
export type Ns4Form1FileTypeInstanceType = {[P in Ns4Form1FileType]: {fileType: Ns4Form1FileType} }
export function  createNs4Form1FileType(): Ns4Form1FileTypeInstanceType { 
return {
  CERTIFICATE_OF_ORIGIN_ORIGIN: {fileType: 'CERTIFICATE_OF_ORIGIN_ORIGIN' },
  PRODUCT_INFORMATION: {fileType: 'PRODUCT_INFORMATION' },
  CERTIFICATE_OF_FORMULA: {fileType: 'CERTIFICATE_OF_FORMULA' },
  CERTIFICATE_OF_HEALTH_PHYTOSANITANY: {fileType: 'CERTIFICATE_OF_HEALTH_PHYTOSANITANY' },
  NS4_ANIMAL_FEED_SAMPLING: {fileType: 'NS4_ANIMAL_FEED_SAMPLING' },
  PURCHASE_PRODUCT_QUANTITY: {fileType: 'PURCHASE_PRODUCT_QUANTITY' },
  DOCUMENT_OTHER: {fileType: 'DOCUMENT_OTHER' },
  DOCUMENT_ANIMAL_FEED: {fileType: 'DOCUMENT_ANIMAL_FEED' },
  DOCUMENT_ANIMAL_FEED_OTHER: {fileType: 'DOCUMENT_ANIMAL_FEED_OTHER' },
  CONSIDERATION_FORM: {fileType: 'CONSIDERATION_FORM' },
  ANIMAL_FEED_SAMPLING: {fileType: 'ANIMAL_FEED_SAMPLING' },
  RECORD_WORD: {fileType: 'RECORD_WORD' },
  SEIZE: {fileType: 'SEIZE' },
  NS4_ANIMAL_FEED: {fileType: 'NS4_ANIMAL_FEED' },
  NS4_ANIMAL_FEED_OTHER: {fileType: 'NS4_ANIMAL_FEED_OTHER' }
 }
}
export type Ns4Form2FileTypeInstanceType = {[P in Ns4Form2FileType]: {fileType: Ns4Form2FileType} }
export function  createNs4Form2FileType(): Ns4Form2FileTypeInstanceType { 
return {
  CERTIFICATE_OF_ORIGIN_ORIGIN: {fileType: 'CERTIFICATE_OF_ORIGIN_ORIGIN' },
  PRODUCT_INFORMATION: {fileType: 'PRODUCT_INFORMATION' },
  CERTIFICATE_OF_FORMULA: {fileType: 'CERTIFICATE_OF_FORMULA' },
  CERTIFICATE_OF_HEALTH_PHYTOSANITANY: {fileType: 'CERTIFICATE_OF_HEALTH_PHYTOSANITANY' },
  NS4_ANIMAL_FEED_SAMPLING: {fileType: 'NS4_ANIMAL_FEED_SAMPLING' },
  PURCHASE_PRODUCT_QUANTITY: {fileType: 'PURCHASE_PRODUCT_QUANTITY' },
  DOCUMENT_OTHER: {fileType: 'DOCUMENT_OTHER' },
  DOCUMENT_ANIMAL_FEED: {fileType: 'DOCUMENT_ANIMAL_FEED' },
  DOCUMENT_ANIMAL_FEED_OTHER: {fileType: 'DOCUMENT_ANIMAL_FEED_OTHER' },
  NS4_ANIMAL_FEED: {fileType: 'NS4_ANIMAL_FEED' },
  NS4_ANIMAL_FEED_OTHER: {fileType: 'NS4_ANIMAL_FEED_OTHER' },
  CONSIDERATION_FORM: {fileType: 'CONSIDERATION_FORM' },
  ANIMAL_FEED_SAMPLING: {fileType: 'ANIMAL_FEED_SAMPLING' },
  RECORD_WORD: {fileType: 'RECORD_WORD' },
  SEIZE: {fileType: 'SEIZE' }
 }
}
export type RequestInspectionAuditFileTypeInstanceType = {[P in RequestInspectionAuditFileType]: {fileType: RequestInspectionAuditFileType} }
export function  createRequestInspectionAuditFileType(): RequestInspectionAuditFileTypeInstanceType { 
return {
  AUDIT: {fileType: 'AUDIT' }
 }
}
export type RequestInspectionFileTypeInstanceType = {[P in RequestInspectionFileType]: {fileType: RequestInspectionFileType} }
export function  createRequestInspectionFileType(): RequestInspectionFileTypeInstanceType { 
return {
  INSPECTION_REPORT: {fileType: 'INSPECTION_REPORT' },
  PRODUCT_INFORMATION: {fileType: 'PRODUCT_INFORMATION' },
  FORMULA_CERT: {fileType: 'FORMULA_CERT' },
  PROCESS_CHART: {fileType: 'PROCESS_CHART' },
  LABEL_COPY: {fileType: 'LABEL_COPY' },
  IMPORT_PERMIT: {fileType: 'IMPORT_PERMIT' },
  RESULT_NOTIFY: {fileType: 'RESULT_NOTIFY' },
  HYGIENIC_LICENSE_GMP: {fileType: 'HYGIENIC_LICENSE_GMP' },
  CRITICAL_LICENSE_NOTICE: {fileType: 'CRITICAL_LICENSE_NOTICE' },
  PRODUCTION_MAP: {fileType: 'PRODUCTION_MAP' },
  STORAGE_MAP: {fileType: 'STORAGE_MAP' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  OTHER: {fileType: 'OTHER' },
  DOCUMENT: {fileType: 'DOCUMENT' }
 }
}
export type RequestInspectionForm1FileTypeInstanceType = {[P in RequestInspectionForm1FileType]: {fileType: RequestInspectionForm1FileType} }
export function  createRequestInspectionForm1FileType(): RequestInspectionForm1FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  PRODUCT_INFORMATION: {fileType: 'PRODUCT_INFORMATION' },
  FORMULA_CERT: {fileType: 'FORMULA_CERT' },
  PROCESS_CHART: {fileType: 'PROCESS_CHART' },
  LABEL_COPY: {fileType: 'LABEL_COPY' },
  IMPORT_PERMIT: {fileType: 'IMPORT_PERMIT' },
  HYGIENIC_LICENSE_GMP: {fileType: 'HYGIENIC_LICENSE_GMP' },
  CRITICAL_LICENSE_NOTICE: {fileType: 'CRITICAL_LICENSE_NOTICE' },
  PRODUCTION_MAP: {fileType: 'PRODUCTION_MAP' },
  STORAGE_MAP: {fileType: 'STORAGE_MAP' },
  ID_CARD_COPY: {fileType: 'ID_CARD_COPY' },
  PASSPORT_COPY: {fileType: 'PASSPORT_COPY' },
  COMPANY_REGISTRATION_COPY: {fileType: 'COMPANY_REGISTRATION_COPY' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  OTHER: {fileType: 'OTHER' }
 }
}
export type RequestInspectionFormAuditFileTypeInstanceType = {[P in RequestInspectionFormAuditFileType]: {fileType: RequestInspectionFormAuditFileType} }
export function  createRequestInspectionFormAuditFileType(): RequestInspectionFormAuditFileTypeInstanceType { 
return {
  AUDIT: {fileType: 'AUDIT' }
 }
}
export type RequestInspectionFormCheckSiteInspectionFileTypeInstanceType = {[P in RequestInspectionFormCheckSiteInspectionFileType]: {fileType: RequestInspectionFormCheckSiteInspectionFileType} }
export function  createRequestInspectionFormCheckSiteInspectionFileType(): RequestInspectionFormCheckSiteInspectionFileTypeInstanceType { 
return {
  IMAGE_INSPECTION: {fileType: 'IMAGE_INSPECTION' },
  AUDIT_LOG: {fileType: 'AUDIT_LOG' },
  LOCATION_CORRECTION_REPORT: {fileType: 'LOCATION_CORRECTION_REPORT' },
  EQUIPMENT_LIST: {fileType: 'EQUIPMENT_LIST' },
  PROCESS: {fileType: 'PROCESS' },
  SITE_INSPECTION_REPORT: {fileType: 'SITE_INSPECTION_REPORT' },
  CHECKLIST_REPORT: {fileType: 'CHECKLIST_REPORT' }
 }
}
export type VoucherFileTypeInstanceType = {[P in VoucherFileType]: {fileType: VoucherFileType} }
export function  createVoucherFileType(): VoucherFileTypeInstanceType { 
return {
  VOUCHER: {fileType: 'VOUCHER' },
  VOUCHER_ORIGINAL: {fileType: 'VOUCHER_ORIGINAL' },
  VOUCHER_CORRECTION: {fileType: 'VOUCHER_CORRECTION' },
  VOUCHER_ATTACHMENT: {fileType: 'VOUCHER_ATTACHMENT' },
  VOUCHER_LABEL: {fileType: 'VOUCHER_LABEL' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  IMPORT_LABEL: {fileType: 'IMPORT_LABEL' },
  IMPORT_CERT_OF_FREE_SALE: {fileType: 'IMPORT_CERT_OF_FREE_SALE' },
  TRIAL_USE_REPORT: {fileType: 'TRIAL_USE_REPORT' },
  CERT_BIOLOGICAL_ANALYSIS: {fileType: 'CERT_BIOLOGICAL_ANALYSIS' },
  CERT_COLOR_ANALYSIS: {fileType: 'CERT_COLOR_ANALYSIS' },
  PRODUCT_PROCESS_DOC: {fileType: 'PRODUCT_PROCESS_DOC' },
  IMPORT_PRODUCT_INFO: {fileType: 'IMPORT_PRODUCT_INFO' },
  IMPORT_CERT_OF_HEALTH: {fileType: 'IMPORT_CERT_OF_HEALTH' },
  COMPANY_REGISTRATION_DOC: {fileType: 'COMPANY_REGISTRATION_DOC' },
  PACKAGE_AND_LABEL: {fileType: 'PACKAGE_AND_LABEL' },
  CERT_OF_FORMULA: {fileType: 'CERT_OF_FORMULA' },
  RESULTS_OF_TRAIL_USE: {fileType: 'RESULTS_OF_TRAIL_USE' },
  CERT_OF_TOTAL_BACTERIA: {fileType: 'CERT_OF_TOTAL_BACTERIA' },
  CERT_OF_TOTAL_MOLD: {fileType: 'CERT_OF_TOTAL_MOLD' },
  CERT_OF_SALMONELLA: {fileType: 'CERT_OF_SALMONELLA' },
  LOST_EVIDENCE: {fileType: 'LOST_EVIDENCE' },
  DAMAGED_EVIDENCE: {fileType: 'DAMAGED_EVIDENCE' },
  OTHER_DOC: {fileType: 'OTHER_DOC' },
  OTHER_DOC2: {fileType: 'OTHER_DOC2' },
  OTHER_DOC3: {fileType: 'OTHER_DOC3' },
  OTHER_DOC4: {fileType: 'OTHER_DOC4' },
  OTHER_DOC5: {fileType: 'OTHER_DOC5' },
  OTHER_DOC6: {fileType: 'OTHER_DOC6' },
  OTHER_DOC7: {fileType: 'OTHER_DOC7' },
  OTHER_DOC8: {fileType: 'OTHER_DOC8' },
  OTHER_DOC9: {fileType: 'OTHER_DOC9' },
  OTHER_DOC10: {fileType: 'OTHER_DOC10' },
  DOCUMENT: {fileType: 'DOCUMENT' }
 }
}
export type VoucherForm1FileTypeInstanceType = {[P in VoucherForm1FileType]: {fileType: VoucherForm1FileType} }
export function  createVoucherForm1FileType(): VoucherForm1FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  IMPORT_LABEL: {fileType: 'IMPORT_LABEL' },
  IMPORT_CERT_OF_FREE_SALE: {fileType: 'IMPORT_CERT_OF_FREE_SALE' },
  TRIAL_USE_REPORT: {fileType: 'TRIAL_USE_REPORT' },
  CERT_BIOLOGICAL_ANALYSIS: {fileType: 'CERT_BIOLOGICAL_ANALYSIS' },
  CERT_COLOR_ANALYSIS: {fileType: 'CERT_COLOR_ANALYSIS' },
  PRODUCT_PROCESS_DOC: {fileType: 'PRODUCT_PROCESS_DOC' },
  IMPORT_PRODUCT_INFO: {fileType: 'IMPORT_PRODUCT_INFO' },
  IMPORT_CERT_OF_HEALTH: {fileType: 'IMPORT_CERT_OF_HEALTH' },
  COMPANY_REGISTRATION_DOC: {fileType: 'COMPANY_REGISTRATION_DOC' },
  OTHER_DOC: {fileType: 'OTHER_DOC' },
  OTHER_DOC2: {fileType: 'OTHER_DOC2' },
  OTHER_DOC3: {fileType: 'OTHER_DOC3' },
  OTHER_DOC4: {fileType: 'OTHER_DOC4' },
  OTHER_DOC5: {fileType: 'OTHER_DOC5' },
  OTHER_DOC6: {fileType: 'OTHER_DOC6' },
  OTHER_DOC7: {fileType: 'OTHER_DOC7' },
  OTHER_DOC8: {fileType: 'OTHER_DOC8' },
  OTHER_DOC9: {fileType: 'OTHER_DOC9' },
  OTHER_DOC10: {fileType: 'OTHER_DOC10' }
 }
}
export type VoucherForm2FileTypeInstanceType = {[P in VoucherForm2FileType]: {fileType: VoucherForm2FileType} }
export function  createVoucherForm2FileType(): VoucherForm2FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  IMPORT_LABEL: {fileType: 'IMPORT_LABEL' },
  IMPORT_CERT_OF_FREE_SALE: {fileType: 'IMPORT_CERT_OF_FREE_SALE' },
  TRIAL_USE_REPORT: {fileType: 'TRIAL_USE_REPORT' },
  CERT_BIOLOGICAL_ANALYSIS: {fileType: 'CERT_BIOLOGICAL_ANALYSIS' },
  CERT_COLOR_ANALYSIS: {fileType: 'CERT_COLOR_ANALYSIS' },
  PRODUCT_PROCESS_DOC: {fileType: 'PRODUCT_PROCESS_DOC' },
  IMPORT_PRODUCT_INFO: {fileType: 'IMPORT_PRODUCT_INFO' },
  IMPORT_CERT_OF_HEALTH: {fileType: 'IMPORT_CERT_OF_HEALTH' },
  COMPANY_REGISTRATION_DOC: {fileType: 'COMPANY_REGISTRATION_DOC' },
  OTHER_DOC: {fileType: 'OTHER_DOC' },
  OTHER_DOC2: {fileType: 'OTHER_DOC2' },
  OTHER_DOC3: {fileType: 'OTHER_DOC3' },
  OTHER_DOC4: {fileType: 'OTHER_DOC4' },
  OTHER_DOC5: {fileType: 'OTHER_DOC5' },
  OTHER_DOC6: {fileType: 'OTHER_DOC6' },
  OTHER_DOC7: {fileType: 'OTHER_DOC7' },
  OTHER_DOC8: {fileType: 'OTHER_DOC8' },
  OTHER_DOC9: {fileType: 'OTHER_DOC9' },
  OTHER_DOC10: {fileType: 'OTHER_DOC10' }
 }
}
export type VoucherForm3FileTypeInstanceType = {[P in VoucherForm3FileType]: {fileType: VoucherForm3FileType} }
export function  createVoucherForm3FileType(): VoucherForm3FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  PACKAGE_AND_LABEL: {fileType: 'PACKAGE_AND_LABEL' },
  CERT_OF_FORMULA: {fileType: 'CERT_OF_FORMULA' },
  IMPORT_CERT_OF_FREE_SALE: {fileType: 'IMPORT_CERT_OF_FREE_SALE' },
  RESULTS_OF_TRAIL_USE: {fileType: 'RESULTS_OF_TRAIL_USE' },
  CERT_OF_TOTAL_BACTERIA: {fileType: 'CERT_OF_TOTAL_BACTERIA' },
  CERT_OF_TOTAL_MOLD: {fileType: 'CERT_OF_TOTAL_MOLD' },
  CERT_OF_SALMONELLA: {fileType: 'CERT_OF_SALMONELLA' },
  PRODUCT_PROCESS_DOC: {fileType: 'PRODUCT_PROCESS_DOC' },
  IMPORT_PRODUCT_INFO: {fileType: 'IMPORT_PRODUCT_INFO' },
  OTHER_DOC: {fileType: 'OTHER_DOC' },
  OTHER_DOC2: {fileType: 'OTHER_DOC2' },
  OTHER_DOC3: {fileType: 'OTHER_DOC3' },
  OTHER_DOC4: {fileType: 'OTHER_DOC4' },
  OTHER_DOC5: {fileType: 'OTHER_DOC5' },
  OTHER_DOC6: {fileType: 'OTHER_DOC6' },
  OTHER_DOC7: {fileType: 'OTHER_DOC7' },
  OTHER_DOC8: {fileType: 'OTHER_DOC8' },
  OTHER_DOC9: {fileType: 'OTHER_DOC9' },
  OTHER_DOC10: {fileType: 'OTHER_DOC10' }
 }
}
export type VoucherForm4FileTypeInstanceType = {[P in VoucherForm4FileType]: {fileType: VoucherForm4FileType} }
export function  createVoucherForm4FileType(): VoucherForm4FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  PACKAGE_AND_LABEL: {fileType: 'PACKAGE_AND_LABEL' },
  CERT_OF_FORMULA: {fileType: 'CERT_OF_FORMULA' },
  IMPORT_CERT_OF_FREE_SALE: {fileType: 'IMPORT_CERT_OF_FREE_SALE' },
  RESULTS_OF_TRAIL_USE: {fileType: 'RESULTS_OF_TRAIL_USE' },
  CERT_OF_TOTAL_BACTERIA: {fileType: 'CERT_OF_TOTAL_BACTERIA' },
  CERT_OF_TOTAL_MOLD: {fileType: 'CERT_OF_TOTAL_MOLD' },
  CERT_OF_SALMONELLA: {fileType: 'CERT_OF_SALMONELLA' },
  PRODUCT_PROCESS_DOC: {fileType: 'PRODUCT_PROCESS_DOC' },
  IMPORT_PRODUCT_INFO: {fileType: 'IMPORT_PRODUCT_INFO' },
  OTHER_DOC: {fileType: 'OTHER_DOC' },
  OTHER_DOC2: {fileType: 'OTHER_DOC2' },
  OTHER_DOC3: {fileType: 'OTHER_DOC3' },
  OTHER_DOC4: {fileType: 'OTHER_DOC4' },
  OTHER_DOC5: {fileType: 'OTHER_DOC5' },
  OTHER_DOC6: {fileType: 'OTHER_DOC6' },
  OTHER_DOC7: {fileType: 'OTHER_DOC7' },
  OTHER_DOC8: {fileType: 'OTHER_DOC8' },
  OTHER_DOC9: {fileType: 'OTHER_DOC9' },
  OTHER_DOC10: {fileType: 'OTHER_DOC10' }
 }
}
export type VoucherForm5FileTypeInstanceType = {[P in VoucherForm5FileType]: {fileType: VoucherForm5FileType} }
export function  createVoucherForm5FileType(): VoucherForm5FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  PACKAGE_AND_LABEL: {fileType: 'PACKAGE_AND_LABEL' },
  CERT_OF_FORMULA: {fileType: 'CERT_OF_FORMULA' },
  IMPORT_CERT_OF_FREE_SALE: {fileType: 'IMPORT_CERT_OF_FREE_SALE' },
  RESULTS_OF_TRAIL_USE: {fileType: 'RESULTS_OF_TRAIL_USE' },
  CERT_OF_TOTAL_BACTERIA: {fileType: 'CERT_OF_TOTAL_BACTERIA' },
  CERT_OF_TOTAL_MOLD: {fileType: 'CERT_OF_TOTAL_MOLD' },
  CERT_OF_SALMONELLA: {fileType: 'CERT_OF_SALMONELLA' },
  OTHER_DOC: {fileType: 'OTHER_DOC' },
  OTHER_DOC2: {fileType: 'OTHER_DOC2' },
  OTHER_DOC3: {fileType: 'OTHER_DOC3' },
  OTHER_DOC4: {fileType: 'OTHER_DOC4' },
  OTHER_DOC5: {fileType: 'OTHER_DOC5' },
  OTHER_DOC6: {fileType: 'OTHER_DOC6' },
  OTHER_DOC7: {fileType: 'OTHER_DOC7' },
  OTHER_DOC8: {fileType: 'OTHER_DOC8' },
  OTHER_DOC9: {fileType: 'OTHER_DOC9' },
  OTHER_DOC10: {fileType: 'OTHER_DOC10' },
  PRODUCT_PROCESS_DOC: {fileType: 'PRODUCT_PROCESS_DOC' },
  IMPORT_PRODUCT_INFO: {fileType: 'IMPORT_PRODUCT_INFO' }
 }
}
export type VoucherForm6FileTypeInstanceType = {[P in VoucherForm6FileType]: {fileType: VoucherForm6FileType} }
export function  createVoucherForm6FileType(): VoucherForm6FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  PACKAGE_AND_LABEL: {fileType: 'PACKAGE_AND_LABEL' },
  CERT_OF_FORMULA: {fileType: 'CERT_OF_FORMULA' },
  IMPORT_CERT_OF_FREE_SALE: {fileType: 'IMPORT_CERT_OF_FREE_SALE' },
  RESULTS_OF_TRAIL_USE: {fileType: 'RESULTS_OF_TRAIL_USE' },
  CERT_OF_TOTAL_BACTERIA: {fileType: 'CERT_OF_TOTAL_BACTERIA' },
  CERT_OF_TOTAL_MOLD: {fileType: 'CERT_OF_TOTAL_MOLD' },
  CERT_OF_SALMONELLA: {fileType: 'CERT_OF_SALMONELLA' },
  OTHER_DOC: {fileType: 'OTHER_DOC' },
  OTHER_DOC2: {fileType: 'OTHER_DOC2' },
  OTHER_DOC3: {fileType: 'OTHER_DOC3' },
  OTHER_DOC4: {fileType: 'OTHER_DOC4' },
  OTHER_DOC5: {fileType: 'OTHER_DOC5' },
  OTHER_DOC6: {fileType: 'OTHER_DOC6' },
  OTHER_DOC7: {fileType: 'OTHER_DOC7' },
  OTHER_DOC8: {fileType: 'OTHER_DOC8' },
  OTHER_DOC9: {fileType: 'OTHER_DOC9' },
  OTHER_DOC10: {fileType: 'OTHER_DOC10' },
  PRODUCT_PROCESS_DOC: {fileType: 'PRODUCT_PROCESS_DOC' },
  IMPORT_PRODUCT_INFO: {fileType: 'IMPORT_PRODUCT_INFO' }
 }
}
export type VoucherForm7FileTypeInstanceType = {[P in VoucherForm7FileType]: {fileType: VoucherForm7FileType} }
export function  createVoucherForm7FileType(): VoucherForm7FileTypeInstanceType { 
return {
  DOCUMENT: {fileType: 'DOCUMENT' },
  VOUCHER: {fileType: 'VOUCHER' },
  ATTORNEY_COPY: {fileType: 'ATTORNEY_COPY' },
  LOST_EVIDENCE: {fileType: 'LOST_EVIDENCE' },
  DAMAGED_EVIDENCE: {fileType: 'DAMAGED_EVIDENCE' },
  OTHER_DOC: {fileType: 'OTHER_DOC' },
  OTHER_DOC2: {fileType: 'OTHER_DOC2' },
  OTHER_DOC3: {fileType: 'OTHER_DOC3' },
  OTHER_DOC4: {fileType: 'OTHER_DOC4' },
  OTHER_DOC5: {fileType: 'OTHER_DOC5' },
  OTHER_DOC6: {fileType: 'OTHER_DOC6' },
  OTHER_DOC7: {fileType: 'OTHER_DOC7' },
  OTHER_DOC8: {fileType: 'OTHER_DOC8' },
  OTHER_DOC9: {fileType: 'OTHER_DOC9' },
  OTHER_DOC10: {fileType: 'OTHER_DOC10' }
 }
}
// Enum description for Aqua Project
//skip AnimalFeedConsiderType because it not have getValue() method
//skip SystemType because it not have getValue() method
export const AuditCorrectionFormStatus : {[p in AuditCorrectionFormStatus] : string } = {
   WAIT_PRIM_CORRECT:'รอแก้ไขข้อมูลเบื้องต้น',
   TECH_CORRECT:'รอแก้ไขข้อมููลทางวิชาการ',
   CORRECT_CHIEF:'รอแก้ไขข้อมูลตามคำสั่งหัวหน้ากลุ่ม กวค.',
   CORRECT_DIRECTOR:'รอแก้ไขข้อมูลตามคำสั่งผอ. กพอ.'
}
export const AuditFormObjectiveType : {[p in AuditFormObjectiveType] : string } = {
   PRODUCE:'เพื่อผลิต',
   IMPORT:'เพื่อนำเข้า'
}
export const AuditFormResultConsiderationType : {[p in AuditFormResultConsiderationType] : string } = {
   IS_ANIMAL_FEED:'เป็นอาหารสัตว์',
   IS_FACTOR_PRODUCTION:'เป็นปัจจัยการผลิตอื่น ๆ',
   OTHER:'อื่น ๆ'
}
export const AuditFormStatus : {[p in AuditFormStatus] : string } = {
   NEW:'คำขอใหม่',
   WAIT_VERIFY_TECH:'รอตรวจสอบทางวิชาการ',
   WAIT_PRIM_CORRECT:'รอแก้ไขข้อมูลเบื้องต้น',
   WAIT_VERIFY_CORRECT_PRIM:'รอตรวจสอบการแก้ไขข้อมูลเบื้องต้น',
   WAIT_PERMIT_TECH:'รออนุมัติทางวิชาการ',
   TECH_CORRECT:'รอแก้ไขข้อมููลทางวิชาการ',
   WAIT_VERIFY_CORRECT_TECH:'รอตรวจสอบการแก้ไขข้อมูลทางวิชาการ',
   WAIT_VERIFY_CORRECT_CHIEF:'รอตรวจสอบการแก้ไขข้อมูลตามคำสั่งหัวหน้ากลุ่ม กวค.',
   WAIT_VERIFY_CORRECT_DIRECTOR:'รอตรวจสอบการแก้ไขข้อมูลตามคำสั่งผอ. กพอ.',
   WAIT_SIGN:'รอลงนาม',
   WAIT_ORDER:'รอพิจารณาออกคำสั่ง',
   CORRECT_CHIEF:'รอแก้ไขข้อมูลตามคำสั่งหัวหน้ากลุ่ม กวค.',
   SPECIFIED:'จัดเป็นอาหารสัตว์ควบคุมเฉพาะ',
   FEED_NOT_SPECIFIED:'จัดเป็นอาหารสัตว์ แต่ไม่จัดเป็นอาหารสัตว์ควบคุมเฉพาะ',
   NOT_FEED_NOT_SPECIFIED:'ไม่จัดเป็นอาหารสัตว์และอาหารสัตว์ควบคุมเฉพาะ ',
   FAILED:'ไม่ผ่าน',
   CORRECT_DIRECTOR:'รอแก้ไขข้อมูลตามคำสั่งผอ. กพอ.',
   WAIT_NOTIFICATION_BOOK:'รอจัดทำหนังสือแจ้งผล',
   APPROVE:'อนุญาต',
   NOT_APPROVE:'ไม่อนุญาต',
   CONDITION_APPROVE:'อนุญาตแบบมีเงื่อนไข',
   CANCELLATION:'ละทิ้งคำขอ',
   CANCEL_BY_APPLICANT:'ยกเลิกคำร้อง/คำขอ'
}
export const AuditProductType : {[p in AuditProductType] : string } = {
   FORM_FILL_1:'แบบกรอกข้อมูลที่ 1',
   FORM_FILL_2:'แบบกรอกข้อมูลที่ 2'
}
export const ApplicantType : {[p in ApplicantType] : string } = {
   MANUFACTURER:'เป็นผู้ผลิต',
   EXPORTER:'เป็นผู้ส่งออก'
}
export const CertOfHealthFileType : {[p in CertOfHealthFileType] : string } = {
   MANUFACTURE_LICENSE:'ใบอนุญาตผลิตอาหารสัตว์',
   VOUCHER_LICENSE:'ใบสำคัญการขึ้นทะเบียนอาหารสัตว์',
   FORMULA_CERT:'หนังสือรับรองสูตร',
   GMP_HACCP_LICENSE:'ใบรับรองระบบ GMP หรือ HACCP',
   ANIMAL_FEED_PRODUCTION_CHART:'แผนภูมิการผลิตอาหารสัตว์',
   SALMONELLA_SPP:'หนังสือรับรองผลวิเคราะห์เชื้อ Salmonella spp.',
   FORMULA_CERT_NO_POULTRY:'หนังสือรับรองสูตร ว่าอาหารสัตว์ไม่มีส่วนผสมของสัตว์ปีก รวมถึงผลิตภัณฑ์จากสัตว์ปีก เช่น (ไข่และขนสัตว์ปีก)',
   FORMULA_CERT_NO_SALMONIDAE:'หนังสือรับรองสูตร ว่าอาหารสัตว์ไม่มีส่วนผสมจากปลาในตระกูล Salmonidae (เช่น ปลาแซลมอนม เทราต์ หรือชนิดอื่นๆที่เกี่ยวข้อง)',
   CERT_ANALYSIS:'หนังสือรับรองผลวิเคราะห์โปรตีน, ไขมัน, ความชื้น, คาร์โบไฮเดรต และเกลือ (ในรูปของโซเดียมคลอไรด์)',
   E_COLI:'หนังสือรับรองผลวิเคราะห์ E. coli',
   VIBRIO_PARAHAEMOLYTICUS:'หนังสือรับรองผลวิเคราะห์ Vibrio parahaemolyticus',
   VIBRIO_CHOLERA:'หนังสือรับรองผลวิเคราะห์ Vibrio cholera',
   STAPHYLOCOCCUS_AUREUS:'หนังสือรับรองผลวิเคราะห์ Staphylococcus aureus',
   AEROBIC_PLATE_COUNT:'หนังสือรับรองผลวิเคราะห์ AEROBIC PLATE COUNT',
   COLIFORM_BACTERIA:'หนังสือรับรองผลวิเคราะห์ COLIFORM BACTERIA',
   FECAL_COLIFORM:'หนังสือรับรองผลวิเคราะห์ FECAL COLIFORM',
   ESHERICHIA_COLI:'หนังสือรับรองผลวิเคราะห์ Esherichia coli',
   LISTERIA_MONOCYTOGENES:'หนังสือรับรองผลวิเคราะห์ Listeria monocytogenes',
   CHLORAMPHENICOL:'หนังสือรับรองผลวิเคราห์ยาปฏิชีวนะ Chloramphenicol',
   NITROFURANS:'หนังสือรับรองผลวิเคราห์ยาปฏิชีวนะ Nitrofurans',
   PRODUCT_LABEL_PHOTO:'ภาพถ่ายฉลากสินค้า ที่แสดงส่วนผสมในอาหารสัตว์',
   FREE_FROM_BIRD_FLU_NOTICE:'หนังสือแจ้งพื้นที่โรงงานผู้ผลิตปราศจากไข้หวัดนก ออกโดยกรมปศุสัตว์',
   INVOICE_LOADING_CONTAINERS:'ใบแจ้งลำเลียงสินค้าลงตู้คอนเทนเนอร์',
   ENTEROBACTER_SPP:'หนังสือรับรองผลวิเคราะห์ Enterobacter spp.',
   AFLATOXINS:'หนังสือรับรองผลวิเคราะห์อะฟลาทอกซิน (Aflatoxins)',
   PRODUCT_INFORMATION:'หนังสือแสดงรายละเอียดผลิตภัณฑ์ (Product Information)',
   DOMESTIC_SALES_INVOICE:'Invoice การขายภายในประเทศ',
   IMPORT_PERMIT_FROM_DESTINATION_COUNTRY:'Import Permit จากประเทศปลายทาง',
   COMPANY_RESPONSE_LETTER:'หนังสือตอบบริษัทฯ จาก กพอ. ว่าอาหารสัตว์น้ำดังกล่าวไม่จัดเป็นอาหารสัตว์ควบคุมเฉพาะ ตามพระราชบัญญัติควบคุมคุณภาพอาหารสัตว์ พ.ศ. 2558',
   INSPECTED_BY_THE_LICENSOR:'ได้รับการตรวจโรงงานผู้ผลิต โดยเจ้าหน้าที่ของผู้อนุญาตแล้ว',
   PACKAGE_PHOTO:'ภาพถ่ายภาชนะบรรจุ',
   CERT_MOISTURE_ANALYSIS:'หนังสือรับรองผลวิเคราะห์ความชื้น',
   PRODUCT_PHOTO:'ภาพถ่ายสินค้า'
}
export const CertificateCorrectionFormStatus : {[p in CertificateCorrectionFormStatus] : string } = {
   WAIT_PRIM_CORRECT:'รอแก้ไขข้อมูลเบื้องต้น',
   WAIT_TECH_CORRECT:'รอแก้ไขข้อมููลทางวิชาการ',
   CORRECT_DIRECTOR:'รอแก้ไขข้อมูลตามคำสั่งผอ. กพอ.',
   CORRECT_CHIEF:'รอแก้ไขข้อมูลตามคำสั่งหัวหน้ากลุ่ม กวค.'
}
//skip CertificateDocumentType because it not have getValue() method
export const CertificateDomesticSaleAttachFileRequest : {[p in CertificateDomesticSaleAttachFileRequest] : string } = {
   DO_NOT_REQUEST_ATTACH:'ไม่ประสงค์ขอใบแนบท้าย',
   REQUEST_ATTACH:'ประสงค์ขอใบแนบท้าย 1 ฉบับ'
}
export const CertificateDomesticSalesCopyRequest : {[p in CertificateDomesticSalesCopyRequest] : string } = {
   DO_NOT_REQUEST_COPY:'ไม่ประสงค์ขอสำเนา',
   REQUEST_COPY:'ประสงค์ขอสำเนา 1 ฉบับ'
}
export const CertificateDomesticSalesType : {[p in CertificateDomesticSalesType] : string } = {
   REGISTER:'เพื่อยื่นขึ้นทะเบียน',
   FOR_EXPORT:'เพื่อการส่งออกสินค้า ( มี Invoice )'
}
//skip CertificateDomesticSalesVoucherFileType because it not have getValue() method
export const CertificateExporterType : {[p in CertificateExporterType] : string } = {
   ADDRESS_THAT_MEETS:'ชื่อ ที่อยู่ ผู้ส่งออกสินค้าตรงตามผู้ผลิตสินค้า',
   ADDRESS_DIFFERENT_FROM:'ชื่อ ที่อยู่ผู้ส่งออกสินค้าต่างจากผู้ผลิตสินค้า'
}
//skip CertificateFileType because it not have getValue() method
//skip CertificateForm1FileType because it not have getValue() method
//skip CertificateForm2FileType because it not have getValue() method
//skip CertificateForm3FileType because it not have getValue() method
//skip CertificateForm4FileType because it not have getValue() method
export const CertificateFormStatus : {[p in CertificateFormStatus] : string } = {
   NEW:'คำขอใหม่',
   CORRECTION:'คำขอแก้ไข',
   SUBSTITUTE:'คำขอใบแทน',
   CANCELLATION:'ละทิ้งคำขอ',
   WAIT_PAYMENT:'รอชำระค่าธรรมเนียม',
   UPLOAD_SLIP:'รอตรวจสอบหลักฐานการชำระค่าธรรมเนียม',
   PAID:'ชำระค่าธรรมเนียมแล้ว',
   WAIT_VERIFY_TECH:'รอตรวจสอบทางวิชาการ',
   WAIT_PRIM_CORRECT:'รอแก้ไขข้อมูลเบื้องต้น',
   WAIT_VERIFY_CORRECTION_PRIM:'รอตรวจสอบการแก้ไขข้อมูลเบื้องต้น',
   WAIT_PERMIT_TECH:'รออนุมัติทางวิชาการ',
   WAIT_TECH_CORRECT:'รอแก้ไขข้อมููลทางวิชาการ',
   WAIT_SCHEDULE:'รอกำหนดการเข้าประชุม',
   WAIT_CERT:'รอจัดทำใบสำคัญ',
   WAIT_VERIFY_CORRECT_TECH:'รอตรวจสอบการแก้ไขข้อมูลทางวิชาการ',
   WAIT_VERIFY_CORRECT_CONCLUDE:'รอตรวจสอบการแก้ไข/ชี้แจงข้อมูลตามมติที่ประชุม',
   WAIT_VERIFY_CORRECT_CHIEF:'รอตรวจสอบการแก้ไขข้อมูลตามคำสั่งหัวหน้ากลุ่ม กวค.',
   WAIT_VERIFY_CORRECT_DIRECTOR:'รอตรวจสอบการแก้ไขข้อมูลตามคำสั่งผอ. กพอ.',
   WAIT_CONFERRED:'รอประชุม',
   DENIED_CONFERRED:'ไม่ผ่านมติที่ประชุม',
   CORRECT_CONCLUDE:'รอแก้ไข/ชี้แจงข้อมูลตามมติที่ประชุม',
   WAIT_SIGN:'รอลงนาม',
   WAIT_ORDER:'รอพิจารณาออกคำสั่ง',
   CORRECT_CHIEF:'รอแก้ไขข้อมูลตามคำสั่งหัวหน้ากลุ่ม กวค.',
   APPROVE:'อนุมัติ',
   WAIT_LICENSE:'รอจัดทำหนังสือรับรอง',
   DISAPPROVE:'ไม่อนุมัติ',
   APPROVE_CONDITION:'อนุุมัติแบบมีเงื่อนไข',
   CORRECT_DIRECTOR:'รอแก้ไขข้อมูลตามคำสั่งผอ. กพอ.',
   DENIED:'ไม่อนุญาต',
   CANCEL_REQUEST:'ยกเลิกคำร้อง/คำขอ'
}
//skip CertificateSystemType because it not have getValue() method
export const CertificateTransportInfo : {[p in CertificateTransportInfo] : string } = {
   SHIP:'เรือ',
   PLANE:'เครื่องบิน',
   TRUCK:'รถบรรทุก',
   OTHER:'อื่นๆ'
}
export const AuthorityType : {[p in AuthorityType] : string } = {
   ADMIN:'ADMIN ผู้ดูแลระบบโดยเจ้าหน้าที่ศูนย์เทคโนโลยีสารสนเทศและการสื่อสาร (ศทส.)',
   OFFICER:'เจ้าหน้าที่',
   DIRECTOR:'ผู้อำนวยการกองวิจัยและพัฒนาอาหารสัตว์น้ำ',
   ACTING_DIRECTOR_KPO:'รักษาราชการแทน ผู้อำนวยการกองวิจัยและพัฒนาอาหารสัตว์น้ำ',
   SCG_ADMIN:'ADMIN ผู้ดูแลระบบโดยเจ้าหน้าที่กลุ่มวิจัยและควบคุมมาตรฐานอาหารสัตว์น้ำ (กวค.)',
   SCG_BASIC_CONSIDERATION:'เจ้าหน้าที่ตรวจสอบเบื้องต้น',
   SCG_ACADEMIC:'เจ้าหน้าที่ตรวจสอบวิชาการ',
   SCG_CHIEF:'หัวหน้ากลุ่มงาน (กวค.)',
   QCG_ADMIN:'ADMIN ผู้ดูแลระบบโดยเจ้าหน้าที่กลุ่มวิจัยและควบคุมคุณภาพการผลิตอาหารสัตว์น้ำ (กคอ.)',
   QCG_ACADEMIC_GOV:'นักวิชาการประมง (พนักงานราชการ)',
   QCG_OFFICER:'เจ้าพนักงานประมง',
   QCG_ACADEMIC:'นักวิชาการประมง',
   QCG_CHIEF:'หัวหน้ากลุ่มงาน (กคอ.)',
   PROVINCE_ACADEMIC_GOV:'พนักงานราชการ (นักวิชาการประมง/เจ้าพนักงานประมง)',
   PROVINCE_OFFICER:'เจ้าพนักงานประมง',
   PROVINCE_ACADEMIC:'นักวิชาการประมง',
   PROVINCE_CHIEF:'หัวหน้ากลุ่มงาน',
   PROVINCE_DIRECTOR:'ประมงจังหวัด',
   PROVINCE_FINANCE_ACCOUNTING:'เจ้าหน้าที่การเงิน',
   CHECKPOINT_OFFICER:'เจ้าหน้าที่ด่านตรวจสัตว์น้ำ',
   CHECKPOINT_CHIEF:'หัวหน้าด่านตรวจสัตว์น้ำ',
   FINANCE_ACCOUNTING:'เจ้าหน้าที่การเงินและบัญชี',
   PERSONAL:'บุคคลธรรมดา',
   COMPANY:'นิติบุคคล',
   REQUEST_NEW:'คำขอเปิดสิทธิ์เข้าใช้งานระบบ',
   REQUEST_AUTHORIZED:'รออนุมัติการเข้าใช้ระบบ',
   MAIN_AGENT:'ผู้ถือบัญชีหลัก',
   AGENT:'ผู้ถือบัญชี',
   EMPLOYEE:'พนักงานบริษัท',
   ENTREPRENEUR:'ผู้ดำเนินกิจการ',
   ATTORNEY:'ผู้รับมอบอำนาจ',
   LICENSING:'ใบอนุญาตผลิต/นำเข้า/ขาย อาหารสัตว์น้ำควบคุมเฉพาะ',
   VOUCHER_1:'ประเภทวัตถุที่ผสมแล้ว ชนิดอาหารสัตว์ผสมสำเร็จรูปหรือหัวอาหารสัตว์',
   VOUCHER_2:'ประเภทวัตถุที่ผสมแล้ว ชนิดสารผสมล่วงหน้า (พรีมิกซ์)',
   VOUCHER_3:'ประเภทอาหารเสริมสำหรับสัตว์',
   CERTIFICATE:'หนังสือรับรองฯ Certificate of Free Sale/Health',
   NS4:'ระบบแจ้งการนำเข้าอาหารสัตว์ควบคุมเฉพาะ (นอ.1)',
   GMP_HACCP:'ใบรับรองระบบประกันคุณภาพ GMP/HACCP',
   AUDIT:'หนังสือแจ้งผลการตรวจสอบอาหารสัตว์น้ำว่า เข้าข่ายหรือไม่เข้าข่ายฯ ตามพรบ.',
   REQUEST_INSPECTION:'หนังสือแจ้งผลการตรวจสอบโรงงานผลิตอาหารสัตว์น้ำเพื่อการส่งออก'
}
//skip Event because it not have getValue() method
//skip State because it not have getValue() method
//skip DocumentType because it not have getValue() method
//skip UsersPermission because it not have getValue() method
export const AmountResult : {[p in AmountResult] : string } = {
   VALID:'ถูกต้อง',
   INVALID:'ไม่ถูกต้อง'
}
export const Animal : {[p in Animal] : string } = {
   PRAWN:'กุ้ง',
   FISH:'ปลา',
   FROG:'กบ',
   SNAPPING_TURTLE:'ตะพาบน้ำ',
   OTHER:'อื่นๆ'
}
export const AnimalFeedActGroup : {[p in AnimalFeedActGroup] : string } = {
   ANIMAL_FEED:'อาหารสัตว์ควบคุมเฉพาะ',
   OTHERS:'อาหารสัตว์อื่นนอกเหนือจากอาหารสัตว์ควบคุมเฉพาะ'
}
export const AnimalFeedGroupId : {[p in AnimalFeedGroupId] : string } = {
   MIXED:'วัตถุที่ผสมแล้ว',
   SUPPLEMENT:'อาหารเสริมสำหรับสัตว์',
   OTHERS_MIXED:'วัตถุที่ผสมแล้ว',
   LIVE_FEED:'อาหารมีชีวิต',
   FROZEN_LIVE_FEED:'อาหารมีชีวิตแช่แข็ง',
   INGREDIENT:'วัตถุดิบ',
   FEED_ADDITIVE:'วัตถุที่เติม'
}
export const AnimalFeedTypeId : {[p in AnimalFeedTypeId] : string } = {
   FEED:'อาหารสัตว์ผสมสำเร็จรูป',
   CONCENTRATED_FEED:'หัวอาหารสัตว์',
   PROTEIN_SUPPLEMENT:'อาหารเสริมโปรตีน',
   FAT_SUPPLEMENT:'อาหารเสริมไขมัน',
   MINERAL_SUPPLEMENT:'อาหารเสริมแร่ธาตุ',
   VITAMIN_SUPPLEMENT:'อาหารเสริมวิตามิน',
   AQUATIC_ANIMAL_PREMIX:'สารผสมล่วงหน้า (พรีมิกซ์)',
   SUPPLEMENT:'อาหารเสริมสำหรับสัตว์',
   SHRIMP_FEED:'อาหารกุ้ง',
   FISH_FEED:'อาหารปลา',
   AQUATIC_ANIMAL_FEED:'อาหารสัตว์น้ำ',
   ORNAMENTAL_FISH_FEED:'อาหารสัตว์ผสมสำเร็จรูปสำหรับปลาสวยงาม',
   ORNAMENTAL_TURTLE_FEED:'อาหารสัตว์ผสมสำเร็จรูปสำหรับเต่าสวยงาม',
   ORNAMENTAL_SHRIMP_FEED:'อาหารสัตว์ผสมสำเร็จรูปสำหรับกุ้งสวยงาม',
   ORNAMENTAL_FROG_FEED:'อาหารสัตว์ผสมสำเร็จรูปสำหรับกบสวยงาม',
   BAIT:'เหยื่อตกปลา',
   ENRICHMENT_FOR_ARTEMIA:'อาหารเสริมสำหรับอาร์ทีเมีย',
   ENRICHMENT_FOR_ROTIFER:'อาหารเสริมสำหรับโรติเฟอร์',
   ENRICHMENT_FOR_ARTEMIA_AND_ROTIFER:'อาหารเสริมสำหรับอาร์ทีเมียและหรือโรติเฟอร์',
   ARTEMIA_CYSTS:'ไข่อาร์ทีเมีย',
   FROZEN_WATER_MITES:'ไรน้ำแช่แข็ง',
   FROZEN_SHRIMP_ROE:'ไข่กุ้งแช่แข็ง',
   FROZEN_SEA_MITES:'ไรทะเลแช่แข็ง',
   FROZEN_SEA_BARNACLES:'เพรียงทะเลแช่แข็ง',
   FROZEN_SQUID:'หมึกแช่แข็ง',
   STIR_SQUID:'ไส้ปลาหมึกกวน',
   ALPHA_STARCH:'อัลฟาสตาร์ช',
   SEAWEED_MEAL:'สาหร่ายป่น 100 %',
   FLAVOR_ADDITIVE:'สารปรุงแต่งกลิ่น',
   COLOR_ENHANCER:'สารปรุงแต่งสี',
   OREGANO_OIL:'น้ำมันออริกาโน่',
   OTHER:'อื่นๆ',
   CONCENTRATED_FEED_FOR_SHRIMP:'',
   CONCENTRATED_FEED_FOR_FISH:'',
   CONCENTRATED_FEED_FOR_AQUATIC_ANIMAL:'',
   ASTAXANTHIN:'แอสต้าแซนทิน',
   MARINE_OIL:'น้ำมันสัตว์ทะเล',
   VEGETABLE_OIL:'น้ำมันพืช',
   TERRESTRIAL_ANIMAL_OIL:'น้ำมันสัตว์บก',
   CHITOSAN:'ไคโตซาน',
   SHRIMP_PASTE:'เปลือกกุ้งป่น',
   YEAST:'ยีสต์และหรือส่วนของยีสต์ตาย 100%',
   ANIMAL_FEED_PRESERVATIVES:'สารถนอมคุณภาพอาหารสัตว์',
   DIGESTIVE_AID:'สารช่วยเสริมการย่อย',
   ANTI_CAKING_AGENT:'สารป้องกันการเป็นก้อน',
   PELLET_AID:'สารช่วยอัดเม็ด',
   AMINO_ACIDS:'กรดอะมิโน',
   ENZYME:'เอนไซม์',
   BIO_SUPPLEMENT:'สารเสริมชีวนะ',
   FROZEN_KRILL:'คริลล์แช่แข็ง',
   FROZEN_RED_WORM:'หนอนแดงแช่แข็ง',
   EPHIPPIUM_EGG:'ไข่ไรแดง',
   INGREDIENT_OTHER:'วัตถุดิบ อื่นๆ',
   FEED_ADDITIVE_OTHER:'วัตถุที่เติม อื่นๆ',
   SUPPLEMENT_OTHER:'อาหารเสริม อื่นๆ',
   OTHERS_MIXED_OTHER:'อาหารสัตว์นอกเหนือ วัตถุที่ผสมแล้ว อื่นๆ',
   PREMIX_ORNAMENTAL_AQUATIC_ANIMAL:'สารผสมล่วงหน้า (พรีมิกซ์) สำหรับสัตว์น้ำสวยงาม',
   SUPPLEMENTS_ORNAMENTAL_AQUATIC_ANIMAL:'อาหารเสริมสำหรับสัตว์น้ำสวยงาม'
}
export const AppointmentStatus : {[p in AppointmentStatus] : string } = {
   ACCEPTED:'ยืนยันนัดหมาย',
   DENIED:'ปฏิเสธนัดหมาย'
}
export const ApproveStatus : {[p in ApproveStatus] : string } = {
   APPROVE:'อนุญาต',
   REJECT:'ไม่อนุญาต',
   CORRECT:'แก้ไข',
   APPROVE_WITH_CONDITIONS:'อนุญาตแบบมีเงื่อนไข'
}
export const CardType : {[p in CardType] : string } = {
   ID_CARD:'บัตรประจำตัวประชาชน',
   PASSPORT:'หนังสือเดินทาง'
}
export const CertificateMessage : {[p in CertificateMessage] : string } = {
   MSG1:'The application for the issuance of the certificate of the registration for this product has been received and found to be complied with  the regulation, procedure and condition as prescribed in The Animal Feed Quality Control Act B.E. 2558 (A.D. 2015).',
   MSG2:'The product is not required to register according to the Animal Feed Quality Act B.E. 2558 (A.D. 2015).',
   OTHER:'อื่นๆ'
}
export const CertificateType : {[p in CertificateType] : string } = {
   CERTIFICATE_OF_FREE_SALE:'Certificate of Free sale',
   HEALTH_CERTIFICATE:'Certificate of Health'
}
export const CheckingResult : {[p in CheckingResult] : string } = {
   PERMIT:'อนุญาต',
   REJECT:'ไม่อนุญาต'
}
export const ConsiderType : {[p in ConsiderType] : string } = {
   BASIC:'เบื้องต้น',
   ACADEMIC:'ทางวิชาการ'
}
export const CorrectionRequestGroup : {[p in CorrectionRequestGroup] : string } = {
   REGISTRATION:'ข้อมูลการขึ้นทะเบียน',
   LABEL:'ข้อมูลที่ต้องระบุบนฉลาก'
}
export const Department : {[p in Department] : string } = {
   DOF:'กรมประมง',
   DLD:'กรมปศุสัตว์',
   NO_LICENSED:'ไม่มีใบอนุญาต'
}
export const DofOrgType : {[p in DofOrgType] : string } = {
   OFFICE:'สำนักงาน',
   PORT:'ด่านตรวจประมง'
}
//skip EmployeeFileType because it not have getValue() method
//skip EntrepreneurFileType because it not have getValue() method
export const ExporterType : {[p in ExporterType] : string } = {
   EXPORTER_TYPE1:'ชื่อ ที่อยู่ ผู้จำหน่ายสินค้าตรงตามผู้นำเข้า',
   EXPORTER_TYPE2:'ชื่อ ที่อยู่ ผู้จำหน่ายสินค้าต่างจากผู้นำเข้า'
}
export const FactorOtherType : {[p in FactorOtherType] : string } = {
   DANGEROUS_OBJECTS:'วัตถุอันตราย',
   DRUG:'ยา',
   OTHER:'อื่น ๆ'
}
//skip FileUploadType because it not have getValue() method
export const FilingOffice : {[p in FilingOffice] : string } = {
   C:'ส่วนกลาง',
   P:'สำนักงานประมงจังหวัด'
}
export const FormStatus : {[p in FormStatus] : string } = {
   NEW:'คำขอใหม่',
   CONSIDER:'พิจารณาคำขอ',
   REVISE:'สั่งให้แก้ไข',
   REVISED:'แก้ไขข้อมูลแล้ว',
   APPOINTMENT:'นัดตรวจสถานที่',
   SITE_INSPECTION:'ตรวจสอบสถานที่',
   LICENSING:'จัดทำใบอนุญาต',
   SIGNING:'เสนอลงนาม',
   ORDER:'พิจารณาออกคำสั่ง'
}
export const FormType : {[p in FormType] : string } = {
   Register:'',
   Entrepreneur:'',
   LicensingForm1:'แบบแจ้งความประสงค์การขอ/ต่ออายุใบอนุญาตผลิต นำเข้า ขาย อาหารสัตว์ควบคุมเฉพาะ',
   LicensingForm2:'แบบคำขอใบอนุญาตผลิตอาหารสัตว์ควบคุมเฉพาะ (มีการแจ้งความประสงค์การขอใบอนุญาต)',
   LicensingForm3:'แบบคำขอใบอนุญาตผลิตอาหารสัตว์ควบคุมเฉพาะ (ไม่มีการแจ้งความประสงค์การขอใบอนุญาต)',
   LicensingForm4:'แบบคำขอต่ออายุใบอนุญาตผลิตอาหารสัตว์ควบคุมเฉพาะ (มีการแจ้งความประสงค์การต่ออายุใบอนุญาต',
   LicensingForm5:'แบบคำขอต่ออายุใบอนุญาตผลิตอาหารสัตว์ควบคุมเฉพาะ (ไม่มีการแจ้งความประสงค์การต่ออายุใบอนุญาต',
   LicensingForm6:'แบบคำขอแก้ไขใบอนุญาตผลิตอาหารสัตว์ควบคุมเฉพาะ',
   LicensingForm7:'แบบคำขอใบแทนใบอนุญาตผลิตอาหารสัตว์ควบคุมเฉพาะ',
   LicensingForm8:'แบบคำขอใบอนุญาตนำเข้าอาหารสัตว์ควบคุมเฉพาะ มีการแจ้งความประสงค์การขอใบอนุญาต',
   LicensingForm9:'แบบคำขอใบอนุญาตนำเข้าอาหารสัตว์ควบคุมเฉพาะ (ไม่มีการแจ้งความประสงค์การขอใบอนุญาต',
   LicensingForm10:'แบบคำขอต่ออายุใบอนุญาตนำเข้าอาหารสัตว์ควบคุมเฉพาะ (มีการแจ้งความประสงค์การต่ออายุใบอนุญาต)',
   LicensingForm11:'แบบคำขอต่ออายุใบอนุญาตนำเข้าอาหารสัตว์ควบคุมเฉพาะ (ไม่มีการแจ้งความประสงค์การต่ออายุใบอนุญาต)',
   LicensingForm12:'แบบคำขอแก้ไขใบอนุญาตนำเข้าอาหารสัตว์ควบคุมเฉพาะ',
   LicensingForm13:'แบบคำขอใบแทนใบอนุญาตนำเข้าอาหารสัตว์ควบคุมเฉพาะ',
   LicensingForm14:'แบบคำขอใบอนุญาตขายอาหารสัตว์ควบคุมเฉพาะ (มีการแจ้งความประสงค์การขอใบอนุญาต)',
   LicensingForm15:'แบบคำขอใบอนุญาตขายอาหารสัตว์ควบคุมเฉพาะ (ไม่มีการแจ้งความประสงค์การขอใบอนุญาต)',
   LicensingForm16:'แบบคำขอต่ออายุใบอนุญาตขายอาหารสัตว์ควบคุมเฉพาะ (มีการแจ้งความประสงค์การต่ออายุใบอนุญาต)',
   LicensingForm17:'แบบคำขอต่ออายุใบอนุญาตขายอาหารสัตว์ควบคุมเฉพาะ (ไม่มีการแจ้งความประสงค์การต่ออายุใบอนุญาต)',
   LicensingForm18:'แบบคำขอแก้ไขใบอนุญาตขายอาหารสัตว์ควบคุมเฉพาะ',
   LicensingForm19:'แบบคำขอใบแทนใบอนุญาตขายอาหารสัตว์ควบคุมเฉพาะ',
   Licensing:'',
   VoucherForm1:'แบบคำขอขึ้นทะเบียนอาหารสัตว์ควบคุมเฉพาะ ประเภทวัตถุที่ผสมแล้ว ชนิดอาหารสัตว์ผสมสำเร็จรูปหรือหัวอาหารสัตว์',
   VoucherForm2:'แบบคำขอแก้ไขรายการขึ้นทะเบียนอาหารสัตว์ควบคุมเฉพาะ ประเภทวัตถุที่ผสมแล้ว ชนิดอาหารสัตว์ผสมสำเร็จรูปหรือหัวอาหารสัตว์',
   VoucherForm3:'แบบคำขอขึ้นทะเบียนอาหารสัตว์ควบคุมเฉพาะ ประเภทวัตถุที่ผสมแล้วชนิดสารผสมล่วงหน้า (พรีมิกซ์)',
   VoucherForm4:'แบบคำขอแก้ไขรายการขึ้นทะเบียนอาหารสัตว์ควบคุมเฉพาะ ประเภทวัตถุที่ผสมแล้วชนิดสารผสมล่วงหน้า (พรีมิกซ์)',
   VoucherForm5:'แบบคำขอขึ้นทะเบียนอาหารสัตว์ควบคุมเฉพาะ ประเภทอาหารเสริมสำหรับสัตว์',
   VoucherForm6:'แบบคำขอแก้ไขรายการขึ้นทะเบียนอาหารสัตว์ควบคุมเฉพาะ ประเภทอาหารเสริมสำหรับสัตว์',
   VoucherForm7:'แบบคำขอใบแทนใบสำคัญการขึ้นทะเบียนอาหารสัตว์ควบคุมเฉพาะ',
   Voucher:'',
   GmpHaccpForm1:'แบบคำขอใบรับรองระบบการจัดการสุขลักษณะที่ดีในสถานประกอบการ (GMP)',
   GmpHaccpForm2:'แบบคำขอต่ออายุใบรับรองระบบการจัดการสุขลักษณะที่ดีในสถานประกอบการ (GMP)',
   GmpHaccpForm3:'แบบคำขอแก้ไขใบรับรองระบบการจัดการสุขลักษณะที่ดีในสถานประกอบการ (GMP)',
   GmpHaccpForm4:'แบบคำขอใบแทนใบรับรองระบบการจัดการสุขลักษณะที่ดีในสถานประกอบการ (GMP)',
   GmpHaccpForm5:'แบบคำขอใบรับรองระบบการจัดการด้านการวิเคราะห์อันตรายและจุดวิกฤตที่ต้องควบคุม (HACCP)',
   GmpHaccpForm6:'แบบคำขอต่ออายุใบรับรองระบบการจัดการด้านการวิเคราะห์อันตรายและจุดวิกฤตที่ต้องควบคุม (HACCP)',
   GmpHaccpForm7:'แบบคำขอแก้ไขใบรับรองระบบการจัดการด้านการวิเคราะห์อันตรายและจุดวิกฤตที่ต้องควบคุม (HACCP)',
   GmpHaccpForm8:'แบบคำขอใบแทนใบรับรองระบบการจัดการด้านการวิเคราะห์อันตรายและจุดวิกฤตที่ต้องควบคุม (HACCP)',
   GmpHaccpForm:'',
   GmpHaccp:'',
   CertificateForm1:'แบบคำขอหนังสือรับรองการขายภายในประเทศ (Certificate of Free Sale) (แบบ รข.1)',
   CertificateForm2:'แบบคำขอแก้ไขหนังสือรับรองการขายภายในประเทศ (Certificate of Free Sale)',
   CertificateForm3:'แบบคำขอหนังสือรับรองสุขภาพ (Certificate of Health) (แบบ รส.1)',
   CertificateForm4:'แบบคำขอแก้ไขหนังสือรับรองสุขภาพ (Certificate of Health)',
   Certificate:'',
   Ns4Form1:'แบบคำขอแจ้งการนำเข้าอาหารสัตว์น้ำ (น.อ.1)',
   Ns4Form2:'แบบคำขอแก้ไขการแจ้งการนำเข้าอาหารสัตว์น้ำ (น.อ.1)',
   AuditForm1:'แบบคำขอหนังสือแจ้งผลการพิจารณาเข้าข่ายเป็นอาหารสัตว์ควบคุมเฉพาะ ตาม พรบ.ควบคุมคุณภาพอาหารสัตว์ พ.ศ.2558',
   Audit:'คำขอหนังสือสอบถามว่าอาหารสัตว์น้ำเข้าข่ายหรือไม่เข้าข่ายเป็นอาหารสัตว์ควบคุมเฉพาะ พรบ.ควบคุมคุณภาพอาหารสัตว์ พ.ศ. 2558',
   RequestInspectionForm1:'แบบคำขอรับการตรวจสอบโรงงานผลิตอาหารสัตว์น้ำเพื่อการส่งออก',
   RequestInspection:'ระบบออกหนังสือแจ้งผลการตรวจสอบโรงงานผลิตอาหารสัตว์เพื่อการส่งออก'
}
export const GmpHaccpIssueType : {[p in GmpHaccpIssueType] : string } = {
   N:'ขอใหม่',
   R:'ต่ออายุ',
   C:'แก้ไข',
   S:'ใบแทน'
}
export const LabelResult : {[p in LabelResult] : string } = {
   VALID:'ถูกต้อง',
   INVALID:'ไม่ถูกต้อง',
   NO_LABEL:'ไม่มีฉลาก'
}
export const LicenseStatus : {[p in LicenseStatus] : string } = {
   AVAILABLE:'คงอยู่',
   USED:'ถูกใช้งานแล้ว',
   CANCELED:'ยกเลิก',
   RENEW:'อยู่ระหว่างการยื่นขอต่ออายุ/ขอแก้ไข',
   EXPIRED:'ไม่สามารถใช้ได้เนื่องจากหมดอายุ'
}
export const LicenseSubType : {[p in LicenseSubType] : string } = {
   WHOLESALE_AND_RETAIL:'ขายส่งและขายปลีก',
   RETAIL:'ขายปลีก'
}
export const LicenseType : {[p in LicenseType] : string } = {
   P:'ใบอนุญาตผลิตอาหารสัตว์ควบคุมเฉพาะ',
   I:'ใบอนุญาตนำเข้าอาหารสัตว์ควบคุมเฉพาะ',
   S:'ใบอนุญาตขายอาหารสัตว์ควบคุมเฉพาะ'
}
//skip LicensingEntrepreneurFileType because it not have getValue() method
export const LicensingFormStatus : {[p in LicensingFormStatus] : string } = {
   NEW:'คำขอใหม่',
   PRIM_CORRECTION:'แก้ไขข้อมูลแบบแจ้ง/คำขอเบื้องต้น',
   CANCELATION:'ยกเลิกคำขอเนื่องจากไม่มีการดำเนินการตามกำหนด',
   CANCEL_BY_APPLICANT:'ยกเลิกคำร้อง/คำขอ',
   PRIM_CORRECTED:'รอตรวจสอบการแก้ไขข้อมูลแบบแจ้ง/คำขอเบื้องต้น',
   WAIT_VERIFY:'รอเอกสารฉบับจริง',
   WAIT_APPOINT_LOCATION:'รอนัดหมายตรวจสอบสถานที่',
   WAIT_ACCEPT_LOCATION:'รอตอบรับนัดหมายตรวจสอบสถานที่',
   APPOINT_DENIED:'ปฏิเสธนัดหมาย',
   WAIT_INSPECT_LOCATION:'รอตรวจสอบสถานที่',
   LOCATION_DENIED:'ไม่ผ่านเนื่องจากสถานที่ไม่เหมาะสม',
   WAIT_APPLICATION:'รอการยื่นคำขอใบอนุญาตฯ',
   APPLIED:'ยื่นคำขอใบอนุญาตแล้ว',
   WAIT_CERT:'รอจัดทำใบอนุญาต',
   REPORT_CORRECT:'แก้ไขรายงานฯ',
   WAIT_SIGN_PROPOSAL:'รอเสนอลงนาม',
   WAIT_ORDER:'รอพิจารณาออกคำสั่ง',
   DENIED:'ไม่อนุญาต',
   WAIT_PAYMENT:'รอชำระค่าธรรมเนียม',
   UPLOAD_SLIP:'รอตรวจสอบหลักฐานการชำระค่าธรรมเนียม',
   PAID:'ชำระค่าธรรมเนียมแล้ว',
   GRANT:'อนุญาต'
}
export const LicensingIssueType : {[p in LicensingIssueType] : string } = {
   N:'ขอใหม่',
   R:'ต่ออายุ',
   C:'แก้ไข',
   S:'ใบแทน'
}
export const Modules : {[p in Modules] : string } = {
   LICENSING_P:'ระบบการออกใบอนุญาตผลิตอาหารสัตว์ควบคุมเฉพาะ',
   LICENSING_I:'ระบบการออกใบอนุญาตนำเข้าอาหารสัตว์ควบคุมเฉพาะ',
   LICENSING_S:'ระบบการออกใบอนุญาตขายอาหารสัตว์ควบคุมเฉพาะ',
   VOUCHER:'ระบบการออกใบสำคัญการขึ้นทะเบียนอาหารสัตว์ควบคุมเฉพาะ',
   GMP:'ระบบการออกใบรับรองระบบการจัดการด้านสุขลักษณะที่ดีในสถานประกอบการ (GMP)',
   HACCP:'ระบบการออกใบรับรองระบบการจัดการด้านการวิเคราะห์อันตรายและจุดวิกฤตที่ต้องควบคุม (HACCP)',
   CERTIFICATE_FREE_SALE:'ระบบการออกหนังสือรับรองการขายภายในประเทศ (Certificate of Free Sale)',
   CERTIFICATE_HEALTH:'ระบบการออกหนังสือรับรองสุขภาพ (Certificate of Health)',
   NS4:'ระบบการแจ้งการนำเข้าซึ่งอาหารสัตว์ (เข้ามาในราชอาณาจักร (น.ส.4) (อาหารสัตว์น้ำ)',
   AUDIT:'ระบบการแจ้งผลการตรวจสอบอาหารสัตว์น้ำว่าเข้าข่ายหรือไม่เข้าข่ายเป็นอาหารสัตว์ควบคุมเฉพาะตาม พรบ.ควบคุมคุณภาพอาหารสัตว์ พ.ศ.2558',
   REQUEST_INSPECTION:'ระบบการแจ้งผลการตรวจสอบโรงงานผลิตอาหารสัตว์เพื่อการส่งออก'
}
export const PerformType : {[p in PerformType] : string } = {
   ENTREPRENEUR:'ผู้ดำเนินกิจการ',
   ATTORNEY:'ผู้รับมอบอำนาจ'
}
export const PersonType : {[p in PersonType] : string } = {
   PERSONAL:'บุคคลธรรมดา',
   COMPANY:'นิติบุคคล'
}
export const QualityType : {[p in QualityType] : string } = {
   PROTEIN:'โปรตีน',
   FAT:'ไขมัน',
   FIBER:'กาก',
   MOISTURE:'ความชื้น'
}
//skip RequestAgentStatus because it not have getValue() method
//skip RequestAgentType because it not have getValue() method
//skip RequestEmployeeFileType because it not have getValue() method
//skip RequestEntrepreneurFileType because it not have getValue() method
//skip RequestInspectionEntrepreneurFileType because it not have getValue() method
//skip RequestMethod because it not have getValue() method
export const RequestRegisterStatus : {[p in RequestRegisterStatus] : string } = {
   NEW:'รอการบันทึกข้อมูลให้ครบถ้วน',
   PENDING:'รออนุมัติ(เข้าใช้ระบบ/เปลี่ยนแปลงข้อมูลทะเบียน)',
   APPROVED:'อนุมัติ(เข้าใช้ระบบ/เปลี่ยนแปลงข้อมูลทะเบียน)',
   CORRECTION:'แก้ไขข้อมูลตามหมายเหตุเจ้าหน้าที่',
   WAIT_CORRECTION_CONSIDER:'รอตรวจสอบแก้ไขข้อมูลตามหมายเหตุเจ้าหน้าที่',
   DENIED:'ยกเลิกคำขอลงทะเบียนเข้าใช้ระบบ'
}
export const RequestRegisterType : {[p in RequestRegisterType] : string } = {
   N:'คำขอเปิดสิทธิ์เข้าใช้ระบบ',
   C:'คำขอเปลี่ยนแปลงข้อมูลทะเบียนผู้เข้าใช้ระบบ',
   R:'คำขอต่ออายุทะเบียนผู้เข้าใช้ระบบ'
}
export const RequestSubstituteReason : {[p in RequestSubstituteReason] : string } = {
   DAMAGED:'ชำรุด',
   LOST:'สูญหาย'
}
export const RequestType : {[p in RequestType] : string } = {
   N:'ขอใหม่',
   R:'ต่ออายุ',
   C:'แก้ไข',
   S:'ใบแทน'
}
//skip RequestUserFileType because it not have getValue() method
export const Sample : {[p in Sample] : string } = {
   SAMPLE_3:'เก็บตัวอย่าง 3 ถุง',
   SAMPLE_4:'เก็บตัวอย่าง 4 ถุง',
   SAMPLE_NONE:'ไม่เก็บตัวอย่าง'
}
//skip UserFileType because it not have getValue() method
export const UserStatus : {[p in UserStatus] : string } = {
   P:'รอการบันทึกข้อมูลให้ครบถ้วน',
   R:'ลงทะเบียนแล้ว'
}
export const UserType : {[p in UserType] : string } = {
   PERSONAL:'ผู้ประกอบการ (บุคคลธรรมดา)',
   COMPANY:'ผู้ประกอบการ (นิติบุคคล)',
   OFFICER:'เจ้าหน้าที่'
}
export const FollowInspectionStatus : {[p in FollowInspectionStatus] : string } = {
   MONITORING_1:'ตรวจติดตามครั้งที่ 1 แล้ว',
   MONITORING_2:'ตรวจติดตามครั้งที่ 2 แล้ว'
}
export const GmpHaccpCertificateLevel : {[p in GmpHaccpCertificateLevel] : string } = {
   LEVEL1:'ระดับที่  1',
   LEVEL2:'ระดับที่  2',
   LEVEL3:'ระดับที่  3'
}
export const GmpHaccpCheckInspectionType : {[p in GmpHaccpCheckInspectionType] : string } = {
   COMPLY:'Comply',
   NOT_COMPLY:'Not Comply',
   PASS:'ผ่าน',
   DEFECTIVE:'ข้อบกพร่อง',
   CR:'Cr',
   SE:'Se',
   M:'M',
   N:'N',
   EMPTY:'EMPTY'
}
export const GmpHaccpCheckSiteInspectionResult : {[p in GmpHaccpCheckSiteInspectionResult] : string } = {
   PASS:'ผ่าน',
   MONITORING_FACTORY:'ตรวจติดตามการแก้ไขที่โรงงานผลิตอาหารสัตว์ควบคุมเฉพาะ',
   MONITORING_REPORT:'ตรวจติดตามการแก้ไขจากรายงานการแก้ไขข้อบกพร่อง',
   CANT_FIX_BUGS_180:'เนื่องจากโรงงานไม่สามารถแก้ไขข้อบกพร่องได้ภายใน 180 วัน'
}
export const GmpHaccpCorrectionRequestType : {[p in GmpHaccpCorrectionRequestType] : string } = {
   LOCATION:'สถานที่ผลิตอาหารสัตว์ควบคุมเฉพาะ',
   SCOPE_OF_CERTIFICATION:'ขอบข่าย',
   OTHER:'อื่นๆ'
}
//skip GmpHaccpFileType because it not have getValue() method
//skip GmpHaccpForm1FileType because it not have getValue() method
//skip GmpHaccpForm2FileType because it not have getValue() method
//skip GmpHaccpForm3FileType because it not have getValue() method
//skip GmpHaccpForm4FileType because it not have getValue() method
//skip GmpHaccpForm5FileType because it not have getValue() method
//skip GmpHaccpForm6FileType because it not have getValue() method
//skip GmpHaccpForm7FileType because it not have getValue() method
//skip GmpHaccpForm8FileType because it not have getValue() method
export const GmpHaccpFormCheckSiteInspectionFileType : {[p in GmpHaccpFormCheckSiteInspectionFileType] : string } = {
   PRODUCTION_EXAM_PIC:'รูปภาพการตรวจสอบสถานที่ผลิต',
   EXAM_SHED_1:'กำหนดการตรวจ ครั้งที่ 1',
   EXAM_SHED_2:'กำหนดการตรวจ ครั้งที่ 2',
   EXAM_SHED_3:'กำหนดการตรวจ ครั้งที่ 3',
   ERROR_REPORT_1:'ใบรายงานข้อบกพร่อง ครั้งที่ 1',
   ERROR_REPORT_2:'ใบรายงานข้อบกพร่อง ครั้งที่ 2',
   ERROR_REPORT_3:'ใบรายงานข้อบกพร่อง ครั้งที่ 3',
   EXAM_REPORT:'สรุปรายงานการตรวจประเมิน',
   CORRECTION_REPORT_1:'รายงานการแก้ไขข้อบกพร่อง ครั้งที่ 1 (กรณีตรวจติดตามที่โรงงาน)',
   CORRECTION_REPORT_2:'รายงานการแก้ไขข้อบกพร่อง ครั้งที่ 2 (กรณีตรวจติดตามที่โรงงาน)',
   CORRECTION_REPORT_3:'รายงานการแก้ไขข้อบกพร่อง ครั้งที่ 1 (กรณีตรวจติดตามจากรายงาน)',
   CORRECTION_REPORT_4:'รายงานการแก้ไขข้อบกพร่อง ครั้งที่ 2 (กรณีตรวจติดตามจากรายงาน)',
   REPORT_SITE_INSPECTION:'รายการตรวจประเมินระบบ'
}
export const GmpHaccpFormFollowInspectionFileType : {[p in GmpHaccpFormFollowInspectionFileType] : string } = {
   EXAM_SHED_1:'กำหนดการตรวจ',
   EXAM_SHED_2:'กำหนดการตรวจ',
   ERROR_REPORT_1:'รายงานข้อบกพร่องที่ต้องแก้ไข',
   ERROR_REPORT_2:'รายงานข้อบกพร่องที่ต้องแก้ไข',
   CORRECTION_REPORT_1:'รายงานการแก้ไขข้อบกพร่อง',
   CORRECTION_REPORT_2:'รายงานการแก้ไขข้อบกพร่อง',
   OTHER_1:'อื่นๆ',
   OTHER_2:'อื่นๆ'
}
export const GmpHaccpFormStatus : {[p in GmpHaccpFormStatus] : string } = {
   NEW:'คำขอใหม่',
   VERIFY_CORRECT_PRIM:'แก้ไขข้อมูลเบื้องต้น',
   CANCELATION:'ละทิ้งคำขอ',
   CANCEL_BY_APPLICANT:'ยกเลิกคำร้อง/คำขอ',
   CORRECTED_PRIM:'แก้ไขข้อมูลเบื้องต้นแล้ว',
   WAIT_OG_DOC:'รอตรวจสอบเอกสารฉบับจริง',
   WAIT_APPOINT_DATE_1:'รอนัดวันตรวจประเมินสถานที่ ครั้งที่ 1',
   WAIT_APPOINT_DATE_2:'รอนัดวันตรวจประเมินสถานที่ ครั้งที่ 2',
   WAIT_APPOINT_DATE_3:'รอนัดวันตรวจประเมินสถานที่ ครั้งที่ 3',
   WAIT_CONFIRM_APPOINT_DATE_1:'รอการตอบรับนัดตรวจประเมินสถานที่ ครั้งที่ 1',
   WAIT_CONFIRM_APPOINT_DATE_2:'รอการตอบรับนัดตรวจประเมินสถานที่ ครั้งที่ 2',
   WAIT_CONFIRM_APPOINT_DATE_3:'รอการตอบรับนัดตรวจประเมินสถานที่ ครั้งที่ 3',
   APPOINT_DENIED_1:'ปฏิเสธนัดหมาย ครั้งที่ 1',
   APPOINT_DENIED_2:'ปฏิเสธนัดหมาย ครั้งที่ 2',
   APPOINT_DENIED_3:'ปฏิเสธนัดหมาย ครั้งที่ 3',
   WAIT_EXAM_PLACE_1:'รอตรวจประเมินสถานที่ ครั้งที่ 1',
   WAIT_EXAM_PLACE_2:'รอตรวจประเมินสถานที่ ครั้งที่ 2',
   WAIT_EXAM_PLACE_3:'รอตรวจประเมินสถานที่ ครั้งที่ 3',
   WAIT_CORRECT_FACTORY_1:'รอโรงงานแก้ไขข้อบกพร่อง ครั้งที่ 1 (กรณีตรวจติดตามที่โรงงาน)',
   WAIT_CORRECT_FACTORY_2:'รอโรงงานแก้ไขข้อบกพร่อง ครั้งที่ 2 (กรณีตรวจติดตามที่โรงงาน)',
   SEND_CORRECT_REPORT_1:'ให้ส่งรายงานแก้ไขข้อบกพร่อง ครั้งที่ 1 (กรณีตรวจติดตามจากรายงาน)',
   SEND_CORRECT_REPORT_2:'ให้ส่งรายงานแก้ไขข้อบกพร่อง ครั้งที่ 2 (กรณีตรวจติดตามจากรายงาน)',
   WAIT_EXAM_CORRECTION_1:'รอตรวจสอบรายงานแก้ไขข้อบกพร่อง ครั้งที่ 1 (กรณีตรวจติดตามจากรายงาน)',
   WAIT_EXAM_CORRECTION_2:'รอตรวจสอบรายงานแก้ไขข้อบกพร่อง ครั้งที่ 2 (กรณีตรวจติดตามจากรายงาน)',
   DENIED_CORRECTION_FAILED:'ไม่ผ่าน เนื่องจากโรงงานไม่สามารถแก้ไขข้อบกพร่องได้ภายใน 180 วัน',
   EXAM_NOTED:'บันทึกรายการตรวจประเมินเรียบร้อยแล้ว รอเข้าประชุมคณะทบทวน',
   WAIT_MEETING:'รอเข้าประชุมคณะทบทวน',
   WAIT_MEETING_REPORT:'รอบันทึกรายงานการประชุม',
   WAIT_CONFIRM_MEETING_REPORT:'รอยืนยันบันทึกรายงานการประชุม',
   WAIT_LICENSE:'รอจัดทำใบรับรอง',
   WAIT_SIGN:'รอเสนอลงนาม',
   WAIT_ORDER:'รอพิจารณาออกคำสั่ง',
   DISAPPROVE:'ไม่อนุญาต',
   APPROVE:'อนุญาต',
   WAIT_PAYMENT:'รอชำระค่าธรรมเนียม',
   UPLOAD_SLIP:'รอตรวจสอบหลักฐานการชำระค่าธรรมเนียม',
   PAID:'ชำระค่าธรรมเนียมแล้ว'
}
export const GmpHaccpMeetingBookingFileType : {[p in GmpHaccpMeetingBookingFileType] : string } = {
   MEETING_REPORT:'รายงานการประชุม',
   SIGN_DOCUMENT:'ใบเซ็นชื่อ',
   INVITATION_LETTER:'หนังสือเชิญ',
   MEETING_PRESENTATION:'ไฟล์นำเสนอที่ประชุม'
}
export const GmpHaccpMeetingStatus : {[p in GmpHaccpMeetingStatus] : string } = {
   WAIT_MEETING_REPORT:'รอบันทึกรายงานการประชุม',
   MEETING_REPORT_DONE:'บันทึกรายงานการประชุมแล้ว',
   MEETING_BYPASS_DONE:'บันทึกรายงานการประชุมแล้ว โดยไม่ผ่านการประชุม'
}
//skip GmpHaccpType because it not have getValue() method
//skip AuditFileType because it not have getValue() method
export const CertificateOfFreeSaleType : {[p in CertificateOfFreeSaleType] : string } = {
   WHOLESALE_AND_RETAIL:'ขายส่งและขายปลีก',
   RETAIL:'ขายปลีก'
}
//skip LicensingFileType because it not have getValue() method
//skip LicensingForm10FileType because it not have getValue() method
//skip LicensingForm11FileType because it not have getValue() method
//skip LicensingForm12FileType because it not have getValue() method
//skip LicensingForm13FileType because it not have getValue() method
//skip LicensingForm14FileType because it not have getValue() method
//skip LicensingForm15FileType because it not have getValue() method
//skip LicensingForm16FileType because it not have getValue() method
//skip LicensingForm17FileType because it not have getValue() method
//skip LicensingForm18FileType because it not have getValue() method
//skip LicensingForm19FileType because it not have getValue() method
//skip LicensingForm1FileType because it not have getValue() method
//skip LicensingForm2FileType because it not have getValue() method
//skip LicensingForm3FileType because it not have getValue() method
//skip LicensingForm4FileType because it not have getValue() method
//skip LicensingForm5FileType because it not have getValue() method
//skip LicensingForm6FileType because it not have getValue() method
//skip LicensingForm7FileType because it not have getValue() method
//skip LicensingForm8FileType because it not have getValue() method
//skip LicensingForm9FileType because it not have getValue() method
//skip LicensingFormSiteInspectionFileType because it not have getValue() method
export const SiteInspectionPassResult : {[p in SiteInspectionPassResult] : string } = {
   NOT_INSPECTION_AGAIN:'ไม่ต้องตรวจซ้ำ',
   SENT_REPORT_LOCATION:'ให้ส่งรายงานแก้ไขสถานที่',
   NOT_OPERATED_PRODUCTION_INSPECTION_AGAIN:'บริษัทยังไม่ได้ดำเนินการผลิต จะดำเนินการตรวจสอบอีกครั้ง',
   NOT_KEPT_STOCK_INSPECTION_AGAIN:'บริษัทยังไม่มีการเก็บสต็อกวัตถุดิบ/อาหารสัตว์ควบคุมเฉพาะ จะดำเนินการตรวจสอบอีกครั้ง'
}
export const SiteInspectionResult : {[p in SiteInspectionResult] : string } = {
   PASS:'ผ่าน',
   NOT_PASS:'ไม่ผ่าน'
}
export const SiteInspectionStatus : {[p in SiteInspectionStatus] : string } = {
   WAIT_CORRECTION_SENT:'รอส่งรายงานแก้ไขสถานที่',
   WAIT_DIGI_SIGN:'รอลงลายมือชื่ออิเล็กทรอนิกส์รับทราบผลการตรวจสอบ',
   WAIT_CORRECTION_SENT_AND_DIGI_SIGN:'รอส่งรายงานแก้ไขสถานที่และลงลายมือชื่ออิเล็กทรอนิกส์รับทราบผลการตรวจสอบ',
   CORRECTION_SENT:'รอตรวจสอบรายงานแก้ไขสถานที่',
   PASS:'ตรวจสอบสถานที่แล้ว',
   NOT_PASS:'ไม่ผ่าน'
}
export const ConfiscationProduct : {[p in ConfiscationProduct] : string } = {
   CONFISCATION:'อายัด',
   NONE_CONFISCATION:'ไม่อายัด'
}
export const SampleAnimalFeed : {[p in SampleAnimalFeed] : string } = {
   COLLECT_SAMPLE:'เก็บตัวอย่างเพื่อตรวจวิเคราะห์',
   NONE_COLLECT_SAMPLE:'ไม่เก็บตัวอย่าง'
}
export const Sampling : {[p in Sampling] : string } = {
   PROTEIN:'โปรตีน',
   FAT:' ไขมัน',
   RESIDUE:'กาก',
   MOISTURE:'ความชื้น',
   ASH:'เถ้า'
}
export const Ns4AnalysisResultType : {[p in Ns4AnalysisResultType] : string } = {
   PROTEIN:' โปรตีน',
   FAT:' ไขมัน',
   FIBER:'กาก',
   MOISTURE:'ความชื้น',
   ASH:'เถ้า',
   CALCIUM:'แคลเซียม',
   PHOSPHORUS:'ฟอสฟอรัส',
   NITROFURANS:'ไรโตรฟูรานส์',
   CHLORAMPHENICOL:'คลอแรมฟินิคอล',
   OXYTETRACYCLINE:'ออกซีเตตร้าชัยคลิน',
   ETHOXY_QUIN:'อีทอกซีควิน',
   FLUOROQUINOLONE:'ฟลูออโรควิโนโลน',
   MELAMINE:'เมลามีน',
   OHTER:'อื่น ๆ'
}
export const Ns4CheckingChemical : {[p in Ns4CheckingChemical] : string } = {
   PASS:' ผ่าน',
   NOT_PASS:'ไม่ผ่าน'
}
export const Ns4ConsiderResult : {[p in Ns4ConsiderResult] : string } = {
   PASS:'ผ่าน',
   NOT_PASS:'ไม่ผ่าน'
}
export const Ns4CorrectionFormStatus : {[p in Ns4CorrectionFormStatus] : string } = {
   WAIT_PRIM_CORRECT:'รอแก้ไขข้อมูลเบื้องต้น',
   WAIT_TECH_CORRECT:'รอแก้ไขข้อมููลทางวิชาการ',
   WAIT_PERMIT_TECH:'รออนุมัติทางวิชาการ',
   CORRECT_CHIEF:'รอแก้ไขข้อมูลตามคำสั่งหัวหน้ากลุ่ม กวค.',
   CORRECT_DIRECTOR:'รอแก้ไขข้อมูลตามคำสั่งผอ. กพอ.'
}
export const Ns4CorrectionRequest : {[p in Ns4CorrectionRequest] : string } = {
   IMPORT:'ข้อมูลการนำเข้า',
   PRODUCT:'ข้อมูลรายการสินค้า',
   WAREHOUSE:'ข้อมูลสถานที่เก็บอาหารสัตว์'
}
export const Ns4Discover : {[p in Ns4Discover] : string } = {
   FOUND:' พบ',
   NOT_FOUND:'ไม่ผ่าน'
}
//skip Ns4DocumentType because it not have getValue() method
export const Ns4FeedType : {[p in Ns4FeedType] : string } = {
   FEED:'อาหารสัตว์ควบคุมเฉพาะ',
   FEED_OTHERS:'อาหารสัตว์อื่นนอกเหนือจากอาหารสัตว์ควบคุมเฉพาะ'
}
//skip Ns4FileType because it not have getValue() method
//skip Ns4Form1FileType because it not have getValue() method
//skip Ns4Form2FileType because it not have getValue() method
export const Ns4FormStatus : {[p in Ns4FormStatus] : string } = {
   NEW:'คำขอใหม่',
   CORRECTION:'คำขอแก้ไข',
   SUBSTITUTE:'คำขอใบแทน',
   CANCELLATION:'ละทิ้งคำขอ',
   WAIT_PAYMENT:'รอชำระค่าธรรมเนียม',
   PAID:'ชำระค่าธรรมเนียมแล้ว',
   WAIT_VERIFY_TECH:'รอตรวจสอบทางวิชาการ',
   WAIT_PRIM_CORRECT:'รอแก้ไขข้อมูลเบื้องต้น',
   WAIT_VERIFY_CORRECTION_PRIM:'รอตรวจสอบการแก้ไขข้อมูลเบื้องต้น',
   WAIT_PERMIT_TECH:'รออนุมัติทางวิชาการ',
   WAIT_TECH_CORRECT:'รอแก้ไขข้อมููลทางวิชาการ',
   WAIT_SCHEDULE:'รอกำหนดการเข้าประชุม',
   WAIT_CERT:'รอจัดทำใบสำคัญ',
   WAIT_MAKE_CERTIFICATE:'รอจัดทำเอกสารแจ้งนำเข้า',
   WAIT_VERIFY_CORRECT_TECH:'รอตรวจสอบการแก้ไขข้อมูลทางวิชาการ',
   WAIT_VERIFY_CORRECT_CONCLUDE:'รอตรวจสอบการแก้ไข/ชี้แจงข้อมูลตามมติที่ประชุม',
   WAIT_VERIFY_CORRECT_CHIEF:'รอตรวจสอบการแก้ไขข้อมูลตามคำสั่งหัวหน้ากลุ่ม กวค.',
   WAIT_VERIFY_CORRECT_DIRECTOR:'รอตรวจสอบการแก้ไขข้อมูลตามคำสั่งผอ. กพอ.',
   WAIT_CONFERRED:'รอประชุม',
   DENIED_CONFERRED:'ไม่ผ่านมติที่ประชุม',
   CORRECT_CONCLUDE:'รอแก้ไข/ชี้แจงข้อมูลตามมติที่ประชุม',
   WAIT_SIGN:'รอลงนาม',
   WAIT_ORDER:'รอพิจารณาออกคำสั่ง',
   CORRECT_CHIEF:'รอแก้ไขข้อมูลตามคำสั่งหัวหน้ากลุ่ม กวค.',
   APPROVE_CONDITION:'อนุุมัติแบบมีเงื่อนไข',
   DISAPPROVE:'ไม่อนุมัติ',
   CORRECT_DIRECTOR:'รอแก้ไขข้อมูลตามคำสั่งผอ. กพอ.',
   WAIT_PRODUCT_INSPECTION:'รอตรวจสอบสินค้า',
   WAIT_RELEASE_INSPECTION:'รอบันทึกผลการเก็บตัวอย่าง',
   WAIT_RELEASE_RESULT:'รอพิจารณาผลการตรวจปล่อยสินค้า',
   RELEASE_RESULT_IN_PROCESS:'อยู่ระหว่างดำเนินการรอผลการเก็บตัวอย่าง',
   RELEASE_RESULT_ENDED:'สิ้นสุดกระบวนการ',
   APPROVE:'อนุญาต',
   NOT_APPROVE:'ไม่อนุญาต',
   CONDITION_APPROVE:'อนุญาตแบบมีเงื่อนไข',
   CANCEL_BY_APPLICANT:'ยกเลิกคำร้อง/คำขอ'
}
export const Ns4Operator : {[p in Ns4Operator] : string } = {
   ENTREPRENEUR:'ผู้ดำเนินกิจการ',
   SHIPPING:'ตัวแทนบริษัท'
}
export const Ns4ReleaseResult : {[p in Ns4ReleaseResult] : string } = {
   RELEASE:' ตรวจปล่อยสินค้า',
   NOT_PASS:' ตรวจปล่อยสินค้าไม่ผ่าน',
   RELEASE_WITH_CONDITION:'ตรวจปล่อยสินค้าแบบมีเงื่อนไข',
   RELEASE_SOME:'ตรวจปล่อยสินค้าบางรายการ'
}
export const Ns4SampleResult : {[p in Ns4SampleResult] : string } = {
   PENDING:'อยู่ระหว่างดำเนินการ',
   PROCESS_ENDED:'สิ้นสุดกระบวนการ'
}
//skip Ns4SystemType because it not have getValue() method
export const PaymentStatus : {[p in PaymentStatus] : string } = {
   WAIT_PAYMENT:'รอชำระค่าธรรมเนียม',
   UPLOAD_SLIP:'รอตรวจสอบหลักฐานการชำระค่าธรรมเนียม',
   WAIT_RECEIPT:'รอจัดทำใบเสร็จรับเงิน',
   PAID:'ชำระค่าธรรมเนียมแล้ว',
   CANCEL:'ยกเลิก'
}
export const ReceiptPrintStatus : {[p in ReceiptPrintStatus] : string } = {
   U:'ยังไม่พิมพ์ใบเสร็จ',
   P:'พิมพ์ใบเสร็จแล้ว'
}
//skip RequestInspectionAuditFileType because it not have getValue() method
//skip RequestInspectionFileType because it not have getValue() method
//skip RequestInspectionForm1FileType because it not have getValue() method
//skip RequestInspectionFormAuditFileType because it not have getValue() method
//skip RequestInspectionFormCheckSiteInspectionFileType because it not have getValue() method
export const RequestInspectionFormStatus : {[p in RequestInspectionFormStatus] : string } = {
   NEW:'คำขอใหม่',
   PRIM_CORRECTION:'แก้ไขข้อมูลเบื้องต้น',
   CANCELATION:'ยกเลิกคำขอเนื่องจากไม่มีการดำเนินการตามกำหนด',
   CANCEL_BY_APPLICANT:'ยกเลิกคำร้อง/คำขอ',
   PRIM_CORRECTED:'รอตรวจสอบการแก้ไขข้อมูลคำขอเบื้องต้น',
   WAIT_VERIFY:'รอเอกสารฉบับจริง',
   WAIT_APPOINT_LOCATION:'รอนัดหมายตรวจสอบสถานที่',
   WAIT_ACCEPT_LOCATION:'รอตอบรับนัดหมายตรวจสอบสถานที่',
   APPOINT_DENIED:'ปฏิเสธนัดหมาย',
   WAIT_INSPECT_LOCATION:'รอตรวจสอบสถานที่',
   LOCATION_DENIED:'ไม่ผ่านเนื่องจากสถานที่ไม่เหมาะสม',
   WAIT_DIGI_SIG:'รอลงลายมือชื่ออิเล็กทรอนิกส์รับทราบผลการตรวจสอบ',
   LOCATION_CORRECTION_REPORT:'ให้ส่งรายงานแก้ไขสถานที่',
   CORRECTION_SENT:'รอตรวจสอบรายงานแก้ไขสถานที่',
   WAIT_CERT:'รอจัดทำหนังสือฯ',
   WAIT_SIGN_PROPOSAL:'รอเสนอลงนาม',
   WAIT_ORDER:'รอพิจารณาออกคำสั่ง',
   DENIED:'ไม่อนุญาต',
   GRANT:'แจ้งผลการตรวจสอบแล้ว'
}
//skip FeedType because it not have getValue() method
export const VoucherCorrectionFormStatus : {[p in VoucherCorrectionFormStatus] : string } = {
   WAIT_PRIM_CORRECT:'รอแก้ไขข้อมูลเบื้องต้น',
   WAIT_TECH_CORRECT:'รอแก้ไขข้อมููลทางวิชาการ',
   CORRECT_CONCLUDE:'รอแก้ไข/ชี้แจงข้อมูลตามมติที่ประชุม',
   CORRECT_DIRECTOR:'รอแก้ไขข้อมูลตามคำสั่งผอ. กพอ.',
   CORRECT_CHIEF:'รอแก้ไขข้อมูลตามคำสั่งหัวหน้ากลุ่ม กวค.'
}
//skip VoucherFileType because it not have getValue() method
//skip VoucherForm1FileType because it not have getValue() method
//skip VoucherForm2FileType because it not have getValue() method
//skip VoucherForm3FileType because it not have getValue() method
//skip VoucherForm4FileType because it not have getValue() method
//skip VoucherForm5FileType because it not have getValue() method
//skip VoucherForm6FileType because it not have getValue() method
//skip VoucherForm7FileType because it not have getValue() method
export const VoucherFormStatus : {[p in VoucherFormStatus] : string } = {
   NEW:'คำขอใหม่',
   NEW_IN_QUEUE:'รอคิวคำขอใหม่',
   CORRECTION:'คำขอแก้ไข',
   CORRECTION_IN_QUEUE:'รอคิวคำขอแก้ไข',
   SUBSTITUTE:'คำขอใบแทน',
   SUBSTITUTE_IN_QUEUE:'รอคิวคำขอใบแทน',
   CANCELLATION:'ละทิ้งคำขอ',
   WAIT_PAYMENT:'รอชำระค่าธรรมเนียม',
   UPLOAD_SLIP:'รอตรวจสอบหลักฐานการชำระค่าธรรมเนียม',
   PAID:'ชำระค่าธรรมเนียมแล้ว',
   WAIT_VERIFY_TECH:'รอตรวจสอบทางวิชาการ',
   WAIT_PRIM_CORRECT:'รอแก้ไขข้อมูลเบื้องต้น',
   WAIT_VERIFY_CORRECTION_PRIM:'รอตรวจสอบการแก้ไขข้อมูลเบื้องต้น',
   WAIT_PERMIT_TECH:'รออนุมัติทางวิชาการ',
   WAIT_TECH_CORRECT:'รอแก้ไขข้อมูลทางวิชาการ',
   WAIT_SCHEDULE:'รอกำหนดการเข้าประชุม',
   WAIT_CERT:'รอจัดทำใบสำคัญ',
   WAIT_VERIFY_CORRECT_TECH:'รอตรวจสอบการแก้ไขข้อมูลทางวิชาการ',
   WAIT_VERIFY_CORRECT_CONCLUDE:'รอตรวจสอบการแก้ไข/ชี้แจงข้อมูลตามมติที่ประชุม',
   WAIT_VERIFY_CORRECT_CHIEF:'รอตรวจสอบการแก้ไขข้อมูลตามคำสั่งหัวหน้ากลุ่ม กวค.',
   WAIT_VERIFY_CORRECT_DIRECTOR:'รอตรวจสอบการแก้ไขข้อมูลตามคำสั่งผอ. กพอ.',
   WAIT_CONFERRED:'รอประชุม',
   DENIED_CONFERRED:'ไม่ผ่านมติที่ประชุม',
   CORRECT_CONCLUDE:'รอแก้ไข/ชี้แจงข้อมูลตามมติที่ประชุม',
   WAIT_SIGN:'รอลงนาม',
   WAIT_ORDER:'รอพิจารณาออกคำสั่ง',
   CORRECT_CHIEF:'รอแก้ไขข้อมูลตามคำสั่งหัวหน้ากลุ่ม กวค.',
   DENIED:'ไม่อนุญาต',
   CORRECT_DIRECTOR:'รอแก้ไขข้อมูลตามคำสั่งผอ. กพอ.',
   CANCEL_REQUEST:'ยกเลิกคำร้อง/คำขอ',
   GRANT:'อนุญาต'
}
export const VoucherMeetingResult : {[p in VoucherMeetingResult] : string } = {
   APPROVED_REQUEST:'อนุมัติตามคำขอ',
   CORRECTION:'แจ้งแก้ไข',
   NOT_APPROVED:'ไม่ผ่านมติที่ประชุม'
}
export const VoucherMeetingStatus : {[p in VoucherMeetingStatus] : string } = {
   MEETING_WAITING:'รอบันทึกรายงานการประชุม',
   MEETING_RECORDED:'บันทึกรายงานการประชุมแล้ว'
}
export const VoucherRequestType : {[p in VoucherRequestType] : string } = {
   N:'ขอใหม่',
   E:'คำขอแก้ไข',
   R:'คำขอใบแทน'
}
export const VoucherStatus : {[p in VoucherStatus] : string } = {
   AVAILABLE:'คงอยู่',
   CANCELED:'ยกเลิก'
}
export const VoucherType : {[p in VoucherType] : string } = {
   M:'ใบสำคัญการขึ้นทะเบียนอาหารสัตว์ควบคุมเฉพาะ ประเภทวัตถุที่ผสมแล้ว ชนิดอาหารสัตว์ผสมสำเร็จรูปหรือหัวอาหารสัตว์',
   P:'ใบสำคัญการขึ้นทะเบียนอาหารสัตว์ควบคุมเฉพาะ ประเภทวัตถุที่ผสมแล้วชนิดสารผสมล่วงหน้า (พรีมิกซ์)',
   S:'ใบสำคัญการขึ้นทะเบียนอาหารสัตว์ควบคุมเฉพาะ ประเภทอาหารเสริมสำหรับสัตว์'
}
//skip PaymentType because it not have getValue() method
